var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/tsup/assets/esm_shims.js
var init_esm_shims = __esm({
  "../../node_modules/tsup/assets/esm_shims.js"() {
  }
});

// ../../node_modules/lodash/noop.js
var require_noop = __commonJS({
  "../../node_modules/lodash/noop.js"(exports, module) {
    init_esm_shims();
    function noop2() {
    }
    module.exports = noop2;
  }
});

// src/layout/index.ts
init_esm_shims();

// src/layout/contexts/UiProvider.tsx
init_esm_shims();

// src/contexts/LocaleProvider.tsx
init_esm_shims();
import { IntlProvider } from "react-intl";

// src/hooks/useLocaleData.ts
init_esm_shims();

// src/locale/translations.ts
init_esm_shims();
var MESSAGES_BY_LOCALE = {
  cs: {
    activity_and_movement_link: "Aktivita a\xA0pohyb",
    address_form_additional_address: "Dal\u0161\xED adresa",
    address_form_address: "Adresa",
    address_form_apt_suite: "\u010C\xEDslo bytu, patro",
    address_form_city: "M\u011Bsto",
    address_form_city_town: "M\u011Bsto",
    address_form_city_ward_town_village: "M\u011Bsto/\u010Dtvr\u0165/obec",
    address_form_country: "Zem\u011B",
    address_form_county: "Okres",
    address_form_email: "E-mail",
    address_form_emirate: "Emir\xE1t",
    address_form_fname: "K\u0159estn\xED jm\xE9no",
    address_form_lname: "P\u0159\xEDjmen\xED",
    address_form_max: "Tohle pole nesm\xED m\xEDt v\xEDc ne\u017E (number) znak\u016F",
    address_form_min: "Tohle pole mus\xED m\xEDt aspo\u0148 (number) znak\u016F",
    address_form_phone: "Telefon",
    address_form_postal: "Po\u0161tovn\xED sm\u011Brovac\xED \u010D\xEDslo",
    address_form_postcode: "PS\u010C",
    address_form_prefecture: "Prefektura",
    address_form_province: "Provincie",
    address_form_region: "Region",
    address_form_required: "Povinn\xE9 pole",
    address_form_state: "St\xE1t",
    address_form_state_province_region: "St\xE1t/provincie/region",
    address_form_state_territory: "St\xE1t/teritorium",
    address_form_street_house_number: "Ulice a\xA0\u010D\xEDslo popisn\xE9",
    address_form_suburb: "P\u0159edm\u011Bst\xED/m\u011Bsto",
    address_form_zip: "Po\u0161tovn\xED sm\u011Brovac\xED \u010D\xEDslo",
    available_day: "K\xA0dispozici {day}",
    best_buy_store_locator_legend_text: "Oura Ring na prodejn\xE1ch Best Buy",
    bfcm_2024_home_hero_title: "Na\u0161e nejni\u017E\u0161\xED<break></break>cena, <em>co tu kdy byla</em>",
    bfcm_2024_menu_card_dyn_price_description: "A\u017E {amount} sleva z\xA0ceny doporu\u010Den\xE9 v\xFDrobcem na <break></break>Oura Ring Gen3.",
    business_gallery_gift_card_title: "D\xE1rkov\xE9 karty",
    carousel_current_slide_label: "(Aktu\xE1ln\xED sn\xEDmek)",
    carousel_live_region_text: "Polo\u017Eka {activeIndex} z\xA0{slideCount}",
    carousel_next_slide_label: "Dal\u0161\xED polo\u017Eka",
    carousel_page_dot_label: "Polo\u017Eka {index}",
    carousel_previous_slide_label: "P\u0159edchoz\xED polo\u017Eka",
    cart: "Ko\u0161\xEDk",
    cart_count_sr_label: "{count, plural, =0 {M\xE1te pr\xE1zdn\xFD ko\u0161\xEDk} =1 {V\xA0ko\u0161\xEDku m\xE1te jednu polo\u017Eku} other {Polo\u017Eek v\xA0ko\u0161\xEDku: #}}",
    checkout_form_country: "Zem\u011B",
    checkout_form_emailformat: "Nespr\xE1vn\xFD form\xE1t e-mailu",
    checkout_form_emailformat_custom: "Nespr\xE1vn\xFD form\xE1t e-mailu",
    checkout_form_phoneinvalid: "Telefonn\xED \u010D\xEDslo je neplatn\xE9 nebo chyb\xED p\u0159edvolba zem\u011B",
    checkout_form_postal_code_pattern: "PS\u010C nesm\xED obsahovat v\xEDc ne\u017E dev\u011Bt p\xEDsmen a\xA0\u010D\xEDslic.",
    checkout_form_postal_code_string: "PS\u010C sm\xED obsahovat jen p\xEDsmena, \u010D\xEDsla, mezery a\xA0spojovn\xEDky",
    checkout_form_postal_required: "Mus\xEDte uv\xE9st PS\u010C",
    checkout_form_zip: "Po\u0161tovn\xED sm\u011Brovac\xED \u010D\xEDslo",
    checkout_input_click_to_show_label: "P\u0159idat \xFAdaj {inputLabel}",
    checkout_pickup_details_plural_units_left: "Posledn\xED kusy ({quantity})",
    checkout_pickup_details_ready_in_time: "P\u0159ipraveno za {time}",
    checkout_pickup_details_single_unit_left: "Posledn\xED kus",
    close: "Zav\u0159\xEDt",
    comparison_slider_control_label: "Pro porovn\xE1n\xED p\u0159et\xE1hn\u011Bte nebo pou\u017Eijte kl\xE1vesy se \u0161ipkou vlevo a vpravo.",
    drop_down_extra_charger: "Nab\xEDje\u010Dka nav\xEDc",
    drop_down_gift_card: "D\xE1rkov\xE1 karta",
    drop_down_oura_ring: "Oura Ring",
    explore_how_it_works_link: "Pod\xEDvejte se, jak to funguje",
    explore_why_oura_link: "Pro\u010D pr\xE1v\u011B Oura Ring",
    facebook: "Facebook",
    fcc_compliance_link: "Shoda s\xA0FCC",
    flexible_spending_footer_link: "Programy pro flexibiln\xED v\xFDdaje (FSA)",
    floating_bar_oura_ring_4_ceramic: "Oura Ring\xA04 <breakSm></breakSm>Ceramic",
    footer_about_us: "O\xA0n\xE1s",
    footer_accessibility: "P\u0159\xEDstupnost",
    footer_all_rights_reserved: "Ouraring Inc. | V\u0161echna pr\xE1va vyhrazena",
    footer_blog_heading: "Blog",
    footer_careers: "Kari\xE9ra",
    footer_company_heading: "Na\u0161e spole\u010Dnost",
    footer_connect: "Spojte se s\xA0n\xE1mi",
    footer_contact: "Kontakt",
    footer_copyright: "\u014CURA, OURA, OURA RING a\xA0\u014C jsou ochrann\xE9 zn\xE1mky spole\u010Dnosti \u014Cura Health Oy a\xA0nesm\xED se pou\u017E\xEDvat bez povolen\xED.",
    footer_dataprotect_1: "Na ochran\u011B va\u0161ich dat n\xE1m z\xE1le\u017E\xED.",
    footer_dataprotect_privacy_policy: "P\u0159e\u010Dt\u011Bte si v\xEDc v\xA0na\u0161ich <PrivacyPolicyLink>z\xE1sad\xE1ch ochrany osobn\xEDch \xFAdaj\u016F</PrivacyPolicyLink>.",
    footer_developers: "V\xFDvoj\xE1\u0159i",
    footer_email: "E-mailov\xE1 adresa",
    footer_email_input_heading: "Z\xEDskejte \u010Dl\xE1nky, tipy a\xA0nab\xEDdky od spole\u010Dnosti Oura",
    footer_email_validation_error: "Zadejte pros\xEDm platnou e-mailovou adresu",
    footer_help: "N\xE1pov\u011Bda",
    footer_image_cta: "Vydejte se dnes na <em>cestu za zdrav\xEDm</em>",
    footer_ip_notice: "Sd\u011Blen\xED k\xA0pr\xE1v\u016Fm du\u0161evn\xEDho vlastnictv\xED",
    footer_leadership: "Veden\xED",
    footer_legal_aria_label: "Pr\xE1vn\xED sd\u011Blen\xED",
    footer_legal_link_v4: "\xA9 2025 Oura Health Oy. V\u0161echna pr\xE1va vyhrazena. \u014CURA, OURA a\xA0\u014C jsou ochrann\xE9 zn\xE1mky spole\u010Dnosti \u014Cura Health Oy a\xA0nesm\xED se pou\u017E\xEDvat bez povolen\xED.",
    footer_medical_advisory_board: "L\xE9ka\u0159sk\xE1 rada",
    footer_membership: "\u010Clenstv\xED",
    footer_my_account: "My Account",
    footer_newsletter_submit_label: "odeslat e-mail pro newsletter",
    footer_oura_on_the_web: "Oura on the Web",
    footer_partner_heading: "Poj\u010Fme spolupracovat",
    footer_press: "Tisk",
    footer_privacy_policy: "Z\xE1sady ochrany osobn\xEDch \xFAdaj\u016F",
    footer_pulse_blog: "Blog The Pulse",
    footer_security_center: "Centrum zabezpe\u010Den\xED",
    footer_sizing: "Velikosti",
    footer_social_heading: "Soci\xE1ln\xED m\xE9dia",
    footer_social_icons_aria_label: "Na\u0161e soci\xE1ln\xED m\xE9dia",
    footer_support_heading: "Podpora",
    footer_terms_and_conditions: "V\u0161eobecn\xE9 podm\xEDnky",
    footer_thanks_for_subscribing: "D\xEDky, \u017Ee m\xE1te z\xE1jem",
    for_business_link: "Pro podniky",
    for_organizations: "Pro organizace",
    gen4_is_here: "Oura Ring\xA04<em>je tady</em>",
    header_hamburger_close_sr_label: "Zav\u0159\xEDt mobiln\xED navigaci",
    header_hamburger_close_sr_label_2024: "Zav\u0159\xEDt horn\xED nab\xEDdku",
    header_hamburger_open_sr_label: "Otev\u0159\xEDt mobiln\xED navigaci",
    header_hamburger_open_sr_label_2024: "Otev\u0159\xEDt horn\xED nab\xEDdku",
    header_shop_now: "Koupit",
    header_skip_to_content: "P\u0159esko\u010Dit na hlavn\xED obsah",
    heart_health_link: "Stav srdce",
    heart_rate_monitoring_link: "Sledov\xE1n\xED tepov\xE9 frekvence",
    how_it_works_link: "Jak to funguje",
    impressum_page_title: "Impresum",
    instagram: "Instagram",
    integrations_link: "Integrace",
    language_preference: "Jazykov\xE9 preference",
    menu: "Nab\xEDdka",
    metabolic_health: "Metabolick\xE9 zdrav\xED",
    nav_experience: "U\u017Eivatelsk\xE1 zku\u0161enost",
    nav_health_features: "Zdravotn\xED funkce",
    nav_help_center: "Centrum n\xE1pov\u011Bdy",
    nav_shop_all_products: "V\u0161echny produkty",
    nav_sizing_guide: "Pr\u016Fvodce velikostmi",
    nav_travel_case: "Oura Ring 4 Travel Case",
    newsroom_link: "Zpr\xE1vy",
    oura_home_link: "Domovsk\xE1 str\xE1nka Oura",
    oura_membership: "\u010Clensk\xFD \xFA\u010Det Oura",
    oura_ring_4_ceramic: "Oura Ring\xA04 Ceramic",
    oura_ring_4_link: "Oura Ring 4 <sup>Novinka</sup>",
    out_of_stock_tag: "Vyprod\xE1no",
    partnerships_link: "Partnerstv\xED",
    pdp_selected_check_label: "Zvolen\xE1 varianta",
    pdp_slideshow_thumbnail_label: "P\u0159ej\xEDt na sn\xEDmek {index}",
    pdp_style_ouraring4_cer: "Oura Ring\xA04 Ceramic",
    pinterest: "Pinterest",
    recycling_program_link: "Program recyklace",
    ring_gen_4: "Oura Ring\xA04",
    ring_gen_4_cer: "Oura Ring\xA04 Ceramic",
    ring_gen3_on_sale: "Oura Ring Gen3 <sup>za v\xFDhodnou cenu</sup>",
    sale: "V\xFDprodej",
    sale_link: "V\xFDprodej prsten\u016F Oura Ring Gen3",
    science_and_research_link: "V\u011Bda a\xA0v\xFDzkum",
    shop: "Obchod",
    shop_rings: "Nakupovat prsteny",
    sleep_and_rest_link: "Sp\xE1nek a\xA0odpo\u010Dinek",
    slider_item_aria_label: "sn\xEDmek {number} z\xA0{maxNumber}",
    stelo_glucose_biosensor: "Gluk\xF3zov\xFD monitor Stelo",
    store_locator_distance: "{distanceInMiles} mi",
    store_locator_item_button_label: "Zobrazit {displayName} {storeName} na map\u011B",
    store_locator_item_link_label: "Zobrazit {displayName} {storeName} v\xA0Map\xE1ch Google (otev\u0159e se na nov\xE9 kart\u011B / v\xA0nov\xE9m okn\u011B)",
    store_locator_location_closed: "Uzav\u0159eno",
    store_locator_location_open: "Otev\u0159eno do {time}",
    store_locator_no_results: "\u017D\xE1dn\xE9 v\xFDsledky jsme nena\u0161li.",
    store_locator_number_results: "V\xFDsledk\u016F: {number}",
    store_locator_postal_code_pattern_error: "Zadejte p\u011Btim\xEDstn\xE9 americk\xE9 po\u0161tovn\xED sm\u011Brovac\xED \u010D\xEDslo",
    store_locator_results_error: "Neda\u0159\xED se n\xE1m naj\xEDt prodejny {storeName} ve va\u0161em okol\xED. Obnovte str\xE1nku a\xA0zkuste to znovu nebo kontaktujte z\xE1kaznickou podporu.",
    stress_link: "Stres",
    the_pulse: "The Pulse",
    tiktok: "TikTok",
    use_current_location_link: "Pou\u017E\xEDt moji aktu\xE1ln\xED polohu",
    why_oura_link: "Pro\u010D Oura",
    womens_health_link: "\u017Densk\xE9 zdrav\xED",
    x: "X",
    youtube: "YouTube"
  },
  da: {
    activity_and_movement_link: "Aktivitet og bev\xE6gelse",
    address_form_additional_address: "Adresse (fort.)",
    address_form_address: "Adresse",
    address_form_apt_suite: "Etage-, side-, d\xF8rnummer",
    address_form_city: "By",
    address_form_city_town: "By",
    address_form_city_ward_town_village: "By",
    address_form_country: "Land",
    address_form_county: "Amt",
    address_form_email: "E-mailadresse",
    address_form_emirate: "Emirat",
    address_form_fname: "Fornavn",
    address_form_lname: "Efternavn",
    address_form_max: "Dette felt m\xE5 ikke indeholde mere end {number} tegn",
    address_form_min: "Dette felt skal indeholde mindst {number} tegn",
    address_form_phone: "Telefonnummer",
    address_form_postal: "Postnummer",
    address_form_postcode: "Postnummer",
    address_form_prefecture: "Pr\xE6fektur",
    address_form_province: "Provins",
    address_form_region: "Region",
    address_form_required: "Dette felt skal udfyldes",
    address_form_state: "Stat",
    address_form_state_province_region: "Stat/provins/region",
    address_form_state_territory: "Stat/omr\xE5de",
    address_form_street_house_number: "Gadenavn og husnummer",
    address_form_suburb: "Forstad/by",
    address_form_zip: "Postnummer",
    available_day: "F\xE5s fra {day}",
    best_buy_store_locator_legend_text: "Oplev Oura i Best Buy-butikker",
    bfcm_2024_home_hero_title: "Vores laveste<break></break>pris <em>nogensinde</em>",
    bfcm_2024_menu_card_dyn_price_description: "Op til {amount} i rabat p\xE5 den vejledende salgspris p\xE5<break></break>Oura Ring Gen3.",
    business_gallery_gift_card_title: "Gavekort",
    carousel_current_slide_label: "(Aktuelt dias)",
    carousel_live_region_text: "Element {activeIndex} af {slideCount}",
    carousel_next_slide_label: "N\xE6ste element",
    carousel_page_dot_label: "Element {index}",
    carousel_previous_slide_label: "Forrige element",
    cart: "Indk\xF8bskurv",
    cart_count_sr_label: "Der {count, plural, =0 {er ingen varer} =1 {er \xE9n vare} other {er # varer}} i din indk\xF8bskurv",
    checkout_form_country: "Land",
    checkout_form_emailformat: "Forkert format for e-mailadresse",
    checkout_form_emailformat_custom: "Forkert format for e-mailadresse",
    checkout_form_phoneinvalid: "Telefonnummeret er ugyldigt, eller landekoden mangler",
    checkout_form_postal_code_pattern: "Postnummeret m\xE5 ikke indeholde mere end 9 bogstaver eller tal.",
    checkout_form_postal_code_string: "Postnummeret m\xE5 kun indeholde bogstaver, tal, mellemrum og bindestreger",
    checkout_form_postal_required: "Postnummer skal udfyldes",
    checkout_form_zip: "Postnummer",
    checkout_input_click_to_show_label: "Tilf\xF8j {inputLabel}",
    checkout_pickup_details_plural_units_left: "Kun {quantity} tilbage",
    checkout_pickup_details_ready_in_time: "Klar om {time}",
    checkout_pickup_details_single_unit_left: "Kun 1 tilbage",
    close: "Luk",
    comparison_slider_control_label: "Tr\xE6k eller brug venstre og h\xF8jre piletast for at sammenligne",
    drop_down_extra_charger: "Ekstra oplader",
    drop_down_gift_card: "Gavekort",
    drop_down_oura_ring: "Oura Ring",
    explore_how_it_works_link: "Find ud af, hvordan det fungerer",
    explore_why_oura_link: "Udforsk, hvorfor du b\xF8r bruge Oura",
    facebook: "Facebook",
    fcc_compliance_link: "FCC-overensstemmelse",
    flexible_spending_footer_link: "Fleksibel k\xF8bsoplevelse",
    floating_bar_oura_ring_4_ceramic: "Oura Ring 4 <breakSm></breakSm>Ceramic",
    footer_about_us: "Om os",
    footer_accessibility: "Tilg\xE6ngelighed",
    footer_all_rights_reserved: "Ouraring Inc. | Alle rettigheder forbeholdes",
    footer_blog_heading: "Blog",
    footer_careers: "Karriere",
    footer_company_heading: "Vores virksomhed",
    footer_connect: "F\xF8lg os",
    footer_contact: "Kontakt",
    footer_copyright: "\u014CURA, OURA, OURA RING og \u014C er varem\xE6rker tilh\xF8rende Oura Health Oy og m\xE5 ikke bruges uden tilladelse.",
    footer_dataprotect_1: "Vi s\xF8rger for at beskytte dine data.",
    footer_dataprotect_privacy_policy: "Du kan l\xE6se mere i vores <PrivacyPolicyLink>databeskyttelsespolitik</PrivacyPolicyLink>.",
    footer_developers: "Udviklere",
    footer_email: "E-mailadresse",
    footer_email_input_heading: "F\xE5 artikler, tips og tilbud fra Oura",
    footer_email_validation_error: "Angiv en gyldig e-mailadresse",
    footer_help: "Hj\xE6lp",
    footer_image_cta: "Start din sundheds-<em>rejse i dag</em>",
    footer_ip_notice: "IP-meddelelse",
    footer_leadership: "Ledelse",
    footer_legal_aria_label: "Juridisk fodnote",
    footer_legal_link_v4: "\xA9 2025 Oura Health Oy. Alle rettigheder forbeholdes. \u014CURA, OURA og \u014C er varem\xE6rker tilh\xF8rende Oura Health Oy og m\xE5 ikke bruges uden tilladelse.",
    footer_medical_advisory_board: "L\xE6gevidenskabelige r\xE5dgivere",
    footer_membership: "Medlemskab",
    footer_my_account: "My Account",
    footer_newsletter_submit_label: "indsend e-mailadresse for at modtage nyhedsbreve",
    footer_oura_on_the_web: "Oura on the Web",
    footer_partner_heading: "Samarbejd med os",
    footer_press: "Nyheder",
    footer_privacy_policy: "Databeskyttelsespolitik",
    footer_pulse_blog: "The Pulse Blog",
    footer_security_center: "Sikkerhedscenter",
    footer_sizing: "Ringst\xF8rrelse",
    footer_social_heading: "Sociale medier",
    footer_social_icons_aria_label: "Oura og sociale medier",
    footer_support_heading: "Support",
    footer_terms_and_conditions: "Vilk\xE5r og betingelser",
    footer_thanks_for_subscribing: "Tak, fordi du abonnerer",
    for_business_link: "Til virksomheder",
    for_organizations: "For organisationer",
    gen4_is_here: "Oura Ring 4<em>er her</em>",
    header_hamburger_close_sr_label: "Luk mobilnavigation",
    header_hamburger_close_sr_label_2024: "Luk hovedmenunavigation",
    header_hamburger_open_sr_label: "\xC5bn mobilnavigation",
    header_hamburger_open_sr_label_2024: "\xC5bn hovedmenunavigation",
    header_shop_now: "K\xF8b nu",
    header_skip_to_content: "Spring navigation til hovedindhold over",
    heart_health_link: "Hjertesundhed",
    heart_rate_monitoring_link: "Overv\xE5gning af puls",
    how_it_works_link: "S\xE5dan fungerer det",
    impressum_page_title: "Impressum",
    instagram: "Instagram",
    integrations_link: "Integrationer",
    language_preference: "Sprogpr\xE6ference",
    menu: "Menu",
    metabolic_health: "Stofskiftesundhed",
    nav_experience: "Oplevelsen",
    nav_health_features: "Sundhedsfunktioner",
    nav_help_center: "Hj\xE6lpecenter",
    nav_shop_all_products: "K\xF8b alle produkter",
    nav_sizing_guide: "St\xF8rrelsesvejledning",
    nav_travel_case: "Oura Ring 4 Travel Case",
    newsroom_link: "Nyheder",
    oura_home_link: "Oura-startside",
    oura_membership: "Oura-medlemskab",
    oura_ring_4_ceramic: "Oura Ring 4 Ceramic",
    oura_ring_4_link: "Oura Ring 4 <sup>Ny</sup>",
    out_of_stock_tag: "Udsolgt",
    partnerships_link: "Partnerskaber",
    pdp_selected_check_label: "V\xE6lg mulighed",
    pdp_slideshow_thumbnail_label: "G\xE5 til dias {index}",
    pdp_style_ouraring4_cer: "Oura Ring 4 Ceramic",
    pinterest: "Pinterest",
    recycling_program_link: "Genanvendelsesprogram",
    ring_gen_4: "Oura Ring 4",
    ring_gen_4_cer: "Oura Ring 4 Ceramic",
    ring_gen3_on_sale: "Oura Ring Gen3 <sup>p\xE5 tilbud</sup>",
    sale: "Udsalg",
    sale_link: "Udsalg p\xE5 Oura Ring Gen3",
    science_and_research_link: "Videnskab og forskning",
    shop: "K\xF8b",
    shop_rings: "K\xF8b ringe",
    sleep_and_rest_link: "S\xF8vn og hvile",
    slider_item_aria_label: "dias {number} af {maxNumber}",
    stelo_glucose_biosensor: "Stelo-biosensor til blodsukkerm\xE5ling",
    store_locator_distance: "{distanceInMiles} miles v\xE6k",
    store_locator_item_button_label: "Se {displayName} {storeName} p\xE5 kortet",
    store_locator_item_link_label: "Se {displayName} {storeName} i Google Maps (\xE5bner p\xE5 ny fane/i nyt vindue)",
    store_locator_location_closed: "Lukket",
    store_locator_location_open: "\xC5ben indtil {time}",
    store_locator_no_results: "Ingen resultater fundet.",
    store_locator_number_results: "{number} resultater",
    store_locator_postal_code_pattern_error: "Angiv et femcifret amerikansk postnummer",
    store_locator_results_error: "Der opstod en fejl under s\xF8gning efter {storeName}-butikker i n\xE6rheden. Opdater siden for at pr\xF8ve igen, eller kontakt kundeservice.",
    stress_link: "Stress",
    the_pulse: "The Pulse",
    tiktok: "TikTok",
    use_current_location_link: "Brug min nuv\xE6rende placering",
    why_oura_link: "Hvorfor Oura",
    womens_health_link: "Kvinders sundhed",
    x: "X",
    youtube: "YouTube"
  },
  de: {
    activity_and_movement_link: "Aktivit\xE4t und Bewegung",
    address_form_additional_address: "Adresszusatz",
    address_form_address: "Adresse",
    address_form_apt_suite: "Adresszusatz",
    address_form_city: "Stadt",
    address_form_city_town: "Stadt/Ort",
    address_form_city_ward_town_village: "Stadt/Bezirk/Ort/Dorf",
    address_form_country: "Land",
    address_form_county: "Region",
    address_form_email: "E-Mail-Adresse",
    address_form_emirate: "Emirat",
    address_form_fname: "Vorname",
    address_form_lname: "Nachname",
    address_form_max: "Dieses Feld darf nicht mehr als {number} Zeichen enthalten",
    address_form_min: "Dieses Feld muss mindestens {number} Zeichen enthalten",
    address_form_phone: "Telefonnummer",
    address_form_postal: "Postleitzahl",
    address_form_postcode: "Postleitzahl",
    address_form_prefecture: "Pr\xE4fektur",
    address_form_province: "Provinz",
    address_form_region: "Region",
    address_form_required: "Die Angabe in diesem Feld ist erforderlich",
    address_form_state: "Bundesland",
    address_form_state_province_region: "Bundesstaat/Provinz/Region",
    address_form_state_territory: "Bundesstaat/Territorium",
    address_form_street_house_number: "Stra\xDFe und Hausnummer",
    address_form_suburb: "Vorort/Stadt",
    address_form_zip: "Postleitzahl",
    available_day: "Verf\xFCgbar: {day}",
    best_buy_store_locator_legend_text: "Oura in Best\xA0Buy-Gesch\xE4ften erleben",
    bfcm_2024_home_hero_title: "So g\xFCnstig<break></break>wie <em>noch nie</em>",
    bfcm_2024_menu_card_dyn_price_description: "Bis zu {amount} weniger als der Standardpreis f\xFCr<break></break>Oura Ring Gen3.",
    business_gallery_gift_card_title: "Gutscheine",
    carousel_current_slide_label: "(Aktuelles Slide)",
    carousel_live_region_text: "Slide {activeIndex} von {slideCount}",
    carousel_next_slide_label: "N\xE4chstes Slide",
    carousel_page_dot_label: "Slide {index}",
    carousel_previous_slide_label: "Vorheriges Slide",
    cart: "Warenkorb",
    cart_count_sr_label: "In deinem Warenkorb {count, plural, =0 {befinden sich keine Artikel} =1 {befindet sich 1 Artikel} other {befinden sich # Artikel}}",
    checkout_form_country: "Land",
    checkout_form_emailformat: "Falsches E-Mail-Format",
    checkout_form_emailformat_custom: "Falsches E-Mail-Format",
    checkout_form_phoneinvalid: "Telefonnummer ung\xFCltig oder fehlende Landesvorwahl",
    checkout_form_postal_code_pattern: "Die Postleitzahl darf nicht mehr als 9 Buchstaben oder Ziffern enthalten.",
    checkout_form_postal_code_string: "Die Postleitzahl darf nur Buchstaben, Ziffern, Leerzeichen und Bindestriche enthalten.",
    checkout_form_postal_required: "Die PLZ muss angegeben werden",
    checkout_form_zip: "Postleitzahl",
    checkout_input_click_to_show_label: "{inputLabel} hinzuf\xFCgen",
    checkout_pickup_details_plural_units_left: "Nur {quantity} Artikel verf\xFCgbar",
    checkout_pickup_details_ready_in_time: "Abholbereit in {time}",
    checkout_pickup_details_single_unit_left: "Nur 1 Artikel verf\xFCgbar",
    close: "Schlie\xDFen",
    comparison_slider_control_label: "Zum Vergleichen ziehen oder die Pfeiltasten f\xFCr rechts und links verwenden",
    drop_down_extra_charger: "Zus\xE4tzliches Ladeger\xE4t",
    drop_down_gift_card: "Gutschein",
    drop_down_oura_ring: "Oura Ring",
    explore_how_it_works_link: "Funktionsweise",
    explore_why_oura_link: "Gr\xFCnde f\xFCr Oura",
    facebook: "Facebook",
    fcc_compliance_link: "FCC Compliance",
    flexible_spending_footer_link: "Steuerbeg\xFCnstigtes Gesundheitskonto",
    floating_bar_oura_ring_4_ceramic: "Oura Ring 4 <breakSm></breakSm>Ceramic",
    footer_about_us: "\xDCber uns",
    footer_accessibility: "Barrierefreiheit",
    footer_all_rights_reserved: "Ouraring Inc. | Alle Rechte vorbehalten",
    footer_blog_heading: "Blog",
    footer_careers: "Karriere",
    footer_company_heading: "Unternehmen",
    footer_connect: "Verbinden",
    footer_contact: "Kontakt",
    footer_copyright: "\u014CURA, OURA, OURA RING und \u014C sind Marken der Oura Health Oy und d\xFCrfen nicht ohne Genehmigung verwendet werden.",
    footer_dataprotect_1: "Der Schutz deiner Daten ist uns wichtig.",
    footer_dataprotect_privacy_policy: "Erfahre mehr in unserer <PrivacyPolicyLink>Datenschutzerkl\xE4rung</PrivacyPolicyLink>.",
    footer_developers: "Entwickler",
    footer_email: "E-Mail-Adresse",
    footer_email_input_heading: "Erhalte die neuesten Beitr\xE4ge, Tipps und Angebote von Oura",
    footer_email_validation_error: "Bitte gib eine g\xFCltige E-Mail-Adresse ein",
    footer_help: "Hilfe",
    footer_image_cta: "Verbessere deine Gesundheit noch heute",
    footer_ip_notice: "Hinweis zum Urheberrecht",
    footer_leadership: "F\xFChrungsteam",
    footer_legal_aria_label: "Footer, rechtliche Hinweise",
    footer_legal_link_v4: "\xA9 2025 Oura Health Oy. Alle Rechte vorbehalten. \u014CURA, OURA und \u014C sind Marken von Oura Health Oy und d\xFCrfen nicht ohne Genehmigung verwendet werden.",
    footer_medical_advisory_board: "Medizinisches Beratungsgremium",
    footer_membership: "Mitgliedschaft",
    footer_my_account: "My Account",
    footer_newsletter_submit_label: "E-Mail-Adresse f\xFCr Newsletter senden",
    footer_oura_on_the_web: "Oura on the Web",
    footer_partner_heading: "Partnerschaften",
    footer_press: "Presse",
    footer_privacy_policy: "Datenschutzerkl\xE4rung",
    footer_pulse_blog: "Blog \u201EThe Pulse\u201C",
    footer_security_center: "Sicherheit",
    footer_sizing: "Ringgr\xF6\xDFen",
    footer_social_heading: "Soziale Netzwerke",
    footer_social_icons_aria_label: "Unsere Social-Media-Kan\xE4le",
    footer_support_heading: "Support",
    footer_terms_and_conditions: "Allgemeine Gesch\xE4ftsbedingungen",
    footer_thanks_for_subscribing: "Danke f\xFCr dein Abonnement",
    for_business_link: "F\xFCr Unternehmen",
    for_organizations: "F\xFCr Unternehmen",
    gen4_is_here: "Der Oura Ring 4 ist da",
    header_hamburger_close_sr_label: "Mobile Navigation schlie\xDFen",
    header_hamburger_close_sr_label_2024: "Men\xFC-Navigation ausblenden",
    header_hamburger_open_sr_label: "Mobile Navigation \xF6ffnen",
    header_hamburger_open_sr_label_2024: "Men\xFC-Navigation einblenden",
    header_shop_now: "Jetzt kaufen",
    header_skip_to_content: "Zum Hauptbereich wechseln",
    heart_health_link: "Herzgesundheit",
    heart_rate_monitoring_link: "Herzfrequenzmessung",
    how_it_works_link: "So funktioniert Oura",
    impressum_page_title: "Impressum",
    instagram: "Instagram",
    integrations_link: "Integrationen",
    language_preference: "Spracheinstellung",
    menu: "Men\xFC",
    metabolic_health: "Metabolische Gesundheit",
    nav_experience: "Erfahrung",
    nav_health_features: "Gesundheitsfunktionen",
    nav_help_center: "Oura-Hilfe-Center",
    nav_shop_all_products: "Alle Produkte entdecken",
    nav_sizing_guide: "Anleitung zur Gr\xF6\xDFenbestimmung",
    nav_travel_case: "Oura Ring 4 Travel Case",
    newsroom_link: "Redaktion",
    oura_home_link: "Oura-Startseite",
    oura_membership: "Oura-Mitgliedschaft",
    oura_ring_4_ceramic: "Oura Ring 4 Ceramic",
    oura_ring_4_link: "Oura Ring 4 <sup>Neu</sup>",
    out_of_stock_tag: "Ausverkauft",
    partnerships_link: "Partnerschaften",
    pdp_selected_check_label: "Gew\xE4hlte Option",
    pdp_slideshow_thumbnail_label: "Gehe zu Folie {index}",
    pdp_style_ouraring4_cer: "Oura Ring 4 Ceramic",
    pinterest: "Pinterest",
    recycling_program_link: "Recyclingprogramm",
    ring_gen_4: "Oura Ring 4",
    ring_gen_4_cer: "Oura Ring 4 Ceramic",
    ring_gen3_on_sale: "Oura Ring Gen3 <sup>im Angebot</sup>",
    sale: "Angebot",
    sale_link: "Sonderangebot f\xFCr Oura Ring Gen3",
    science_and_research_link: "Forschung und Wissenschaft",
    shop: "Jetzt kaufen",
    shop_rings: "Ring kaufen",
    sleep_and_rest_link: "Schlaf und Erholung",
    slider_item_aria_label: "Folie {number} von {maxNumber}",
    stelo_glucose_biosensor: "Stelo Glukose-Biosensor",
    store_locator_distance: "{distanceInMiles} Meilen entfernt",
    store_locator_item_button_label: "{displayName} {storeName} auf der Karte anzeigen",
    store_locator_item_link_label: "{displayName} {storeName} auf Google Maps anzeigen (in neuem Tab/Fenster)",
    store_locator_location_closed: "Geschlossen",
    store_locator_location_open: "Ge\xF6ffnet bis {time}",
    store_locator_no_results: "Keine Gesch\xE4fte gefunden.",
    store_locator_number_results: "{number} Ergebnisse",
    store_locator_postal_code_pattern_error: "Bitte gib eine f\xFCnfstellige Postleitzahl f\xFCr die USA ein",
    store_locator_results_error: "Beim Abrufen von {storeName}-Standorten ist ein Fehler aufgetreten. Bitte aktualisiere die Seite und versuche es erneut oder kontaktiere unseren Kundensupport.",
    stress_link: "Stress",
    the_pulse: "The Pulse",
    tiktok: "TikTok",
    use_current_location_link: "Meinen aktuellen Standort verwenden",
    why_oura_link: "Warum Oura",
    womens_health_link: "Frauengesundheit",
    x: "X",
    youtube: "YouTube"
  },
  en: {
    activity_and_movement_link: "Activity and Movement",
    address_form_additional_address: "Additional Address",
    address_form_address: "Address",
    address_form_apt_suite: "Apt #, Suite, Floor",
    address_form_city: "City",
    address_form_city_town: "City/Town",
    address_form_city_ward_town_village: "City/Ward/Town/Village",
    address_form_country: "Country",
    address_form_county: "County",
    address_form_email: "Email",
    address_form_emirate: "Emirate",
    address_form_fname: "First Name",
    address_form_lname: "Last Name",
    address_form_max: "This field cannot exceed {number} characters",
    address_form_min: "This field must be at least {number} characters",
    address_form_phone: "Phone Number",
    address_form_postal: "Postal Code",
    address_form_postcode: "Postcode",
    address_form_prefecture: "Prefecture",
    address_form_province: "Province",
    address_form_region: "Region",
    address_form_required: "This field is required",
    address_form_state: "State",
    address_form_state_province_region: "State/Province/Region",
    address_form_state_territory: "State/Territory",
    address_form_street_house_number: "Street and House Number",
    address_form_suburb: "Suburb/Town",
    address_form_zip: "Zip Code",
    available_day: "Available {day}",
    best_buy_store_locator_legend_text: "Best Buy in-store Oura Experience",
    bfcm_2024_home_hero_title: "Our lowest<break></break>price <em>ever</em>",
    bfcm_2024_menu_card_dyn_price_description: "Up to {amount} off MSRP on<break></break>Oura Ring Gen3.",
    business_gallery_gift_card_title: "Gift cards",
    carousel_current_slide_label: "(Current slide)",
    carousel_live_region_text: "Item {activeIndex} of {slideCount}",
    carousel_next_slide_label: "Next item",
    carousel_page_dot_label: "Item {index}",
    carousel_previous_slide_label: "Previous item",
    cart: "Cart",
    cart_count_sr_label: "There {count, plural, =0 {are no items} =1 {is one item} other {are # items}} in your cart",
    checkout_form_country: "Country",
    checkout_form_emailformat: "Incorrect email format",
    checkout_form_emailformat_custom: "Incorrect email format",
    checkout_form_phoneinvalid: "Phone number invalid or country code missing",
    checkout_form_postal_code_pattern: "Postal code may contain no more than 9 letter or number characters.",
    checkout_form_postal_code_string: "Postal code can only contain letters, numbers, spaces, and hyphens",
    checkout_form_postal_required: "Postal Code is required",
    checkout_form_zip: "Postal Code",
    checkout_input_click_to_show_label: "Add {inputLabel}",
    checkout_pickup_details_plural_units_left: "Only {quantity} units left",
    checkout_pickup_details_ready_in_time: "Ready in {time}",
    checkout_pickup_details_single_unit_left: "Only 1 unit left",
    close: "Close",
    comparison_slider_control_label: "Drag or use the left and right arrow keys to compare",
    drop_down_extra_charger: "Extra Charger",
    drop_down_gift_card: "Gift Card",
    drop_down_oura_ring: "Oura Ring",
    explore_how_it_works_link: "Explore How It Works",
    explore_why_oura_link: "Explore Why Oura",
    facebook: "Facebook",
    fcc_compliance_link: "FCC Compliance",
    flexible_spending_footer_link: "Flexible Spending",
    floating_bar_oura_ring_4_ceramic: "Oura Ring 4 <breakSm></breakSm>Ceramic",
    footer_about_us: "About Us",
    footer_accessibility: "Accessibility",
    footer_all_rights_reserved: "Ouraring Inc. | All Rights Reserved",
    footer_blog_heading: "Blog",
    footer_careers: "Careers",
    footer_company_heading: "Our Company",
    footer_connect: "Connect",
    footer_contact: "Contact",
    footer_copyright: "\u014CURA, OURA, OURA RING, and \u014C are trademarks of Oura Health Oy and may not be used without permission.",
    footer_dataprotect_1: "We care about protecting your data.",
    footer_dataprotect_privacy_policy: "Read more in our <PrivacyPolicyLink>Privacy Policy</PrivacyPolicyLink>.",
    footer_developers: "Developers",
    footer_email: "Email address",
    footer_email_input_heading: "Receive articles, tips, and offers from Oura",
    footer_email_validation_error: "Please enter a valid email address",
    footer_help: "Help",
    footer_image_cta: "Start your health<em>journey today</em>",
    footer_ip_notice: "IP Notice",
    footer_leadership: "Leadership",
    footer_legal_aria_label: "Footer legal",
    footer_legal_link_v4: "\xA9  2025 Oura Health Oy. All rights reserved. \u014CURA, OURA, and \u014C are trademarks of Oura Health Oy and may not be used without permission.",
    footer_medical_advisory_board: "Medical Advisory Board",
    footer_membership: "Membership",
    footer_my_account: "My Account",
    footer_newsletter_submit_label: "submit email for newsletter",
    footer_oura_on_the_web: "Oura on the Web",
    footer_partner_heading: "Partner With Us",
    footer_press: "Press",
    footer_privacy_policy: "Privacy Policy",
    footer_pulse_blog: "The Pulse Blog",
    footer_security_center: "Security Center",
    footer_sizing: "Sizing",
    footer_social_heading: "Social",
    footer_social_icons_aria_label: "Oura social media",
    footer_support_heading: "Support",
    footer_terms_and_conditions: "Terms & Conditions",
    footer_thanks_for_subscribing: "Thanks for subscribing",
    for_business_link: "For Business",
    for_organizations: "For Organizations",
    gen4_is_here: "Oura Ring 4<em>is here</em>",
    header_hamburger_close_sr_label: "Close mobile navigation",
    header_hamburger_close_sr_label_2024: "Close header menu navigation",
    header_hamburger_open_sr_label: "Open mobile navigation",
    header_hamburger_open_sr_label_2024: "Open header menu navigation",
    header_shop_now: "Shop Now",
    header_skip_to_content: "Skip Navigation to Main Content",
    heart_health_link: "Heart Health",
    heart_rate_monitoring_link: "Heart Rate Monitoring",
    how_it_works_link: "How It Works",
    impressum_page_title: "Impressum",
    instagram: "Instagram",
    integrations_link: "Integrations",
    language_preference: "Language Preference",
    menu: "Menu",
    metabolic_health: "Metabolic Health",
    nav_experience: "Experience",
    nav_health_features: "Health Features",
    nav_help_center: "Help Center",
    nav_shop_all_products: "Shop all products",
    nav_sizing_guide: "Sizing Guide",
    nav_travel_case: "Oura Ring 4 Travel Case",
    newsroom_link: "Newsroom",
    oura_home_link: "Oura home",
    oura_membership: "Oura Membership",
    oura_ring_4_ceramic: "Oura Ring 4 Ceramic",
    oura_ring_4_link: "Oura Ring 4 <sup>New</sup>",
    out_of_stock_tag: "Out of stock",
    partnerships_link: "Partnerships",
    pdp_selected_check_label: "Chosen option",
    pdp_slideshow_thumbnail_label: "Go to slide {index}",
    pdp_style_ouraring4_cer: "Oura Ring 4 Ceramic",
    pinterest: "Pinterest",
    recycling_program_link: "Recycling Program",
    ring_gen_4: "Oura Ring 4",
    ring_gen_4_cer: "Oura Ring 4 Ceramic",
    ring_gen3_on_sale: "Oura Ring Gen3 <sup>On Sale</sup>",
    sale: "Sale",
    sale_link: "Sale on Oura Ring Gen3",
    science_and_research_link: "Science and Research",
    shop: "Shop",
    shop_rings: "Shop Rings",
    sleep_and_rest_link: "Sleep and Rest",
    slider_item_aria_label: "slide {number} of {maxNumber}",
    stelo_glucose_biosensor: "Stelo Glucose Biosensor",
    store_locator_distance: "{distanceInMiles} miles away",
    store_locator_item_button_label: "View {displayName} {storeName} on the map",
    store_locator_item_link_label: "View {displayName} {storeName} in Google Maps (opens in new tab/window)",
    store_locator_location_closed: "Closed",
    store_locator_location_open: "Open until {time}",
    store_locator_no_results: "No results found.",
    store_locator_number_results: "{number} Results",
    store_locator_postal_code_pattern_error: "Please enter a five-digit US postal code",
    store_locator_results_error: "There was an error finding nearby {storeName} locations. Please refresh the page and try again or contact customer support.",
    stress_link: "Stress",
    the_pulse: "The Pulse",
    tiktok: "TikTok",
    use_current_location_link: "Use my current location",
    why_oura_link: "Why Oura",
    womens_health_link: "Women's Health",
    x: "X",
    youtube: "YouTube"
  },
  es: {
    activity_and_movement_link: "Actividad y movimiento",
    address_form_additional_address: "Direcci\xF3n adicional",
    address_form_address: "Direcci\xF3n",
    address_form_apt_suite: "Portal, piso, puerta",
    address_form_city: "Municipio",
    address_form_city_town: "Municipio",
    address_form_city_ward_town_village: "Ciudad/Barrio/Pueblo/Aldea",
    address_form_country: "Pa\xEDs",
    address_form_county: "Condado",
    address_form_email: "Correo electr\xF3nico",
    address_form_emirate: "Emirato",
    address_form_fname: "Nombre",
    address_form_lname: "Apellidos",
    address_form_max: "Este campo no puede contener m\xE1s de {number} caracteres",
    address_form_min: "Este campo debe contener al menos {number} caracteres",
    address_form_phone: "N\xFAmero de tel\xE9fono",
    address_form_postal: "C\xF3digo postal",
    address_form_postcode: "C\xF3digo postal",
    address_form_prefecture: "Prefectura",
    address_form_province: "Provincia",
    address_form_region: "Regi\xF3n",
    address_form_required: "Este campo es obligatorio",
    address_form_state: "Provincia",
    address_form_state_province_region: "Estado/Provincia/Regi\xF3n",
    address_form_state_territory: "Estado/Territorio",
    address_form_street_house_number: "Direcci\xF3n",
    address_form_suburb: "Barrio/Ciudad",
    address_form_zip: "C\xF3digo postal",
    available_day: "Disponible: {day}",
    best_buy_store_locator_legend_text: "Experiencia Oura en las tiendas Best Buy",
    bfcm_2024_home_hero_title: "Nuestro<break></break>precio <em>m\xE1s bajo</em>",
    bfcm_2024_menu_card_dyn_price_description: "Hasta {amount} de descuento<break></break>en el Oura Ring Gen3.",
    business_gallery_gift_card_title: "Tarjetas regalo",
    carousel_current_slide_label: "(Diapositiva actual)",
    carousel_live_region_text: "Elemento {activeIndex} de {slideCount}",
    carousel_next_slide_label: "Siguiente elemento",
    carousel_page_dot_label: "Elemento {index}",
    carousel_previous_slide_label: "Elemento anterior",
    cart: "Carrito",
    cart_count_sr_label: "{count, plural, =0 {No hay ning\xFAn art\xEDculo} =1 {Hay un art\xEDculo} other {Hay # art\xEDculos}} en el carrito",
    checkout_form_country: "Pa\xEDs",
    checkout_form_emailformat: "Formato de correo electr\xF3nico incorrecto",
    checkout_form_emailformat_custom: "Formato de correo electr\xF3nico incorrecto",
    checkout_form_phoneinvalid: "El n\xFAmero de tel\xE9fono no es v\xE1lido o falta el prefijo del pa\xEDs",
    checkout_form_postal_code_pattern: "El c\xF3digo postal no puede tener m\xE1s de 9 caracteres (letras o n\xFAmeros)",
    checkout_form_postal_code_string: "El c\xF3digo postal solo puede contener letras, n\xFAmeros, espacios y guiones",
    checkout_form_postal_required: "Debes indicar el c\xF3digo postal",
    checkout_form_zip: "C\xF3digo postal",
    checkout_input_click_to_show_label: "A\xF1adir {inputLabel}",
    checkout_pickup_details_plural_units_left: "Solo quedan {quantity} unidades",
    checkout_pickup_details_ready_in_time: "Listo en {time}",
    checkout_pickup_details_single_unit_left: "Solo queda 1 unidad",
    close: "Cerrar",
    comparison_slider_control_label: "Arrastra con el rat\xF3n o usa las flechas de derecha e izquierda del teclado para comparar",
    drop_down_extra_charger: "Cargador adicional",
    drop_down_gift_card: "Tarjeta regalo",
    drop_down_oura_ring: "Oura Ring",
    explore_how_it_works_link: 'Explorar "C\xF3mo funciona"',
    explore_why_oura_link: 'Explorar "Por qu\xE9 Oura"',
    facebook: "Facebook",
    fcc_compliance_link: "FCC Compliance",
    flexible_spending_footer_link: "Gastos flexibles",
    floating_bar_oura_ring_4_ceramic: "Oura Ring 4 <breakSm></breakSm>Ceramic",
    footer_about_us: "Qui\xE9nes somos",
    footer_accessibility: "Accesibilidad",
    footer_all_rights_reserved: "Ouraring Inc. | Todos los derechos reservados",
    footer_blog_heading: "Blog",
    footer_careers: "Trabaja con nosotros",
    footer_company_heading: "Nuestra empresa",
    footer_connect: "S\xEDguenos",
    footer_contact: "Contacto",
    footer_copyright: "\u014CURA, OURA, OURA RING y \u014C son marcas registradas de Oura Health Oy y no se pueden utilizar sin autorizaci\xF3n.",
    footer_dataprotect_1: "Para nosotros, proteger tus datos es una prioridad.",
    footer_dataprotect_privacy_policy: "Encontrar\xE1s m\xE1s informaci\xF3n en nuestra <PrivacyPolicyLink>Pol\xEDtica de Privacidad</PrivacyPolicyLink>.",
    footer_developers: "Desarrolladores",
    footer_email: "Direcci\xF3n de correo electr\xF3nico",
    footer_email_input_heading: "Recibe art\xEDculos, consejos y ofertas de Oura",
    footer_email_validation_error: "Introduce una direcci\xF3n de correo electr\xF3nico v\xE1lida",
    footer_help: "Ayuda",
    footer_image_cta: "Empieza hoy mismo a monitorizar tu salud",
    footer_ip_notice: "Aviso de Propiedad Intelectual",
    footer_leadership: "Equipo directivo",
    footer_legal_aria_label: "Aviso legal",
    footer_legal_link_v4: "\xA9 2025 Oura Health Oy. Todos los derechos reservados. \u014CURA, OURA y \u014C son marcas comerciales de Oura Health Oy y est\xE1 prohibido usarlas sin permiso.",
    footer_medical_advisory_board: "Junta de asesoramiento m\xE9dico",
    footer_membership: "Suscripci\xF3n",
    footer_my_account: "My Account",
    footer_newsletter_submit_label: "enviar correo electr\xF3nico para la newsletter",
    footer_oura_on_the_web: "Oura on the Web",
    footer_partner_heading: "Colabora con nosotros",
    footer_press: "Prensa",
    footer_privacy_policy: "Pol\xEDtica de Privacidad",
    footer_pulse_blog: "Blog The Pulse",
    footer_security_center: "Centro de Seguridad",
    footer_sizing: "Tallaje",
    footer_social_heading: "Redes sociales",
    footer_social_icons_aria_label: "Oura en las redes sociales",
    footer_support_heading: "Recursos",
    footer_terms_and_conditions: "T\xE9rminos y Condiciones",
    footer_thanks_for_subscribing: "Gracias por suscribirte",
    for_business_link: "Para empresas",
    for_organizations: "Para organizaciones",
    gen4_is_here: "Ya est\xE1 aqu\xED el Oura Ring 4",
    header_hamburger_close_sr_label: "Cerrar la navegaci\xF3n m\xF3vil",
    header_hamburger_close_sr_label_2024: "Cerrar men\xFA de cabecera de navegaci\xF3n",
    header_hamburger_open_sr_label: "Abrir la navegaci\xF3n m\xF3vil",
    header_hamburger_open_sr_label_2024: "Abrir men\xFA de cabecera de navegaci\xF3n",
    header_shop_now: "Comprar ahora",
    header_skip_to_content: "Omitir la navegaci\xF3n al contenido principal",
    heart_health_link: "Salud card\xEDaca",
    heart_rate_monitoring_link: "Seguimiento de la frecuencia card\xEDaca",
    how_it_works_link: "C\xF3mo funciona",
    impressum_page_title: "Impressum",
    instagram: "Instagram",
    integrations_link: "Integraciones",
    language_preference: "Selecciona un idioma",
    menu: "Men\xFA",
    metabolic_health: "Salud metab\xF3lica",
    nav_experience: "Experiencia",
    nav_health_features: "Funciones de salud",
    nav_help_center: "Centro de Ayuda",
    nav_shop_all_products: "Ver todos los productos",
    nav_sizing_guide: "Gu\xEDa de tallaje",
    nav_travel_case: "Oura Ring 4 Travel Case",
    newsroom_link: "Prensa",
    oura_home_link: "P\xE1gina inicial de Oura",
    oura_membership: "Suscripci\xF3n a Oura",
    oura_ring_4_ceramic: "Oura Ring 4 Ceramic",
    oura_ring_4_link: "Oura Ring 4 <sup>Novedad</sup>",
    out_of_stock_tag: "Existencias agotadas",
    partnerships_link: "Colaboraciones",
    pdp_selected_check_label: "Opci\xF3n seleccionada",
    pdp_slideshow_thumbnail_label: "Ir a la diapositiva {index}",
    pdp_style_ouraring4_cer: "Oura Ring 4 Ceramic",
    pinterest: "Pinterest",
    recycling_program_link: "Programa de reciclaje",
    ring_gen_4: "Anillo Oura Ring 4",
    ring_gen_4_cer: "Oura Ring 4 Ceramic",
    ring_gen3_on_sale: "Oura Ring Gen3 <sup>en oferta</sup>",
    sale: "Oferta",
    sale_link: "Descuentos en el Oura Ring Gen3",
    science_and_research_link: "Ciencia e investigaci\xF3n",
    shop: "Comprar",
    shop_rings: "Comprar anillos",
    sleep_and_rest_link: "Sue\xF1o y descanso",
    slider_item_aria_label: "diapositiva {number} de {maxNumber}",
    stelo_glucose_biosensor: "Biosensor de glucosa Stelo",
    store_locator_distance: "A {distanceInMiles} millas",
    store_locator_item_button_label: "Ver {displayName} {storeName} en el mapa",
    store_locator_item_link_label: "Ver {displayName} {storeName} en Google Maps (se abre en otra pesta\xF1a/ventana)",
    store_locator_location_closed: "Cerrado",
    store_locator_location_open: "Abierto hasta las {time}",
    store_locator_no_results: "No hemos obtenido ning\xFAn resultado.",
    store_locator_number_results: "{number} resultados",
    store_locator_postal_code_pattern_error: "Introduce un c\xF3digo postal de cinco d\xEDgitos de EE.\xA0UU.",
    store_locator_results_error: "Se ha producido un error al buscar tiendas {storeName} cerca de tu ubicaci\xF3n. Actualiza la p\xE1gina y vuelve a intentarlo o ponte en contacto con el servicio de atenci\xF3n al cliente.",
    stress_link: "Estr\xE9s",
    the_pulse: "The Pulse",
    tiktok: "TikTok",
    use_current_location_link: "Utilizar mi ubicaci\xF3n actual",
    why_oura_link: "Por qu\xE9 Oura",
    womens_health_link: "Salud de la mujer",
    x: "X",
    youtube: "YouTube"
  },
  fi: {
    activity_and_movement_link: "Aktiivisuus ja liike",
    address_form_additional_address: "Osoite",
    address_form_address: "Osoite",
    address_form_apt_suite: "Asunnon nro, kerros",
    address_form_city: "Kaupunki",
    address_form_city_town: "Kaupunki",
    address_form_city_ward_town_village: "Kaupunki/Hallintoalue/Kyl\xE4",
    address_form_country: "Maa",
    address_form_county: "Piirikunta",
    address_form_email: "S\xE4hk\xF6posti",
    address_form_emirate: "Emiraatti",
    address_form_fname: "Etunimi",
    address_form_lname: "Sukunimi",
    address_form_max: "T\xE4ss\xE4 kent\xE4ss\xE4 ei voi olla enemp\xE4\xE4 kuin {number} merkki\xE4",
    address_form_min: "T\xE4ss\xE4 kent\xE4ss\xE4 t\xE4ytyy olla v\xE4hint\xE4\xE4n {number} merkki\xE4",
    address_form_phone: "Puhelinnumero",
    address_form_postal: "Postinumero",
    address_form_postcode: "Postinumero",
    address_form_prefecture: "Prefektuuri",
    address_form_province: "Provinssi",
    address_form_region: "Alue",
    address_form_required: "T\xE4m\xE4 kentt\xE4 on pakollinen",
    address_form_state: "Osavaltio",
    address_form_state_province_region: "Osavaltio/Provinssi/Alue",
    address_form_state_territory: "Osavaltio/Territorio",
    address_form_street_house_number: "Kadun ja talon numero",
    address_form_suburb: "Kaupunki",
    address_form_zip: "Postinumero",
    available_day: "Noudettavissa {day}",
    best_buy_store_locator_legend_text: "Oura Ringit nyt Best Buy -myym\xE4l\xF6ist\xE4",
    bfcm_2024_home_hero_title: "Edullisin<break></break>hintamme <em>koskaan</em>",
    bfcm_2024_menu_card_dyn_price_description: "Jopa {amount} alennusta <break></break>Oura Ring Gen3:n ohjev\xE4hitt\xE4ishinnasta.",
    business_gallery_gift_card_title: "Lahjakortit",
    carousel_current_slide_label: "(Nykyinen dia)",
    carousel_live_region_text: "Kohde {activeIndex} / {slideCount}",
    carousel_next_slide_label: "Seuraava kohde",
    carousel_page_dot_label: "Kohde {index}",
    carousel_previous_slide_label: "Edellinen kohde",
    cart: "Ostoskori",
    cart_count_sr_label: "Ostoskorissasi {count, plural, =0 {ei ole yht\xE4\xE4n tuotetta} =1 {on yksi tuote} other {on # tuotetta}}",
    checkout_form_country: "Maa",
    checkout_form_emailformat: "Virheellinen s\xE4hk\xF6postimuoto",
    checkout_form_emailformat_custom: "Virheellinen s\xE4hk\xF6postimuoto",
    checkout_form_phoneinvalid: "Puhelinnumero on virheellinen tai maatunnus puuttuu",
    checkout_form_postal_code_pattern: "Postinumero saa sis\xE4lt\xE4\xE4 enint\xE4\xE4n 9 kirjainta tai numeroa.",
    checkout_form_postal_code_string: "Postinumero voi sis\xE4lt\xE4\xE4 vain kirjaimia, numeroita, v\xE4lily\xF6ntej\xE4 ja yhdysmerkkej\xE4",
    checkout_form_postal_required: "Postinumero on pakollinen tieto",
    checkout_form_zip: "Postinumero",
    checkout_input_click_to_show_label: "Lis\xE4\xE4 {inputLabel}",
    checkout_pickup_details_plural_units_left: "Vain {quantity} kpl j\xE4ljell\xE4",
    checkout_pickup_details_ready_in_time: "Valmis {time}",
    checkout_pickup_details_single_unit_left: "Vain 1 kpl j\xE4ljell\xE4",
    close: "Sulje",
    comparison_slider_control_label: "Vertaa malleja vet\xE4m\xE4ll\xE4 tai nuolin\xE4pp\xE4imi\xE4 k\xE4ytt\xE4en",
    drop_down_extra_charger: "Lis\xE4laturi",
    drop_down_gift_card: "Lahjakortti",
    drop_down_oura_ring: "Oura Ring",
    explore_how_it_works_link: "Tutki, kuinka se toimii",
    explore_why_oura_link: "Lue, miksi juuri Oura",
    facebook: "Facebook",
    fcc_compliance_link: "FCC Compliance",
    flexible_spending_footer_link: "Flexible Spending",
    floating_bar_oura_ring_4_ceramic: "Oura Ring 4 <breakSm></breakSm>Ceramic",
    footer_about_us: "Tietoa meist\xE4",
    footer_accessibility: "Saavutettavuus",
    footer_all_rights_reserved: "Ouraring Inc. | Kaikki oikeudet pid\xE4tet\xE4\xE4n",
    footer_blog_heading: "Blogi",
    footer_careers: "Avoimet ty\xF6paikat",
    footer_company_heading: "Yritys",
    footer_connect: "Yhdist\xE4",
    footer_contact: "Yhteystiedot",
    footer_copyright: "\u014CURA, OURA, OURA RING ja \u014C ovat Oura Health Oy:n tavaramerkkej\xE4, ja niiden k\xE4ytt\xE4minen ilman lupaa on kielletty.",
    footer_dataprotect_1: "Tietojesi suojaaminen on meille t\xE4rke\xE4\xE4.",
    footer_dataprotect_privacy_policy: "Lue lis\xE4\xE4 <PrivacyPolicyLink>Tietosuojaselosteestamme</PrivacyPolicyLink>.",
    footer_developers: "Kehitt\xE4j\xE4t",
    footer_email: "S\xE4hk\xF6postiosoite",
    footer_email_input_heading: "Haluan saada Ouran uusimmat artikkelit, vinkit ja tarjoukset",
    footer_email_validation_error: "Sy\xF6t\xE4 kelvollinen s\xE4hk\xF6postiosoite",
    footer_help: "Tuki",
    footer_image_cta: "Aloita t\xE4n\xE4\xE4n matkasi kohti parempaa terveytt\xE4",
    footer_ip_notice: "Immateriaalioikeudet",
    footer_leadership: "Johtoryhm\xE4",
    footer_legal_aria_label: "Alatunniste, legal",
    footer_legal_link_v4: "\xA9 2025 Oura Health Oy. Kaikki oikeudet pid\xE4tet\xE4\xE4n. \u014CURA, OURA ja \u014C ovat Oura Health Oy:n tavaramerkkej\xE4, eik\xE4 niit\xE4 saa k\xE4ytt\xE4\xE4 ilman lupaa.",
    footer_medical_advisory_board: "L\xE4\xE4ketieteellinen neuvottelukunta",
    footer_membership: "J\xE4senyys",
    footer_my_account: "My Account",
    footer_newsletter_submit_label: "sy\xF6t\xE4 s\xE4hk\xF6postisoite ja tilaa uutiskirje",
    footer_oura_on_the_web: "Oura on the Web",
    footer_partner_heading: "Ryhdy kumppaniksemme",
    footer_press: "Lehdist\xF6lle",
    footer_privacy_policy: "Tietosuojaseloste",
    footer_pulse_blog: "The Pulse -blogi",
    footer_security_center: "Tietoturvakeskus",
    footer_sizing: "Koon valinta",
    footer_social_heading: "Sosiaalinen media",
    footer_social_icons_aria_label: "Oura sosiaalisessa mediassa",
    footer_support_heading: "Tuki",
    footer_terms_and_conditions: "K\xE4ytt\xF6ehdot",
    footer_thanks_for_subscribing: "Kiitos tilauksesta",
    for_business_link: "Yrityksille",
    for_organizations: "Yrityksille",
    gen4_is_here: "Oura Ring 4 on t\xE4\xE4ll\xE4",
    header_hamburger_close_sr_label: "Sulje navigointi",
    header_hamburger_close_sr_label_2024: "Sulje yl\xE4tunnisteen valikko",
    header_hamburger_open_sr_label: "Avaa navigointi",
    header_hamburger_open_sr_label_2024: "Avaa yl\xE4tunnisteen valikko",
    header_shop_now: "Osta nyt",
    header_skip_to_content: "Siirry p\xE4\xE4sis\xE4lt\xF6\xF6n",
    heart_health_link: "Syd\xE4men terveys",
    heart_rate_monitoring_link: "Sykkeenseuranta",
    how_it_works_link: "Miten se toimii",
    impressum_page_title: "Impressum",
    instagram: "Instagram",
    integrations_link: "Integraatiot",
    language_preference: "Kielivalinta",
    menu: "Valikko",
    metabolic_health: "Aineenvaihdunnan terveys",
    nav_experience: "Tutustu",
    nav_health_features: "Terveysominaisuudet",
    nav_help_center: "Oura Tuki",
    nav_shop_all_products: "Osta kaikkia tuotteita",
    nav_sizing_guide: "Sovitusopas",
    nav_travel_case: "Oura Ring 4 Travel Case",
    newsroom_link: "Uutishuone",
    oura_home_link: "Etusivu",
    oura_membership: "Oura-j\xE4senyys",
    oura_ring_4_ceramic: "Oura Ring 4 Ceramic",
    oura_ring_4_link: "Oura Ring 4 <sup>Uusi</sup>",
    out_of_stock_tag: "Loppu varastosta",
    partnerships_link: "Kumppanuudet",
    pdp_selected_check_label: "Valittu vaihtoehto",
    pdp_slideshow_thumbnail_label: "Siirry diaan {index}",
    pdp_style_ouraring4_cer: "Oura Ring 4 Ceramic",
    pinterest: "Pinterest",
    recycling_program_link: "Kierr\xE4tysohjelma",
    ring_gen_4: "Oura Ring 4",
    ring_gen_4_cer: "Oura Ring 4 Ceramic",
    ring_gen3_on_sale: "Oura Ring Gen3 <sup>alennusmyynniss\xE4</sup>",
    sale: "Alennusmyynti",
    sale_link: "Oura Ring Gen3 nyt tarjouksessa",
    science_and_research_link: "Tiede ja tutkimus",
    shop: "Ostoksille",
    shop_rings: "Osta sormuksia",
    sleep_and_rest_link: "Uni ja lepo",
    slider_item_aria_label: "dia {number} / {maxNumber}",
    stelo_glucose_biosensor: "Stelo Glucose Biosensor",
    store_locator_distance: "{distanceInMiles} mailin p\xE4\xE4ss\xE4",
    store_locator_item_button_label: "N\xE4yt\xE4 {displayName} {storeName} kartalla",
    store_locator_item_link_label: "N\xE4yt\xE4 {displayName} {storeName} Google Mapsissa (avautuu uuteen v\xE4lilehteen/ikkunaan)",
    store_locator_location_closed: "Suljettu",
    store_locator_location_open: "Avoinna klo {time} saakka",
    store_locator_no_results: "Tuloksia ei l\xF6ytynyt.",
    store_locator_number_results: "{number} tulosta",
    store_locator_postal_code_pattern_error: "Sy\xF6t\xE4 viisinumeroinen USA:n postinumero",
    store_locator_results_error: "L\xE4himpien {storeName} -myym\xE4l\xF6iden etsinn\xE4ss\xE4 tapahtui virhe. P\xE4ivit\xE4 sivu ja yrit\xE4 uudelleen tai ota yhteytt\xE4 asiakastukeen.",
    stress_link: "Stressi",
    the_pulse: "The Pulse",
    tiktok: "TikTok",
    use_current_location_link: "K\xE4yt\xE4 nykyist\xE4 sijaintiani",
    why_oura_link: "Miksi juuri Oura?",
    womens_health_link: "Naisen terveys",
    x: "X",
    youtube: "YouTube"
  },
  fr: {
    activity_and_movement_link: "Activit\xE9 et mouvement",
    address_form_additional_address: "Compl\xE9ment d'adresse",
    address_form_address: "Adresse",
    address_form_apt_suite: "Num\xE9ro d'appartement, bureau, \xE9tage",
    address_form_city: "Ville",
    address_form_city_town: "Ville/localit\xE9",
    address_form_city_ward_town_village: "Ville/arrondissement/localit\xE9/village",
    address_form_country: "Pays",
    address_form_county: "Comt\xE9",
    address_form_email: "Adresse e-mail",
    address_form_emirate: "\xC9mirat",
    address_form_fname: "Pr\xE9nom",
    address_form_lname: "Nom de famille",
    address_form_max: "Le contenu de ce champ ne peut pas d\xE9passer {number}\xA0caract\xE8res",
    address_form_min: "Ce champ doit contenir au moins {number}\xA0caract\xE8res",
    address_form_phone: "Num\xE9ro de t\xE9l\xE9phone",
    address_form_postal: "Code postal",
    address_form_postcode: "Code postal",
    address_form_prefecture: "Pr\xE9fecture",
    address_form_province: "Province/Canton",
    address_form_region: "R\xE9gion",
    address_form_required: "Ce champ est obligatoire",
    address_form_state: "\xC9tat",
    address_form_state_province_region: "\xC9tat/province/r\xE9gion",
    address_form_state_territory: "\xC9tat/territoire",
    address_form_street_house_number: "Rue et num\xE9ro",
    address_form_suburb: "Banlieue/localit\xE9",
    address_form_zip: "Code postal",
    available_day: "Disponible\xA0: {day}",
    best_buy_store_locator_legend_text: "L'exp\xE9rience Oura dans un magasin Best Buy",
    bfcm_2024_home_hero_title: "Notre prix<break></break>le plus bas <em>jamais atteint</em>",
    bfcm_2024_menu_card_dyn_price_description: "Jusqu\u2019\xE0 {amount} de remise sur le prix de vente conseill\xE9 de<break></break>l\u2019anneau Oura Ring Gen3.",
    business_gallery_gift_card_title: "Cartes cadeaux",
    carousel_current_slide_label: "(diapo en cours)",
    carousel_live_region_text: "\xC9l\xE9ment {activeIndex} sur {slideCount}",
    carousel_next_slide_label: "\xC9l\xE9ment suivant",
    carousel_page_dot_label: "\xC9l\xE9ment {index}",
    carousel_previous_slide_label: "\xC9l\xE9ment pr\xE9c\xE9dent",
    cart: "Panier",
    cart_count_sr_label: "Votre panier contient {count, plural, =0 {are no items} =1 {is one item} other {are # items}} article(s)",
    checkout_form_country: "Pays",
    checkout_form_emailformat: "Le format de l'adresse e-mail est incorrect.",
    checkout_form_emailformat_custom: "Le format de l'adresse e-mail est incorrect.",
    checkout_form_phoneinvalid: "Num\xE9ro de t\xE9l\xE9phone non valide et code pays manquant",
    checkout_form_postal_code_pattern: "Le code postal ne doit pas contenir plus de 9\xA0lettres ou chiffres.",
    checkout_form_postal_code_string: "Le code postal ne peut contenir que des lettres, des chiffres, des espaces et des traits d'union.",
    checkout_form_postal_required: "Vous devez saisir un code postal",
    checkout_form_zip: "Code postal",
    checkout_input_click_to_show_label: "Ajouter {inputLabel}",
    checkout_pickup_details_plural_units_left: "Il ne reste que {quantity}\xA0articles",
    checkout_pickup_details_ready_in_time: "Commande pr\xEAte dans {time}",
    checkout_pickup_details_single_unit_left: "Il ne reste qu'un article",
    close: "Fermer",
    comparison_slider_control_label: "Faire glisser ou utiliser les touches fl\xE9ch\xE9es gauche et droite pour comparer",
    drop_down_extra_charger: "Chargeur suppl\xE9mentaire",
    drop_down_gift_card: "Carte cadeau",
    drop_down_oura_ring: "Oura Ring",
    explore_how_it_works_link: "Acc\xE9der \xE0 Fonctionnement d'Oura",
    explore_why_oura_link: "Acc\xE9der \xE0 Pourquoi choisir Oura\xA0?",
    facebook: "Facebook",
    fcc_compliance_link: "FCC Compliance",
    flexible_spending_footer_link: "D\xE9penses flexibles",
    floating_bar_oura_ring_4_ceramic: "Oura Ring\xA04 <breakSm></breakSm>Ceramic",
    footer_about_us: "\xC0 propos",
    footer_accessibility: "Accessibilit\xE9",
    footer_all_rights_reserved: "Ouraring Inc. | Tous droits r\xE9serv\xE9s.",
    footer_blog_heading: "Blog",
    footer_careers: "Carri\xE8res",
    footer_company_heading: "Notre soci\xE9t\xE9",
    footer_connect: "Suivez-nous",
    footer_contact: "Contact",
    footer_copyright: "\u014CURA, OURA, OURA RING et \u014C sont des marques d'Oura\xA0Health\xA0Oy qui ne peuvent \xEAtre utilis\xE9es sans autorisation.",
    footer_dataprotect_1: "Nous avons \xE0 c\u0153ur de prot\xE9ger vos donn\xE9es.",
    footer_dataprotect_privacy_policy: "Pour en savoir plus, consultez notre <PrivacyPolicyLink>politique de confidentialit\xE9</PrivacyPolicyLink>.",
    footer_developers: "D\xE9veloppeurs",
    footer_email: "Adresse e-mail",
    footer_email_input_heading: "Recevez des articles, conseils et offres d'Oura",
    footer_email_validation_error: "Veuillez saisir une adresse e-mail valide",
    footer_help: "Aide",
    footer_image_cta: "Commencez d\xE8s maintenant \xE0 prendre soin de vous",
    footer_ip_notice: "Avis de propri\xE9t\xE9 intellectuelle",
    footer_leadership: "Leadership",
    footer_legal_aria_label: "Informations l\xE9gales en pied de page",
    footer_legal_link_v4: "\xA9 2025 Oura Health Oy. Tous droits r\xE9serv\xE9s. \u014CURA, OURA et \u014C sont des marques d\xE9pos\xE9es d'Oura Health Oy et ne peuvent \xEAtre utilis\xE9es sans autorisation.",
    footer_medical_advisory_board: "Comit\xE9 m\xE9dical consultatif",
    footer_membership: "Abonnement",
    footer_my_account: "My Account",
    footer_newsletter_submit_label: "S'inscrire pour recevoir la newsletter",
    footer_oura_on_the_web: "Oura on the Web",
    footer_partner_heading: "Collaboration",
    footer_press: "Presse",
    footer_privacy_policy: "Politique de confidentialit\xE9",
    footer_pulse_blog: "Blog The Pulse",
    footer_security_center: "Centre de s\xE9curit\xE9",
    footer_sizing: "Choisir sa taille",
    footer_social_heading: "Suivez-nous sur",
    footer_social_icons_aria_label: "R\xE9seaux sociaux d\u2019Oura",
    footer_support_heading: "Assistance",
    footer_terms_and_conditions: "Conditions d'utilisation",
    footer_thanks_for_subscribing: "Merci de votre inscription",
    for_business_link: "Pour les entreprises",
    for_organizations: "Pour les organisations",
    gen4_is_here: "L'Oura Ring 4 est arriv\xE9",
    header_hamburger_close_sr_label: "Sortir de la navigation mobile",
    header_hamburger_close_sr_label_2024: "Sortir de la navigation du menu d'en-t\xEAte",
    header_hamburger_open_sr_label: "Acc\xE9der \xE0 la navigation mobile",
    header_hamburger_open_sr_label_2024: "Acc\xE9der \xE0 la navigation du menu d'en-t\xEAte",
    header_shop_now: "Acheter",
    header_skip_to_content: "Ignorer la navigation pour acc\xE9der au contenu principal",
    heart_health_link: "Sant\xE9 cardiaque",
    heart_rate_monitoring_link: "Surveillance de la fr\xE9quence cardiaque",
    how_it_works_link: "Fonctionnement",
    impressum_page_title: "Mentions l\xE9gales",
    instagram: "Instagram",
    integrations_link: "Int\xE9grations",
    language_preference: "Pr\xE9f\xE9rence linguistique",
    menu: "Menu",
    metabolic_health: "Sant\xE9 m\xE9tabolique",
    nav_experience: "Exp\xE9rience",
    nav_health_features: "Fonctionnalit\xE9s de sant\xE9",
    nav_help_center: "Centre d'aide",
    nav_shop_all_products: "D\xE9couvrez tous les produits",
    nav_sizing_guide: "Guide des tailles",
    nav_travel_case: "Oura Ring\xA04 Travel Case",
    newsroom_link: "Newsroom",
    oura_home_link: "Page d'accueil d'Oura",
    oura_membership: "Abonnement Oura",
    oura_ring_4_ceramic: "Oura Ring\xA04 Ceramic",
    oura_ring_4_link: "Oura Ring\xA04 <sup>Nouveaut\xE9</sup>",
    out_of_stock_tag: "En rupture de stock",
    partnerships_link: "Partenariats",
    pdp_selected_check_label: "Option choisie",
    pdp_slideshow_thumbnail_label: "Passer \xE0 la diapositive {index}",
    pdp_style_ouraring4_cer: "Oura Ring\xA04 Ceramic",
    pinterest: "Pinterest",
    recycling_program_link: "Programme de recyclage",
    ring_gen_4: "Oura Ring 4",
    ring_gen_4_cer: "Oura Ring\xA04 Ceramic",
    ring_gen3_on_sale: "L\u2019anneau Oura Ring Gen3 est <sup>en promotion</sup>",
    sale: "Promotion",
    sale_link: "Soldes sur l'Oura Ring Gen3",
    science_and_research_link: "Science et recherche",
    shop: "Acheter",
    shop_rings: "Acheter des anneaux",
    sleep_and_rest_link: "Sommeil et repos",
    slider_item_aria_label: "diapositive {number} sur {maxNumber}",
    stelo_glucose_biosensor: "Biocapteur de glucose Stelo",
    store_locator_distance: "\xC0 {distanceInMiles} miles",
    store_locator_item_button_label: "Afficher {displayName} {storeName} sur la carte",
    store_locator_item_link_label: "Afficher {displayName} {storeName} dans Google\xA0Maps (s'ouvre dans un nouvel onglet/une nouvelle fen\xEAtre)",
    store_locator_location_closed: "Ferm\xE9",
    store_locator_location_open: "Ouvert jusqu'\xE0 {time}",
    store_locator_no_results: "Aucun r\xE9sultat n'a \xE9t\xE9 trouv\xE9.",
    store_locator_number_results: "{number} r\xE9sultats",
    store_locator_postal_code_pattern_error: "Veuillez saisir un code postal am\xE9ricain \xE0 cinq chiffres",
    store_locator_results_error: "Une erreur s'est produite pendant la recherche des magasins {storeName} \xE0 proximit\xE9. Veuillez actualiser la page et r\xE9essayer ou contacter le service client\xE8le.",
    stress_link: "Stress",
    the_pulse: "The Pulse",
    tiktok: "TikTok",
    use_current_location_link: "Utiliser ma position actuelle",
    why_oura_link: "Pourquoi choisir Oura\xA0?",
    womens_health_link: "Sant\xE9 des femmes",
    x: "X",
    youtube: "YouTube"
  },
  it: {
    activity_and_movement_link: "Attivit\xE0 e movimento",
    address_form_additional_address: "Indicazioni aggiuntive di indirizzo",
    address_form_address: "Indirizzo",
    address_form_apt_suite: "N. appartamento, suite, piano",
    address_form_city: "Citt\xE0",
    address_form_city_town: "Citt\xE0/Comune",
    address_form_city_ward_town_village: "Citt\xE0/Quartiere/Frazione/Villaggio",
    address_form_country: "Paese",
    address_form_county: "Contea",
    address_form_email: "E-mail",
    address_form_emirate: "Emirato",
    address_form_fname: "Nome",
    address_form_lname: "Cognome",
    address_form_max: "Il campo non pu\xF2 contenere pi\xF9 di {number} caratteri",
    address_form_min: "Il campo deve contenere almeno {number} caratteri",
    address_form_phone: "Numero di telefono",
    address_form_postal: "Codice postale",
    address_form_postcode: "Codice postale",
    address_form_prefecture: "Prefettura",
    address_form_province: "Provincia",
    address_form_region: "Regione",
    address_form_required: "Il campo \xE8 obbligatorio",
    address_form_state: "Stato",
    address_form_state_province_region: "Stato/Regione/Provincia",
    address_form_state_territory: "Stato/Territorio",
    address_form_street_house_number: "Via e numero civico",
    address_form_suburb: "Quartiere/Citt\xE0",
    address_form_zip: "Codice postale",
    available_day: "Disponibile: {day}",
    best_buy_store_locator_legend_text: "Esperienza di acquisto in negozio con Best Buy",
    bfcm_2024_home_hero_title: "Al prezzo pi\xF9 basso <em>di sempre</em>",
    bfcm_2024_menu_card_dyn_price_description: "Fino a {amount} di sconto sul prezzo di vendita consigliato di<break>Oura Ring Gen3</break>.",
    business_gallery_gift_card_title: "Buoni regalo",
    carousel_current_slide_label: "(Diapositiva attuale)",
    carousel_live_region_text: "Elemento {activeIndex} di {slideCount}",
    carousel_next_slide_label: "Elemento successivo",
    carousel_page_dot_label: "Elemento {index}",
    carousel_previous_slide_label: "Elemento precedente",
    cart: "Carrello",
    cart_count_sr_label: "{count, plural, =0 {0 articoli} =1 {1 articolo} other {# articoli}} nel carrello",
    checkout_form_country: "Paese",
    checkout_form_emailformat: "Formato e-mail non corretto",
    checkout_form_emailformat_custom: "Formato e-mail non corretto",
    checkout_form_phoneinvalid: "Numero di telefono non valido o prefisso internazionale mancante",
    checkout_form_postal_code_pattern: "Il codice postale non pu\xF2 contenere pi\xF9 di 9 caratteri di lettere o numeri.",
    checkout_form_postal_code_string: "Il codice postale pu\xF2 contenere solo lettere, numeri, spazi e trattini",
    checkout_form_postal_required: "Il codice postale \xE8 obbligatorio",
    checkout_form_zip: "Codice postale",
    checkout_input_click_to_show_label: "Aggiungi {inputLabel}",
    checkout_pickup_details_plural_units_left: "Unit\xE0 disponibili: {quantity}",
    checkout_pickup_details_ready_in_time: "Pronto entro {time}",
    checkout_pickup_details_single_unit_left: "Unit\xE0 disponibili: 1",
    close: "Chiudi",
    comparison_slider_control_label: "Trascina o usa i tasti freccia sinistra e destra per confrontare i modelli",
    drop_down_extra_charger: "Caricabatterie extra",
    drop_down_gift_card: "Buoni regalo",
    drop_down_oura_ring: "Oura Ring",
    explore_how_it_works_link: "Scopri come funziona",
    explore_why_oura_link: "Perch\xE9 Oura",
    facebook: "Facebook",
    fcc_compliance_link: "FCC Compliance",
    flexible_spending_footer_link: "Piano di spesa flessibile",
    floating_bar_oura_ring_4_ceramic: "Oura Ring 4 <breakSm></breakSm>Ceramic",
    footer_about_us: "Chi siamo",
    footer_accessibility: "Accessibilit\xE0",
    footer_all_rights_reserved: "Ouraring Inc. | Tutti i diritti riservati",
    footer_blog_heading: "Blog",
    footer_careers: "Lavora con noi",
    footer_company_heading: "La nostra azienda",
    footer_connect: "Seguici",
    footer_contact: "Contatto",
    footer_copyright: "\u014CURA e OURA e OURA RING e \u014C sono marchi commerciali di Oura Health Oy e non possono essere utilizzati senza autorizzazione.",
    footer_dataprotect_1: "Per noi \xE8 importante proteggere i tuoi dati.",
    footer_dataprotect_privacy_policy: "Per saperne di pi\xF9, consulta la nostra <PrivacyPolicyLink>Informativa sulla privacy</PrivacyPolicyLink>.",
    footer_developers: "Sviluppatori",
    footer_email: "Indirizzo e-mail",
    footer_email_input_heading: "Ricevi articoli, consigli e offerte da Oura",
    footer_email_validation_error: "Inserisci un indirizzo e-mail valido",
    footer_help: "Aiuto",
    footer_image_cta: "Inizia oggi il tuo percorso verso il benessere",
    footer_ip_notice: "Avviso IP",
    footer_leadership: "Leadership",
    footer_legal_aria_label: "Pi\xE8 di pagina con info legali",
    footer_legal_link_v4: "\xA9 2025 Oura Health Oy. Tutti i diritti riservati. \u014CURA, OURA e \u014C sono marchi commerciali di Oura Health Oy e non possono essere utilizzati senza autorizzazione.",
    footer_medical_advisory_board: "Comitato medico scientifico",
    footer_membership: "Abbonamento",
    footer_my_account: "My Account",
    footer_newsletter_submit_label: "inserisci e-mail per la newsletter",
    footer_oura_on_the_web: "Oura Web",
    footer_partner_heading: "Collabora con noi",
    footer_press: "Stampa",
    footer_privacy_policy: "Informativa sulla privacy",
    footer_pulse_blog: "The Pulse Blog",
    footer_security_center: "Centro sicurezza",
    footer_sizing: "Trova la tua misura",
    footer_social_heading: "Social media",
    footer_social_icons_aria_label: "Social media di Oura",
    footer_support_heading: "Assistenza",
    footer_terms_and_conditions: "Termini e condizioni",
    footer_thanks_for_subscribing: "Ti ringraziamo per la tua iscrizione",
    for_business_link: "Per le aziende",
    for_organizations: "Per le organizzazioni",
    gen4_is_here: "Oura Ring 4 <em>\xE8 arrivato</em>",
    header_hamburger_close_sr_label: "Chiudi navigazione mobile",
    header_hamburger_close_sr_label_2024: "Chiudi navigazione del menu di intestazione",
    header_hamburger_open_sr_label: "Apri navigazione mobile",
    header_hamburger_open_sr_label_2024: "Apri navigazione del menu di intestazione",
    header_shop_now: "Acquista ora",
    header_skip_to_content: "Salta la navigazione al contenuto principale",
    heart_health_link: "Salute del cuore",
    heart_rate_monitoring_link: "Monitoraggio della frequenza cardiaca",
    how_it_works_link: "Come funziona",
    impressum_page_title: "Informazioni legali",
    instagram: "Instagram",
    integrations_link: "Integrazioni",
    language_preference: "Preferenze lingua",
    menu: "Menu",
    metabolic_health: "Funzionalit\xE0 metabolica",
    nav_experience: "Esperienza",
    nav_health_features: "Funzionalit\xE0 per la salute",
    nav_help_center: "Centro assistenza",
    nav_shop_all_products: "Scopri tutti i prodotti",
    nav_sizing_guide: "Guida alla misurazione",
    nav_travel_case: "Oura Ring 4 Travel Case",
    newsroom_link: "Media",
    oura_home_link: "Homepage di Oura",
    oura_membership: "Abbonamento Oura",
    oura_ring_4_ceramic: "Oura Ring 4 Ceramic",
    oura_ring_4_link: "Oura Ring 4 <sup>Novit\xE0</sup>",
    out_of_stock_tag: "Esaurito",
    partnerships_link: "Collaborazioni",
    pdp_selected_check_label: "Seleziona opzione",
    pdp_slideshow_thumbnail_label: "Vai alla slide {index}",
    pdp_style_ouraring4_cer: "Oura Ring 4 Ceramic",
    pinterest: "Pinterest",
    recycling_program_link: "Programma di riciclaggio",
    ring_gen_4: "Oura Ring 4",
    ring_gen_4_cer: "Oura Ring 4 Ceramic",
    ring_gen3_on_sale: "Oura Ring Gen3 <sup>in promozione</sup>",
    sale: "Promozione",
    sale_link: "Offerte per Oura Ring Gen3",
    science_and_research_link: "Scienza e ricerca",
    shop: "Acquista",
    shop_rings: "Acquista anelli",
    sleep_and_rest_link: "Sonno e riposo",
    slider_item_aria_label: "slide {number} di {maxNumber}",
    stelo_glucose_biosensor: "Stelo Glucose Biosensor",
    store_locator_distance: "a {distanceInMiles} miglia di distanza",
    store_locator_item_button_label: "Visualizza {displayName} {storeName} sulla mappa",
    store_locator_item_link_label: "Visualizza {displayName} {storeName} in Google Maps (si apre in una nuova scheda/finestra)",
    store_locator_location_closed: "Chiuso",
    store_locator_location_open: "Aperto fino alle {time}",
    store_locator_no_results: "Nessun risultato trovato.",
    store_locator_number_results: "{number} risultati",
    store_locator_postal_code_pattern_error: "Inserisci un codice postale degli Stati Uniti composto da cinque numeri",
    store_locator_results_error: "Si \xE8 verificato un errore nella ricerca di negozi {storeName} nelle vicinanze. Ricarica la pagina e riprova o contatta l'assistenza clienti.",
    stress_link: "Stress",
    the_pulse: "The Pulse",
    tiktok: "TikTok",
    use_current_location_link: "Usa la mia posizione attuale",
    why_oura_link: "Perch\xE9 Oura",
    womens_health_link: "Salute femminile",
    x: "X",
    youtube: "YouTube"
  },
  ja: {
    activity_and_movement_link: "\u30A2\u30AF\u30C6\u30A3\u30D3\u30C6\u30A3\u3068\u52D5\u304D",
    address_form_additional_address: "\u8FFD\u8A18\u6B04",
    address_form_address: "\u4F4F\u6240",
    address_form_apt_suite: "\u5EFA\u7269\u540D\u3001\u30DE\u30F3\u30B7\u30E7\u30F3\u540D\u3001\u90E8\u5C4B\u756A\u53F7",
    address_form_city: "\u5E02",
    address_form_city_town: "\u5E02/\u753A",
    address_form_city_ward_town_village: "\u5E02\u533A\u753A\u6751",
    address_form_country: "\u56FD",
    address_form_county: "\u770C",
    address_form_email: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
    address_form_emirate: "\u9996\u9577\u56FD",
    address_form_fname: "\u540D",
    address_form_lname: "\u59D3",
    address_form_max: "\u3053\u306E\u9805\u76EE\u306F{number}\u6587\u5B57\u4EE5\u5185\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
    address_form_min: "\u3053\u306E\u9805\u76EE\u306F{number}\u6587\u5B57\u4EE5\u4E0A\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
    address_form_phone: "\u96FB\u8A71\u756A\u53F7",
    address_form_postal: "\u90F5\u4FBF\u756A\u53F7",
    address_form_postcode: "\u90F5\u4FBF\u756A\u53F7",
    address_form_prefecture: "\u90FD\u9053\u5E9C\u770C",
    address_form_province: "\u5DDE",
    address_form_region: "\u5730\u65B9",
    address_form_required: "\u3053\u308C\u306F\u5FC5\u9808\u9805\u76EE\u3067\u3059",
    address_form_state: "\u5DDE",
    address_form_state_province_region: "\u5DDE/\u5730\u65B9",
    address_form_state_territory: "\u5DDE/\u7279\u5225\u5730\u57DF",
    address_form_street_house_number: "\u901A\u308A\u540D\u3001\u5BB6\u756A\u53F7",
    address_form_suburb: "\u30B5\u30D0\u30FC\u30D6/\u30BF\u30A6\u30F3",
    address_form_zip: "\u90F5\u4FBF\u756A\u53F7",
    available_day: "\u53D7\u53D6\u53EF\u80FD\u65E5\uFF1A{day}",
    best_buy_store_locator_legend_text: "Best Buy\u5B9F\u5E97\u8217\u3067\u306EOura\u30A8\u30AF\u30B9\u30DA\u30EA\u30A8\u30F3\u30B9",
    bfcm_2024_home_hero_title: "Oura<em>\u53F2\u4E0A</em><break></break>\u6700\u5B89\u4FA1\u683C\u3002",
    bfcm_2024_menu_card_dyn_price_description: "Oura Ring Gen3\u304C<break></break>\u5E0C\u671B\u5C0F\u58F2\u4FA1\u683C\u304B\u3089\u6700\u5927{amount}\u5272\u5F15\u3002",
    business_gallery_gift_card_title: "\u30AE\u30D5\u30C8\u30AB\u30FC\u30C9",
    carousel_current_slide_label: "(\u73FE\u5728\u306E\u30B9\u30E9\u30A4\u30C9)",
    carousel_live_region_text: "\u30A2\u30A4\u30C6\u30E0\u5168{slideCount}\u500B\u306E\u3046\u3061{activeIndex}\u500B\u76EE",
    carousel_next_slide_label: "\u6B21\u306E\u30A2\u30A4\u30C6\u30E0",
    carousel_page_dot_label: "\u30A2\u30A4\u30C6\u30E0{index}",
    carousel_previous_slide_label: "\u524D\u306E\u30A2\u30A4\u30C6\u30E0",
    cart: "\u30AB\u30FC\u30C8",
    cart_count_sr_label: "\u30AB\u30FC\u30C8\u5185\u306B{count, plural, =0 {\u5546\u54C1\u304C\u3042\u308A\u307E\u305B\u3093} =1 {1\u70B9\u306E\u5546\u54C1\u304C\u3042\u308A\u307E\u3059} other {#\u70B9\u306E\u5546\u54C1\u304C\u3042\u308A\u307E\u3059}}",
    checkout_form_country: "\u56FD",
    checkout_form_emailformat: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306E\u5F62\u5F0F\u304C\u6B63\u3057\u304F\u3042\u308A\u307E\u305B\u3093",
    checkout_form_emailformat_custom: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306E\u5F62\u5F0F\u304C\u6B63\u3057\u304F\u3042\u308A\u307E\u305B\u3093",
    checkout_form_phoneinvalid: "\u96FB\u8A71\u756A\u53F7\u304C\u7121\u52B9\u3001\u307E\u305F\u306F\u56FD\u30B3\u30FC\u30C9\u304C\u5165\u529B\u3055\u308C\u3066\u3044\u307E\u305B\u3093",
    checkout_form_postal_code_pattern: "\u90F5\u4FBF\u756A\u53F7\u306B\u4F7F\u7528\u3067\u304D\u308B\u306E\u306F\u30019\u6587\u5B57\u307E\u3067\u306E\u82F1\u6570\u5B57\u3067\u3059\u3002",
    checkout_form_postal_code_string: "\u90F5\u4FBF\u756A\u53F7\u306B\u4F7F\u7528\u3067\u304D\u308B\u306E\u306F\u3001\u6587\u5B57\u3001\u6570\u5B57\u3001\u30B9\u30DA\u30FC\u30B9\u3001\u30CF\u30A4\u30D5\u30F3\u306E\u307F\u3067\u3059\u3002",
    checkout_form_postal_required: "\u90F5\u4FBF\u756A\u53F7\u306F\u5FC5\u9808\u9805\u76EE\u3067\u3059",
    checkout_form_zip: "\u90F5\u4FBF\u756A\u53F7",
    checkout_input_click_to_show_label: "{inputLabel}\u306E\u8FFD\u52A0",
    checkout_pickup_details_plural_units_left: "\u6B8B\u308A{quantity}\u30E6\u30CB\u30C3\u30C8\u306E\u307F",
    checkout_pickup_details_ready_in_time: "{time}\u3067\u3054\u7528\u610F\u3067\u304D\u307E\u3059",
    checkout_pickup_details_single_unit_left: "\u6B8B\u308A1\u30E6\u30CB\u30C3\u30C8\u306E\u307F",
    close: "\u9589\u3058\u308B",
    comparison_slider_control_label: "\u30C9\u30E9\u30C3\u30B0\u3059\u308B\u304B\u3001\u5DE6\u77E2\u5370\u30AD\u30FC\u3068\u53F3\u77E2\u5370\u30AD\u30FC\u3092\u4F7F\u7528\u3057\u3066\u6BD4\u8F03\u3067\u304D\u307E\u3059",
    drop_down_extra_charger: "\u5145\u96FB\u5668\u306E\u307F\u306E\u3054\u6CE8\u6587",
    drop_down_gift_card: "\u30AE\u30D5\u30C8\u30AB\u30FC\u30C9",
    drop_down_oura_ring: "Oura Ring",
    explore_how_it_works_link: "Oura\u306E\u4ED5\u7D44\u307F",
    explore_why_oura_link: "Oura\u304C\u9078\u3070\u308C\u308B\u7406\u7531",
    facebook: "Facebook",
    fcc_compliance_link: "FCC Compliance",
    flexible_spending_footer_link: "\u30D5\u30EC\u30AD\u30B7\u30D6\u30EB\u652F\u51FA",
    floating_bar_oura_ring_4_ceramic: "Oura Ring 4 <breakSm></breakSm>Ceramic",
    footer_about_us: "\u4F1A\u793E\u6982\u8981",
    footer_accessibility: "\u30A2\u30AF\u30BB\u30B7\u30D3\u30EA\u30C6\u30A3",
    footer_all_rights_reserved: "Ouraring Inc. | All Rights Reserved\uFF08\u5168\u3066\u306E\u6A29\u5229\u3092\u7559\u4FDD\u3057\u307E\u3059\uFF09",
    footer_blog_heading: "\u30D6\u30ED\u30B0",
    footer_careers: "\u30AD\u30E3\u30EA\u30A2",
    footer_company_heading: "\u4F1A\u793E\u60C5\u5831",
    footer_connect: "\u3064\u306A\u304C\u308B",
    footer_contact: "\u304A\u554F\u3044\u5408\u308F\u305B",
    footer_copyright: "\u014CURA\u3001OURA\u3001OURA RING\u3001\u014C\u306F\u3001Oura Health Oy\u306E\u5546\u6A19\u3067\u3042\u308A\u3001\u8A31\u53EF\u306A\u304F\u4F7F\u7528\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002",
    footer_dataprotect_1: "\u5F53\u793E\u306F\u304A\u5BA2\u69D8\u306E\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u3092\u5C0A\u91CD\u3057\u3066\u3044\u307E\u3059\u3002",
    footer_dataprotect_privacy_policy: "\u8A73\u3057\u304F\u306F<PrivacyPolicyLink>\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30DD\u30EA\u30B7\u30FC</PrivacyPolicyLink>\u3092\u3054\u89A7\u304F\u3060\u3055\u3044\u3002",
    footer_developers: "\u958B\u767A\u8005\u5411\u3051",
    footer_email: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
    footer_email_input_heading: "Oura\u306E\u8A18\u4E8B\u3001\u304A\u5F79\u7ACB\u3061\u60C5\u5831\u3001\u30AA\u30D5\u30A1\u30FC\u3092\u304A\u5C4A\u3051\u3057\u307E\u3059",
    footer_email_validation_error: "\u6B63\u3057\u3044\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
    footer_help: "\u30D8\u30EB\u30D7",
    footer_image_cta: "\u5065\u5EB7\u306E\u65C5\u3092\u4ECA\u65E5\u304B\u3089\u59CB\u3081\u307E\u3057\u3087\u3046",
    footer_ip_notice: "\u77E5\u7684\u8CA1\u7523\u6A29",
    footer_leadership: "\u30EA\u30FC\u30C0\u30FC\u30B7\u30C3\u30D7\u30C1\u30FC\u30E0",
    footer_legal_aria_label: "\u30D5\u30C3\u30BF\u30FC\u306E\u6CD5\u7684\u60C5\u5831",
    footer_legal_link_v4: "\xA9 2025 Oura Health Oy.All rights reserved.\u014CURA\u3001OURA\u3001\u014C\u306F\u3001Oura Health Oy\u306E\u5546\u6A19\u3067\u3042\u308A\u3001\u8A31\u53EF\u306A\u304F\u4F7F\u7528\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002",
    footer_medical_advisory_board: "\u533B\u7642\u8AEE\u554F\u59D4\u54E1\u4F1A",
    footer_membership: "\u30E1\u30F3\u30D0\u30FC\u30B7\u30C3\u30D7",
    footer_my_account: "\u30DE\u30A4\u30A2\u30AB\u30A6\u30F3\u30C8",
    footer_newsletter_submit_label: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3066\u30CB\u30E5\u30FC\u30B9\u30EC\u30BF\u30FC\u3092\u8CFC\u8AAD",
    footer_oura_on_the_web: "Oura on the Web",
    footer_partner_heading: "\u30D1\u30FC\u30C8\u30CA\u30FC\u5411\u3051",
    footer_press: "\u30D7\u30EC\u30B9",
    footer_privacy_policy: "\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30DD\u30EA\u30B7\u30FC",
    footer_pulse_blog: "The Pulse\u30D6\u30ED\u30B0",
    footer_security_center: "\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30BB\u30F3\u30BF\u30FC",
    footer_sizing: "\u30B5\u30A4\u30BA\u9078\u3073",
    footer_social_heading: "\u30BD\u30FC\u30B7\u30E3\u30EB\u30E1\u30C7\u30A3\u30A2",
    footer_social_icons_aria_label: "Oura\u30BD\u30FC\u30B7\u30E3\u30EB\u30E1\u30C7\u30A3\u30A2",
    footer_support_heading: "\u30B5\u30DD\u30FC\u30C8",
    footer_terms_and_conditions: "\u5229\u7528\u898F\u7D04",
    footer_thanks_for_subscribing: "\u3054\u8CFC\u8AAD\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059",
    for_business_link: "\u30D3\u30B8\u30CD\u30B9\u5411\u3051",
    for_organizations: "\u30D3\u30B8\u30CD\u30B9\u5411\u3051",
    gen4_is_here: "Oura Ring 4\u304C\u767B\u5834",
    header_hamburger_close_sr_label: "\u30E2\u30D0\u30A4\u30EB\u30CA\u30D3\u30B2\u30FC\u30B7\u30E7\u30F3\u3092\u9589\u3058\u308B",
    header_hamburger_close_sr_label_2024: "\u30D8\u30C3\u30C0\u30FC\u30E1\u30CB\u30E5\u30FC\u30CA\u30D3\u30B2\u30FC\u30B7\u30E7\u30F3\u3092\u9589\u3058\u308B",
    header_hamburger_open_sr_label: "\u30E2\u30D0\u30A4\u30EB \u30CA\u30D3\u30B2\u30FC\u30B7\u30E7\u30F3\u3092\u958B\u304F",
    header_hamburger_open_sr_label_2024: "\u30D8\u30C3\u30C0\u30FC\u30E1\u30CB\u30E5\u30FC\u30CA\u30D3\u30B2\u30FC\u30B7\u30E7\u30F3\u3092\u958B\u304F",
    header_shop_now: "\u4ECA\u3059\u3050\u8CFC\u5165",
    header_skip_to_content: "\u30CA\u30D3\u30B2\u30FC\u30B7\u30E7\u30F3\u3092\u30B9\u30AD\u30C3\u30D7\u3057\u3001\u30E1\u30A4\u30F3\u30B3\u30F3\u30C6\u30F3\u30C4\u3078",
    heart_health_link: "\u5FC3\u81D3\u306E\u5065\u5EB7",
    heart_rate_monitoring_link: "\u5FC3\u62CD\u6570\u30E2\u30CB\u30BF\u30EA\u30F3\u30B0",
    how_it_works_link: "Oura\u306E\u4ED5\u7D44\u307F",
    impressum_page_title: "\u6CD5\u7684\u60C5\u5831",
    instagram: "Instagram",
    integrations_link: "\u9023\u643A",
    language_preference: "\u8A00\u8A9E\u8A2D\u5B9A",
    menu: "\u30E1\u30CB\u30E5\u30FC",
    metabolic_health: "\u4EE3\u8B1D\u306E\u5065\u5EB7",
    nav_experience: "\u30A8\u30AF\u30B9\u30DA\u30EA\u30A8\u30F3\u30B9",
    nav_health_features: "\u5065\u5EB7\u30B5\u30DD\u30FC\u30C8\u6A5F\u80FD",
    nav_help_center: "\u30D8\u30EB\u30D7\u30BB\u30F3\u30BF\u30FC",
    nav_shop_all_products: "\u3059\u3079\u3066\u306E\u88FD\u54C1\u3092\u898B\u308B",
    nav_sizing_guide: "\u30B5\u30A4\u30BA\u9078\u3073\u30AC\u30A4\u30C9",
    nav_travel_case: "Oura Ring 4 Travel Case",
    newsroom_link: "\u30E1\u30C7\u30A3\u30A2",
    oura_home_link: "Oura\u30DB\u30FC\u30E0",
    oura_membership: "Oura\u30E1\u30F3\u30D0\u30FC\u30B7\u30C3\u30D7",
    oura_ring_4_ceramic: "Oura Ring 4 Ceramic",
    oura_ring_4_link: "Oura Ring 4<sup>\u65B0\u767A\u58F2</sup>",
    out_of_stock_tag: "\u5728\u5EAB\u5207\u308C",
    partnerships_link: "\u30D1\u30FC\u30C8\u30CA\u30FC\u30B7\u30C3\u30D7",
    pdp_selected_check_label: "\u30AA\u30D7\u30B7\u30E7\u30F3\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
    pdp_slideshow_thumbnail_label: "\u30B9\u30E9\u30A4\u30C9{index}\u306B\u79FB\u52D5",
    pdp_style_ouraring4_cer: "Oura Ring 4 Ceramic",
    pinterest: "Pinterest",
    recycling_program_link: "\u30EA\u30B5\u30A4\u30AF\u30EB\u30D7\u30ED\u30B0\u30E9\u30E0",
    ring_gen_4: "Oura Ring 4",
    ring_gen_4_cer: "Oura Ring 4 Ceramic",
    ring_gen3_on_sale: "Oura Ring Gen3<sup>\u30BB\u30FC\u30EB\u4E2D</sup>",
    sale: "\u30BB\u30FC\u30EB",
    sale_link: "Oura Ring Gen3\u306E\u30BB\u30FC\u30EB",
    science_and_research_link: "\u79D1\u5B66\u3068\u7814\u7A76\u306B\u3064\u3044\u3066",
    shop: "\u8CFC\u5165\u3059\u308B",
    shop_rings: "\u30EA\u30F3\u30B0\u3092\u8CFC\u5165",
    sleep_and_rest_link: "\u7761\u7720\u3068\u4F11\u606F\u306B\u3064\u3044\u3066",
    slider_item_aria_label: "\u30B9\u30E9\u30A4\u30C9 {number}/{maxNumber}\u679A\u76EE",
    stelo_glucose_biosensor: "Stelo\u30B0\u30EB\u30B3\u30FC\u30B9\u30D0\u30A4\u30AA\u30BB\u30F3\u30B5\u30FC",
    store_locator_distance: "{distanceInMiles}\u30DE\u30A4\u30EB\u5148",
    store_locator_item_button_label: "\u5730\u56F3\u3067{displayName} {storeName}\u3092\u8868\u793A",
    store_locator_item_link_label: "Google\u30DE\u30C3\u30D7\u3067{displayName} {storeName}\u3092\u8868\u793A\uFF08\u65B0\u898F\u30BF\u30D6/\u30A6\u30A3\u30F3\u30C9\u30A6\u3067\u958B\u304D\u307E\u3059\uFF09",
    store_locator_location_closed: "\u55B6\u696D\u6642\u9593\u5916",
    store_locator_location_open: "{time}\u307E\u3067\u55B6\u696D",
    store_locator_no_results: "\u691C\u7D22\u7D50\u679C\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002",
    store_locator_number_results: "{number}\u4EF6\u306E\u7D50\u679C",
    store_locator_postal_code_pattern_error: "\u7C73\u56FD\u306E\u90F5\u4FBF\u756A\u53F7\u30925\u6841\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
    store_locator_results_error: "\u4ED8\u8FD1\u306E{storeName}\u5E97\u8217\u306E\u691C\u7D22\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u30DA\u30FC\u30B8\u3092\u66F4\u65B0\u3057\u3066\u518D\u5EA6\u304A\u8A66\u3057\u3044\u305F\u3060\u304F\u304B\u3001\u30AB\u30B9\u30BF\u30DE\u30FC\u30B5\u30DD\u30FC\u30C8\u307E\u3067\u3054\u9023\u7D61\u304F\u3060\u3055\u3044\u3002",
    stress_link: "\u30B9\u30C8\u30EC\u30B9",
    the_pulse: "The Pulse",
    tiktok: "TikTok",
    use_current_location_link: "\u73FE\u5728\u306E\u4F4D\u7F6E\u60C5\u5831\u3092\u4F7F\u7528\u3059\u308B",
    why_oura_link: "Oura\u3092\u9078\u3076\u7406\u7531",
    womens_health_link: "\u5973\u6027\u306E\u5065\u5EB7",
    x: "X",
    youtube: "YouTube"
  },
  nb: {
    activity_and_movement_link: "Aktivitet og bevegelse",
    address_form_additional_address: "Tilleggsadresse",
    address_form_address: "Adresse",
    address_form_apt_suite: "Leil.nr., rom, etasje",
    address_form_city: "By",
    address_form_city_town: "By/sted",
    address_form_city_ward_town_village: "By/region/sted",
    address_form_country: "Land",
    address_form_county: "Fylke",
    address_form_email: "E-postadresse",
    address_form_emirate: "Emirat",
    address_form_fname: "Fornavn",
    address_form_lname: "Etternavn",
    address_form_max: "Dette feltet kan ikke best\xE5 av mer enn {number} tegn",
    address_form_min: "Dette feltet m\xE5 best\xE5 av minst {number} tegn",
    address_form_phone: "Telefonnummer",
    address_form_postal: "Postnummer",
    address_form_postcode: "Postnummer",
    address_form_prefecture: "Prefektur",
    address_form_province: "Provins",
    address_form_region: "Region",
    address_form_required: "Dette feltet er p\xE5krevd",
    address_form_state: "Stat/fylke",
    address_form_state_province_region: "Stat/fylke/provins/region",
    address_form_state_territory: "Stat/fylke/omr\xE5de",
    address_form_street_house_number: "Gate- og husnummer",
    address_form_suburb: "Forstad/by",
    address_form_zip: "Postnummer",
    available_day: "Tilgjengelig {day}",
    best_buy_store_locator_legend_text: "Oura-opplevelsen i Best Buy-butikker",
    bfcm_2024_home_hero_title: "V\xE5r laveste<break></break>pris <em>noensinne</em>",
    bfcm_2024_menu_card_dyn_price_description: "Opptil {amount} rabatt p\xE5 veil. pris p\xE5<break></break>Oura Ring Gen3.",
    business_gallery_gift_card_title: "Gavekort",
    carousel_current_slide_label: "(N\xE5v\xE6rende lysbilde)",
    carousel_live_region_text: "Element {activeIndex} av {slideCount}",
    carousel_next_slide_label: "Neste element",
    carousel_page_dot_label: "Element {index}",
    carousel_previous_slide_label: "Forrige element",
    cart: "Handlekurv",
    cart_count_sr_label: "Det {count, plural, =0 {are no items} =1 {is one item} other {are # items}} i handlekurven din",
    checkout_form_country: "Land",
    checkout_form_emailformat: "Feil e-postformat",
    checkout_form_emailformat_custom: "Feil e-postformat",
    checkout_form_phoneinvalid: "Telefonnummeret er ugyldig eller landkoden mangler",
    checkout_form_postal_code_pattern: "Postnummeret kan ikke inneholde mer enn 9 tegn i form av bokstaver eller tall.",
    checkout_form_postal_code_string: "Postnummeret kan kun inneholde bokstaver, tall, mellomrom og bindestreker",
    checkout_form_postal_required: "Postnummer er p\xE5krevd",
    checkout_form_zip: "Postnummer",
    checkout_input_click_to_show_label: "Legg til {inputLabel}",
    checkout_pickup_details_plural_units_left: "Bare {quantity} enheter igjen",
    checkout_pickup_details_ready_in_time: "Klar om {time}",
    checkout_pickup_details_single_unit_left: "Bare 1 enhet igjen",
    close: "Lukk",
    comparison_slider_control_label: "Dra eller bruk venstre og h\xF8yre piltaster for \xE5 sammenligne",
    drop_down_extra_charger: "Ekstra lader",
    drop_down_gift_card: "Gavekort",
    drop_down_oura_ring: "Oura Ring",
    explore_how_it_works_link: "Utforsk Slik fungerer det",
    explore_why_oura_link: "Utforsk Hvorfor Oura?",
    facebook: "Facebook",
    fcc_compliance_link: "I samsvar med FCC",
    flexible_spending_footer_link: "Fleksible muligheter",
    floating_bar_oura_ring_4_ceramic: "Oura Ring 4 <breakSm></breakSm>Ceramic",
    footer_about_us: "Om oss",
    footer_accessibility: "Tilgjengelighet",
    footer_all_rights_reserved: "Ouraring Inc. | Med enerett",
    footer_blog_heading: "Blogg",
    footer_careers: "Ledige stillinger",
    footer_company_heading: "Selskapet v\xE5rt",
    footer_connect: "Koble til",
    footer_contact: "Kontakt",
    footer_copyright: "\u014CURA, OURA, OURA RING og \u014C er varemerker tilh\xF8rende Oura Health Oy og kan ikke brukes uten tillatelse.",
    footer_dataprotect_1: "Vi er opptatt av \xE5 beskytte dataene dine.",
    footer_dataprotect_privacy_policy: "Les mer i v\xE5r <PrivacyPolicyLink>Personvernerkl\xE6ring</PrivacyPolicyLink>.",
    footer_developers: "Utviklere",
    footer_email: "E-postadresse",
    footer_email_input_heading: "F\xE5 artikler, tips og tilbud fra Oura",
    footer_email_validation_error: "Oppgi en gyldig e-postadresse",
    footer_help: "Hjelp",
    footer_image_cta: "Start din helsereise <em>i dag</em>",
    footer_ip_notice: "IP-varsel",
    footer_leadership: "Lederskap",
    footer_legal_aria_label: "Bunntekst juridisk",
    footer_legal_link_v4: "\xA9 2025 Oura Health Oy. Med enerett. \u014CURA, OURA og \u014C er varemerker tilh\xF8rende Oura Health Oy og kan ikke brukes uten tillatelse.",
    footer_medical_advisory_board: "Utvalg av medisinske r\xE5dgivere",
    footer_membership: "Medlemskap",
    footer_my_account: "Min konto",
    footer_newsletter_submit_label: "send inn e-post for nyhetsbrev",
    footer_oura_on_the_web: "Oura on the Web",
    footer_partner_heading: "Bli v\xE5r partner",
    footer_press: "Presse",
    footer_privacy_policy: "Personvernerkl\xE6ring",
    footer_pulse_blog: "The Pulse-bloggen",
    footer_security_center: "Sikkerhetssenter",
    footer_sizing: "St\xF8rrelser",
    footer_social_heading: "Sosiale medier",
    footer_social_icons_aria_label: "Oura i sosiale medier",
    footer_support_heading: "St\xF8tte",
    footer_terms_and_conditions: "Vilk\xE5r",
    footer_thanks_for_subscribing: "Takk for at du abonnerer",
    for_business_link: "For bedrifter",
    for_organizations: "For organisasjoner",
    gen4_is_here: "Oura Ring 4<em>er her</em>",
    header_hamburger_close_sr_label: "Lukk mobilnavigasjon",
    header_hamburger_close_sr_label_2024: "Lukk navigasjonen i toppmenyen",
    header_hamburger_open_sr_label: "\xC5pne mobilnavigasjon",
    header_hamburger_open_sr_label_2024: "\xC5pne navigasjon i toppmenyen",
    header_shop_now: "Kj\xF8p n\xE5",
    header_skip_to_content: "Hopp til hovedinnhold",
    heart_health_link: "Hjertehelse",
    heart_rate_monitoring_link: "Overv\xE5king av puls",
    how_it_works_link: "Slik fungerer det",
    impressum_page_title: "Impressum",
    instagram: "Instagram",
    integrations_link: "Integrasjoner",
    language_preference: "Foretrukket spr\xE5k",
    menu: "Meny",
    metabolic_health: "Metabolsk helse",
    nav_experience: "Opplevelse",
    nav_health_features: "Helsefunksjoner",
    nav_help_center: "Hjelpesenter",
    nav_shop_all_products: "Handle alle produkter",
    nav_sizing_guide: "St\xF8rrelsesveiledning",
    nav_travel_case: "Reiseetui til Oura Ring 4",
    newsroom_link: "Nyheter",
    oura_home_link: "Oura-startside",
    oura_membership: "Oura-medlemskap",
    oura_ring_4_ceramic: "Oura Ring 4 Ceramic",
    oura_ring_4_link: "Oura Ring 4 <sup>Ny</sup>",
    out_of_stock_tag: "Utsolgt fra lager",
    partnerships_link: "Partnere",
    pdp_selected_check_label: "Valgt alternativ",
    pdp_slideshow_thumbnail_label: "G\xE5 til lysbilde {index}",
    pdp_style_ouraring4_cer: "Oura Ring 4 Ceramic",
    pinterest: "Pinterest",
    recycling_program_link: "Gjenvinningsprogram",
    ring_gen_4: "Oura Ring 4",
    ring_gen_4_cer: "Oura Ring 4 Ceramic",
    ring_gen3_on_sale: "Oura Ring Gen3 <sup>p\xE5 salg</sup>",
    sale: "Salg",
    sale_link: "Salg p\xE5 Oura Ring Gen3",
    science_and_research_link: "Vitenskap og forskning",
    shop: "Butikk",
    shop_rings: "Kj\xF8p ringer",
    sleep_and_rest_link: "S\xF8vn og hvile",
    slider_item_aria_label: "lysbilde {number} av {maxNumber}",
    stelo_glucose_biosensor: "Stelo glukose-biosensor",
    store_locator_distance: "{distanceInMiles} miles unna",
    store_locator_item_button_label: "Vis {displayName} {storeName} p\xE5 kartet",
    store_locator_item_link_label: "Vis {displayName} {storeName} i Google Maps (\xE5pnes i ny fane\xA0/\xA0nytt vindu)",
    store_locator_location_closed: "Lukket",
    store_locator_location_open: "\xC5pent til {time}",
    store_locator_no_results: "Fant ingen resultater.",
    store_locator_number_results: "{number} resultater",
    store_locator_postal_code_pattern_error: "Oppgi et femsifret postnummer i USA",
    store_locator_results_error: "Det oppstod en feil med \xE5 finne {storeName} sine butikker i n\xE6rheten. Oppdater siden og pr\xF8v p\xE5 nytt, eller kontakt kundest\xF8tten.",
    stress_link: "Stress",
    the_pulse: "The Pulse",
    tiktok: "TikTok",
    use_current_location_link: "Bruk min n\xE5v\xE6rende plassering",
    why_oura_link: "Hvorfor Oura?",
    womens_health_link: "Kvinnehelse",
    x: "X",
    youtube: "YouTube"
  },
  nl: {
    activity_and_movement_link: "Activiteit en beweging",
    address_form_additional_address: "Aanvullend adres",
    address_form_address: "Adres",
    address_form_apt_suite: "Flatnr., suite, verdieping",
    address_form_city: "Woonplaats",
    address_form_city_town: "Woonplaats",
    address_form_city_ward_town_village: "Woonplaats",
    address_form_country: "Land",
    address_form_county: "County",
    address_form_email: "E-mailadres",
    address_form_emirate: "Emiraat",
    address_form_fname: "Voornaam",
    address_form_lname: "Achternaam",
    address_form_max: "Dit veld mag maximaal {number} tekens bevatten",
    address_form_min: "Dit veld moet minimaal {number} tekens bevatten",
    address_form_phone: "Telefoonnummer",
    address_form_postal: "Postcode",
    address_form_postcode: "Postcode",
    address_form_prefecture: "Prefectuur",
    address_form_province: "Provincie",
    address_form_region: "Regio",
    address_form_required: "Dit is een vereist veld",
    address_form_state: "Provincie/staat",
    address_form_state_province_region: "Provincie/staat/regio",
    address_form_state_territory: "Provincie/staat/gebied",
    address_form_street_house_number: "Straat en huisnummer",
    address_form_suburb: "Voorstad/woonplaats",
    address_form_zip: "Postcode",
    available_day: "{day} beschikbaar",
    best_buy_store_locator_legend_text: "Oura uitproberen in een winkel van Best Buy",
    bfcm_2024_home_hero_title: "Onze laagste<break></break>prijs <em>ooit</em>",
    bfcm_2024_menu_card_dyn_price_description: "Tot wel {amount} korting op de adviesprijs van<break></break>de Oura Ring Gen3.",
    business_gallery_gift_card_title: "Giftcards",
    carousel_current_slide_label: "(Huidige slide)",
    carousel_live_region_text: "Item {activeIndex} van de {slideCount}",
    carousel_next_slide_label: "Volgend item",
    carousel_page_dot_label: "Item {index}",
    carousel_previous_slide_label: "Vorig item",
    cart: "Winkelwagen",
    cart_count_sr_label: "Er {count, plural, =0 {ligt niets} =1 {ligt \xE9\xE9n artikel} other {liggen # artikelen}} in je winkelwagen",
    checkout_form_country: "Land",
    checkout_form_emailformat: "Indeling e-mailadres onjuist",
    checkout_form_emailformat_custom: "Indeling e-mailadres onjuist",
    checkout_form_phoneinvalid: "Telefoonnummer is ongeldig of landcode ontbreekt",
    checkout_form_postal_code_pattern: "Postcode mag uit maximaal 9\xA0letters of cijfers bestaan.",
    checkout_form_postal_code_string: "Postcode mag alleen uit letters, cijfers, spaties en koppeltekens bestaan",
    checkout_form_postal_required: "Postcode is vereist",
    checkout_form_zip: "Postcode",
    checkout_input_click_to_show_label: "{inputLabel} toevoegen",
    checkout_pickup_details_plural_units_left: "Nog maar {quantity} exemplaren over",
    checkout_pickup_details_ready_in_time: "Klaar over {time}",
    checkout_pickup_details_single_unit_left: "Nog maar 1\xA0exemplaar over",
    close: "Sluiten",
    comparison_slider_control_label: "Sleep of gebruik de pijltjestoetsen om te vergelijken",
    drop_down_extra_charger: "Extra oplader",
    drop_down_gift_card: "Giftcard",
    drop_down_oura_ring: "Oura Ring",
    explore_how_it_works_link: "Ontdek hoe het werkt",
    explore_why_oura_link: "Waarom Oura?",
    facebook: "Facebook",
    fcc_compliance_link: "Naleving van FCC-voorschriften",
    flexible_spending_footer_link: "Flexible spending",
    floating_bar_oura_ring_4_ceramic: "Oura Ring\xA04 <breakSm></breakSm>Ceramic",
    footer_about_us: "Over ons",
    footer_accessibility: "Toegankelijkheid",
    footer_all_rights_reserved: "Ouraring Inc. | Alle rechten voorbehouden",
    footer_blog_heading: "Blog",
    footer_careers: "Werken bij",
    footer_company_heading: "Ons bedrijf",
    footer_connect: "Verbinden",
    footer_contact: "Contactinformatie",
    footer_copyright: "\u014CURA, OURA, OURA RING en \u014C zijn handelsmerken van Oura Health Oy en mogen niet zonder toestemming worden gebruikt.",
    footer_dataprotect_1: "We vinden het belangrijk dat je gegevens veilig blijven.",
    footer_dataprotect_privacy_policy: "Lees meer in ons <PrivacyPolicyLink>privacybeleid</PrivacyPolicyLink>.",
    footer_developers: "Ontwikkelaars",
    footer_email: "E-mailadres",
    footer_email_input_heading: "Ontvang artikelen, tips en aanbiedingen van Oura",
    footer_email_validation_error: "Voer een geldig e-mailadres in",
    footer_help: "Help",
    footer_image_cta: "<em>Zet vandaag nog de eerste stap</em> op weg naar een gezonder leven",
    footer_ip_notice: "Kennisgeving IE",
    footer_leadership: "Directie",
    footer_legal_aria_label: "Voettekst juridisch",
    footer_legal_link_v4: "\xA9 2025 Oura Health Oy. Alle rechten voorbehouden. \u014CURA, OURA en \u014C zijn handelsmerken van Oura Health Oy en mogen niet zonder toestemming worden gebruikt.",
    footer_medical_advisory_board: "Medische adviesraad",
    footer_membership: "Lidmaatschap",
    footer_my_account: "My Account",
    footer_newsletter_submit_label: "e-mailadres voor nieuwsbrief indienen",
    footer_oura_on_the_web: "Oura on the Web",
    footer_partner_heading: "Samenwerking",
    footer_press: "Pers",
    footer_privacy_policy: "Privacybeleid",
    footer_pulse_blog: "The Pulse Blog",
    footer_security_center: "Beveiligingscentrum",
    footer_sizing: "Maten",
    footer_social_heading: "Sociale media",
    footer_social_icons_aria_label: "Oura op sociale media",
    footer_support_heading: "Support",
    footer_terms_and_conditions: "Algemene voorwaarden",
    footer_thanks_for_subscribing: "Bedankt voor je aanmelding",
    for_business_link: "For Business",
    for_organizations: "Voor organisaties",
    gen4_is_here: "De Oura Ring\xA04 <em>is er</em>",
    header_hamburger_close_sr_label: "Mobiele navigatie sluiten",
    header_hamburger_close_sr_label_2024: "Navigatie van menu bovenaan sluiten",
    header_hamburger_open_sr_label: "Mobiele navigatie openen",
    header_hamburger_open_sr_label_2024: "Navigatie van menu bovenaan openen",
    header_shop_now: "Shop nu",
    header_skip_to_content: "Navigatie naar hoofdcontent overslaan",
    heart_health_link: "Hartgezondheid",
    heart_rate_monitoring_link: "Hartslagmonitoring",
    how_it_works_link: "Zo werkt het",
    impressum_page_title: "Juridische informatie",
    instagram: "Instagram",
    integrations_link: "Integraties",
    language_preference: "Taalvoorkeur",
    menu: "Menu",
    metabolic_health: "Metabole gezondheid",
    nav_experience: "Ervaring",
    nav_health_features: "Gezondheidsfuncties",
    nav_help_center: "Helpcenter",
    nav_shop_all_products: "Alle producten shoppen",
    nav_sizing_guide: "Instructies voor maatbepaling",
    nav_travel_case: "Reisetui Oura Ring\xA04",
    newsroom_link: "Nieuws",
    oura_home_link: "Oura-homepage",
    oura_membership: "Oura-lidmaatschap",
    oura_ring_4_ceramic: "Oura Ring\xA04 Ceramic",
    oura_ring_4_link: "Oura Ring\xA04 <sup>Nieuw</sup>",
    out_of_stock_tag: "Niet op voorraad",
    partnerships_link: "Partnerschappen",
    pdp_selected_check_label: "Gekozen optie",
    pdp_slideshow_thumbnail_label: "Naar slide {index}",
    pdp_style_ouraring4_cer: "Oura Ring\xA04 Ceramic",
    pinterest: "Pinterest",
    recycling_program_link: "Recyclingprogramma",
    ring_gen_4: "Oura Ring\xA04",
    ring_gen_4_cer: "Oura Ring\xA04 Ceramic",
    ring_gen3_on_sale: "Oura Ring Gen3 <sup>in de aanbieding</sup>",
    sale: "Aanbiedingen",
    sale_link: "Oura Ring Gen3 in de aanbieding",
    science_and_research_link: "Wetenschap en onderzoek",
    shop: "Shop",
    shop_rings: "Shop ringen",
    sleep_and_rest_link: "Slaap en rust",
    slider_item_aria_label: "slide {number} van de {maxNumber}",
    stelo_glucose_biosensor: "Glucosebiosensor van Stelo",
    store_locator_distance: "{distanceInMiles} mijl bij jou vandaan",
    store_locator_item_button_label: "{displayName} {storeName} op de kaart bekijken",
    store_locator_item_link_label: "{displayName} {storeName} op Google Maps bekijken (wordt in nieuw tabblad/venster geopend)",
    store_locator_location_closed: "Gesloten",
    store_locator_location_open: "Open tot {time}",
    store_locator_no_results: "Geen resultaten gevonden.",
    store_locator_number_results: "{number} resultaten",
    store_locator_postal_code_pattern_error: "Voer een vijfcijferige Amerikaanse postcode in",
    store_locator_results_error: "Er is een fout opgetreden bij het zoeken van {storeName}-vestigingen in de buurt. Vernieuw de pagina en probeer het opnieuw of neem contact op met de klantenondersteuning.",
    stress_link: "Stress",
    the_pulse: "The Pulse",
    tiktok: "TikTok",
    use_current_location_link: "Mijn huidige locatie gebruiken",
    why_oura_link: "Waarom Oura",
    womens_health_link: "Gezondheid van vrouwen",
    x: "X",
    youtube: "YouTube"
  },
  sv: {
    activity_and_movement_link: "Aktivitet och r\xF6relse",
    address_form_additional_address: "Ytterligare adress",
    address_form_address: "Adress",
    address_form_apt_suite: "L\xE4genhetsnr, svit, v\xE5ning",
    address_form_city: "Ort",
    address_form_city_town: "Stad/ort",
    address_form_city_ward_town_village: "Stad/distrikt/ort/by",
    address_form_country: "Land",
    address_form_county: "L\xE4n",
    address_form_email: "E-postadress",
    address_form_emirate: "Emirat",
    address_form_fname: "F\xF6rnamn",
    address_form_lname: "Efternamn",
    address_form_max: "F\xE4ltet f\xE5r inte \xF6verstiga {number} tecken",
    address_form_min: "F\xE4ltet m\xE5ste inneh\xE5lla minst {number} tecken",
    address_form_phone: "Telefonnummer",
    address_form_postal: "Postnummer",
    address_form_postcode: "Postnummer",
    address_form_prefecture: "Prefektur",
    address_form_province: "Provins",
    address_form_region: "Region",
    address_form_required: "Det h\xE4r f\xE4ltet \xE4r obligatoriskt",
    address_form_state: "Delstat",
    address_form_state_province_region: "Delstat/provins/region",
    address_form_state_territory: "Delstat/omr\xE5de",
    address_form_street_house_number: "Gata och husnummer",
    address_form_suburb: "F\xF6rort/ort",
    address_form_zip: "Postnummer",
    available_day: "Tillg\xE4nglig {day}",
    best_buy_store_locator_legend_text: "Oura-upplevelsen i Best Buy-butiker",
    bfcm_2024_home_hero_title: "V\xE5rt l\xE4gsta pris<break></break> <em>n\xE5gonsin</em>",
    bfcm_2024_menu_card_dyn_price_description: "Upp till {amount} i rabatt p\xE5 tillverkarens rekommenderade pris f\xF6r<break></break>Oura Ring Gen3.",
    business_gallery_gift_card_title: "Presentkort",
    carousel_current_slide_label: "(Aktuell bild)",
    carousel_live_region_text: "Del {activeIndex} av {slideCount}",
    carousel_next_slide_label: "N\xE4sta del",
    carousel_page_dot_label: "Del {index}",
    carousel_previous_slide_label: "F\xF6reg\xE5ende del",
    cart: "Varukorg",
    cart_count_sr_label: "Du har {count, plural, =0 {inga varor} =1 {en vara} other {# varor}} i varukorgen",
    checkout_form_country: "Land",
    checkout_form_emailformat: "Felaktigt format p\xE5 e-postadressen",
    checkout_form_emailformat_custom: "Felaktigt format p\xE5 e-postadressen",
    checkout_form_phoneinvalid: "Telefonnumret \xE4r ogiltigt eller saknar landskod",
    checkout_form_postal_code_pattern: "Postnumret f\xE5r inneh\xE5lla max 9 tecken (bokst\xE4ver eller siffror).",
    checkout_form_postal_code_string: "Postnumret f\xE5r bara inneh\xE5lla bokst\xE4ver, siffror, mellanslag och bindestreck",
    checkout_form_postal_required: "Postnummer \xE4r obligatoriskt",
    checkout_form_zip: "Postnummer",
    checkout_input_click_to_show_label: "L\xE4gg till {inputLabel}",
    checkout_pickup_details_plural_units_left: "Bara {quantity} kvar i lager",
    checkout_pickup_details_ready_in_time: "Klar om {time}",
    checkout_pickup_details_single_unit_left: "Bara 1 kvar i lager",
    close: "St\xE4ng",
    comparison_slider_control_label: "Dra eller anv\xE4nd v\xE4nster och h\xF6ger piltangent f\xF6r att j\xE4mf\xF6ra",
    drop_down_extra_charger: "Extra laddare",
    drop_down_gift_card: "Presentkort",
    drop_down_oura_ring: "Oura Ring",
    explore_how_it_works_link: "Ta reda p\xE5 hur det funkar",
    explore_why_oura_link: "Utforska varf\xF6r Oura",
    facebook: "Facebook",
    fcc_compliance_link: "FCC-\xF6verensst\xE4mmelse",
    flexible_spending_footer_link: "Flexible spending",
    floating_bar_oura_ring_4_ceramic: "Oura Ring 4 <breakSm></breakSm>Ceramic",
    footer_about_us: "Om oss",
    footer_accessibility: "Tillg\xE4nglighet",
    footer_all_rights_reserved: "Ouraring Inc. | Alla r\xE4ttigheter f\xF6rbeh\xE5lls",
    footer_blog_heading: "Blogg",
    footer_careers: "Karri\xE4r",
    footer_company_heading: "V\xE5rt f\xF6retag",
    footer_connect: "Anslut",
    footer_contact: "Kontakt",
    footer_copyright: "\u014CURA och OURA och OURA RING och \u014C \xE4r varum\xE4rken som tillh\xF6r Oura Health Oy. De f\xE5r inte anv\xE4ndas utan till\xE5telse.",
    footer_dataprotect_1: "Det \xE4r viktigt f\xF6r oss att skydda dina uppgifter.",
    footer_dataprotect_privacy_policy: "L\xE4s mer i v\xE5r <PrivacyPolicyLink>integritetspolicy</PrivacyPolicyLink>.",
    footer_developers: "Utvecklare",
    footer_email: "E-postadress",
    footer_email_input_heading: "F\xE5 artiklar, tips och erbjudanden fr\xE5n Oura.",
    footer_email_validation_error: "Ange en giltig e-postadress",
    footer_help: "Hj\xE4lp",
    footer_image_cta: "B\xF6rja din h\xE4lsoresa<em>idag</em>",
    footer_ip_notice: "Immateriella r\xE4ttigheter",
    footer_leadership: "Ledning",
    footer_legal_aria_label: "Sidfot juridisk information",
    footer_legal_link_v4: "\xA9 2025 Oura Health Oy. Alla r\xE4ttigheter f\xF6rbeh\xE5lls. \u014CURA, OURA och \u014C \xE4r varum\xE4rken som tillh\xF6r Oura Health Oy. De f\xE5r inte anv\xE4ndas utan till\xE5telse.",
    footer_medical_advisory_board: "Medicinsk r\xE5dgivningsgrupp",
    footer_membership: "Medlemskap",
    footer_my_account: "Mitt konto",
    footer_newsletter_submit_label: "registrera e-postadress f\xF6r nyhetsbrev",
    footer_oura_on_the_web: "Oura on the web",
    footer_partner_heading: "Samarbeta med oss",
    footer_press: "Press",
    footer_privacy_policy: "Integritetspolicy",
    footer_pulse_blog: "The Pulse-bloggen",
    footer_security_center: "S\xE4kerhetscenter",
    footer_sizing: "V\xE4lja storlek",
    footer_social_heading: "Sociala medier",
    footer_social_icons_aria_label: "Oura i sociala medier",
    footer_support_heading: "Support",
    footer_terms_and_conditions: "Villkor",
    footer_thanks_for_subscribing: "Tack f\xF6r att du prenumererar",
    for_business_link: "F\xF6r f\xF6retag",
    for_organizations: "F\xF6r organisationer",
    gen4_is_here: "Oura Ring 4<em>\xE4r h\xE4r</em>",
    header_hamburger_close_sr_label: "St\xE4ng mobilmeny",
    header_hamburger_close_sr_label_2024: "St\xE4ng meny i sidhuvud",
    header_hamburger_open_sr_label: "\xD6ppna mobilmeny",
    header_hamburger_open_sr_label_2024: "\xD6ppna meny i sidhuvud",
    header_shop_now: "K\xF6p nu",
    header_skip_to_content: "G\xE5 till huvudinneh\xE5ll",
    heart_health_link: "Hj\xE4rth\xE4lsa",
    heart_rate_monitoring_link: "Pulsm\xE4tning",
    how_it_works_link: "S\xE5 funkar det",
    impressum_page_title: "Impressum",
    instagram: "Instagram",
    integrations_link: "Integrationer",
    language_preference: "Spr\xE5kval",
    menu: "Meny",
    metabolic_health: "Metabolisk h\xE4lsa",
    nav_experience: "Upplevelse",
    nav_health_features: "H\xE4lsofunktioner",
    nav_help_center: "Hj\xE4lpcenter",
    nav_shop_all_products: "Visa alla produkter",
    nav_sizing_guide: "Storleksguide",
    nav_travel_case: "Oura Ring 4 Travel Case",
    newsroom_link: "Nyheter",
    oura_home_link: "Ouras startsida",
    oura_membership: "Oura-medlemskap",
    oura_ring_4_ceramic: "Oura Ring 4\xA0Ceramic",
    oura_ring_4_link: "Oura Ring 4 <sup>Nyhet</sup>",
    out_of_stock_tag: "Sluts\xE5ld",
    partnerships_link: "Samarbeten",
    pdp_selected_check_label: "Vald",
    pdp_slideshow_thumbnail_label: "G\xE5 till bild {index}",
    pdp_style_ouraring4_cer: "Oura Ring 4\xA0Ceramic",
    pinterest: "Pinterest",
    recycling_program_link: "\xC5tervinningsprogram",
    ring_gen_4: "Oura Ring 4",
    ring_gen_4_cer: "Oura Ring 4\xA0Ceramic",
    ring_gen3_on_sale: "Oura Ring Gen3 <sup>P\xE5 rea</sup>",
    sale: "Rea",
    sale_link: "Rea p\xE5 Oura Ring Gen3",
    science_and_research_link: "Vetenskap och forskning",
    shop: "K\xF6p",
    shop_rings: "K\xF6p ringar",
    sleep_and_rest_link: "S\xF6mn och vila",
    slider_item_aria_label: "bild {number} av {maxNumber}",
    stelo_glucose_biosensor: "Stelo glukossensor",
    store_locator_distance: "{distanceInMiles} miles bort",
    store_locator_item_button_label: "Visa {displayName} {storeName} p\xE5 kartan",
    store_locator_item_link_label: "Visa {displayName} {storeName} i Google Maps (\xF6ppnas i ny flik/nytt f\xF6nster)",
    store_locator_location_closed: "St\xE4ngt",
    store_locator_location_open: "\xD6ppet till kl. {time}",
    store_locator_no_results: "Inga resultat hittades.",
    store_locator_number_results: "{number} resultat",
    store_locator_postal_code_pattern_error: "Ange ett femsiffrigt amerikanskt postnummer",
    store_locator_results_error: "Det gick inte att hitta n\xE5gon {storeName} i n\xE4rheten. Uppdatera sidan och f\xF6rs\xF6k igen eller kontakta kundsupporten.",
    stress_link: "Stress",
    the_pulse: "The Pulse",
    tiktok: "TikTok",
    use_current_location_link: "Anv\xE4nd min nuvarande plats",
    why_oura_link: "Varf\xF6r Oura",
    womens_health_link: "Kvinnors h\xE4lsa",
    x: "X",
    youtube: "YouTube"
  }
};

// src/utils/isBrowser.ts
init_esm_shims();
function isBrowser() {
  return typeof window !== "undefined";
}

// src/hooks/useLocaleData.ts
var useLocaleData = (defaultLocale = "en", locale) => {
  const fallbackLocale = locale != null ? locale : defaultLocale;
  const output = {
    data: MESSAGES_BY_LOCALE[fallbackLocale],
    locale: fallbackLocale
  };
  if (!locale && isBrowser()) {
    const { language } = navigator;
    const selectedLocale = Object.keys(MESSAGES_BY_LOCALE).find(
      (key) => language.startsWith(key)
    );
    if (selectedLocale) {
      output.locale = selectedLocale;
      output.data = MESSAGES_BY_LOCALE[selectedLocale];
    }
  }
  return output;
};
var useLocaleData_default = useLocaleData;

// src/contexts/LocaleProvider.tsx
import { jsx } from "react/jsx-runtime";
function LocaleProvider({
  defaultLocale = "en",
  locale,
  children,
  ...props
}) {
  const { data: messages, locale: selectedLocale } = useLocaleData_default(
    defaultLocale,
    locale
  );
  return /* @__PURE__ */ jsx(IntlProvider, {
    defaultLocale,
    locale: selectedLocale,
    messages,
    ...props,
    children
  });
}
LocaleProvider.displayName = "LocaleProvider";

// src/contexts/CurrencyProvider.tsx
init_esm_shims();
import {
  I18nContext,
  I18nManager
} from "@shopify/react-i18n";
import { createContext, useMemo, useRef } from "react";
import { jsx as jsx2 } from "react/jsx-runtime";
var CurrencyContext = createContext({
  fallbackCurrencyCode: "USD",
  freeMessage: ""
});
function CurrencyProvider({
  children,
  country,
  fallbackCurrencyCode = "USD",
  fallbackLocale,
  freeMessage = "",
  locale,
  onI18nManagerError
}) {
  const onI18nManagerErrorRef = useRef(onI18nManagerError);
  const currencyManager = useMemo(() => {
    return new I18nManager({
      country,
      fallbackLocale,
      locale,
      onError: onI18nManagerErrorRef.current
    });
  }, [country, fallbackLocale, locale]);
  const currencyContextValue = useMemo(
    () => ({ fallbackCurrencyCode, freeMessage }),
    [fallbackCurrencyCode, freeMessage]
  );
  return /* @__PURE__ */ jsx2(I18nContext.Provider, {
    value: currencyManager,
    children: /* @__PURE__ */ jsx2(CurrencyContext.Provider, {
      value: currencyContextValue,
      children
    })
  });
}

// src/contexts/ComponentProvider.tsx
init_esm_shims();
import { createContext as createContext2, useMemo as useMemo2 } from "react";
import { jsx as jsx3 } from "react/jsx-runtime";
var GLOBAL_KEY = "__@jouzen/ecom-components:ComponentContext__";
function getOrCreateContext() {
  const g = globalThis;
  if (!g[GLOBAL_KEY])
    g[GLOBAL_KEY] = createContext2({});
  return g[GLOBAL_KEY];
}
var Context = getOrCreateContext();
function ComponentProvider({
  children,
  LinkComponent,
  ImageComponent
}) {
  const contextValue = useMemo2(
    () => ({ ImageComponent, LinkComponent }),
    [ImageComponent, LinkComponent]
  );
  return /* @__PURE__ */ jsx3(Context.Provider, {
    value: contextValue,
    children
  });
}
ComponentProvider.displayName = "ComponentProvider";

// src/layout/contexts/FooterProvider.tsx
init_esm_shims();
import { useMemo as useMemo3, useState } from "react";

// src/layout/contexts/FooterContext.tsx
init_esm_shims();
var import_noop = __toESM(require_noop());
import { createContext as createContext3 } from "react";
var FooterContext = createContext3({
  isFooterInView: false,
  setIsFooterInView: import_noop.default
});

// src/layout/contexts/FooterProvider.tsx
import { jsx as jsx4 } from "react/jsx-runtime";
function FooterProvider({
  children
}) {
  const [isFooterInView, setIsFooterInView] = useState(false);
  const values = useMemo3(
    () => ({
      isFooterInView,
      setIsFooterInView
    }),
    [isFooterInView]
  );
  return /* @__PURE__ */ jsx4(FooterContext.Provider, {
    value: values,
    children
  });
}
FooterProvider.displayName = "FooterProvider";

// src/layout/contexts/HeaderProvider.tsx
init_esm_shims();
import { useMemo as useMemo4, useState as useState2 } from "react";

// src/layout/contexts/HeaderContext.tsx
init_esm_shims();
import { createContext as createContext4 } from "react";
var HeaderContext = createContext4(null);

// src/layout/contexts/HeaderProvider.tsx
import { jsx as jsx5 } from "react/jsx-runtime";
function HeaderProvider({
  children
}) {
  const [inverse, setInverse] = useState2(false);
  const [headerHeight, setHeaderHeight] = useState2(0);
  const contextValue = useMemo4(
    () => ({
      headerHeight,
      setHeaderHeight,
      inverse,
      setInverse
    }),
    [headerHeight, setHeaderHeight, inverse, setInverse]
  );
  return /* @__PURE__ */ jsx5(HeaderContext.Provider, {
    value: contextValue,
    children
  });
}
HeaderProvider.displayName = "HeaderProvider";

// src/layout/contexts/UiProvider.tsx
import { jsx as jsx6 } from "react/jsx-runtime";
function UiProvider({
  children,
  currencyProps,
  intlProps,
  ImageComponent,
  LinkComponent
}) {
  return /* @__PURE__ */ jsx6(LocaleProvider, {
    ...intlProps,
    children: /* @__PURE__ */ jsx6(ComponentProvider, {
      ImageComponent,
      LinkComponent,
      children: /* @__PURE__ */ jsx6(CurrencyProvider, {
        ...currencyProps,
        children: /* @__PURE__ */ jsx6(HeaderProvider, {
          children: /* @__PURE__ */ jsx6(FooterProvider, {
            children
          })
        })
      })
    })
  });
}
UiProvider.displayName = "UiProvider";

// src/layout/contexts/useFooterContext.tsx
init_esm_shims();
import { useContext } from "react";
var useFooterContext = () => {
  return useContext(FooterContext);
};

// src/layout/contexts/useHeaderContext.tsx
init_esm_shims();
import { useContext as useContext2 } from "react";
var useHeaderContext = () => {
  return useContext2(HeaderContext);
};

// src/layout/v3/InverseHeader/index.tsx
init_esm_shims();
import {
  useEffect,
  useRef as useRef2
} from "react";
import { useInView } from "framer-motion";
import { jsx as jsx7 } from "react/jsx-runtime";
function InverseHeader({
  children,
  className,
  enter = false,
  exit = false,
  margin = "0% 0% -95% 0%"
}) {
  const headerContext = useHeaderContext();
  const ref = useRef2(null);
  const isInView = useInView(ref, { margin });
  const setInverse = headerContext == null ? void 0 : headerContext.setInverse;
  useEffect(() => {
    if (setInverse) {
      if (isInView) {
        setInverse(enter);
      } else {
        setInverse(exit);
      }
    }
  }, [enter, exit, isInView, setInverse]);
  return /* @__PURE__ */ jsx7("div", {
    className,
    ref,
    children
  });
}
InverseHeader.displayName = "InverseHeader";

// src/layout/v3/PageLayout/index.tsx
init_esm_shims();
import { cx as cx23 } from "class-variance-authority";

// src/react-intl/FormattedMessage.tsx
init_esm_shims();
import { FormattedMessage as ReactIntlFormattedMessage } from "react-intl";

// src/react-intl/getLocaleFormatting.tsx
init_esm_shims();

// src/react-intl/htmlFormatting.tsx
init_esm_shims();

// src/v3/BodyLink/index.tsx
init_esm_shims();
import { forwardRef, useContext as useContext3 } from "react";
import { cx } from "class-variance-authority";
import { jsx as jsx8 } from "react/jsx-runtime";
var BodyLink = forwardRef(
  function BodyLink2({
    children,
    className,
    color = "sandstone-500",
    external = false,
    href = "",
    onClick,
    ...rest
  }, ref) {
    const context = useContext3(Context);
    const LinkComponent = external || !context.LinkComponent ? "a" : context.LinkComponent;
    return /* @__PURE__ */ jsx8(LinkComponent, {
      "data-cy": "body_link",
      ...rest,
      className: cx(`ui-underline ui-text-${color}`, className),
      href,
      onClick: (evt) => onClick == null ? void 0 : onClick(evt),
      ref,
      children
    });
  }
);
BodyLink.displayName = "BodyLink";

// src/react-intl/htmlFormatting.tsx
import { jsx as jsx9 } from "react/jsx-runtime";
var htmlFormatting = {
  br: /* @__PURE__ */ jsx9("br", {}),
  w: /* @__PURE__ */ jsx9("wbr", {}),
  r: String.fromCharCode(174),
  tm: String.fromCharCode(8482),
  break: function breakTag() {
    return /* @__PURE__ */ jsx9("br", {});
  },
  strong: function strong(chunks) {
    return /* @__PURE__ */ jsx9("strong", {
      children: chunks
    });
  },
  b: function b(chunks) {
    return /* @__PURE__ */ jsx9("strong", {
      children: chunks
    });
  },
  em: function em(chunks) {
    return /* @__PURE__ */ jsx9("em", {
      children: chunks
    });
  },
  i: function i(chunks) {
    return /* @__PURE__ */ jsx9("em", {
      children: chunks
    });
  },
  u: function u(chunks) {
    return /* @__PURE__ */ jsx9("span", {
      className: "ui-underline",
      children: chunks
    });
  },
  sup: function sup(chunks) {
    return /* @__PURE__ */ jsx9("sup", {
      className: "ui-font-serif ui-italic ui-text-blue-200 ui-font-semibold ui-tracking-wider",
      children: chunks
    });
  },
  li: function li(chunks) {
    return /* @__PURE__ */ jsx9("li", {
      children: chunks
    });
  },
  ExternalLink: function ExternalLink(href) {
    return /* @__PURE__ */ jsx9(BodyLink, {
      href,
      rel: "noreferrer",
      target: "_blank",
      children: href
    });
  },
  EmailLink: function EmailLink(email) {
    return /* @__PURE__ */ jsx9(BodyLink, {
      href: `mailto:${email}`,
      children: email
    });
  }
};

// src/react-intl/stringFormatting.ts
init_esm_shims();
var stringFormatting = Object.entries(
  htmlFormatting
).reduce((obj, [key, value]) => {
  const type = typeof value;
  if (type === "string") {
    return { ...obj, [key]: value };
  } else if (type === "function") {
    return { ...obj, [key]: (chunks) => chunks };
  }
  return { ...obj, [key]: "" };
}, {});

// src/react-intl/getLocaleFormatting.tsx
var getLocaleFormatting = (options = {}) => {
  const { stripHtml } = options;
  if (stripHtml) {
    return stringFormatting;
  }
  return htmlFormatting;
};
getLocaleFormatting.displayName = "getLocaleFormatting";
var getLocaleFormatting_default = getLocaleFormatting;

// src/react-intl/FormattedMessage.tsx
import { jsx as jsx10 } from "react/jsx-runtime";
function FormattedMessage({
  id,
  values: optionalValues,
  ...props
}) {
  const localeFormatting = getLocaleFormatting_default();
  const values = {
    ...localeFormatting,
    ...optionalValues
  };
  return /* @__PURE__ */ jsx10(ReactIntlFormattedMessage, {
    id,
    values,
    ...props
  });
}
function t(id, values) {
  return /* @__PURE__ */ jsx10(FormattedMessage, {
    id,
    values
  });
}
FormattedMessage.displayName = "FormattedMessage";
var FormattedMessage_default = FormattedMessage;

// src/layout/v3/Footer/Footnotes/index.tsx
init_esm_shims();
import { cva as cva3 } from "class-variance-authority";

// src/v3/List/index.tsx
init_esm_shims();
import { cva as cva2 } from "class-variance-authority";

// src/v3/Typography/index.tsx
init_esm_shims();
import { cva } from "class-variance-authority";
import { jsx as jsx11 } from "react/jsx-runtime";
var typography = cva("", {
  variants: {
    variant: {
      h1: "ui-text-[2.5rem] ui-tracking-tight md:ui-text-[3.75rem] lg:ui-text-[5rem]",
      h2: "ui-text-[2.25rem] ui-tracking-normal md:ui-text-[3rem] lg:ui-text-[4.25rem] lg:ui-tracking-[-2px]",
      h3: "ui-text-[2rem] ui-tracking-normal md:ui-text-[2.5rem] lg:ui-text-[3.5rem]",
      h4: "ui-text-[1.75rem] ui-tracking-normal md:ui-text-[2rem] lg:ui-text-[2.5rem]",
      h5: "ui-text-[1.25rem] ui-tracking-normal lg:ui-leading-10",
      h6: "ui-text-[1.25rem] ui-tracking-normal",
      "body-large": "ui-text-[1.125rem] ui-tracking-normal",
      "title-large": "ui-text-[4.25rem] md:ui-text-7xl lg:ui-text-8xl xl:ui-text-[7.5rem]",
      "title-small": "ui-text-[4.25rem] md:ui-text-7xl lg:ui-text-[5rem]",
      base: "ui-text-base ui-tracking-normal",
      "body-small": "ui-text-[0.875rem] ui-tracking-normal",
      "eyebrow-large": "ui-text-base",
      "eyebrow-small": "ui-text-[0.75rem]",
      unset: ""
    },
    align: {
      left: "ui-text-left",
      center: "ui-text-center",
      right: "ui-text-right",
      justify: "ui-text-justify",
      centerMdLeft: "ui-text-center md:ui-text-left",
      centerLgLeft: "ui-text-center lg:ui-text-left"
    },
    color: {
      light: "ui-text-sandstone-200",
      dark: "ui-text-sandstone-500",
      disabled: "ui-text-gray-300",
      error: "ui-text-red-600",
      gray: "ui-text-gray-400",
      success: "ui-text-green-600",
      inherit: "ui-text-inherit",
      unset: ""
    },
    font: {
      sans: "ui-font-sans",
      serif: "ui-font-serif",
      "serif-italic": "ui-font-serif ui-italic"
    },
    height: {
      none: "ui-leading-none",
      tight: "ui-leading-tight",
      snug: "ui-leading-snug",
      normal: "ui-leading-normal",
      relaxed: "ui-leading-relaxed",
      loose: "ui-leading-loose",
      heading: "ui-leading-heading"
    },
    weight: {
      thin: "ui-font-thin",
      extralight: "ui-font-extralight",
      light: "ui-font-light",
      normal: "ui-font-normal",
      medium: "ui-font-medium",
      semibold: "ui-font-semibold",
      bold: "ui-font-bold",
      extrabold: "ui-font-extrabold",
      black: "ui-font-black"
    }
  },
  defaultVariants: {
    variant: "base",
    height: "normal",
    weight: "normal",
    font: "sans"
  }
});
function Typography({
  align = "left",
  Element = "p",
  children,
  className,
  color = "dark",
  font = "sans",
  height,
  variant = "base",
  weight = "normal",
  style: style2,
  ...props
}) {
  let _weight = weight;
  if (variant === "h1" || variant === "h2" || variant === "h3" || variant === "h4") {
    _weight = "light";
  }
  return /* @__PURE__ */ jsx11(Element, {
    className: typography({
      align,
      color,
      height,
      variant,
      weight: _weight,
      font,
      className
    }),
    style: style2,
    ...props,
    children
  });
}
Typography.displayName = "Typography";

// src/v3/List/index.tsx
import { jsx as jsx12 } from "react/jsx-runtime";
var LIST_TYPE_OL = "ol";
var LIST_TYPE_UL = "ul";
var listVar = cva2("[&>li]ui-list-[inherit]", {
  variants: {
    Element: {
      [LIST_TYPE_OL]: "",
      [LIST_TYPE_UL]: ""
    },
    condensed: {
      true: "",
      false: ""
    },
    unstyled: {
      true: "",
      false: ""
    }
  },
  compoundVariants: [
    {
      condensed: true,
      unstyled: true,
      className: "ui-my-1 [&>li]ui-my-1 ui-list-none"
    },
    {
      condensed: true,
      unstyled: false,
      className: "ui-my-1 [&>li]ui-my-1"
    },
    {
      condensed: false,
      unstyled: true,
      className: "ui-list-none"
    },
    {
      condensed: false,
      unstyled: false,
      className: "[&>li]ui-my-2"
    },
    {
      Element: LIST_TYPE_OL,
      unstyled: false,
      className: "ui-list-decimal ui-pl-8"
    },
    {
      Element: LIST_TYPE_UL,
      unstyled: false,
      className: "ui-list-disc ui-pl-8"
    }
  ]
});
function List({
  Element = "ul",
  condensed = false,
  unstyled = false,
  children,
  className = "",
  ...props
}) {
  return /* @__PURE__ */ jsx12(Typography, {
    Element,
    className: listVar({ className, condensed, Element, unstyled }),
    ...props,
    children
  });
}
List.displayName = "List";

// src/layout/v3/Footer/Footnotes/Footnote.tsx
init_esm_shims();
import { useContext as useContext4 } from "react";

// src/v3/ListItem/index.tsx
init_esm_shims();
import { jsx as jsx13 } from "react/jsx-runtime";
function ListItem({ children, ...props }) {
  return /* @__PURE__ */ jsx13(Typography, {
    ...props,
    Element: "li",
    weight: "normal",
    children
  });
}
ListItem.displayName = "ListItem";

// src/layout/v3/Footer/Footnotes/Footnote.tsx
import { Fragment, jsx as jsx14, jsxs } from "react/jsx-runtime";
function Footnote({
  marker,
  content,
  linkProps
}) {
  var _a;
  const context = useContext4(Context);
  const LinkComponent = (_a = context.LinkComponent) != null ? _a : "a";
  return /* @__PURE__ */ jsxs(ListItem, {
    className: "ui-!mb-1 ui-!mt-0 ui-text-sm",
    color: "inherit",
    "data-cy": `footnote-${content}`,
    children: [
      /* @__PURE__ */ jsxs("sup", {
        children: [
          marker,
          "\xA0"
        ]
      }),
      linkProps ? /* @__PURE__ */ jsx14(LinkComponent, {
        className: "ui-no-underline",
        "data-cy": `footnote-${content}-link`,
        href: linkProps.href || "",
        ...linkProps,
        children: content
      }) : /* @__PURE__ */ jsx14(Fragment, {
        children: content
      })
    ]
  });
}

// src/layout/v3/Footer/Footnotes/index.tsx
import { jsx as jsx15, jsxs as jsxs2 } from "react/jsx-runtime";
import { createElement } from "react";
var footnotesVar = cva3("ui-pb-8 ui-pt-16", {
  variants: {
    color: {
      "gray-600": "ui-bg-gray-600 ui-text-sandstone-200",
      "sandstone-500": "ui-bg-sandstone-500 ui-text-sandstone-200",
      "mustard-350": "ui-bg-mustard-350 ui-text-sandstone-200",
      "sandstone-200": "ui-bg-sandstone-200 ui-text-sandstone-500",
      unset: ""
    }
  },
  defaultVariants: {
    color: "gray-600"
  }
});
function Footnotes({
  afterContent,
  footnotes = [],
  className,
  color,
  inverseHeader = false,
  ...props
}) {
  if (!footnotes.length)
    return null;
  return /* @__PURE__ */ jsx15(InverseHeader, {
    enter: inverseHeader,
    children: /* @__PURE__ */ jsx15("div", {
      className: footnotesVar({ color, className }),
      "data-cy": "footnotes",
      ...props,
      children: /* @__PURE__ */ jsxs2("div", {
        className: "ui-mx-6 ui-border-t ui-border-gray-400/20 ui-pb-5 ui-pt-6 ui-flex ui-flex-col ui-gap-y-6 md:ui-mx-10 md:ui-px-10 xl:ui-mx-16 xl:ui-px-16",
        children: [
          /* @__PURE__ */ jsx15(List, {
            Element: "ol",
            className: "ui-flex ui-flex-col ui-gap-y-1 ui-w-full",
            color: "inherit",
            unstyled: true,
            children: footnotes.map((footnote) => /* @__PURE__ */ createElement(Footnote, {
              ...footnote,
              key: `footnote-${footnote.marker}`
            }))
          }),
          afterContent
        ]
      })
    })
  });
}

// src/layout/v3/Header/index.tsx
init_esm_shims();
import { cx as cx16 } from "class-variance-authority";

// src/icons/Oura.tsx
init_esm_shims();
import { jsx as jsx16, jsxs as jsxs3 } from "react/jsx-runtime";
function Oura({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs3("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    viewBox: "0 0 993 311",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx16("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx16("path", {
        d: "M63.443 27.388H190.38V0H63.443zM643.464 174.105H554.68V83.082h88.783c31.634 0 52.89 18.292 52.89 45.513 0 27.221-21.256 45.51-52.89 45.51m29.409 21.29c30.456-8.686 50.136-34.907 50.136-66.8 0-41.397-31.967-69.212-79.547-69.212H528.035v244.66h26.646V198.174h90.3l57.501 105.867h28.83l-59.946-108.218zM389.668 308.653c65.348 0 110.987-45.903 110.987-111.63V59.384h-27.387v135.793c0 50.688-34.377 86.09-83.6 86.09-40.798 0-84.709-26.94-84.709-86.09V59.384h-27.382v137.64c0 65.726 46.093 111.628 112.093 111.628m478.192-217.35 57.757 126.333H809.735zm-12.848-31.916L743.16 304.044h28.606l27.662-62.713h136.493l27.67 62.713h28.603L880.342 59.383zm-728.077-4.611C56.944 54.775 0 111.719 0 181.712c0 69.996 56.944 126.94 126.937 126.94 69.996 0 126.94-56.944 126.94-126.94 0-69.993-56.944-126.937-126.94-126.937m0 226.49c-54.893 0-99.553-44.66-99.553-99.553 0-54.892 44.661-99.55 99.554-99.55 54.894 0 99.556 44.658 99.556 99.55 0 54.893-44.662 99.553-99.556 99.553",
        fill: "currentColor"
      })
    ]
  });
}

// src/v3/Button/index.tsx
init_esm_shims();
import { forwardRef as forwardRef2, useContext as useContext5 } from "react";
import { cx as cx2, cva as cva4 } from "class-variance-authority";

// src/v3/CircularProgress/index.tsx
init_esm_shims();
import { motion } from "framer-motion";
import { jsx as jsx17 } from "react/jsx-runtime";
var SIZE = 44;
function CircularProgress({
  size = 40,
  thickness = 3.6,
  ...props
}) {
  return /* @__PURE__ */ jsx17("span", {
    ...props,
    "data-chromatic": "ignore",
    children: /* @__PURE__ */ jsx17(motion.span, {
      animate: { rotate: 360 },
      className: "ui-block",
      initial: { rotate: 0 },
      role: "progressbar",
      style: { width: size, height: size },
      transition: {
        repeat: Infinity,
        ease: "linear",
        duration: 1.4
      },
      children: /* @__PURE__ */ jsx17("svg", {
        className: "ui-block",
        viewBox: `${SIZE / 2} ${SIZE / 2} ${SIZE} ${SIZE}`,
        children: /* @__PURE__ */ jsx17(motion.circle, {
          animate: {
            strokeDasharray: ["1, 200", "100, 200", "100, 200"],
            strokeDashoffset: [0, -15, -125]
          },
          cx: SIZE,
          cy: SIZE,
          fill: "none",
          initial: {
            strokeDasharray: "80px, 200px",
            strokeDashoffset: 0
          },
          r: (SIZE - thickness) / 2,
          stroke: "currentColor",
          strokeDasharray: "80px, 200px",
          strokeDashoffset: 0,
          strokeWidth: thickness,
          transition: { ease: "easeInOut", repeat: Infinity, duration: 1.4 }
        })
      })
    })
  });
}
CircularProgress.displayName = "CircularProgress";

// src/icons/CardBtnArrowIcon.tsx
init_esm_shims();
import { jsx as jsx18, jsxs as jsxs4 } from "react/jsx-runtime";
function CardBtnArrowIcon({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs4("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 13,
    viewBox: "0 0 13 13",
    width: 13,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx18("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx18("path", {
        d: "M12.5303 6.53033C12.8232 6.23744 12.8232 5.76256 12.5303 5.46967L7.75736 0.696699C7.46447 0.403806 6.98959 0.403806 6.6967 0.696699C6.40381 0.989593 6.40381 1.46447 6.6967 1.75736L10.9393 6L6.6967 10.2426C6.40381 10.5355 6.40381 11.0104 6.6967 11.3033C6.98959 11.5962 7.46447 11.5962 7.75736 11.3033L12.5303 6.53033ZM0 6.75L12 6.75V5.25L0 5.25L0 6.75Z",
        fill: "currentColor"
      })
    ]
  });
}

// src/icons/TextLinkRightArrowIcon.tsx
init_esm_shims();
import { jsx as jsx19, jsxs as jsxs5 } from "react/jsx-runtime";
function TextLinkRightArrowIcon({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs5("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 6,
    viewBox: "0 0 20 6",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx19("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx19("path", {
        d: "M20 3L15 0.11325L15 5.88675L20 3ZM-4.37114e-08 3.5L15.5 3.5L15.5 2.5L4.37114e-08 2.5L-4.37114e-08 3.5Z",
        fill: "currentColor"
      })
    ]
  });
}

// src/v3/Button/index.tsx
import { jsx as jsx20, jsxs as jsxs6 } from "react/jsx-runtime";
var buttonVar = cva4(
  "ui-rounded-full ui-text-center ui-inline-block ui-transition",
  {
    variants: {
      variant: {
        primary: "ui-bg-blue-100 ui-text-sandstone-200 hover:ui-bg-blue-200",
        "secondary-light": "ui-bg-sandstone-200 ui-text-sandstone-500 hover:ui-bg-gray-400",
        "secondary-dark": "ui-bg-sandstone-500 ui-text-sandstone-200 hover:ui-bg-gray-600",
        "primary-text-link": "ui-text-stroke-color-transparent ui-text-stroke-width-0.5 hover:ui-text-stroke-color-current",
        "secondary-text-link": "ui-text-sandstone-200 ui-text-stroke-color-transparent ui-text-stroke-width-0.5 hover:ui-text-stroke-color-current",
        "outlined-dark": "ui-bg-transparent ui-text-sandstone-500 ui-border ui-border-solid ui-border-current",
        "outlined-light": "ui-bg-transparent ui-text-sandstone-200 ui-border ui-border-solid ui-border-current",
        unset: ""
      },
      size: {
        none: "ui-p-0",
        small: "ui-py-2 ui-px-4",
        medium: "ui-py-2 ui-px-4 lg:ui-py-3 lg:ui-px-6",
        large: "ui-py-3 ui-px-6"
      },
      loadingBtnPrimary: {
        true: "ui-bg-blue-200 ui-text-sandstone-200"
      },
      loadingBtnSecondaryLight: {
        true: "ui-bg-gray-400"
      },
      loadingBtnSecondaryDark: {
        true: "ui-bg-gray-600 ui-text-sandstone-200"
      },
      disabled: {
        true: "ui-pointer-events-none"
      }
    },
    defaultVariants: {
      variant: "primary",
      size: "large"
    },
    compoundVariants: [
      {
        class: "ui-bg-gray-300",
        disabled: true,
        variant: "primary"
      },
      {
        class: "ui-bg-gray-300 ui-text-sandstone-200",
        disabled: true,
        variant: "secondary-light"
      },
      {
        class: "ui-bg-gray-300 ui-text-sandstone-200",
        disabled: true,
        variant: "secondary-dark"
      },
      {
        class: "ui-text-gray-300",
        disabled: true,
        variant: "primary-text-link"
      },
      {
        class: "ui-text-gray-300",
        disabled: true,
        variant: "secondary-text-link"
      }
    ]
  }
);
function Spinner() {
  return /* @__PURE__ */ jsx20(CircularProgress, {
    "data-cy": "button-loading",
    size: 12,
    thickness: 3
  });
}
function ButtonCompartment({
  children,
  className = "",
  external,
  loading,
  icon,
  isTextLink
}) {
  const showCardButtonArrow = external && !isTextLink;
  const showTextLinkRightArrow = !external && isTextLink;
  const showIcon = Boolean(icon) && !showCardButtonArrow && !showTextLinkRightArrow;
  return /* @__PURE__ */ jsxs6("span", {
    className: cx2(
      "ui-items-center ui-inline-flex ui-gap-2 ui-content-center ui-justify-center",
      className,
      {
        "ui-relative": loading,
        "ui-underline": isTextLink
      }
    ),
    "data-cy": "button-compartment",
    children: [
      /* @__PURE__ */ jsx20("span", {
        children
      }),
      showCardButtonArrow ? /* @__PURE__ */ jsx20(CardBtnArrowIcon, {
        "aria-hidden": true,
        className: "ui--rotate-45",
        "data-cy": "card_button_arrow_icon"
      }) : null,
      showTextLinkRightArrow ? /* @__PURE__ */ jsx20(TextLinkRightArrowIcon, {
        "aria-hidden": true,
        "data-cy": "link_button_arrow_icon"
      }) : null,
      showIcon ? icon : null
    ]
  });
}
var Button = forwardRef2(function Button2({
  buttonCompartmentClassName = "",
  children,
  className = "",
  disabled = false,
  external,
  href = "",
  icon,
  loading = false,
  loadingTextEnabled = true,
  size,
  type = "button",
  variant = "primary",
  ...props
}, ref) {
  const context = useContext5(Context);
  const LinkComponent = external || !context.LinkComponent ? "a" : context.LinkComponent;
  const isTextLink = variant === "primary-text-link" || variant === "secondary-text-link";
  const _size = isTextLink ? "none" : size;
  const loadingBtnPrimary = variant === "primary" && loading;
  const loadingBtnSecondaryLight = variant === "secondary-light" && loading;
  const loadingBtnSecondaryDark = variant === "secondary-dark" && loading;
  if (href) {
    return /* @__PURE__ */ jsx20(LinkComponent, {
      "aria-disabled": disabled,
      className: buttonVar({
        variant,
        size: _size,
        disabled,
        className
      }),
      "data-cy": "button-link",
      href,
      ref,
      ...props,
      children: /* @__PURE__ */ jsx20(ButtonCompartment, {
        className: buttonCompartmentClassName,
        external,
        icon,
        isTextLink,
        children
      })
    });
  } else if (loadingTextEnabled && loading) {
    return /* @__PURE__ */ jsx20("button", {
      className: buttonVar({
        variant: "unset",
        size: _size,
        loadingBtnPrimary,
        loadingBtnSecondaryLight,
        loadingBtnSecondaryDark,
        disabled,
        className
      }),
      "data-cy": "button-loading-text",
      disabled: true,
      ref,
      type,
      ...props,
      children: /* @__PURE__ */ jsxs6("div", {
        className: "ui-inline-flex ui-gap-2 ui-justify-center ui-items-center",
        children: [
          /* @__PURE__ */ jsx20(Spinner, {}),
          children,
          isTextLink ? /* @__PURE__ */ jsx20(TextLinkRightArrowIcon, {}) : null
        ]
      })
    });
  }
  return /* @__PURE__ */ jsx20("button", {
    className: buttonVar({
      variant: loading ? "unset" : variant,
      size: _size,
      loadingBtnPrimary,
      loadingBtnSecondaryLight,
      loadingBtnSecondaryDark,
      disabled,
      className
    }),
    "data-cy": "button",
    disabled: loading || disabled,
    ref,
    type,
    ...props,
    children: /* @__PURE__ */ jsxs6(ButtonCompartment, {
      className: buttonCompartmentClassName,
      icon,
      isTextLink,
      loading,
      children: [
        /* @__PURE__ */ jsx20("span", {
          className: cx2({ "ui-invisible": loading }),
          children
        }),
        loading ? /* @__PURE__ */ jsx20("span", {
          className: "ui-m-0 ui-absolute ui-top-0 ui-left-0 ui-right-0 ui-bottom-0 ui-flex ui-justify-center ui-items-center",
          children: /* @__PURE__ */ jsx20(Spinner, {})
        }) : null
      ]
    })
  });
});
Button.displayName = "Button";

// src/v3/GridItem/index.tsx
init_esm_shims();
import { cx as cx3 } from "class-variance-authority";

// src/v3/GridItem/gridItemVariants.ts
init_esm_shims();
import { cva as cva5 } from "class-variance-authority";
var spanVar = cva5("", {
  variants: {
    sm: {
      1: "ui-col-span-1",
      2: "ui-col-span-2",
      3: "ui-col-span-3",
      4: "ui-col-span-4",
      5: "ui-col-span-5",
      6: "ui-col-span-6",
      7: "ui-col-span-7",
      8: "ui-col-span-8",
      9: "ui-col-span-9",
      10: "ui-col-span-10"
    },
    md: {
      1: "md:ui-col-span-1",
      2: "md:ui-col-span-2",
      3: "md:ui-col-span-3",
      4: "md:ui-col-span-4",
      5: "md:ui-col-span-5",
      6: "md:ui-col-span-6",
      7: "md:ui-col-span-7",
      8: "md:ui-col-span-8",
      9: "md:ui-col-span-9",
      10: "md:ui-col-span-10",
      11: "md:ui-col-span-11",
      12: "md:ui-col-span-12",
      13: "md:ui-col-span-13",
      14: "md:ui-col-span-14",
      15: "md:ui-col-span-15",
      16: "md:ui-col-span-16",
      17: "md:ui-col-span-17",
      18: "md:ui-col-span-18",
      19: "md:ui-col-span-19",
      20: "md:ui-col-span-20",
      21: "md:ui-col-span-21",
      22: "md:ui-col-span-22",
      23: "md:ui-col-span-23",
      24: "md:ui-col-span-24"
    },
    lg: {
      1: "lg:ui-col-span-1",
      2: "lg:ui-col-span-2",
      3: "lg:ui-col-span-3",
      4: "lg:ui-col-span-4",
      5: "lg:ui-col-span-5",
      6: "lg:ui-col-span-6",
      7: "lg:ui-col-span-7",
      8: "lg:ui-col-span-8",
      9: "lg:ui-col-span-9",
      10: "lg:ui-col-span-10",
      11: "lg:ui-col-span-11",
      12: "lg:ui-col-span-12",
      13: "lg:ui-col-span-13",
      14: "lg:ui-col-span-14",
      15: "lg:ui-col-span-15",
      16: "lg:ui-col-span-16",
      17: "lg:ui-col-span-17",
      18: "lg:ui-col-span-18",
      19: "lg:ui-col-span-19",
      20: "lg:ui-col-span-20",
      21: "lg:ui-col-span-21",
      22: "lg:ui-col-span-22",
      23: "lg:ui-col-span-23",
      24: "lg:ui-col-span-24"
    },
    xl: {
      1: "xl:ui-col-span-1",
      2: "xl:ui-col-span-2",
      3: "xl:ui-col-span-3",
      4: "xl:ui-col-span-4",
      5: "xl:ui-col-span-5",
      6: "xl:ui-col-span-6",
      7: "xl:ui-col-span-7",
      8: "xl:ui-col-span-8",
      9: "xl:ui-col-span-9",
      10: "xl:ui-col-span-10",
      11: "xl:ui-col-span-11",
      12: "xl:ui-col-span-12",
      13: "xl:ui-col-span-13",
      14: "xl:ui-col-span-14",
      15: "xl:ui-col-span-15",
      16: "xl:ui-col-span-16",
      17: "xl:ui-col-span-17",
      18: "xl:ui-col-span-18",
      19: "xl:ui-col-span-19",
      20: "xl:ui-col-span-20",
      21: "xl:ui-col-span-21",
      22: "xl:ui-col-span-22",
      23: "xl:ui-col-span-23",
      24: "xl:ui-col-span-24"
    },
    xxl: {
      1: "xxl:ui-col-span-1",
      2: "xxl:ui-col-span-2",
      3: "xxl:ui-col-span-3",
      4: "xxl:ui-col-span-4",
      5: "xxl:ui-col-span-5",
      6: "xxl:ui-col-span-6",
      7: "xxl:ui-col-span-7",
      8: "xxl:ui-col-span-8",
      9: "xxl:ui-col-span-9",
      10: "xxl:ui-col-span-10",
      11: "xxl:ui-col-span-11",
      12: "xxl:ui-col-span-12",
      13: "xxl:ui-col-span-13",
      14: "xxl:ui-col-span-14",
      15: "xxl:ui-col-span-15",
      16: "xxl:ui-col-span-16",
      17: "xxl:ui-col-span-17",
      18: "xxl:ui-col-span-18",
      19: "xxl:ui-col-span-19",
      20: "xxl:ui-col-span-20",
      21: "xxl:ui-col-span-21",
      22: "xxl:ui-col-span-22",
      23: "xxl:ui-col-span-23",
      24: "xxl:ui-col-span-24"
    }
  }
});
var colStartVar = cva5("", {
  variants: {
    sm: {
      full: "ui-col-start-full",
      main: "ui-col-start-main",
      1: "ui-col-start-1",
      2: "ui-col-start-2",
      3: "ui-col-start-3",
      4: "ui-col-start-4",
      5: "ui-col-start-5",
      6: "ui-col-start-6",
      7: "ui-col-start-7",
      8: "ui-col-start-8",
      9: "ui-col-start-9"
    },
    md: {
      full: "md:ui-col-start-full",
      main: "md:ui-col-start-main",
      1: "md:ui-col-start-1",
      2: "md:ui-col-start-2",
      3: "md:ui-col-start-3",
      4: "md:ui-col-start-4",
      5: "md:ui-col-start-5",
      6: "md:ui-col-start-6",
      7: "md:ui-col-start-7",
      8: "md:ui-col-start-8",
      9: "md:ui-col-start-9",
      10: "md:ui-col-start-10",
      11: "md:ui-col-start-11",
      12: "md:ui-col-start-12",
      13: "md:ui-col-start-13",
      14: "md:ui-col-start-14",
      15: "md:ui-col-start-15",
      16: "md:ui-col-start-16",
      17: "md:ui-col-start-17",
      18: "md:ui-col-start-18",
      19: "md:ui-col-start-19",
      20: "md:ui-col-start-20",
      21: "md:ui-col-start-21",
      22: "md:ui-col-start-22",
      23: "md:ui-col-start-23"
    },
    lg: {
      full: "lg:ui-col-start-full",
      main: "lg:ui-col-start-main",
      1: "lg:ui-col-start-1",
      2: "lg:ui-col-start-2",
      3: "lg:ui-col-start-3",
      4: "lg:ui-col-start-4",
      5: "lg:ui-col-start-5",
      6: "lg:ui-col-start-6",
      7: "lg:ui-col-start-7",
      8: "lg:ui-col-start-8",
      9: "lg:ui-col-start-9",
      10: "lg:ui-col-start-10",
      11: "lg:ui-col-start-11",
      12: "lg:ui-col-start-12",
      13: "lg:ui-col-start-13",
      14: "lg:ui-col-start-14",
      15: "lg:ui-col-start-15",
      16: "lg:ui-col-start-16",
      17: "lg:ui-col-start-17",
      18: "lg:ui-col-start-18",
      19: "lg:ui-col-start-19",
      20: "lg:ui-col-start-20",
      21: "lg:ui-col-start-21",
      22: "lg:ui-col-start-22",
      23: "lg:ui-col-start-23"
    },
    xl: {
      full: "xl:ui-col-start-full",
      main: "xl:ui-col-start-main",
      1: "xl:ui-col-start-1",
      2: "xl:ui-col-start-2",
      3: "xl:ui-col-start-3",
      4: "xl:ui-col-start-4",
      5: "xl:ui-col-start-5",
      6: "xl:ui-col-start-6",
      7: "xl:ui-col-start-7",
      8: "xl:ui-col-start-8",
      9: "xl:ui-col-start-9",
      10: "xl:ui-col-start-10",
      11: "xl:ui-col-start-11",
      12: "xl:ui-col-start-12",
      13: "xl:ui-col-start-13",
      14: "xl:ui-col-start-14",
      15: "xl:ui-col-start-15",
      16: "xl:ui-col-start-16",
      17: "xl:ui-col-start-17",
      18: "xl:ui-col-start-18",
      19: "xl:ui-col-start-19",
      20: "xl:ui-col-start-20",
      21: "xl:ui-col-start-21",
      22: "xl:ui-col-start-22",
      23: "xl:ui-col-start-23"
    },
    xxl: {
      full: "xxl:ui-col-start-full",
      main: "xxl:ui-col-start-main",
      1: "xxl:ui-col-start-1",
      2: "xxl:ui-col-start-2",
      3: "xxl:ui-col-start-3",
      4: "xxl:ui-col-start-4",
      5: "xxl:ui-col-start-5",
      6: "xxl:ui-col-start-6",
      7: "xxl:ui-col-start-7",
      8: "xxl:ui-col-start-8",
      9: "xxl:ui-col-start-9",
      10: "xxl:ui-col-start-10",
      11: "xxl:ui-col-start-11",
      12: "xxl:ui-col-start-12",
      13: "xxl:ui-col-start-13",
      14: "xxl:ui-col-start-14",
      15: "xxl:ui-col-start-15",
      16: "xxl:ui-col-start-16",
      17: "xxl:ui-col-start-17",
      18: "xxl:ui-col-start-18",
      19: "xxl:ui-col-start-19",
      20: "xxl:ui-col-start-20",
      21: "xxl:ui-col-start-21",
      22: "xxl:ui-col-start-22",
      23: "xxl:ui-col-start-23"
    }
  }
});
var colEndVar = cva5("", {
  variants: {
    sm: {
      full: "ui-col-end-full",
      main: "ui-col-end-main",
      1: "ui-col-end-1",
      2: "ui-col-end-2",
      3: "ui-col-end-3",
      4: "ui-col-end-4",
      5: "ui-col-end-5",
      6: "ui-col-end-6",
      7: "ui-col-end-7",
      8: "ui-col-end-8",
      9: "ui-col-end-9",
      10: "ui-col-end-10"
    },
    md: {
      full: "md:ui-col-end-full",
      main: "md:ui-col-end-main",
      1: "md:ui-col-end-1",
      2: "md:ui-col-end-2",
      3: "md:ui-col-end-3",
      4: "md:ui-col-end-4",
      5: "md:ui-col-end-5",
      6: "md:ui-col-end-6",
      7: "md:ui-col-end-7",
      8: "md:ui-col-end-8",
      9: "md:ui-col-end-9",
      10: "md:ui-col-end-10",
      11: "md:ui-col-end-11",
      12: "md:ui-col-end-12",
      13: "md:ui-col-end-13",
      14: "md:ui-col-end-14",
      15: "md:ui-col-end-15",
      16: "md:ui-col-end-16",
      17: "md:ui-col-end-17",
      18: "md:ui-col-end-18",
      19: "md:ui-col-end-19",
      20: "md:ui-col-end-20",
      21: "md:ui-col-end-21",
      22: "md:ui-col-end-22",
      23: "md:ui-col-end-23",
      24: "md:ui-col-end-24"
    },
    lg: {
      full: "lg:ui-col-end-full",
      main: "lg:ui-col-end-main",
      1: "lg:ui-col-end-1",
      2: "lg:ui-col-end-2",
      3: "lg:ui-col-end-3",
      4: "lg:ui-col-end-4",
      5: "lg:ui-col-end-5",
      6: "lg:ui-col-end-6",
      7: "lg:ui-col-end-7",
      8: "lg:ui-col-end-8",
      9: "lg:ui-col-end-9",
      10: "lg:ui-col-end-10",
      11: "lg:ui-col-end-11",
      12: "lg:ui-col-end-12",
      13: "lg:ui-col-end-13",
      14: "lg:ui-col-end-14",
      15: "lg:ui-col-end-15",
      16: "lg:ui-col-end-16",
      17: "lg:ui-col-end-17",
      18: "lg:ui-col-end-18",
      19: "lg:ui-col-end-19",
      20: "lg:ui-col-end-20",
      21: "lg:ui-col-end-21",
      22: "lg:ui-col-end-22",
      23: "lg:ui-col-end-23",
      24: "lg:ui-col-end-24"
    },
    xl: {
      full: "xl:ui-col-end-full",
      main: "xl:ui-col-end-main",
      1: "xl:ui-col-end-1",
      2: "xl:ui-col-end-2",
      3: "xl:ui-col-end-3",
      4: "xl:ui-col-end-4",
      5: "xl:ui-col-end-5",
      6: "xl:ui-col-end-6",
      7: "xl:ui-col-end-7",
      8: "xl:ui-col-end-8",
      9: "xl:ui-col-end-9",
      10: "xl:ui-col-end-10",
      11: "xl:ui-col-end-11",
      12: "xl:ui-col-end-12",
      13: "xl:ui-col-end-13",
      14: "xl:ui-col-end-14",
      15: "xl:ui-col-end-15",
      16: "xl:ui-col-end-16",
      17: "xl:ui-col-end-17",
      18: "xl:ui-col-end-18",
      19: "xl:ui-col-end-19",
      20: "xl:ui-col-end-20",
      21: "xl:ui-col-end-21",
      22: "xl:ui-col-end-22",
      23: "xl:ui-col-end-23",
      24: "xl:ui-col-end-24"
    },
    xxl: {
      full: "xxl:ui-col-end-full",
      main: "xxl:ui-col-end-main",
      1: "xxl:ui-col-end-1",
      2: "xxl:ui-col-end-2",
      3: "xxl:ui-col-end-3",
      4: "xxl:ui-col-end-4",
      5: "xxl:ui-col-end-5",
      6: "xxl:ui-col-end-6",
      7: "xxl:ui-col-end-7",
      8: "xxl:ui-col-end-8",
      9: "xxl:ui-col-end-9",
      10: "xxl:ui-col-end-10",
      11: "xxl:ui-col-end-11",
      12: "xxl:ui-col-end-12",
      13: "xxl:ui-col-end-13",
      14: "xxl:ui-col-end-14",
      15: "xxl:ui-col-end-15",
      16: "xxl:ui-col-end-16",
      17: "xxl:ui-col-end-17",
      18: "xxl:ui-col-end-18",
      19: "xxl:ui-col-end-19",
      20: "xxl:ui-col-end-20",
      21: "xxl:ui-col-end-21",
      22: "xxl:ui-col-end-22",
      23: "xxl:ui-col-end-23",
      24: "xxl:ui-col-end-24"
    }
  }
});
var rowStartVar = cva5("", {
  variants: {
    sm: {
      1: "ui-row-start-1",
      2: "ui-row-start-2",
      3: "ui-row-start-3",
      4: "ui-row-start-4",
      5: "ui-row-start-5",
      6: "ui-row-start-6",
      7: "ui-row-start-7",
      8: "ui-row-start-8",
      9: "ui-row-start-9",
      10: "ui-row-start-10",
      11: "ui-row-start-11",
      12: "ui-row-start-12"
    },
    md: {
      1: "md:ui-row-start-1",
      2: "md:ui-row-start-2",
      3: "md:ui-row-start-3",
      4: "md:ui-row-start-4",
      5: "md:ui-row-start-5",
      6: "md:ui-row-start-6",
      7: "md:ui-row-start-7",
      8: "md:ui-row-start-8",
      9: "md:ui-row-start-9",
      10: "md:ui-row-start-10",
      11: "md:ui-row-start-11",
      12: "md:ui-row-start-12"
    },
    lg: {
      1: "lg:ui-row-start-1",
      2: "lg:ui-row-start-2",
      3: "lg:ui-row-start-3",
      4: "lg:ui-row-start-4",
      5: "lg:ui-row-start-5",
      6: "lg:ui-row-start-6",
      7: "lg:ui-row-start-7",
      8: "lg:ui-row-start-8",
      9: "lg:ui-row-start-9",
      10: "lg:ui-row-start-10",
      11: "lg:ui-row-start-11",
      12: "lg:ui-row-start-12"
    },
    xl: {
      1: "xl:ui-row-start-1",
      2: "xl:ui-row-start-2",
      3: "xl:ui-row-start-3",
      4: "xl:ui-row-start-4",
      5: "xl:ui-row-start-5",
      6: "xl:ui-row-start-6",
      7: "xl:ui-row-start-7",
      8: "xl:ui-row-start-8",
      9: "xl:ui-row-start-9",
      10: "xl:ui-row-start-10",
      11: "xl:ui-row-start-11",
      12: "xl:ui-row-start-12"
    },
    xxl: {
      1: "xxl:ui-row-start-1",
      2: "xxl:ui-row-start-2",
      3: "xxl:ui-row-start-3",
      4: "xxl:ui-row-start-4",
      5: "xxl:ui-row-start-5",
      6: "xxl:ui-row-start-6",
      7: "xxl:ui-row-start-7",
      8: "xxl:ui-row-start-8",
      9: "xxl:ui-row-start-9",
      10: "xxl:ui-row-start-10",
      11: "xxl:ui-row-start-11",
      12: "xxl:ui-row-start-12"
    }
  }
});
var rowEndVar = cva5("", {
  variants: {
    sm: {
      2: "ui-row-end-2",
      3: "ui-row-end-3",
      4: "ui-row-end-4",
      5: "ui-row-end-5",
      6: "ui-row-end-6",
      7: "ui-row-end-7",
      8: "ui-row-end-8",
      9: "ui-row-end-9",
      10: "ui-row-end-10",
      11: "ui-row-end-11",
      12: "ui-row-end-12"
    },
    md: {
      2: "md:ui-row-end-2",
      3: "md:ui-row-end-3",
      4: "md:ui-row-end-4",
      5: "md:ui-row-end-5",
      6: "md:ui-row-end-6",
      7: "md:ui-row-end-7",
      8: "md:ui-row-end-8",
      9: "md:ui-row-end-9",
      10: "md:ui-row-end-10",
      11: "md:ui-row-end-11",
      12: "md:ui-row-end-12"
    },
    lg: {
      2: "lg:ui-row-end-2",
      3: "lg:ui-row-end-3",
      4: "lg:ui-row-end-4",
      5: "lg:ui-row-end-5",
      6: "lg:ui-row-end-6",
      7: "lg:ui-row-end-7",
      8: "lg:ui-row-end-8",
      9: "lg:ui-row-end-9",
      10: "lg:ui-row-end-10",
      11: "lg:ui-row-end-11",
      12: "lg:ui-row-end-12"
    },
    xl: {
      2: "xl:ui-row-end-2",
      3: "xl:ui-row-end-3",
      4: "xl:ui-row-end-4",
      5: "xl:ui-row-end-5",
      6: "xl:ui-row-end-6",
      7: "xl:ui-row-end-7",
      8: "xl:ui-row-end-8",
      9: "xl:ui-row-end-9",
      10: "xl:ui-row-end-10",
      11: "xl:ui-row-end-11",
      12: "xl:ui-row-end-12"
    },
    xxl: {
      2: "xxl:ui-row-end-2",
      3: "xxl:ui-row-end-3",
      4: "xxl:ui-row-end-4",
      5: "xxl:ui-row-end-5",
      6: "xxl:ui-row-end-6",
      7: "xxl:ui-row-end-7",
      8: "xxl:ui-row-end-8",
      9: "xxl:ui-row-end-9",
      10: "xxl:ui-row-end-10",
      11: "xxl:ui-row-end-11",
      12: "xxl:ui-row-end-12"
    }
  }
});

// src/v3/GridItem/index.tsx
import { jsx as jsx21 } from "react/jsx-runtime";
function GridItem({
  children,
  className,
  colEnd,
  colStart,
  Element = "div",
  rowEnd,
  rowStart,
  span,
  ...props
}) {
  const {
    sm: smallSpan,
    md: mediumSpan,
    lg: largeSpan,
    xl: xlSpan,
    xxl: xxlSpan
  } = span || {};
  const {
    sm: smallStart,
    md: mediumStart,
    lg: largeStart,
    xl: xlStart,
    xxl: xxlStart
  } = colStart || {};
  const {
    sm: smallEnd,
    md: mediumEnd,
    lg: largeEnd,
    xl: xlEnd,
    xxl: xxlEnd
  } = colEnd || {};
  const {
    sm: smallRowStart,
    md: mediumRowStart,
    lg: largeRowStart,
    xl: xlRowStart,
    xxl: xxlRowStart
  } = rowStart || {};
  const {
    sm: smallRowEnd,
    md: mediumRowEnd,
    lg: largeRowEnd,
    xl: xlRowEnd,
    xxl: xxlRowEnd
  } = rowEnd || {};
  return /* @__PURE__ */ jsx21(Element, {
    className: cx3(
      spanVar({
        sm: smallSpan,
        md: mediumSpan,
        lg: largeSpan,
        xl: xlSpan,
        xxl: xxlSpan
      }),
      colStartVar({
        sm: smallStart,
        md: mediumStart,
        lg: largeStart,
        xl: xlStart,
        xxl: xxlStart
      }),
      colEndVar({
        sm: smallEnd,
        md: mediumEnd,
        lg: largeEnd,
        xl: xlEnd,
        xxl: xxlEnd
      }),
      rowStartVar({
        sm: smallRowStart,
        md: mediumRowStart,
        lg: largeRowStart,
        xl: xlRowStart,
        xxl: xxlRowStart
      }),
      rowEndVar({
        sm: smallRowEnd,
        md: mediumRowEnd,
        lg: largeRowEnd,
        xl: xlRowEnd,
        xxl: xxlRowEnd
      }),
      className
    ),
    "data-cy": "gridItem_div",
    ...props,
    children
  });
}
GridItem.displayName = "GridItem";

// src/v3/LayoutGrid/index.tsx
init_esm_shims();
import { cva as cva6, cx as cx4 } from "class-variance-authority";
import { jsx as jsx22 } from "react/jsx-runtime";
var grid = cva6("", {
  variants: {
    rowGap: {
      0: "ui-gap-y-0",
      8: "ui-gap-y-2",
      16: "ui-gap-y-4",
      24: "ui-gap-y-6",
      32: "ui-gap-y-8",
      40: "ui-gap-y-10",
      48: "ui-gap-y-12",
      56: "ui-gap-y-14",
      64: "ui-gap-y-16",
      80: "ui-gap-y-20",
      96: "ui-gap-y-24",
      112: "ui-gap-y-28",
      128: "ui-gap-y-32",
      144: "ui-gap-y-36",
      160: "ui-gap-y-40",
      176: "ui-gap-y-44"
    }
  },
  defaultVariants: {
    rowGap: 8
  }
});
function LayoutGrid({
  children,
  className = "",
  Element = "div",
  rowGap,
  ...props
}) {
  return /* @__PURE__ */ jsx22(Element, {
    className: grid({ rowGap, className: cx4("gridContainerV3", className) }),
    "data-cy": "layout-grid",
    ...props,
    children
  });
}
LayoutGrid.displayName = "LayoutGrid";

// src/layout/v3/NavLink/index.tsx
init_esm_shims();
import { cx as cx5 } from "class-variance-authority";
import { useContext as useContext6 } from "react";
import { jsx as jsx23, jsxs as jsxs7 } from "react/jsx-runtime";
function NavLink({
  as,
  children,
  className,
  external,
  hideArrow = false,
  href = "",
  id,
  replace,
  scroll,
  shallow,
  onClick = void 0,
  ...props
}) {
  const context = useContext6(Context);
  const LinkComponent = external || !context.LinkComponent ? "a" : context.LinkComponent;
  const hasArrow = external && !hideArrow;
  return /* @__PURE__ */ jsx23("li", {
    className: "ui-list-none ui-h-full",
    children: /* @__PURE__ */ jsxs7(LinkComponent, {
      as,
      className: cx5(className, {
        "ui-relative ui-inline": hasArrow
      }),
      "data-cy": id,
      "data-menu-link": true,
      href,
      id,
      onClick,
      replace,
      scroll,
      shallow,
      tabIndex: 0,
      ...props,
      children: [
        children,
        hasArrow ? /* @__PURE__ */ jsx23(CardBtnArrowIcon, {
          "aria-hidden": "true",
          className: "ui-absolute ui-inline ui--rotate-45 ui-translate-x-2 ui-translate-y-[0.375rem]",
          "data-cy": "nav-link-arrow"
        }) : null
      ]
    })
  });
}
NavLink.displayName = "NavLink";

// src/layout/v3/Header/HamburgerBox/index.tsx
init_esm_shims();
import { cx as cx7 } from "class-variance-authority";
import { forwardRef as forwardRef4 } from "react";

// src/layout/v3/Header/Hamburger/index.tsx
init_esm_shims();
import { forwardRef as forwardRef3 } from "react";
import { cx as cx6 } from "class-variance-authority";
import { jsx as jsx24, jsxs as jsxs8 } from "react/jsx-runtime";
var Hamburger = forwardRef3(
  function Hamburger2({ onClick, open }, ref) {
    return /* @__PURE__ */ jsxs8("button", {
      "aria-controls": "navMenu",
      "aria-expanded": open,
      className: cx6(
        "ui-bg-transparent ui-relative ui-text-inherit",
        "ui-h-10 ui-w-10 lg:ui-h-12 lg:ui-w-12",
        "ui-rounded-full ui-border-solid ui-border"
      ),
      "data-cy": "nav_hamburger",
      id: "hamburger",
      onClick,
      ref,
      type: "button",
      children: [
        /* @__PURE__ */ jsx24("span", {
          className: "ui-sr-only",
          children: open ? /* @__PURE__ */ jsx24(FormattedMessage_default, {
            id: "header_hamburger_close_sr_label_2024"
          }) : /* @__PURE__ */ jsx24(FormattedMessage_default, {
            id: "header_hamburger_open_sr_label_2024"
          })
        }),
        /* @__PURE__ */ jsx24("span", {
          "aria-hidden": "true",
          className: cx6(
            "hamburgerLinesV3 ui-block ui-h-4 ui-w-4",
            "ui-absolute ui-left-1/2 ui-top-1/2 ui-transform ui--translate-x-1/2 ui--translate-y-1/2",
            {
              active: open
            }
          )
        })
      ]
    });
  }
);
Hamburger.displayName = "Hamburger";

// src/layout/v3/Header/HamburgerBox/index.tsx
import { jsx as jsx25, jsxs as jsxs9 } from "react/jsx-runtime";
var HamburgerBox = forwardRef4(
  function HamburgerBox2({ className = "", hideLinks, onClick, open }, ref) {
    return /* @__PURE__ */ jsxs9("div", {
      className: cx7(
        "ui-flex ui-items-center ui-gap-3",
        { "lg:ui-hidden": hideLinks },
        className
      ),
      children: [
        /* @__PURE__ */ jsx25(Typography, {
          Element: "span",
          align: "right",
          "aria-hidden": "true",
          className: "ui-hidden lg:ui-block",
          color: "inherit",
          variant: "body-small",
          weight: "bold",
          children: t(open ? "close" : "menu")
        }),
        /* @__PURE__ */ jsx25(Hamburger, {
          onClick,
          open,
          ref
        })
      ]
    });
  }
);
HamburgerBox.displayName = "HamburgerBox";

// src/layout/v3/Header/Menu/index.tsx
init_esm_shims();
import { cx as cx12 } from "class-variance-authority";
import { Fragment as Fragment4 } from "react";

// src/v3/GradientBG/index.tsx
init_esm_shims();
import { cva as cva7 } from "class-variance-authority";

// src/v3/RadialGradient/index.tsx
init_esm_shims();
import { cx as cx8 } from "class-variance-authority";

// src/v3/utils/hexToRgba.ts
init_esm_shims();
function hexToRgba(hex, opacity) {
  const result = /^#?(?<temp3>[a-f\d]{2})(?<temp2>[a-f\d]{2})(?<temp1>[a-f\d]{2})$/i.exec(
    hex
  );
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16),
    a: opacity
  } : { r: 0, g: 0, b: 0, a: 0 };
}

// src/v3/RadialGradient/index.tsx
import { jsx as jsx26 } from "react/jsx-runtime";
var style = (shape, positionX, positionY, gradientColor, size) => ({
  backgroundImage: `radial-gradient(${shape} at ${positionX} ${positionY}, ${gradientColor} 0px, transparent ${size})`
});
function RadialGradient({
  hex = "#081C2D",
  id = "default-gradient",
  opacity = 1,
  position = [50, 50],
  shape = "ellipse",
  size = 40,
  className
}) {
  const gradientColor = hexToRgba(hex, opacity);
  const { r, g, b: b2, a } = gradientColor;
  return /* @__PURE__ */ jsx26("div", {
    className: cx8(
      "ui-absolute ui-w-full ui-h-full ui-top-0 ui-left-0 ui-pointer-events-none",
      className
    ),
    "data-cy": "radialGradient_div",
    id,
    style: style(
      shape,
      `${position[0]}%`,
      `${position[1]}%`,
      `rgba(${r}, ${g}, ${b2}, ${a})`,
      `${size}%`
    )
  });
}
RadialGradient.displayName = "RadialGradient";

// src/v3/GradientBG/index.tsx
import { jsx as jsx27, jsxs as jsxs10 } from "react/jsx-runtime";
var gradientBGVar = cva7("ui-relative ui-min-h-full", {
  variants: {
    background: {
      "gray-600": "ui-bg-gray-600",
      "cream-100": "ui-bg-cream-100",
      "sandstone-200": "ui-bg-sandstone-200",
      "sandstone-300": "ui-bg-sandstone-300",
      "sandstone-400": "ui-bg-sandstone-400",
      "gray-100": "ui-bg-gray-100",
      "gray-200": "ui-bg-gray-200",
      "slate-100": "ui-bg-slate-100",
      "slate-300": "ui-bg-slate-300",
      "slate-600": "ui-bg-slate-600",
      "mustard-50": "ui-bg-mustard-50"
    }
  },
  defaultVariants: {
    background: "gray-100"
  }
});
function RadialGradientBG({
  background,
  className = "",
  children,
  gradients: gradients4,
  ...rest
}) {
  return /* @__PURE__ */ jsxs10("div", {
    className: gradientBGVar({ background, className }),
    "data-cy": "radialGradientBG_div",
    ...rest,
    children: [
      gradients4.map(({ hex, id, ...props }) => /* @__PURE__ */ jsx27(RadialGradient, {
        hex,
        id,
        ...props
      }, `${hex}-${id}`)),
      children
    ]
  });
}
RadialGradientBG.displayName = "RadialGradientBG";

// src/v3/Accordion/index.tsx
init_esm_shims();
import { cx as cx9 } from "class-variance-authority";
import {
  Children,
  Fragment as Fragment2,
  useState as useState3,
  useEffect as useEffect2,
  useId,
  useCallback,
  isValidElement
} from "react";
import { motion as motion2, useReducedMotion } from "framer-motion";

// src/icons/ChevronIconThin.tsx
init_esm_shims();
import { jsx as jsx28, jsxs as jsxs11 } from "react/jsx-runtime";
function ChevronIconThin({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs11("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 8,
    viewBox: "0 0 14 8",
    width: 14,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx28("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx28("path", {
        d: "M1 0.999756L7 6.99976L13 0.999756",
        stroke: "currentColor"
      })
    ]
  });
}

// src/v3/Accordion/index.tsx
import { Fragment as Fragment3, jsx as jsx29, jsxs as jsxs12 } from "react/jsx-runtime";
function AccordionHeader({
  children
}) {
  return /* @__PURE__ */ jsx29(Fragment3, {
    children
  });
}
function AccordionContent({
  children
}) {
  return /* @__PURE__ */ jsx29(Fragment3, {
    children
  });
}
function AHeader({
  children,
  expanded,
  hidden = false,
  onClick,
  variant,
  ...rest
}) {
  return /* @__PURE__ */ jsx29("div", {
    className: cx9("ui-border-t ui-border-opacity-[0.2]", {
      "ui-border-sandstone-500": variant === "dark",
      "ui-border-sandstone-200": variant === "light",
      "ui-hidden": hidden
    }),
    children: /* @__PURE__ */ jsxs12("button", {
      "aria-expanded": expanded,
      className: cx9(
        "ui-pt-4 ui-w-full",
        "ui-flex ui-justify-between ui-items-center"
      ),
      onClick,
      tabIndex: expanded ? -1 : 0,
      type: "button",
      ...rest,
      children: [
        children,
        /* @__PURE__ */ jsx29(ChevronIconThin, {
          "aria-hidden": true,
          className: cx9("ui-transition ui-duration-500 ui-rotate-0", {
            "ui-rotate-180": expanded
          })
        })
      ]
    })
  });
}
var getAContentMotionProps = ({
  expanded,
  isContentAnimated,
  shouldReduceMotion
}) => {
  if (isContentAnimated) {
    return {
      animate: {
        opacity: expanded ? 1 : 0,
        filter: expanded ? "blur(0px)" : "blur(5px)",
        y: expanded ? 0 : -5,
        transition: {
          type: "tween",
          duration: shouldReduceMotion ? 0 : 0.8,
          staggerChildren: shouldReduceMotion ? 0 : 0.1
        }
      },
      initial: {
        opacity: 0,
        filter: "blur(5px)",
        y: -5
      },
      transition: {
        type: "spring",
        stiffness: 50,
        duration: 0.8
      }
    };
  }
  return {};
};
function AContent({
  children,
  expanded,
  hidden,
  lastIndex: lastIndex2,
  variant,
  isContentAnimated,
  ...rest
}) {
  const shouldReduceMotion = useReducedMotion();
  const _expanded = Boolean(expanded);
  return /* @__PURE__ */ jsx29("div", {
    className: cx9("ui-border-opacity-[0.2] ui-w-full ui-pb-4", {
      "ui-border-b": lastIndex2,
      "ui-border-sandstone-500": variant === "dark",
      "ui-border-sandstone-200": variant === "light",
      "ui-hidden": hidden
    }),
    children: /* @__PURE__ */ jsx29("div", {
      "aria-hidden": !_expanded,
      className: cx9("ui-mt-4", { "ui-hidden": !_expanded }),
      "data-cy": "accordion-content-wrapper",
      "data-expanded": _expanded,
      ...rest,
      children: /* @__PURE__ */ jsx29(motion2.div, {
        ...getAContentMotionProps({
          isContentAnimated,
          expanded: _expanded,
          shouldReduceMotion: Boolean(shouldReduceMotion)
        }),
        children
      })
    })
  });
}
var lastIndex = (index, childrenArray) => {
  return childrenArray.length - 1 === index;
};
function Accordion({
  children,
  close,
  hiddenIndices = [],
  nested = false,
  openAtIndex = null,
  variant = "dark",
  isContentAnimated = true,
  onClick
}) {
  const [open, setOpen] = useState3(openAtIndex);
  const id = useId();
  const getChildren = useCallback(() => {
    if (nested) {
      const nestedChildren = children.map((el) => {
        var _a;
        if (isValidElement(el)) {
          return (_a = el.props.children) != null ? _a : null;
        }
        return null;
      }).filter((child) => child !== null);
      return Children.toArray(nestedChildren);
    }
    return Children.toArray(children);
  }, [children, nested]);
  const childrenArray = getChildren();
  const headerId = `${id}-header`;
  const contentId = `${id}-content`;
  const checkExpanded = (index) => open === index;
  const handleChange = (index) => {
    if (checkExpanded(index)) {
      setOpen(null);
    } else {
      setOpen(index);
    }
    onClick == null ? void 0 : onClick(index);
  };
  useEffect2(() => {
    if (close) {
      setOpen(openAtIndex);
    }
  }, [close, openAtIndex]);
  return /* @__PURE__ */ jsx29(Fragment3, {
    children: childrenArray.map((child, index) => {
      const hiddenHeader = hiddenIndices.includes(index + 1);
      const hiddenContent = hiddenIndices.includes(index);
      const isLastBeforeHidden = hiddenIndices.includes(index + 2);
      const isLast = lastIndex(index, childrenArray) || isLastBeforeHidden;
      return /* @__PURE__ */ jsx29(Fragment2, {
        children: index % 2 ? /* @__PURE__ */ jsx29(AContent, {
          "aria-labelledby": headerId,
          expanded: checkExpanded(index),
          hidden: hiddenContent,
          lastIndex: isLast,
          ...child["props"],
          isContentAnimated,
          variant
        }) : /* @__PURE__ */ jsx29(AHeader, {
          "aria-controls": contentId,
          expanded: checkExpanded(index + 1),
          hidden: hiddenHeader,
          onClick: () => {
            handleChange(index + 1);
          },
          ...child["props"],
          variant
        })
      }, index);
    })
  });
}
Accordion.displayName = "Accordion";

// src/v3/data/defaultMenuData.ts
init_esm_shims();
var menuData = {
  menuLinks: [
    {
      id: "shop-category" /* ShopCategory */,
      title: "shop",
      links: [
        {
          id: "oura-ring",
          href: "/product/rings",
          label: "ring_gen_4"
        },
        {
          id: "sale",
          href: "/product/rings/oura-gen3",
          label: "ring_gen3_on_sale"
        },
        {
          id: "chargers",
          href: "/product/accessories/charger-oura-4",
          label: "drop_down_extra_charger"
        }
      ]
    },
    {
      id: "why-oura-category" /* WhyOuraCategory */,
      title: "why_oura_link",
      links: [
        {
          id: "why-oura",
          href: "/why-oura",
          label: "explore_why_oura_link"
        },
        {
          id: "science-and-research",
          href: "/science-and-research",
          label: "science_and_research_link"
        },
        {
          id: "sleep-and-rest",
          href: "/sleep-and-rest",
          label: "sleep_and_rest_link"
        },
        {
          id: "womens-health",
          href: "/womens-health",
          label: "womens_health_link"
        },
        {
          id: "stress",
          href: "/stress",
          label: "stress_link"
        },
        {
          id: "heart-health",
          href: "/heart-health",
          label: "heart_health_link"
        },
        {
          id: "activity-and-movement",
          href: "/activity-and-movement",
          label: "activity_and_movement_link"
        }
      ]
    },
    {
      id: "how-it-works-category" /* HowItWorksCategory */,
      title: "how_it_works_link",
      links: [
        {
          id: "how-it-works",
          href: "/how-it-works",
          label: "explore_how_it_works_link"
        },
        {
          id: "integrations",
          href: "/integrations",
          label: "integrations_link"
        }
      ]
    },
    {
      id: "menu-card" /* MenuCard */,
      title: "shop",
      link: {
        id: "oura-ring",
        href: "/product/rings",
        label: "shop"
      }
    }
  ]
};
var defaultMenuData_default = menuData;

// src/layout/v3/NavLinks/index.tsx
init_esm_shims();
import { cx as cx10 } from "class-variance-authority";
import { jsx as jsx30, jsxs as jsxs13 } from "react/jsx-runtime";
function NavLinks({
  border = true,
  currentPath,
  heading,
  isLocalised,
  navLinkClass = "",
  navLinks,
  tabIndex,
  onClick
}) {
  return /* @__PURE__ */ jsxs13("nav", {
    className: cx10("lg:ui-pt-4", {
      "ui-border-sandstone-500 ui-border-opacity-[0.2] lg:ui-border-t": border
    }),
    children: [
      heading ? /* @__PURE__ */ jsx30(Typography, {
        Element: "div",
        className: "ui-pb-2.5",
        variant: "body-large",
        weight: "semibold",
        children: isLocalised ? heading : t(heading)
      }) : null,
      /* @__PURE__ */ jsx30("ul", {
        className: "ui-flex ui-flex-col ui-space-y-3",
        children: navLinks.map(({ id, label, ...args }) => /* @__PURE__ */ jsx30(NavLink, {
          className: cx10(navLinkClass, {
            "ui-font-bold ui-cursor-default": currentPath === args.href
          }),
          ...args,
          onClick,
          tabIndex,
          children: isLocalised ? label : t(label)
        }, id))
      })
    ]
  });
}
NavLink.displayName = "NavLinks";

// src/layout/v3/Header/Menu/MenuCtaImage.tsx
init_esm_shims();
import { useIntl } from "react-intl";
import { cx as cx11 } from "class-variance-authority";
import { jsx as jsx31, jsxs as jsxs14 } from "react/jsx-runtime";
var tValue = {
  em: function em2(chunks) {
    return /* @__PURE__ */ jsx31("em", {
      className: "ui-font-serif ui-italic",
      children: chunks
    });
  }
};
function MenuCtaImage({
  isLocalised,
  menuCardLink,
  menuImageComponent,
  onClick,
  tabIndex
}) {
  var _a, _b;
  const { formatMessage } = useIntl();
  const link = menuCardLink == null ? void 0 : menuCardLink.link;
  const overlay = link == null ? void 0 : link.overlay;
  const color = (_a = overlay == null ? void 0 : overlay.color) != null ? _a : "light";
  const title = (_b = overlay == null ? void 0 : overlay.title) != null ? _b : t("gen4_is_here", tValue);
  const description = overlay == null ? void 0 : overlay.description;
  return /* @__PURE__ */ jsx31(GridItem, {
    colEnd: { sm: "main", lg: "main" },
    colStart: { sm: "main", lg: 17 },
    children: /* @__PURE__ */ jsxs14("nav", {
      className: "ui-grid ui-grid-cols-1",
      children: [
        /* @__PURE__ */ jsx31(GridItem, {
          colEnd: { sm: "full" },
          colStart: { sm: "full" },
          rowEnd: { sm: 2 },
          rowStart: { sm: 1 },
          children: /* @__PURE__ */ jsx31("ul", {
            children: link ? /* @__PURE__ */ jsx31(NavLink, {
              "aria-label": formatMessage({ id: "shop_rings" }),
              className: "ui-block ui-rounded-xl ui-overflow-hidden",
              "data-cy": "shop",
              href: link.href,
              onClick,
              tabIndex,
              children: menuImageComponent
            }) : null
          })
        }),
        /* @__PURE__ */ jsx31(GridItem, {
          className: "ui-p-4 ui-flex ui-flex-col ui-justify-start ui-pointer-events-none ui-relative",
          colEnd: { sm: "full" },
          colStart: { sm: "full" },
          rowEnd: { sm: 2 },
          rowStart: { sm: 1 },
          children: /* @__PURE__ */ jsxs14(Typography, {
            Element: "div",
            className: "ui-flex ui-flex-col",
            children: [
              /* @__PURE__ */ jsx31(Typography, {
                Element: "span",
                className: "ui-text-heading-sm xl:ui-text-heading-lg",
                color,
                height: description ? "none" : "tight",
                variant: "unset",
                weight: description ? "normal" : "thin",
                children: title
              }),
              description ? /* @__PURE__ */ jsx31(Typography, {
                Element: "p",
                className: "ui-mt-3",
                color,
                variant: "base",
                weight: "normal",
                children: description
              }) : null
            ]
          })
        }),
        /* @__PURE__ */ jsx31(GridItem, {
          className: "ui-p-4 ui-flex ui-flex-col ui-justify-end ui-pointer-events-none ui-relative",
          colEnd: { sm: "full" },
          colStart: { sm: "full" },
          rowEnd: { sm: 2 },
          rowStart: { sm: 1 },
          children: link ? /* @__PURE__ */ jsx31("div", {
            className: cx11(
              "ui-bg-blue-100 ui-text-sandstone-200",
              "ui-self-end ui-rounded-full ui-text-center ui-inline-block",
              "ui-py-2 ui-px-4 lg:ui-py-3 lg:ui-px-6"
            ),
            children: isLocalised ? link.label : t("shop")
          }) : null
        })
      ]
    })
  });
}
MenuCtaImage.displayName = "MenuCtaImage";

// src/layout/v3/Header/Menu/index.tsx
import { jsx as jsx32, jsxs as jsxs15 } from "react/jsx-runtime";
var gradients = [
  {
    shape: "circle",
    hex: "#D7C9A7",
    id: "butter-1",
    position: [10, 10],
    opacity: 1,
    size: 40
  },
  {
    shape: "circle",
    hex: "#D7C9A7",
    id: "butter-2",
    position: [70, 70],
    opacity: 1,
    size: 90
  }
];
var COL_STARTS = ["main", 7, 12];
var COL_ENDS = [6, 11, 16];
function DesktopMenu({
  currentPath,
  isLocalised,
  menuCardLink,
  menuImageComponent,
  menuLinks,
  open,
  onMenuLinkClick,
  onMenuShopButtonClick
}) {
  const tabIndex = open ? 0 : -1;
  return /* @__PURE__ */ jsx32("div", {
    "aria-describedby": "hamburger",
    "aria-hidden": !open,
    className: cx12(
      "ui-rounded-b-xl ui-bg-sandstone-200",
      "ui-fixed ui-top-0 ui-left-0 ui-right-0",
      "ui-transition-all ui-duration-300",
      "ui-pt-28 ui-pb-16",
      "ui-hidden lg:ui-block",
      { "ui--translate-y-full": !open },
      { "ui-translate-y-0": open }
    ),
    "data-cy": "desktop-menu",
    id: "navMenu",
    children: /* @__PURE__ */ jsxs15(LayoutGrid, {
      children: [
        menuLinks == null ? void 0 : menuLinks.map((link, index) => {
          if (!link.links)
            return null;
          const colEnd = COL_ENDS[index];
          const colStart = COL_STARTS[index];
          return /* @__PURE__ */ jsx32(GridItem, {
            colEnd: { lg: colEnd },
            colStart: { lg: colStart },
            children: /* @__PURE__ */ jsx32(NavLinks, {
              currentPath,
              heading: link.title,
              isLocalised,
              navLinkClass: "hover:ui-font-bold",
              navLinks: link.links,
              onClick: onMenuLinkClick,
              tabIndex
            })
          }, link.id);
        }),
        /* @__PURE__ */ jsx32(MenuCtaImage, {
          isLocalised,
          menuCardLink,
          menuImageComponent,
          onClick: onMenuShopButtonClick,
          tabIndex
        })
      ]
    })
  });
}
function MobileMenu({
  accordionOpenAtIndex = null,
  currentPath,
  hideLinks,
  isLocalised,
  menuCardLink,
  menuImageComponent,
  menuLinks,
  open,
  onMenuLinkClick,
  onMenuShopButtonClick
}) {
  const tabIndex = open ? 0 : -1;
  return /* @__PURE__ */ jsx32("div", {
    "aria-describedby": "hamburger",
    "aria-hidden": !open,
    className: cx12(
      "ui-fixed ui-top-0 ui-left-0 ui-right-0 ui-z-100",
      "ui-transition-all ui-duration-300",
      "ui-h-dvh ui-overflow-y-scroll",
      "lg:ui-hidden",
      { "ui--translate-y-full": !open },
      { "ui-translate-y-0": open }
    ),
    "data-cy": "mobile-menu",
    id: "navMenu",
    children: /* @__PURE__ */ jsx32(RadialGradientBG, {
      background: "cream-100",
      className: "ui-pt-20 ui-pb-8",
      gradients,
      children: /* @__PURE__ */ jsxs15(LayoutGrid, {
        className: "ui-h-auto ui-content-between ui-relative",
        style: { minHeight: "calc(100dvh - 112px)" },
        children: [
          /* @__PURE__ */ jsx32(GridItem, {
            colEnd: { sm: "main" },
            colStart: { sm: "main" },
            children: hideLinks ? /* @__PURE__ */ jsx32("div", {}) : /* @__PURE__ */ jsx32(Accordion, {
              close: !open,
              nested: true,
              openAtIndex: accordionOpenAtIndex,
              children: menuLinks == null ? void 0 : menuLinks.map((link) => {
                return /* @__PURE__ */ jsxs15(Fragment4, {
                  children: [
                    /* @__PURE__ */ jsx32(AccordionHeader, {
                      children: link.title ? /* @__PURE__ */ jsx32(Typography, {
                        Element: "div",
                        variant: "body-large",
                        children: isLocalised ? link.title : t(link.title)
                      }) : null
                    }),
                    /* @__PURE__ */ jsx32(AccordionContent, {
                      children: link.links ? /* @__PURE__ */ jsx32(NavLinks, {
                        currentPath,
                        isLocalised,
                        navLinkClass: "hover:ui-font-bold",
                        navLinks: link.links,
                        onClick: onMenuLinkClick,
                        tabIndex
                      }) : null
                    })
                  ]
                }, link.id);
              })
            })
          }),
          /* @__PURE__ */ jsx32(MenuCtaImage, {
            isLocalised,
            menuCardLink,
            menuImageComponent,
            onClick: onMenuShopButtonClick,
            tabIndex
          })
        ]
      })
    })
  });
}
function Menu({ menuLinks, ...props }) {
  const _menuLinks = menuLinks != null ? menuLinks : defaultMenuData_default.menuLinks;
  const categoryLinks = _menuLinks.filter(
    ({ id }) => id !== "menu-card" /* MenuCard */
  );
  const menuCardLink = _menuLinks.find(
    ({ id }) => id === "menu-card" /* MenuCard */
  );
  return /* @__PURE__ */ jsxs15("div", {
    className: "menuWrapper",
    children: [
      /* @__PURE__ */ jsx32(MobileMenu, {
        isLocalised: Boolean(menuLinks),
        menuCardLink,
        menuLinks: categoryLinks,
        ...props
      }),
      /* @__PURE__ */ jsx32(DesktopMenu, {
        isLocalised: Boolean(menuLinks),
        menuCardLink,
        menuLinks: categoryLinks,
        ...props
      })
    ]
  });
}
Menu.displayName = "Menu";

// src/layout/v3/Header/MainLinks/index.tsx
init_esm_shims();
import { cx as cx13 } from "class-variance-authority";

// src/v3/data/defaultHeaderData.ts
init_esm_shims();
var headerData = {
  headerLinks: [
    {
      id: "why-oura-category" /* WhyOuraCategory */,
      link: {
        id: "nav_ouraexperience",
        href: "/why-oura",
        label: "why_oura_link"
      }
    },
    {
      id: "how-it-works-category" /* HowItWorksCategory */,
      link: {
        id: "nav_howitworks",
        href: "/how-it-works",
        label: "how_it_works_link"
      }
    },
    {
      id: "business-category" /* BusinessCategory */,
      link: {
        id: "nav_business",
        href: "/business",
        label: "for_business_link"
      }
    },
    {
      id: "shop-category" /* ShopCategory */,
      link: {
        id: "oura-ring",
        href: "/product/rings",
        label: "shop"
      }
    }
  ]
};
var defaultHeaderData_default = headerData;

// src/layout/v3/Header/MainLinks/index.tsx
import { jsx as jsx33 } from "react/jsx-runtime";
function MainLinks({
  currentPath,
  headerLinks,
  onClick,
  open
}) {
  const _headerLinks = headerLinks != null ? headerLinks : defaultHeaderData_default.headerLinks;
  const mainLinks = _headerLinks.filter(
    ({ id }) => id !== "shop-category" /* ShopCategory */
  );
  return /* @__PURE__ */ jsx33("ul", {
    className: cx13("ui-hidden lg:ui-flex lg:ui-gap-12", {
      "ui-opacity-0": open
    }),
    children: mainLinks.map(({ link }) => {
      if (!link)
        return null;
      return /* @__PURE__ */ jsx33(NavLink, {
        className: cx13(
          "ui-py-3 ui-text-stroke-color-transparent ui-text-stroke-width-0.5 ui-transition-all hover:ui-text-stroke-color-current",
          {
            "ui-font-bold ui-cursor-default": currentPath === link.href
          }
        ),
        href: link.href,
        id: link.id,
        onClick,
        tabIndex: open ? -1 : 0,
        children: headerLinks ? link.label : t(link.label)
      }, link.id);
    })
  });
}
MainLinks.displayName = "MainLinks";

// src/layout/v3/Header/DesktopMenuBlur/index.tsx
init_esm_shims();
import { cx as cx14 } from "class-variance-authority";
import { jsx as jsx34 } from "react/jsx-runtime";
function DesktopMenuBlur({
  blurElement,
  onOutsideClick,
  open,
  tabIndex
}) {
  return /* @__PURE__ */ jsx34("button", {
    "aria-hidden": !open,
    className: cx14(
      "headerMenuBlurV3 ui-hidden",
      "lg:ui-fixed lg:ui-top-0 lg:ui-left-0 lg:ui-right-0",
      "lg:ui-block lg:ui-transition-opacity lg:ui--z-10",
      {
        "lg:ui-bottom-auto lg:ui-opacity-0": !open,
        "lg:ui-bottom-0": open
      }
    ),
    "data-cy": "desktop_menu_background_blur",
    onClick: onOutsideClick,
    ref: blurElement,
    tabIndex,
    type: "button",
    children: /* @__PURE__ */ jsx34("span", {
      className: "ui-sr-only",
      children: t("header_hamburger_close_sr_label_2024")
    })
  });
}
DesktopMenuBlur.displayName = "DesktopMenuBlur";

// src/layout/v3/Header/ShoppingCart/index.tsx
init_esm_shims();
import { cx as cx15 } from "class-variance-authority";

// src/icons/ShoppingCartIcon.tsx
init_esm_shims();
import { jsx as jsx35, jsxs as jsxs16 } from "react/jsx-runtime";
function ShoppingCartIcon({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs16("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 22,
    viewBox: "0 0 21 22",
    width: 21,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx35("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx35("path", {
        d: "M6.41347 20C5.95753 20 5.56885 19.8319 5.24742 19.4956C4.926 19.1593 4.76528 18.755 4.76528 18.2828C4.76528 17.8106 4.92762 17.408 5.25229 17.0751C5.57698 16.7422 5.96728 16.5757 6.4232 16.5757C6.87914 16.5757 7.26782 16.7439 7.58925 17.0801C7.91067 17.4164 8.07139 17.8207 8.07139 18.2929C8.07139 18.7651 7.90905 19.1677 7.58438 19.5006C7.25969 19.8335 6.86939 20 6.41347 20ZM15.5971 20C15.1411 20 14.7525 19.8319 14.431 19.4956C14.1096 19.1593 13.9489 18.755 13.9489 18.2828C13.9489 17.8106 14.1112 17.408 14.4359 17.0751C14.7606 16.7422 15.1509 16.5757 15.6068 16.5757C16.0628 16.5757 16.4514 16.7439 16.7729 17.0801C17.0943 17.4164 17.255 17.8207 17.255 18.2929C17.255 18.7651 17.0927 19.1677 16.768 19.5006C16.4433 19.8335 16.053 20 15.5971 20ZM5.22446 4.30538L7.74996 9.72716H14.3622L17.232 4.30538H5.22446ZM4.53569 2.8786H18.0603C18.4118 2.8786 18.6792 3.04506 18.8626 3.37797C19.046 3.71089 19.0458 4.0438 18.8621 4.37672L15.7627 10.1552C15.5943 10.4564 15.3757 10.6982 15.107 10.8805C14.8382 11.0628 14.544 11.1539 14.2244 11.1539H7.26782L5.98211 13.627H17.255V15.0538H6.18874C5.54589 15.0538 5.08288 14.8319 4.79972 14.388C4.51656 13.9441 4.52039 13.4447 4.8112 12.8899L6.28058 10.0839L2.79081 2.42678H1V1H3.68621L4.53569 2.8786Z",
        fill: "currentColor"
      })
    ]
  });
}

// src/layout/v3/Header/ShoppingCart/index.tsx
import { jsx as jsx36, jsxs as jsxs17 } from "react/jsx-runtime";
function ShoppingCart({
  hiddenHamburger,
  inverseHeader,
  onShoppingCartClick,
  shoppingCartCount
}) {
  return /* @__PURE__ */ jsxs17("div", {
    className: cx15("ui-flex ui-items-center ui-gap-3", {
      "ui-mr-1 sm:ui-mr-3": !hiddenHamburger,
      "ui-mr-0": hiddenHamburger
    }),
    children: [
      /* @__PURE__ */ jsxs17(Typography, {
        Element: "span",
        align: "right",
        "aria-hidden": "true",
        className: "ui-hidden lg:ui-block",
        color: inverseHeader ? "light" : "dark",
        variant: "body-small",
        weight: "bold",
        children: [
          /* @__PURE__ */ jsx36(FormattedMessage_default, {
            id: "cart"
          }),
          ` (${shoppingCartCount})`
        ]
      }),
      /* @__PURE__ */ jsx36("div", {
        className: cx15(
          "ui-rounded-full ui-border-solid ui-border",
          "ui-flex ui-justify-center ui-items-center ui-relative",
          "ui-h-10 ui-w-10",
          "lg:ui-h-12 lg:ui-w-12",
          {
            "ui-border-sandstone-200 ui-text-sandstone-200": inverseHeader,
            "ui-border-sandstone-500 ui-text-sandstone-500": !inverseHeader
          }
        ),
        "data-cy": "shopping-cart",
        children: /* @__PURE__ */ jsxs17("button", {
          className: "ui-flex ui-justify-center ui-items-center",
          onClick: onShoppingCartClick,
          type: "button",
          children: [
            /* @__PURE__ */ jsxs17("div", {
              className: cx15("ui-text-inherit", {
                "ui-text-sandstone-200": inverseHeader
              }),
              children: [
                /* @__PURE__ */ jsx36(ShoppingCartIcon, {}),
                /* @__PURE__ */ jsx36("span", {
                  className: "ui-sr-only",
                  children: /* @__PURE__ */ jsx36(FormattedMessage_default, {
                    id: "cart_count_sr_label",
                    values: { count: shoppingCartCount }
                  })
                })
              ]
            }),
            Boolean(shoppingCartCount) && /* @__PURE__ */ jsx36("div", {
              className: cx15(
                "ui-absolute ui-top-1 ui-right-1.5 ui-rounded-full ui-bg-blue-100",
                "ui-flex ui-justify-center ui-items-center",
                "ui-h-[0.6875rem] ui-w-[0.6875rem]",
                "lg:ui-hidden"
              ),
              children: /* @__PURE__ */ jsx36(Typography, {
                Element: "div",
                "aria-hidden": "true",
                className: "ui-text-[0.5rem] ui-font-normal ui-tracking-normal",
                color: "light",
                variant: "unset",
                children: shoppingCartCount
              })
            })
          ]
        })
      })
    ]
  });
}
ShoppingCart.displayName = "ShoppingCart";

// src/layout/v3/Header/_hooks/useHeaderV3.ts
init_esm_shims();
import {
  useEffect as useEffect3,
  useRef as useRef4,
  useState as useState4
} from "react";
import { useIntl as useIntl2 } from "react-intl";
import { useMotionValueEvent, useScroll } from "framer-motion";

// src/hooks/useLockBodyScroll.ts
init_esm_shims();
import { useLayoutEffect, useRef as useRef3 } from "react";
var updateOverflow = (overflow) => document.body.style.overflow = overflow;
var useLockBodyScroll = (shouldLock = true) => {
  const originalOverflow = useRef3("");
  useLayoutEffect(() => {
    if (!originalOverflow.current) {
      originalOverflow.current = window.getComputedStyle(
        document.body
      ).overflow;
    }
    if (shouldLock) {
      updateOverflow("hidden");
    } else {
      updateOverflow(originalOverflow.current);
    }
    return () => updateOverflow(originalOverflow.current);
  }, [shouldLock]);
};

// src/layout/v3/Header/_hooks/useHeaderV3.ts
function useHeaderV3({
  isParentInverse,
  onHamburgerClick
}) {
  var _a;
  const [position, setPosition] = useState4(0);
  const [visible, setVisible] = useState4(true);
  const [open, setOpen] = useState4(false);
  const hamburgerElement = useRef4(null);
  const blurElement = useRef4(null);
  const context = useHeaderContext();
  const { formatMessage } = useIntl2();
  const tabIndex = open ? 0 : -1;
  useLockBodyScroll(open);
  const { scrollY } = useScroll();
  useEffect3(() => {
    setPosition(window.scrollY);
  }, []);
  const updateScroll = (moving) => {
    setVisible(position > moving);
    setPosition(moving);
  };
  useMotionValueEvent(scrollY, "change", (latest) => {
    updateScroll(latest);
  });
  useEffect3(() => {
    const handleBlur = () => {
      var _a2;
      (_a2 = hamburgerElement.current) == null ? void 0 : _a2.focus();
    };
    const hamburgerEl = hamburgerElement.current;
    const blurEl = blurElement.current;
    if (hamburgerEl && blurEl) {
      blurEl.addEventListener("blur", handleBlur);
      return () => {
        blurEl.removeEventListener("blur", handleBlur);
      };
    }
  }, []);
  let inverse = false;
  switch (true) {
    case open:
      break;
    case isParentInverse:
      inverse = true;
      break;
    case (context == null ? void 0 : context.inverse):
      inverse = (_a = context == null ? void 0 : context.inverse) != null ? _a : false;
      break;
  }
  const handleHamburgerClick = () => {
    setOpen((prevOpen) => !prevOpen);
    onHamburgerClick == null ? void 0 : onHamburgerClick({ open: !open });
  };
  const handleOutsideClick = () => {
    var _a2;
    setOpen(false);
    (_a2 = hamburgerElement.current) == null ? void 0 : _a2.focus();
  };
  return {
    blurElement,
    formatMessage,
    hamburgerElement,
    inverse,
    position,
    open,
    tabIndex,
    visible,
    onHamburgerButtonClick: handleHamburgerClick,
    onOutsideClick: handleOutsideClick
  };
}

// src/layout/v3/Header/index.tsx
import { jsx as jsx37, jsxs as jsxs18 } from "react/jsx-runtime";
function Header({
  accordionOpenAtIndex,
  count,
  currentPath,
  menuImageComponent,
  menuLinks,
  headerLinks,
  headerPosition = "fold",
  hideHamburger = false,
  hideLinks = false,
  inverse: _inverse,
  shopButton = {
    href: "/product/rings",
    label: t("shop")
  },
  showCart = true,
  onClick,
  onHamburgerClick,
  onMenuLinkClick,
  onMenuShopButtonClick,
  onShopButtonClick,
  onShoppingCartClick
}) {
  const {
    blurElement,
    formatMessage,
    hamburgerElement,
    inverse,
    position,
    open,
    tabIndex,
    visible,
    onHamburgerButtonClick,
    onOutsideClick
  } = useHeaderV3({ isParentInverse: _inverse, onHamburgerClick });
  return /* @__PURE__ */ jsxs18("header", {
    className: cx16(
      "ui-py-2 ui-mt-4 ui-w-full ui-transition-all ui-duration-500 ui-z-100 ui-pointer-events-auto",
      {
        "lg:ui--top-28": !visible && headerPosition === "fold",
        "ui-relative ui-top-0": headerPosition === "static",
        "ui-sticky ui-top-4": ["fold", "fixed"].includes(headerPosition)
      }
    ),
    "data-cy": "header",
    children: [
      /* @__PURE__ */ jsx37("div", {
        className: cx16(
          "headerBlurV3 ui-overflow-hidden ui-rounded-lg",
          "ui-absolute ui-top-0 ui-right-2 ui-bottom-0 ui-left-2",
          "lg:ui-left-6 lg:ui-right-6 lg:ui-transition-opacity",
          {
            inverse,
            "lg:ui-opacity-0": position < 10 && visible || headerPosition === "static",
            hideBlur: !visible && headerPosition === "fold"
          }
        )
      }),
      /* @__PURE__ */ jsx37(LayoutGrid, {
        className: cx16("ui-z-200", {
          "ui-fixed ui-top-6 ui-left-0 ui-right-0 ui-w-full xxl:ui-left-1/2 xxl:-ui-translate-x-1/2": open,
          "ui-relative": !open
        }),
        children: /* @__PURE__ */ jsx37(GridItem, {
          colEnd: { sm: "main" },
          colStart: { sm: "main" },
          children: /* @__PURE__ */ jsxs18("nav", {
            className: cx16("headerV3 ui-flex ui-items-center", {
              inverse
            }),
            children: [
              /* @__PURE__ */ jsx37("ul", {
                className: "ui-relative ui-w-24 ui-z-200",
                children: /* @__PURE__ */ jsx37(NavLink, {
                  "aria-label": formatMessage({ id: "oura_home_link" }),
                  className: "ui-py-3 ui-block ui-w-16 lg:ui-w-20",
                  "data-cy": "nav_logo_link",
                  href: "/",
                  id: "nav_home",
                  onClick,
                  children: /* @__PURE__ */ jsx37(Oura, {})
                })
              }),
              /* @__PURE__ */ jsxs18("div", {
                className: cx16(
                  "ui-flex-1 ui-flex ui-items-center ui-justify-end ui-mx-2",
                  "ui-transition lg:ui-gap-12",
                  "sm:ui-mx-4",
                  {
                    "ui-opacity-0 ui-pointer-events-none": open,
                    "lg:ui-justify-end": hideLinks,
                    "lg:ui-justify-center": !hideLinks
                  }
                ),
                children: [
                  !hideLinks ? /* @__PURE__ */ jsx37(MainLinks, {
                    currentPath,
                    headerLinks,
                    onClick,
                    open
                  }) : null,
                  shopButton ? /* @__PURE__ */ jsx37(Button, {
                    className: cx16({ "ui-hidden": open }),
                    "data-cy": "nav_shopcta",
                    href: shopButton.href,
                    onClick: onShopButtonClick,
                    size: "medium",
                    children: shopButton.label
                  }) : null
                ]
              }),
              showCart && Boolean(count) ? /* @__PURE__ */ jsx37("div", {
                className: cx16({
                  "ui-hidden": open
                }),
                children: /* @__PURE__ */ jsx37(ShoppingCart, {
                  hiddenHamburger: hideHamburger,
                  inverseHeader: inverse,
                  onShoppingCartClick,
                  shoppingCartCount: count
                })
              }) : null,
              !hideHamburger ? /* @__PURE__ */ jsx37(HamburgerBox, {
                hideLinks,
                onClick: onHamburgerButtonClick,
                open,
                ref: hamburgerElement
              }) : null
            ]
          })
        })
      }),
      /* @__PURE__ */ jsx37(Menu, {
        accordionOpenAtIndex,
        currentPath,
        hideLinks,
        menuImageComponent,
        menuLinks,
        onMenuLinkClick,
        onMenuShopButtonClick,
        open
      }),
      /* @__PURE__ */ jsx37(DesktopMenuBlur, {
        blurElement,
        onOutsideClick,
        open,
        tabIndex
      })
    ]
  });
}
Header.displayName = "Header";

// src/layout/v3/Footer/index.tsx
init_esm_shims();
import { useInView as useInView2 } from "framer-motion";
import {
  useMemo as useMemo5,
  useRef as useRef6,
  useEffect as useEffect4
} from "react";

// src/layout/v3/Footer/EcomFooter/index.tsx
init_esm_shims();
import { cx as cx21 } from "class-variance-authority";
import { useIntl as useIntl6 } from "react-intl";
import { useRef as useRef5 } from "react";
import {
  motion as motion3,
  useReducedMotion as useReducedMotion2,
  useScroll as useScroll2,
  useTransform
} from "framer-motion";

// src/v3/data/defaultFooterData.ts
init_esm_shims();
var footerData = {
  footerLinks: [
    {
      id: "our-company-category" /* CompanyCategory */,
      title: "footer_company_heading",
      links: [
        {
          id: "about-us",
          href: "/about-us",
          label: "footer_about_us"
        },
        {
          id: "leadership",
          href: "/leadership",
          label: "footer_leadership"
        },
        {
          id: "medical-advisory-board",
          href: "/medical-advisory-board",
          label: "footer_medical_advisory_board"
        },
        {
          id: "careers",
          href: "/careers",
          label: "footer_careers"
        },
        {
          id: "press",
          href: "/press",
          label: "footer_press"
        }
      ]
    },
    {
      id: "support-category" /* SupportCategory */,
      title: "footer_support_heading",
      links: [
        {
          id: "help",
          href: "https://support.ouraring.com/hc/",
          label: "footer_help",
          external: true
        },
        {
          id: "sizing",
          href: "/sizing",
          label: "footer_sizing"
        },
        {
          id: "membership",
          href: "/membership",
          label: "footer_membership"
        },
        {
          id: "my-account",
          href: "/my-account",
          label: "footer_my_account"
        },
        {
          id: "oura-on-the-web",
          href: "https://cloud.ouraring.com/user/sign-in",
          label: "footer_oura_on_the_web",
          external: true,
          target: "_blank"
        },
        {
          id: "contact",
          href: "/contact",
          label: "footer_contact"
        }
      ]
    },
    {
      id: "partner-category" /* PartnerCategory */,
      title: "footer_partner_heading",
      links: [
        {
          id: "oura-for-business",
          href: "/business",
          label: "for_business_link"
        },
        {
          id: "developers",
          href: "/developer",
          label: "footer_developers"
        }
      ]
    },
    {
      id: "blog-category" /* BlogCategory */,
      title: "footer_blog_heading",
      links: [
        {
          id: "blog",
          href: "https://blog.ouraring.com/",
          label: "the_pulse"
        }
      ]
    },
    {
      id: "footer-card" /* FooterCard */,
      title: "shop",
      link: {
        id: "oura-ring",
        href: "/product/rings",
        label: "shop"
      }
    }
  ],
  legalLinks: [
    {
      id: "terms-and-conditions",
      label: "footer_terms_and_conditions",
      href: "/terms-and-conditions"
    },
    {
      id: "privacy-policy",
      label: "footer_privacy_policy",
      href: "/privacy-policy"
    },
    {
      id: "accessibility",
      label: "footer_accessibility",
      href: "/accessibility"
    },
    {
      id: "intellectual-property-notice",
      label: "footer_ip_notice",
      href: "/intellectual-property-notice"
    },
    {
      id: "security",
      label: "footer_security_center",
      href: "/security"
    }
  ]
};
var defaultFooterData_default = footerData;

// src/icons/HsaFsaBlockOutlinedLogo.tsx
init_esm_shims();
import { jsx as jsx38, jsxs as jsxs19 } from "react/jsx-runtime";
function HsaFsaBlockOutlinedLogo({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs19("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 53,
    viewBox: "0 0 121 53",
    width: 121,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx38("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx38("rect", {
        height: 50.0224,
        rx: 3,
        width: 119,
        x: 1,
        y: 1
      }),
      /* @__PURE__ */ jsx38("rect", {
        height: 50.0224,
        rx: 3,
        stroke: "currentColor",
        strokeWidth: 2,
        width: 119,
        x: 1,
        y: 1
      }),
      /* @__PURE__ */ jsx38("path", {
        clipRule: "evenodd",
        d: "M33.2348 10C33.4002 10.0315 33.5002 10.1264 33.6204 10.1999C33.8535 10.3425 34.0976 10.4619 34.3244 10.5996C34.4339 10.6662 34.5977 10.6882 34.643 10.8162C34.6577 10.8376 34.6579 10.8573 34.6597 10.8994C34.568 11.0012 34.5325 11.1459 34.4586 11.2659C34.2555 11.5945 34.079 11.9463 33.8718 12.2819C33.452 12.9618 33.0663 13.685 32.648 14.3639C32.4484 14.6881 32.3109 15.0237 32.1116 15.3467C31.7077 16.0011 31.3639 16.6991 30.9549 17.3621C29.2957 20.0505 27.8518 22.9008 26.1939 25.5903C26.0348 25.8483 25.9332 26.1151 25.7748 26.3731C25.1359 27.4131 24.5564 28.5154 23.914 29.5544C23.7094 29.8852 23.5448 30.2317 23.344 30.5538C23.2749 30.6647 23.2157 30.9031 23.0925 30.9536C23.0727 30.9669 23.0644 30.9664 23.0255 30.9702C22.7051 30.6264 22.3554 30.2971 22.0699 29.9209C21.8615 29.6462 21.5645 29.4214 21.3491 29.138L21.1311 28.9382C20.8505 28.5694 20.4899 28.2747 20.2091 27.9055L19.8235 27.5224C19.5112 27.1108 19.1136 26.7853 18.8009 26.3731L18.5495 26.1399C18.2876 25.7956 17.9567 25.519 17.6945 25.1738C17.5751 25.0168 17.299 24.8954 17.2754 24.6575L17.7951 24.1412C18.0175 23.9751 18.2397 23.7884 18.4321 23.5915H18.5327C19.9198 25.0716 21.2805 26.58 22.6734 28.0554H22.7908C23.3314 27.1814 23.828 26.2507 24.3666 25.3737C24.5015 25.154 24.5832 24.9277 24.7186 24.7075C26.0153 22.5993 27.159 20.369 28.457 18.2615C28.5626 18.0899 28.6203 17.9159 28.7252 17.7452C29.1601 17.0381 29.5645 16.2859 29.9993 15.5798C30.1753 15.2942 30.2937 14.9994 30.4687 14.7137C31.0736 13.7267 31.6222 12.6837 32.2289 11.6989C32.4496 11.3408 32.6338 10.9674 32.8492 10.6163C32.9821 10.3996 33.0658 10.1762 33.2348 10Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }),
      /* @__PURE__ */ jsx38("path", {
        clipRule: "evenodd",
        d: "M78.3155 11.549H79.2543C79.3606 11.549 79.5477 11.5217 79.6231 11.5657C79.6691 11.5923 79.6712 11.6411 79.6734 11.7156C79.5182 11.9233 79.4474 12.3975 79.3381 12.665C79.1254 13.1858 78.9697 13.7666 78.7514 14.2807C78.6792 14.4509 78.6721 14.6238 78.6005 14.797C78.4206 15.2322 78.2781 15.7279 78.0976 16.1628L77.9635 16.6292C77.7762 17.0806 77.6306 17.5919 77.4438 18.045L77.3935 18.2615C76.9129 19.4366 76.5464 20.7036 76.1027 21.8926C75.8194 22.6518 75.6167 23.4269 75.3148 24.1578C75.2226 24.3812 75.1647 24.6192 75.0801 24.8241C75.0484 24.9007 75.0566 25.0273 74.9962 25.0739C74.9141 25.1375 74.6809 25.1072 74.5436 25.1072C74.1443 25.1072 73.6529 25.1634 73.2863 25.0906C73.2732 25.0533 73.2692 25.0001 73.2696 24.9407C73.4003 24.7426 73.4105 24.4703 73.5042 24.2411C73.7861 23.551 73.9725 22.8233 74.2419 22.1091C74.7253 20.8269 75.1538 19.4822 75.6333 18.1949C75.7925 17.7673 75.9023 17.3496 76.0691 16.9457C76.0971 16.8402 76.125 16.7346 76.153 16.6292C76.3734 16.0952 76.5392 15.4987 76.7565 14.9636C76.8539 14.7237 76.8832 14.5067 76.9744 14.264C77.1875 13.697 77.4002 13.0832 77.6114 12.5151C77.6867 12.3126 77.7491 12.1183 77.8126 11.9321C77.8554 11.807 77.8597 11.6272 77.9803 11.5823C78.0559 11.5369 78.2406 11.5953 78.3155 11.549Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }),
      /* @__PURE__ */ jsx38("path", {
        clipRule: "evenodd",
        d: "M23.2627 12.4984C24.985 12.4654 26.6138 12.7869 27.8392 13.2813C27.9755 13.3362 28.0912 13.3417 28.2248 13.3979C28.3353 13.4442 28.4657 13.5173 28.5769 13.5644C28.7318 13.6302 28.9106 13.6242 28.9121 13.8476C28.8298 13.9368 28.7941 14.0578 28.7277 14.164C28.5915 14.3819 28.4448 14.6124 28.3086 14.8303C28.2211 14.9704 28.2211 15.1619 27.9901 15.1634C27.8929 15.091 27.7579 15.0808 27.6381 15.0302C27.1849 14.8386 26.7244 14.7059 26.1964 14.5638C25.76 14.4464 25.2651 14.3904 24.7882 14.2806C24.5414 14.2238 24.2878 14.2855 24.0338 14.2307C23.6254 14.1426 22.7016 14.1762 22.3239 14.264L21.7874 14.2973C21.5455 14.3561 21.2446 14.4039 21.0163 14.4639L20.7983 14.4805C19.8523 14.7555 18.9719 15.0363 18.1831 15.4466C17.4655 15.8198 16.8291 16.2204 16.205 16.6791C16.008 16.8239 15.8456 17.0331 15.6518 17.1788C15.4251 17.3492 15.203 17.5529 15.0315 17.7784L14.7633 18.0283C14.579 18.27 14.3556 18.4862 14.1765 18.7279C13.7982 19.2387 13.4761 19.7912 13.1372 20.3435C13.0429 20.4969 12.9938 20.6578 12.9192 20.8265C12.7675 21.1697 12.6002 21.5459 12.4498 21.9092C12.2163 22.4733 12.1186 23.1314 11.9637 23.758C11.8976 24.0255 11.9407 24.2509 11.8799 24.5242C11.8344 24.7284 11.8784 24.9828 11.8296 25.2071C11.7885 25.3963 11.8128 25.6717 11.8128 25.89C11.8128 26.4085 11.8442 26.9395 11.9469 27.3724V27.5557C11.9719 27.6598 12.0037 27.7895 12.0307 27.8888C12.1612 28.3667 12.1881 28.824 12.366 29.2546C12.5769 29.7649 12.7685 30.2793 12.9863 30.7703C13.0513 30.9171 13.1553 31.0691 13.2377 31.2034C13.3685 31.4164 13.4577 31.6283 13.5898 31.8363C13.8163 32.1933 14.0773 32.5306 14.3274 32.869C14.4476 33.0317 14.6255 33.1598 14.7465 33.3187C14.9936 33.6434 15.2915 33.9563 15.6182 34.2015C15.7839 34.3258 15.9208 34.5101 16.0876 34.6346C17.2405 35.4945 18.3536 36.1235 19.8428 36.6666C20.3065 36.8357 20.8319 36.9058 21.318 37.0331C21.5422 37.0917 21.7856 37.0837 21.9886 37.133L22.5921 37.1663C22.866 37.2259 23.2407 37.1996 23.5644 37.1996H24.017C24.4452 37.102 24.9183 37.1545 25.3414 37.0497C25.9437 36.9005 26.5472 36.7651 27.0849 36.5834C30.2566 35.5112 32.7173 33.2205 34.0084 30.2873C34.2792 29.6723 34.4674 29.0071 34.6622 28.3219C34.7509 28.0095 34.7717 27.6811 34.8466 27.3724L34.8634 27.0726C34.9464 26.7044 34.947 26.272 34.9472 25.8234C34.9472 25.5701 34.9811 25.2469 34.9304 25.0239L34.9137 24.6408C34.8315 24.2864 34.8548 23.9089 34.7628 23.5582C34.5152 22.6141 34.3125 21.6024 33.8575 20.8599L33.7067 20.5101C33.4254 20.0497 33.191 19.5767 32.8852 19.1443C32.7645 18.9735 32.5263 18.8091 32.5164 18.5446C32.6299 18.4195 32.6772 18.2428 32.7679 18.0949C32.879 17.9137 33.009 17.7243 33.1199 17.5453C33.2083 17.4025 33.2499 17.1345 33.472 17.1289C33.6326 17.3797 33.8854 17.5849 34.0587 17.8284C34.3769 18.2755 34.674 18.7402 34.964 19.2109C35.0729 19.3876 35.135 19.5748 35.2322 19.7605C35.6396 20.5392 35.9385 21.4002 36.238 22.3089C36.3693 22.7074 36.3978 23.1542 36.5063 23.5582C36.6069 23.9324 36.5537 24.3558 36.6404 24.7408V25.1905C36.6974 25.4521 36.6992 25.911 36.6404 26.1732C36.5866 26.4134 36.6533 26.6995 36.6069 26.9061V27.0893C36.5217 27.4547 36.5326 27.8548 36.4392 28.2219C36.2033 29.1487 35.9807 29.9948 35.6345 30.787C34.6128 33.1255 33.1696 34.9834 31.1921 36.3668C30.485 36.8615 29.7326 37.3692 28.8954 37.7326C28.3849 37.9542 27.8476 38.1524 27.3028 38.3323C27.1352 38.3876 26.9933 38.3924 26.8166 38.4489C26.3129 38.6098 25.7312 38.6695 25.1738 38.7986C24.9587 38.8484 24.7429 38.8228 24.5535 38.8653H24.2853C24.0761 38.9109 23.4613 38.9459 23.2459 38.8986H22.81C22.5618 38.8986 22.3185 38.8796 22.1059 38.8319H21.9048L20.966 38.6987C20.5673 38.5959 20.1316 38.5435 19.7422 38.4155C19.0552 38.19 18.3939 37.9583 17.764 37.6827C16.9046 37.3064 16.1337 36.7731 15.4171 36.2502C13.8577 35.1124 12.7534 33.7406 11.729 32.0695C11.394 31.523 11.1303 30.8181 10.874 30.204C10.8214 30.0778 10.817 29.9652 10.7734 29.8376C10.6241 29.4 10.4941 28.9138 10.3711 28.4384C10.3045 28.1814 10.3211 27.9542 10.2537 27.6889C10.235 27.615 10.2048 27.4964 10.1867 27.4224L10.1532 27.0726C10.133 27.0148 10.0583 26.9615 10.0358 26.9061C9.96658 26.735 10.019 26.412 10.019 26.2065V24.5909C10.0397 24.5311 10.1133 24.4524 10.1364 24.391L10.1532 24.2078C10.2086 23.9832 10.2105 23.7514 10.2705 23.5082C10.4127 22.9322 10.4923 22.3471 10.6728 21.8093C11.109 20.5102 11.6628 19.3045 12.3828 18.2781C12.6044 17.9622 12.8753 17.6668 13.1036 17.362C13.3823 16.9899 13.6996 16.6698 14.0257 16.346L14.3442 16.0129C14.6255 15.8013 14.8664 15.5365 15.1489 15.33C15.5949 15.0038 16.0501 14.6777 16.5235 14.3806C17.4539 13.7968 18.527 13.4183 19.6416 13.0148L20.044 12.9315C20.4445 12.8106 20.9026 12.7523 21.3348 12.6483C21.547 12.5974 21.7782 12.609 21.9718 12.565C22.2623 12.5484 22.553 12.5317 22.8436 12.5151C22.9576 12.5151 23.1834 12.5477 23.2627 12.4984Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }),
      /* @__PURE__ */ jsx38("path", {
        clipRule: "evenodd",
        d: "M55.9846 12.5149C57.2449 12.4922 58.2404 12.7407 59.0022 13.2144C59.1847 13.3278 59.322 13.5059 59.4883 13.6308C59.5683 13.6909 59.6635 13.7521 59.723 13.8307C59.8702 14.0254 59.9756 14.2126 60.1086 14.4303C60.3294 14.7916 60.5424 15.2661 60.5444 15.8294C60.4955 15.8601 60.4958 15.8751 60.4103 15.8794C60.3047 15.9405 60.0072 15.8434 59.8404 15.8794C59.6965 15.9104 59.4596 15.8653 59.3207 15.8794C58.9071 15.9217 58.281 15.942 57.8957 15.8628C57.8055 15.7015 57.7593 15.5003 57.661 15.3464C57.4315 14.9865 57.0518 14.8122 56.5714 14.6968C56.1789 14.6025 55.4978 14.7256 55.2638 14.8634C55.0998 14.96 54.9675 15.1064 54.8614 15.2631C54.7203 15.4717 54.6767 15.8879 54.8111 16.1459C55.1649 16.8245 56.3759 16.8078 57.2084 17.0287C57.5993 17.1325 58.0471 17.1859 58.4322 17.3119C59.3904 17.6253 60.1753 18.1288 60.5612 19.0108C60.6978 19.3229 60.7307 19.687 60.8127 20.0601V20.3433C60.8569 20.5605 60.8013 21.0412 60.7456 21.2594C60.6078 21.7997 60.3647 22.2086 60.0751 22.5919C59.9252 22.7901 59.6932 22.9457 59.4883 23.0916C58.9938 23.4438 58.4084 23.6604 57.7113 23.8244C57.4946 23.8754 57.2907 23.8648 57.0911 23.9077H56.8228C56.5383 23.9672 56.0468 23.9482 55.7835 23.8911C55.5068 23.8311 55.2577 23.8742 54.9955 23.8078C53.9483 23.5426 53.1062 23.154 52.548 22.4087C52.3517 22.1467 52.148 21.8655 52.0115 21.5425C51.941 21.3755 51.9178 21.2159 51.8607 21.0428C51.8013 20.8631 51.6915 20.5387 51.7601 20.3599C51.9292 20.2862 52.2704 20.3266 52.4977 20.3266H53.8724C54.0873 20.3266 54.3823 20.2971 54.5429 20.3599C54.6229 20.5014 54.6469 20.6884 54.7273 20.843C54.967 21.3035 55.4079 21.5797 55.9679 21.7258C56.1229 21.7662 56.2849 21.7591 56.4708 21.7591C57.2671 21.7591 57.7358 21.4971 57.946 20.9096C58.0225 20.6959 57.9965 20.3891 57.9125 20.1934C57.7499 19.8146 57.2619 19.6519 56.8396 19.5271L56.3199 19.4438C55.1628 19.1369 54.0155 19.0771 53.1515 18.4778C52.6283 18.1148 52.2275 17.6142 52.0115 16.9454C51.9522 16.7614 51.9723 16.6005 51.9277 16.3958C51.8773 16.1642 51.8709 15.7258 51.9277 15.4797C51.9815 15.2461 52.0154 15.0126 52.0954 14.7968C52.3777 14.0347 52.9498 13.5096 53.6041 13.1145C53.9788 12.8883 54.4601 12.7514 54.9285 12.6314C55.1675 12.5701 55.4004 12.582 55.6326 12.5315C55.7405 12.508 55.9047 12.5647 55.9846 12.5149Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }),
      /* @__PURE__ */ jsx38("path", {
        clipRule: "evenodd",
        d: "M93.6052 12.5152C95.6209 12.4789 96.9139 13.1063 97.6788 14.314C97.9244 14.7018 98.1776 15.2213 98.1817 15.8298C98.1573 15.8439 98.1336 15.8599 98.1147 15.8797C97.5447 15.8852 96.9747 15.8909 96.4048 15.8964C96.1137 15.8964 95.7729 15.9115 95.533 15.8631C95.4623 15.7385 95.4286 15.5589 95.3486 15.43C95.0968 15.0243 94.7352 14.8206 94.1919 14.6971C93.6154 14.5662 92.9829 14.7819 92.6664 15.0303C92.5856 15.0937 92.5381 15.2068 92.482 15.2968C92.3246 15.5491 92.338 16.002 92.4987 16.2462C92.8776 16.822 94.0709 16.8238 94.8457 17.029C95.1959 17.1218 95.5999 17.1649 95.9521 17.2789C96.8934 17.5835 97.6148 18.0046 98.0812 18.7779C98.2357 19.0343 98.3157 19.3772 98.3997 19.694C98.4052 19.7994 98.4109 19.905 98.4164 20.0105C98.4805 20.3098 98.4721 20.8498 98.3997 21.1431C98.2738 21.6533 98.0919 22.0719 97.8297 22.4423C97.3786 23.0797 96.6125 23.4611 95.7845 23.7248C95.5164 23.8103 95.2589 23.7878 94.963 23.8581C94.4688 23.9755 93.6308 23.9727 93.1358 23.8581C92.8241 23.7859 92.5477 23.8099 92.264 23.7248C91.2835 23.4303 90.5588 22.956 90.0344 22.2091C89.7809 21.8482 89.6274 21.4782 89.4812 20.9932C89.4276 20.8153 89.3553 20.5839 89.3974 20.3603C89.676 20.2911 90.1023 20.3269 90.4368 20.3269H91.5097C91.7353 20.3269 92.0055 20.3169 92.1802 20.3603C92.2738 20.563 92.3324 20.807 92.4484 20.9932C92.684 21.3711 93.1106 21.6033 93.6052 21.7261C93.7998 21.7744 94.1361 21.7889 94.3428 21.7427C94.4928 21.7092 94.6065 21.7314 94.7451 21.6928C95.1121 21.5905 95.3548 21.3861 95.5163 21.0765C95.5935 20.9282 95.6799 20.5888 95.6001 20.3436C95.3632 19.6159 94.631 19.6186 93.8566 19.4275C93.4972 19.3389 93.0706 19.2821 92.7167 19.1777L92.4317 19.1444C91.7655 18.9663 91.1657 18.7409 90.6714 18.3948C90.1779 18.0492 89.8363 17.5302 89.6321 16.8958C89.5799 16.734 89.6051 16.578 89.565 16.3961C89.5124 16.1572 89.5104 15.7053 89.565 15.4633C89.6192 15.2235 89.6438 14.9916 89.7327 14.7804C90.0644 13.9917 90.6248 13.4871 91.3252 13.0648C91.7306 12.8206 92.2483 12.7214 92.767 12.5984C92.938 12.558 93.1083 12.567 93.2699 12.5318C93.3735 12.5093 93.5289 12.5628 93.6052 12.5152Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }),
      /* @__PURE__ */ jsx38("path", {
        clipRule: "evenodd",
        d: "M40.7469 12.7983H42.7419C42.9219 12.7983 43.3309 12.7435 43.3957 12.8649C43.4822 12.9802 43.4292 13.6846 43.4292 13.8976V15.9796C43.4292 16.2688 43.3734 16.7007 43.4627 16.929C43.6562 17.0373 44.257 16.979 44.5524 16.979H46.4467C46.7634 16.979 47.1495 17.017 47.4358 16.9623C47.5538 16.7073 47.4861 16.1735 47.4861 15.8297V13.8809C47.4861 13.54 47.4551 13.1181 47.5196 12.8316C47.6695 12.7658 47.9675 12.7983 48.1734 12.7983H49.5984C49.7757 12.7983 50.166 12.7463 50.2522 12.8482C50.3385 12.9627 50.2857 13.3344 50.2857 13.5145V22.9752C50.2857 23.109 50.3202 23.5087 50.2689 23.5915C50.2084 23.6891 49.8185 23.6415 49.6654 23.6415H48.0561C47.8908 23.6415 47.5786 23.6865 47.5196 23.5749C47.4712 23.5052 47.4861 23.3582 47.4861 23.2417V20.4268C47.4861 20.0909 47.5273 19.683 47.4693 19.3775C47.4398 19.3595 47.4086 19.3355 47.3855 19.3109H44.6865C44.3544 19.3109 43.7346 19.2451 43.4795 19.3442C43.3673 19.5446 43.4292 20.0214 43.4292 20.3102V23.3084C43.4292 23.3942 43.4486 23.5329 43.4124 23.5915C43.363 23.6716 43.1207 23.6415 42.9933 23.6415H41.7528C41.4519 23.6415 40.9089 23.698 40.6799 23.6082C40.6046 23.4355 40.6463 23.0893 40.6463 22.8587V13.4978C40.6463 13.3653 40.6113 12.9254 40.6631 12.8482C40.6792 12.8243 40.7253 12.8173 40.7469 12.7983Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }),
      /* @__PURE__ */ jsx38("path", {
        clipRule: "evenodd",
        d: "M72.2288 23.1748C72.1338 22.945 72.0667 22.7073 71.9774 22.4919C71.6924 21.8047 71.4825 21.0847 71.2062 20.4099C71.045 20.0162 70.9678 19.6381 70.8039 19.244C70.2032 17.8 69.7571 16.2523 69.1443 14.8134C68.866 14.1603 68.7297 13.4416 68.4066 12.8313C68.1815 12.7437 67.7538 12.798 67.4678 12.798H65.4394C65.2198 13.0082 65.1799 13.3755 65.0538 13.6808C64.7866 14.3284 64.5898 15.0178 64.3162 15.6795C63.6183 17.3676 63.1026 19.164 62.3883 20.843C62.3184 21.0072 62.3055 21.1618 62.2375 21.326C62.0277 21.8325 61.8422 22.385 61.6339 22.8917C61.549 23.0986 61.534 23.3318 61.416 23.508C61.4202 23.5661 61.4219 23.5781 61.4495 23.6079C61.5493 23.6832 61.8584 23.6412 62.0195 23.6412H63.5283C63.6988 23.6412 64.0419 23.6887 64.1486 23.6079C64.286 23.5155 64.3045 23.225 64.3665 23.0583C64.5316 22.615 64.6545 21.9869 64.8862 21.6092C65.1673 21.5495 65.574 21.5758 65.9088 21.5758H67.7528C67.9679 21.5758 68.6189 21.5237 68.7419 21.6092C68.9087 21.6675 68.9144 21.9754 68.9766 22.1422C69.1536 22.6162 69.2795 23.145 69.4795 23.6079C69.6901 23.6557 70.0051 23.6412 70.2674 23.6412H71.5918C71.7648 23.6412 72.2335 23.6799 72.3294 23.6079C72.3407 23.6024 72.3517 23.5968 72.363 23.5913C72.3562 23.4135 72.2816 23.3023 72.2288 23.1748ZM67.5014 19.4605H66.2105C65.9844 19.4605 65.741 19.4777 65.607 19.3939C65.6109 19.2133 65.6811 19.1227 65.7244 18.9941C65.8268 18.69 65.9133 18.4087 66.0094 18.128C66.2761 17.3483 66.4613 16.5347 66.7805 15.7961H66.8643C67.0127 16.0458 67.0643 16.3599 67.1661 16.6623C67.343 17.1878 67.5242 17.7424 67.7193 18.2613C67.8239 18.5392 67.8799 18.8181 67.9875 19.0774C68.0175 19.15 68.0133 19.2208 68.0546 19.2773C68.0506 19.5395 67.75 19.4605 67.5014 19.4605Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }),
      /* @__PURE__ */ jsx38("path", {
        clipRule: "evenodd",
        d: "M81.3849 12.7985H87.772C87.9916 12.7985 88.2945 12.7678 88.4593 12.8318C88.5252 12.9812 88.4929 13.2765 88.4929 13.4814C88.4929 13.9326 88.5552 14.5919 88.4761 14.9971C88.2414 15.1042 87.7578 15.0471 87.4367 15.0471H85.1401C84.8269 15.0471 84.3506 14.9836 84.1007 15.0804C84.0308 15.2008 84.0504 15.4368 84.0504 15.63V16.796C84.0504 16.9749 84.0033 17.2742 84.1342 17.329C84.2378 17.4053 84.7696 17.3623 84.9557 17.3623H87.202C87.4252 17.3623 88.0711 17.3123 88.1576 17.4289C88.228 17.5207 88.1911 17.795 88.1911 17.9453V18.9779C88.1911 19.1523 88.2072 19.37 88.1576 19.4943C87.8993 19.6076 87.3799 19.5443 87.0344 19.5443H85.1065C84.7895 19.5443 84.4043 19.5069 84.1174 19.5609C84.0993 19.5902 84.0752 19.6212 84.0504 19.6442V22.6423C84.0504 22.8457 84.0958 23.5489 83.9833 23.6084C83.8834 23.6835 83.5745 23.6417 83.4134 23.6417H81.9046C81.7522 23.6417 81.3608 23.6893 81.3011 23.5917C81.2417 23.4946 81.2843 22.9983 81.2843 22.8422V13.7479C81.2843 13.4501 81.257 13.0756 81.3178 12.8318C81.3554 12.822 81.3624 12.8193 81.3849 12.7985Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }),
      /* @__PURE__ */ jsx38("path", {
        clipRule: "evenodd",
        d: "M109.902 23.2916C109.782 22.9405 109.656 22.6192 109.533 22.2922C109.244 21.5215 109.004 20.753 108.695 20.0103C108.54 19.6369 108.465 19.2683 108.309 18.8944C107.764 17.5825 107.348 16.1769 106.801 14.8635C106.521 14.1931 106.375 13.4101 106.013 12.8148C105.721 12.7595 105.329 12.7982 105.007 12.7982H103.096C103.083 12.8097 103.058 12.8202 103.046 12.8315C102.92 12.8781 102.829 13.2989 102.777 13.4478C102.683 13.7184 102.552 14.0154 102.442 14.2806C102.325 14.5627 102.273 14.8356 102.157 15.1134C101.46 16.7888 100.933 18.5684 100.246 20.2435C100.08 20.6493 99.9972 21.0433 99.8268 21.4428C99.6081 21.9556 99.4456 22.4969 99.2401 23.0251C99.2062 23.1119 99.0277 23.505 99.0557 23.5581V23.6081C99.2488 23.6564 99.5482 23.6414 99.7933 23.6414H101.084C101.271 23.6414 101.669 23.6977 101.788 23.6081C101.936 23.5051 101.939 23.1905 102.006 23.0084C102.173 22.5596 102.302 21.9831 102.543 21.5927C103.448 21.528 104.441 21.576 105.376 21.576C105.585 21.576 106.269 21.5252 106.382 21.6093C106.527 21.6601 106.582 22.0444 106.633 22.2089C106.775 22.663 106.93 23.1773 107.119 23.6081C107.393 23.6694 107.797 23.6414 108.125 23.6414H109.936C109.955 23.6216 109.978 23.6056 110.003 23.5914C109.994 23.4533 109.936 23.3914 109.902 23.2916ZM105.661 19.394C105.602 19.5056 105.29 19.4607 105.124 19.4607H103.8C103.652 19.4607 103.387 19.4956 103.297 19.4274H103.263C103.21 19.1399 103.457 18.6577 103.548 18.4113C103.773 17.8099 103.932 17.1806 104.152 16.5958C104.255 16.3211 104.298 16.0241 104.437 15.7963C104.471 15.803 104.469 15.8005 104.487 15.8129C104.605 15.8607 104.699 16.3798 104.755 16.5292C105.005 17.1937 105.21 17.9283 105.46 18.5945C105.531 18.7854 105.576 18.9776 105.644 19.1609C105.666 19.221 105.7 19.3336 105.661 19.394Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }),
      /* @__PURE__ */ jsx38("path", {
        clipRule: "evenodd",
        d: "M78.7384 33.8683C78.7329 33.7683 78.7272 33.6684 78.7217 33.5685C78.6617 33.3186 78.6174 33.048 78.5373 32.8023C78.2194 31.8274 77.5701 31.0067 76.6765 30.6037C76.4205 30.4882 76.1323 30.4273 75.8383 30.3538C75.5248 30.2755 74.9184 30.2805 74.6145 30.3538C74.4666 30.3895 74.3504 30.3765 74.2121 30.4204C73.4418 30.6655 72.8385 31.0774 72.4351 31.6863C72.3916 31.683 72.3782 31.679 72.3513 31.6697C72.2854 31.3365 72.3178 30.874 72.3178 30.4871V27.4889C72.3178 27.3895 72.3429 27.207 72.301 27.1392C72.2955 27.1225 72.2898 27.1058 72.2843 27.0892C72.2204 27.0747 72.1797 27.0577 72.0999 27.0559C71.9175 27.1676 71.1103 26.9776 70.9264 27.0892C70.9096 27.0947 70.8929 27.1004 70.8761 27.1058C70.8058 27.4723 70.8593 27.9566 70.8593 28.3551V38.5653C70.8841 38.5883 70.9083 38.6193 70.9264 38.6486H71.8819C71.9986 38.6486 72.1735 38.6731 72.2172 38.5987C72.2596 38.5264 72.234 38.351 72.234 38.2489C72.234 37.9687 72.2251 37.6528 72.2507 37.3994L72.2675 37.3828C72.3064 37.3866 72.3148 37.3861 72.3346 37.3994C72.4269 37.4445 72.4471 37.5497 72.5022 37.6326C72.6033 37.7847 72.7354 37.9266 72.8543 38.0657C73.0418 38.2852 73.6242 38.6043 73.9272 38.7153C74.1572 38.7995 74.4029 38.8427 74.648 38.8985H74.8156C75.3457 39.0134 76.0569 38.8573 76.4082 38.7153C76.5601 38.6538 76.7107 38.6293 76.8441 38.5487C77.9613 37.8746 78.405 37.0028 78.7384 35.5506C78.744 35.4285 78.7497 35.3062 78.7552 35.1841C78.8318 34.835 78.8144 34.2132 78.7384 33.8683ZM77.2632 35.1841C77.1909 35.5109 77.1643 35.8344 77.0453 36.1169C76.7824 36.7407 76.3031 37.2783 75.6538 37.516C75.4465 37.592 75.2307 37.6154 75.0001 37.6659C74.5722 37.7595 73.9458 37.5213 73.7092 37.3994C72.9637 37.0152 72.5885 36.3927 72.3513 35.5006C72.3022 35.316 72.3235 35.1133 72.2843 34.9343V34.5512C72.24 34.32 72.352 33.6551 72.4184 33.4352C72.6343 32.7205 73.1102 32.0714 73.7595 31.7863C73.9439 31.7251 74.1283 31.6642 74.3127 31.603C74.4001 31.5807 74.4985 31.6099 74.5642 31.5697C76.1469 31.5649 76.8215 32.3267 77.1626 33.5518C77.2563 33.8883 77.28 34.2865 77.28 34.7344C77.2744 34.8843 77.2687 35.0342 77.2632 35.1841Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }),
      /* @__PURE__ */ jsx38("path", {
        clipRule: "evenodd",
        d: "M81.5625 27.0559C81.693 27.0537 81.7951 27.0677 81.8978 27.0892L81.9146 27.1392C81.986 27.2498 81.9313 27.5686 81.9313 27.7554V34.9176C81.9313 35.5088 81.8407 36.8088 82.0655 37.1496C82.2658 37.4532 82.5243 37.2903 82.8534 37.4161C82.9466 37.5778 82.933 38.3673 82.8869 38.5987C82.8572 38.6147 82.8587 38.6197 82.8198 38.632C82.7476 38.6771 82.215 38.6665 82.1325 38.6486C81.9308 38.6052 81.7417 38.6668 81.5625 38.6153C81.1436 38.4951 80.8038 38.272 80.6405 37.8991C80.4585 37.4832 80.4729 36.8814 80.4729 36.2834V28.0053C80.4729 27.7096 80.4514 27.3487 80.5064 27.1059C80.6816 27.0321 81.0276 27.0725 81.2608 27.0725C81.3496 27.0725 81.5037 27.0922 81.5625 27.0559Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }),
      /* @__PURE__ */ jsx38("path", {
        clipRule: "evenodd",
        d: "M50.0192 27.0728C50.3367 27.0703 51.1771 27.0118 51.3939 27.1061C51.4249 27.3801 51.4106 27.7211 51.4106 28.0222V36.2671C51.4106 36.6137 51.3837 36.968 51.528 37.1665C51.7339 37.4498 51.9962 37.2939 52.3159 37.4163C52.3877 37.5777 52.3726 38.4209 52.3327 38.6156L52.2824 38.6322C52.1954 38.6867 51.7385 38.6489 51.595 38.6489C50.7614 38.6489 50.2606 38.3787 50.036 37.7828C49.9834 37.643 49.9673 37.4925 49.9354 37.3497V36.9666C49.8828 36.7218 49.9186 36.3757 49.9186 36.1005V34.4016C49.9186 31.9877 49.8725 29.5251 49.9354 27.1394C49.9649 27.1214 49.9961 27.0975 50.0192 27.0728Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }),
      /* @__PURE__ */ jsx38("path", {
        clipRule: "evenodd",
        d: "M54.4238 27.156C54.9727 27.1476 55.3133 27.4148 55.4464 27.8222L55.4632 28.0554C55.4749 28.1192 55.4771 28.2999 55.4464 28.3885C55.3173 28.7608 55.0573 28.9437 54.6418 29.0381C53.8659 29.2145 53.3159 28.3507 53.6024 27.689C53.673 27.5259 53.8589 27.3273 54.0215 27.2559C54.1413 27.2033 54.314 27.2244 54.4238 27.156Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }),
      /* @__PURE__ */ jsx38("path", {
        clipRule: "evenodd",
        d: "M67.8035 27.1558C68.5388 27.1543 69.083 27.774 68.7591 28.5216C68.6359 28.8061 68.3609 28.9626 68.0215 29.0379C67.2889 29.2003 66.6545 28.4143 66.9486 27.7221C67.0297 27.5312 67.228 27.3203 67.4179 27.239C67.5329 27.1897 67.7011 27.2194 67.8035 27.1558Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }),
      /* @__PURE__ */ jsx38("path", {
        clipRule: "evenodd",
        d: "M41.0503 27.5392H47.2363C47.4851 27.5392 47.7875 27.5142 48.0074 27.5558C48.1129 27.7382 48.0871 28.6275 48.041 28.8384L47.9907 28.855C47.883 28.929 47.6648 28.8723 47.5213 28.8717L46.4819 28.8883C45.6536 28.8882 44.7788 28.8882 43.9505 28.8883C43.5125 28.8883 42.9812 28.8287 42.5759 28.905C42.5578 28.9343 42.5336 28.9653 42.5088 28.9883V31.1036C42.5088 31.4747 42.4708 31.9374 42.5423 32.2529C42.8104 32.3715 43.3588 32.3029 43.7158 32.3029H47.2698C47.4217 32.3029 47.5731 32.2829 47.6386 32.3695C47.6892 32.4353 47.6721 32.588 47.6721 32.7026C47.6721 32.9789 47.6753 33.2852 47.6554 33.5354C47.6259 33.5534 47.5947 33.5774 47.5716 33.602H44.2523C43.7349 33.602 43.0265 33.5348 42.5759 33.6354C42.4548 33.8456 42.5088 34.3171 42.5088 34.6347V36.3503C42.5088 36.6481 42.4813 37.0227 42.5423 37.2664C42.7951 37.3815 43.4459 37.3164 43.7997 37.3164H47.6554C47.8105 37.3164 47.9739 37.2944 48.041 37.383C48.0916 37.4488 48.0745 37.6015 48.0745 37.7161C48.0745 38.0048 48.0715 38.3193 48.0577 38.5823C47.9224 38.6679 47.6673 38.6489 47.4375 38.6489H41.0336C41.0165 38.6356 41.0291 38.6431 41.0001 38.6322C40.9003 38.4177 40.9498 37.9806 40.9498 37.6828V28.5052C40.9498 28.1994 40.9263 27.825 40.9833 27.5725C41.0208 27.5627 41.0279 27.56 41.0503 27.5392Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }),
      /* @__PURE__ */ jsx38("path", {
        clipRule: "evenodd",
        d: "M64.5857 30.5872H63.6469C63.6238 30.6118 63.5926 30.6358 63.5631 30.6538C63.5561 30.8738 63.5577 31.1533 63.5463 31.37C63.5406 31.4796 63.5779 31.6762 63.5296 31.7531V31.7864C63.3395 31.7786 63.339 31.6522 63.2614 31.5366C63.1443 31.3625 62.9599 31.1612 62.792 31.0369C62.2327 30.6232 61.53 30.2845 60.5456 30.304C60.4613 30.356 60.2893 30.2955 60.1768 30.3207C59.9079 30.381 59.6148 30.4071 59.3721 30.5039C58.301 30.9313 57.5401 31.7295 57.1928 32.8691C57.1017 33.1677 57.0784 33.4844 57.0084 33.8018V34.035C56.9271 34.4091 56.9998 35.0569 57.0754 35.3675C57.1515 35.68 57.1753 35.9268 57.2766 36.2003C57.6265 37.1452 58.2925 37.8568 59.2045 38.2491C59.9293 38.5609 61.1119 38.645 61.9035 38.3157C62.545 38.0488 62.9086 37.6944 63.3452 37.233C63.3888 37.2364 63.4022 37.2404 63.429 37.2497C63.5217 37.484 63.4625 38.042 63.4625 38.349C63.4625 39.6922 62.9381 40.3426 61.9202 40.6642C61.7135 40.6975 61.5067 40.7308 61.3 40.7641C61.1938 40.7587 61.0876 40.753 60.9814 40.7475C60.8441 40.7761 60.5332 40.737 60.3779 40.6975C59.8036 40.5513 59.3003 40.2879 59.0033 39.8647C58.8625 39.664 58.7991 39.3875 58.668 39.1818C58.3867 39.1482 57.5094 39.1024 57.3101 39.2151C57.2223 39.6788 57.6965 40.396 57.8969 40.6642C58.3475 41.2673 59.0264 41.6757 59.8583 41.8968C60.0611 41.9507 60.2653 41.9537 60.4618 41.9967H60.8809C61.0812 42.0397 61.6347 42.0254 61.8364 41.9801C62.1201 41.9163 62.4106 41.8831 62.6746 41.7968C63.6218 41.4874 64.3138 40.8313 64.6863 39.948C64.7691 39.7516 64.8166 39.5276 64.8707 39.3151C64.9014 39.1945 64.861 39.0141 64.921 38.9153V30.6538C64.8804 30.568 64.7135 30.5872 64.5857 30.5872ZM63.4793 34.9178C63.4132 35.2179 63.3742 35.5238 63.2614 35.7839C63.022 36.3359 62.5626 36.8314 62.0041 37.0665C61.7586 37.1697 61.5073 37.2032 61.2161 37.2663H60.9647C60.5305 37.2663 60.2475 37.1736 59.9588 37.0498C59.3449 36.7865 58.9359 36.3034 58.6848 35.684C58.5854 35.4386 58.5619 35.1418 58.5004 34.8678V34.1183C58.5015 33.8763 58.5332 33.6116 58.6009 33.4021C58.8437 32.6509 59.2985 32.0539 59.9924 31.7531C60.1389 31.6897 60.3213 31.6419 60.4785 31.6032C60.5659 31.5817 60.6644 31.6097 60.73 31.5699C62.1186 31.5669 62.8882 32.1594 63.2949 33.1189C63.3748 33.3076 63.3733 33.4809 63.429 33.7019C63.4987 33.9786 63.5525 34.5845 63.4793 34.9178Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }),
      /* @__PURE__ */ jsx38("path", {
        clipRule: "evenodd",
        d: "M91.6368 34.4844C91.6368 33.8866 91.5791 33.4052 91.4356 32.9687C90.926 31.4186 89.7728 30.265 87.6805 30.3037C87.5966 30.3556 87.424 30.2958 87.3117 30.3203C87.1125 30.3638 86.8905 30.373 86.6914 30.4369C86.0845 30.6318 85.6181 30.9145 85.1659 31.2531C85.0011 31.3765 84.8547 31.5709 84.73 31.7361C84.6735 31.8109 84.5833 31.875 84.5288 31.9526C84.2787 32.3086 84.0814 32.7438 83.9421 33.2019C83.903 33.4072 83.8638 33.6128 83.8247 33.8181V34.018C83.7852 34.1969 83.7428 34.8283 83.7912 35.0507C83.8487 35.3149 83.8395 35.6012 83.9085 35.8502C84.195 36.8841 84.6903 37.6897 85.4676 38.2321C85.9585 38.5745 86.5185 38.7404 87.2111 38.8983C87.4952 38.9631 88.1582 38.9418 88.4181 38.8816C88.6028 38.839 88.7596 38.8513 88.9378 38.7984C89.665 38.5825 90.3399 38.2357 90.7483 37.6991C90.8145 37.6119 90.9186 37.5402 90.983 37.4492C91.1493 37.2142 91.2502 36.9702 91.3686 36.683C91.4214 36.5551 91.5268 36.3686 91.4691 36.2333C91.1686 36.174 90.7614 36.2166 90.4298 36.2166C90.327 36.2166 90.131 36.1893 90.061 36.2333C89.9562 36.2719 89.749 36.777 89.6586 36.8996C89.3875 37.2675 88.9423 37.4825 88.4348 37.6158C88.1696 37.6854 87.7499 37.6936 87.4793 37.6324C87.3432 37.6018 87.2337 37.6216 87.1105 37.5825C86.3831 37.3516 85.9157 36.914 85.585 36.2833C85.4738 36.0714 85.3363 35.7699 85.3167 35.4838C85.308 35.3572 85.2535 35.1998 85.3167 35.1173C85.3895 35.0314 85.5779 35.0507 85.7358 35.0507H91.2009C91.3047 35.0507 91.4985 35.0775 91.5697 35.0341C91.5865 35.0286 91.6033 35.0229 91.62 35.0174C91.6485 34.8695 91.6368 34.6591 91.6368 34.4844ZM90.1113 33.9014C90.0988 33.9401 90.0938 33.9386 90.0777 33.9681C89.8001 34.0222 89.4176 34.0014 89.0886 34.0014C88.8999 34.0014 88.6623 34.0187 88.5019 33.9847H87.9487C87.5076 33.9847 87.059 34.0012 86.6411 34.0014C86.2711 34.0015 85.559 34.0703 85.3167 33.9347C85.2574 33.6291 85.3925 33.3183 85.4844 33.1019C85.7343 32.5131 86.1269 32.0383 86.7081 31.7861C86.8837 31.71 87.0847 31.6535 87.2781 31.6029C87.3624 31.5807 87.48 31.6097 87.5464 31.5696C88.7814 31.5591 89.5027 32.0464 89.8766 32.8854C89.9285 33.002 90.0056 33.1531 90.0442 33.2851C90.061 33.3962 90.0777 33.5072 90.0945 33.6183C90.1126 33.6827 90.158 33.8275 90.1113 33.9014Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }),
      /* @__PURE__ */ jsx38("path", {
        clipRule: "evenodd",
        d: "M53.844 30.5868C54.2668 30.585 54.8342 30.5297 55.2186 30.6035L55.2354 30.6534C55.2904 30.7417 55.2522 30.9954 55.2522 31.1198V38.0655C55.2522 38.1972 55.2941 38.471 55.2354 38.5651C55.2126 38.6384 55.1831 38.6498 55.0845 38.6484C55.0389 38.6722 54.8492 38.6484 54.7493 38.6484C54.449 38.6484 54.0804 38.6851 53.8105 38.6318L53.7937 38.5818C53.7219 38.4867 53.7602 38.203 53.7602 38.0488V31.2197C53.7602 31.0234 53.737 30.7642 53.7937 30.6201C53.8148 30.6093 53.8284 30.602 53.844 30.5868Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }),
      /* @__PURE__ */ jsx38("path", {
        clipRule: "evenodd",
        d: "M67.2138 30.5871C67.6346 30.5851 68.1503 30.5293 68.5382 30.6038C68.5543 30.6333 68.5593 30.6318 68.5717 30.6704C68.6376 30.7765 68.5885 31.0905 68.5885 31.2367V37.9325C68.5885 38.1486 68.6079 38.4106 68.5717 38.5988C68.5421 38.6148 68.5436 38.6198 68.5047 38.6321C68.447 38.6691 68.2908 38.6488 68.2029 38.6488H67.4653C67.3429 38.6488 67.2192 38.6656 67.1636 38.5988C67.09 38.5012 67.13 38.2067 67.13 38.0491V31.32C67.13 31.0988 67.1096 30.8303 67.1468 30.6371C67.1713 30.6229 67.1949 30.607 67.2138 30.5871Z",
        fill: "currentColor",
        fillRule: "evenodd"
      })
    ]
  });
}

// src/layout/v3/Footer/FooterEmailSignup/index.tsx
init_esm_shims();
import { useState as useState5 } from "react";
import { cx as cx17 } from "class-variance-authority";
import { useFormik } from "formik";
import { FormattedMessage as FormattedMessage2, useIntl as useIntl3 } from "react-intl";

// src/icons/RightArrowIcon.tsx
init_esm_shims();
import { jsx as jsx39, jsxs as jsxs20 } from "react/jsx-runtime";
function RightArrowIcon({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs20("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 12,
    viewBox: "0 0 21 12",
    width: 21,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx39("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx39("path", {
        d: "M20.5303 6.53033C20.8232 6.23744 20.8232 5.76256 20.5303 5.46967L15.7574 0.696699C15.4645 0.403806 14.9896 0.403806 14.6967 0.696699C14.4038 0.989593 14.4038 1.46447 14.6967 1.75736L18.9393 6L14.6967 10.2426C14.4038 10.5355 14.4038 11.0104 14.6967 11.3033C14.9896 11.5962 15.4645 11.5962 15.7574 11.3033L20.5303 6.53033ZM0 6.75H20V5.25H0V6.75Z",
        fill: "currentColor"
      })
    ]
  });
}

// src/layout/v3/Footer/FooterEmailSignup/index.tsx
import { Fragment as Fragment5, jsx as jsx40, jsxs as jsxs21 } from "react/jsx-runtime";
function PrivacyPolicyLink(text) {
  return /* @__PURE__ */ jsx40(BodyLink, {
    color: "inherit",
    href: "/privacy-policy",
    children: text
  }, "privacy-policy-link");
}
function FooterEmailSignup({
  emailSubmitted,
  onNewsletterFormSubmit
}) {
  const [focused, setFocused] = useState5(false);
  const { formatMessage } = useIntl3();
  const handleFocus = () => {
    setFocused(true);
  };
  const formik = useFormik({
    validateOnChange: false,
    validateOnBlur: false,
    validate: (values) => {
      const errors = {};
      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
        errors.email = formatMessage({ id: "footer_email_validation_error" });
      }
      return errors;
    },
    initialValues: {
      email: ""
    },
    onSubmit: (values) => {
      onNewsletterFormSubmit(values.email);
    }
  });
  return /* @__PURE__ */ jsxs21(Fragment5, {
    children: [
      /* @__PURE__ */ jsx40(Typography, {
        Element: "span",
        color: "inherit",
        weight: "bold",
        children: t("footer_email_input_heading")
      }),
      /* @__PURE__ */ jsxs21("form", {
        className: "ui-flex ui-flex-col ui-text-gray-400 ui-relative ui-max-w-96 ui-my-6",
        "data-cy": "footer_email_signup",
        noValidate: true,
        onSubmit: formik.handleSubmit,
        children: [
          /* @__PURE__ */ jsx40("label", {
            className: cx17(
              "ui-absolute ui-top-5 ui-left-4",
              "ui-transform ui--translate-y-1/2 ui-transition-all",
              {
                "ui--translate-y-10 ui--translate-x-4 ui-text-xs": focused
              }
            ),
            htmlFor: "footer_email_signup_input",
            children: emailSubmitted ? /* @__PURE__ */ jsx40(FormattedMessage2, {
              id: "footer_thanks_for_subscribing"
            }) : /* @__PURE__ */ jsx40(FormattedMessage2, {
              id: "footer_email"
            })
          }),
          /* @__PURE__ */ jsx40("input", {
            className: cx17(
              "ui-appearance-none ui-bg-sandstone-200",
              "ui-h-10 ui-w-full ui-py-2 ui-px-4",
              "ui-rounded ui-overflow-hidden"
            ),
            id: "footer_email_signup_input",
            name: "email",
            onBlurCapture: formik.handleBlur,
            onChange: formik.handleChange,
            onFocus: handleFocus,
            type: "email",
            value: formik.values.email
          }),
          !emailSubmitted ? /* @__PURE__ */ jsx40("button", {
            "aria-label": formatMessage({
              id: "footer_newsletter_submit_label"
            }),
            className: cx17(
              "ui-absolute ui-bottom-0 ui-right-0 ui-h-10",
              "ui-py-2 ui-pl-2 ui-pr-4",
              "ui-bg-sandstone-200 ui-rounded-r",
              {
                "ui-text-gray-400": !focused,
                "ui-text-sandstone-500": focused
              }
            ),
            "data-cy": "footer_email_signup_submit",
            name: "submit",
            type: "submit",
            children: /* @__PURE__ */ jsx40(RightArrowIcon, {})
          }) : null,
          formik.errors.email ? /* @__PURE__ */ jsx40("div", {
            className: "ui-absolute ui-text-xs ui--bottom-5 ui-text-red",
            "data-cy": "email_error_message",
            children: formik.errors.email
          }) : null
        ]
      }),
      /* @__PURE__ */ jsx40(Typography, {
        className: "ui-mt-4",
        color: "inherit",
        variant: "eyebrow-small",
        children: /* @__PURE__ */ jsx40(FormattedMessage2, {
          id: "footer_dataprotect_1"
        })
      }),
      /* @__PURE__ */ jsx40(Typography, {
        Element: "div",
        color: "inherit",
        variant: "eyebrow-small",
        children: /* @__PURE__ */ jsx40(FormattedMessage2, {
          id: "footer_dataprotect_privacy_policy",
          values: {
            PrivacyPolicyLink
          }
        })
      })
    ]
  });
}
FooterEmailSignup.displayName = "FooterEmailSignup";

// src/layout/v3/Footer/FooterLegal/index.tsx
init_esm_shims();
import { cx as cx20 } from "class-variance-authority";
import { useIntl as useIntl4 } from "react-intl";

// src/layout/v3/Footer/FooterLegal/FooterLegalese.tsx
init_esm_shims();
import { FormattedMessage as FormattedMessage3 } from "react-intl";
import { cx as cx18 } from "class-variance-authority";
import { jsx as jsx41, jsxs as jsxs22 } from "react/jsx-runtime";
function FooterLegalese({
  className
}) {
  return /* @__PURE__ */ jsxs22(Typography, {
    Element: "div",
    className: cx18(className, "ui-flex ui-flex-col ui-gap-2"),
    color: "inherit",
    variant: "eyebrow-small",
    children: [
      /* @__PURE__ */ jsxs22("p", {
        children: [
          "\xA9 ",
          new Date().getFullYear(),
          " ",
          /* @__PURE__ */ jsx41(FormattedMessage3, {
            id: "footer_all_rights_reserved"
          })
        ]
      }),
      /* @__PURE__ */ jsx41("p", {
        children: /* @__PURE__ */ jsx41(FormattedMessage3, {
          id: "footer_copyright"
        })
      })
    ]
  });
}
FooterLegalese.displayName = "FooterLegalese";

// src/layout/v3/Footer/FooterLegal/FooterLegalLinks.tsx
init_esm_shims();
import { useContext as useContext7 } from "react";
import { FormattedMessage as FormattedMessage4 } from "react-intl";
import { cx as cx19 } from "class-variance-authority";
import { jsx as jsx42 } from "react/jsx-runtime";
function FooterLegalLinks({
  isLocalised,
  links
}) {
  var _a;
  const context = useContext7(Context);
  const LinkComponent = (_a = context.LinkComponent) != null ? _a : "a";
  return /* @__PURE__ */ jsx42("ul", {
    className: cx19(
      "ui-flex ui-flex-wrap ui-gap-x-2 ui-gap-y-2 ui-justify-left ui-text-eyebrow",
      "md:ui-gap-x-4"
    ),
    children: links.map((link) => /* @__PURE__ */ jsx42("li", {
      children: /* @__PURE__ */ jsx42(LinkComponent, {
        className: "ui-whitespace-nowrap",
        href: link.href,
        children: isLocalised ? link.label : /* @__PURE__ */ jsx42(FormattedMessage4, {
          id: link.label
        })
      })
    }, link.id))
  });
}
FooterLegalLinks.displayName = "FooterLegalLinks";

// src/layout/v3/Footer/FooterLegal/index.tsx
import { jsx as jsx43, jsxs as jsxs23 } from "react/jsx-runtime";
function FooterLegal({
  isLocalised,
  legalLinks
}) {
  const { formatMessage } = useIntl4();
  return /* @__PURE__ */ jsxs23("div", {
    className: cx20(
      "ui-text-gray-400",
      "ui-pt-4 ui-pb-8",
      "ui-flex ui-flex-col ui-gap-6 lg:ui-gap-2"
    ),
    children: [
      /* @__PURE__ */ jsx43("nav", {
        "aria-label": formatMessage({ id: "footer_legal_aria_label" }),
        className: "ui-flex-1",
        children: /* @__PURE__ */ jsx43(FooterLegalLinks, {
          isLocalised,
          links: legalLinks
        })
      }),
      /* @__PURE__ */ jsx43(FooterLegalese, {
        className: "ui-flex-1"
      })
    ]
  });
}
FooterLegal.displayName = "FooterLegal";

// src/layout/v3/Footer/FooterSocialIcons/index.tsx
init_esm_shims();
import { useIntl as useIntl5 } from "react-intl";

// src/icons/Facebook.tsx
init_esm_shims();
import { jsx as jsx44, jsxs as jsxs24 } from "react/jsx-runtime";
function Facebook({
  title = "Facebook",
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs24("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx44("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx44("path", {
        d: "M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z",
        fill: "currentColor"
      })
    ]
  });
}

// src/icons/Instagram.tsx
init_esm_shims();
import { jsx as jsx45, jsxs as jsxs25 } from "react/jsx-runtime";
function Instagram({
  title = "Instagram",
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs25("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx45("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx45("path", {
        d: "M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z"
      })
    ]
  });
}

// src/icons/Pinterest.tsx
init_esm_shims();
import { jsx as jsx46, jsxs as jsxs26 } from "react/jsx-runtime";
function Pinterest({
  title = "Pinterest",
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs26("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx46("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx46("path", {
        d: "M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.401.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.354-.629-2.758-1.379l-.749 2.848c-.269 1.045-1.004 2.352-1.498 3.146 1.123.345 2.306.535 3.55.535 6.607 0 11.985-5.365 11.985-11.987C23.97 5.39 18.592.026 11.985.026L12.017 0z"
      })
    ]
  });
}

// src/icons/Tiktok.tsx
init_esm_shims();
import { jsx as jsx47, jsxs as jsxs27 } from "react/jsx-runtime";
function Tiktok({
  title = "TikTok",
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs27("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx47("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx47("path", {
        d: "M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"
      })
    ]
  });
}

// src/icons/Twitter.tsx
init_esm_shims();
import { jsx as jsx48, jsxs as jsxs28 } from "react/jsx-runtime";
function Twitter({
  title = "X (formerly known as Twitter)",
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs28("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx48("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx48("path", {
        d: "M0.837831 0.0463867L6.39553 7.47756L0.802734 13.5194H2.06145L6.95793 8.22968L10.9142 13.5194H15.1976L9.32721 5.67025L14.5329 0.0463867H13.2742L8.76481 4.91813L5.12128 0.0463867H0.837831ZM2.68886 0.973558H4.65669L13.3463 12.5921H11.3785L2.68886 0.973558Z"
      })
    ]
  });
}

// src/icons/Youtube.tsx
init_esm_shims();
import { jsx as jsx49, jsxs as jsxs29 } from "react/jsx-runtime";
function Youtube({
  title = "YouTube",
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs29("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx49("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx49("path", {
        d: "M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"
      })
    ]
  });
}

// src/consts/links.tsx
init_esm_shims();
var INSTAGRAM_URL = "https://www.instagram.com/ouraring/";
var INSTAGRAM_URL_UTM = `${INSTAGRAM_URL}?utm_source=web&utm_medium=organic&utm_campaign=alwayson_websocial&utm_content=static`;
var TWITTER_URL = "https://twitter.com/ouraring";
var TWITTER_URL_UTM = `${TWITTER_URL}?utm_source=web&utm_medium=organic&utm_campaign=alwayson_websocial&utm_content=static`;
var FACEBOOK_URL = "https://www.facebook.com/ouraring";
var FACEBOOK_URL_UTM = `${FACEBOOK_URL}?utm_source=web&utm_medium=organic&utm_campaign=alwayson_websocial&utm_content=static`;
var YOUTUBE_URL = "https://www.youtube.com/channel/UCf-xFf4xPcT9DVdOkcCaScg";
var YOUTUBE_URL_UTM = `${YOUTUBE_URL}?utm_source=web&utm_medium=organic&utm_campaign=alwayson_websocial&utm_content=static`;
var TIKTOK_URL = "https://www.tiktok.com/@ouraring";
var TIKTOK_URL_UTM = `${TIKTOK_URL}?utm_source=web&utm_medium=organic&utm_campaign=alwayson_websocial&utm_content=static`;
var PINTEREST_URL = "https://www.pinterest.com/Ouraring/";
var PINTEREST_URL_UTM = `${PINTEREST_URL}?utm_source=web&utm_medium=organic&utm_campaign=alwayson_websocial&utm_content=static`;

// src/v3/CircularIcon/index.tsx
init_esm_shims();
import { jsx as jsx50 } from "react/jsx-runtime";
function CircularIcon({
  icon,
  ...props
}) {
  return /* @__PURE__ */ jsx50("a", {
    className: "ui-h-4 ui-w-4 ui-inline-block ui-relative ui-rounded-full ui-bg-sandstone-200 ui-text-sandstone-500 sm:ui-w-8 sm:ui-h-8",
    rel: "noreferrer",
    target: "_blank",
    ...props,
    children: /* @__PURE__ */ jsx50("div", {
      className: "ui-absolute ui-top-1/2 ui-left-1/2 ui-transform ui--translate-x-1/2 ui--translate-y-1/2 ui-text-zero",
      children: icon
    })
  });
}
CircularIcon.displayName = "CircularIcon";

// src/layout/v3/Footer/FooterSocialIcons/index.tsx
import { jsx as jsx51 } from "react/jsx-runtime";
function SocialIcon({
  Icon,
  name,
  onClick,
  url
}) {
  const handleClick = () => {
    onClick == null ? void 0 : onClick({ name, url });
  };
  return /* @__PURE__ */ jsx51(CircularIcon, {
    "aria-label": name,
    "data-cy": "footer-social-link",
    "data-site": name.toLowerCase(),
    href: url,
    icon: /* @__PURE__ */ jsx51(Icon, {
      className: "ui-h-3 ui-w-3 sm:ui-w-4 sm:ui-h-4"
    }),
    onClick: handleClick
  });
}
var SOCIAL_ICONS_DATA = [
  {
    Icon: Facebook,
    name: "Facebook",
    url: FACEBOOK_URL_UTM
  },
  {
    Icon: Instagram,
    name: "Instagram",
    url: INSTAGRAM_URL_UTM
  },
  {
    Icon: Twitter,
    name: "Twitter",
    url: TWITTER_URL_UTM
  },
  {
    Icon: Youtube,
    name: "Youtube",
    url: YOUTUBE_URL_UTM
  },
  {
    Icon: Tiktok,
    name: "TikTok",
    url: TIKTOK_URL_UTM
  },
  {
    Icon: Pinterest,
    name: "Pinterest",
    url: PINTEREST_URL_UTM
  }
];
function FooterSocialIconsV3({
  onSocialLinkClick
}) {
  const { formatMessage } = useIntl5();
  return /* @__PURE__ */ jsx51("nav", {
    "aria-label": formatMessage({ id: "footer_social_icons_aria_label" }),
    children: /* @__PURE__ */ jsx51("ul", {
      className: "ui-flex ui-gap-4",
      children: SOCIAL_ICONS_DATA.map((icon) => /* @__PURE__ */ jsx51("li", {
        className: "ui-flex-none",
        children: /* @__PURE__ */ jsx51(SocialIcon, {
          ...icon,
          onClick: onSocialLinkClick
        })
      }, icon.name))
    })
  });
}
FooterSocialIconsV3.displayName = "FooterSocialIconsV3";

// src/layout/v3/Footer/EcomFooter/index.tsx
import { Fragment as Fragment6, jsx as jsx52, jsxs as jsxs30 } from "react/jsx-runtime";
var gradients2 = [
  {
    shape: "ellipse",
    hex: "#3A3837",
    id: "gray-1",
    position: [10, 99],
    opacity: 1,
    size: 50
  },
  {
    shape: "ellipse",
    hex: "#3A3837",
    id: "gray-2",
    position: [99, 10],
    opacity: 1,
    size: 50
  }
];
function CategoryLinks({
  category,
  isLocalised,
  onClick
}) {
  return /* @__PURE__ */ jsxs30("div", {
    className: "ui-pt-8 ui-text-gray-400",
    children: [
      (category == null ? void 0 : category.title) ? /* @__PURE__ */ jsx52(Typography, {
        Element: "span",
        color: "inherit",
        weight: "bold",
        children: isLocalised ? category.title : t(category.title)
      }) : null,
      /* @__PURE__ */ jsx52("div", {
        className: "ui-text-sandstone-200 ui-pt-3 lg:ui-pt-0",
        children: (category == null ? void 0 : category.links) ? /* @__PURE__ */ jsx52(NavLinks, {
          border: false,
          isLocalised,
          navLinkClass: "ui-text-stroke-color-transparent ui-text-stroke-width-0.5 ui-transition-all hover:ui-text-stroke-color-current",
          navLinks: category.links,
          onClick,
          tabIndex: 0
        }) : null
      })
    ]
  });
}
var tValue2 = {
  em: function em3(chunks) {
    return /* @__PURE__ */ jsx52("em", {
      className: "ui-font-serif ui-italic ui-self-end",
      children: chunks
    });
  }
};
function Motion({ children }) {
  const shouldReduceMotion = useReducedMotion2();
  const target = useRef5(null);
  const { scrollYProgress } = useScroll2({
    target,
    offset: ["start end", "end start"]
  });
  const scrollY = useTransform(scrollYProgress, [0, 1], ["-20%", "5%"]);
  return /* @__PURE__ */ jsx52(motion3.div, {
    ref: target,
    style: {
      position: "absolute",
      inset: 0,
      y: shouldReduceMotion ? 0 : scrollY,
      height: shouldReduceMotion ? "100%" : "115%"
    },
    children
  });
}
function DefaultImage({
  children
}) {
  return /* @__PURE__ */ jsx52(Fragment6, {
    children
  });
}
function EcomFooter({
  disableImageMotion = false,
  emailSubmitted,
  footerImageComponent,
  footerLinks,
  hideSocialLinks,
  inverseHeaderOnScrollUp = false,
  legalLinks,
  onFooterLinkClick,
  onNewsletterFormSubmit,
  onSocialLinkClick,
  showHsaFsaBlockLogo,
  wrapperClassName = "ui-bg-gray-600"
}) {
  var _a, _b, _c;
  const { formatMessage } = useIntl6();
  const ImageComp = disableImageMotion ? DefaultImage : Motion;
  const _footerLinks = footerLinks != null ? footerLinks : defaultFooterData_default.footerLinks;
  const companyLinks = _footerLinks.find(
    ({ id }) => id === "our-company-category" /* CompanyCategory */
  );
  const supportLinks = _footerLinks.find(
    ({ id }) => id === "support-category" /* SupportCategory */
  );
  const partnerLinks = _footerLinks.find(
    ({ id }) => id === "partner-category" /* PartnerCategory */
  );
  const blogLinks = _footerLinks.find(
    ({ id }) => id === "blog-category" /* BlogCategory */
  );
  const footerCardLink = _footerLinks.find(
    ({ id }) => id === "footer-card" /* FooterCard */
  );
  const _legalLinks = legalLinks != null ? legalLinks : defaultFooterData_default.legalLinks;
  return /* @__PURE__ */ jsx52(InverseHeader, {
    enter: true,
    exit: inverseHeaderOnScrollUp,
    children: /* @__PURE__ */ jsxs30(LayoutGrid, {
      className: cx21("lg:ui-px-6 lg:ui-pb-6", wrapperClassName),
      "data-cy": "ecom-footer",
      children: [
        /* @__PURE__ */ jsx52(GridItem, {
          colEnd: { sm: "full" },
          colStart: { sm: "full" },
          rowEnd: { sm: 10, md: 6, lg: 4 },
          rowStart: { sm: 1, md: 1, lg: 1 },
          children: /* @__PURE__ */ jsx52(RadialGradientBG, {
            background: "gray-600",
            className: "lg:ui-rounded-xl ui-overflow-hidden",
            gradients: gradients2
          })
        }),
        /* @__PURE__ */ jsx52(GridItem, {
          className: cx21(
            "ui-relative ui-h-[320px] ui-mt-8 ui-rounded-lg ui-overflow-hidden",
            "md:ui-rounded-none md:ui-rounded-r-lg md:ui-mt-0 md:ui-h-full",
            "lg:ui-rounded-lg"
          ),
          colEnd: { sm: "main", md: 10, lg: 7 },
          colStart: {
            sm: "main",
            md: "full",
            lg: "full"
          },
          rowEnd: { sm: 4, md: 6, lg: 4 },
          rowStart: { sm: 1, md: 1, lg: 1 },
          children: /* @__PURE__ */ jsx52("nav", {
            className: "ui-h-full",
            id: "nav_footer",
            children: /* @__PURE__ */ jsx52("ul", {
              className: "ui-h-full",
              children: (footerCardLink == null ? void 0 : footerCardLink.link) ? /* @__PURE__ */ jsx52(NavLink, {
                "aria-label": footerCardLink.link.ariaLabel || formatMessage({ id: "shop_rings" }),
                className: cx21(
                  "ui-block ui-h-full ui-relative ui-rounded-lg ui-overflow-hidden",
                  "md:ui-rounded-none md:ui-rounded-r-lg",
                  "lg:ui-rounded-lg"
                ),
                "data-cy": "footer-cta-link",
                href: footerCardLink.link.href,
                onClick: onFooterLinkClick,
                tabIndex: 0,
                target: footerCardLink.link.target,
                children: /* @__PURE__ */ jsx52(ImageComp, {
                  children: footerImageComponent
                })
              }) : null
            })
          })
        }),
        /* @__PURE__ */ jsxs30(GridItem, {
          className: cx21(
            "ui-relative ui-pt-12 ui-pb-8 ui-px-6",
            "ui-pointer-events-none",
            "ui-flex ui-flex-col ui-justify-between",
            "md:ui-pt-8"
          ),
          colEnd: { sm: "main", md: 10, lg: 7 },
          colStart: {
            sm: "main",
            md: "full",
            lg: "full"
          },
          rowEnd: { sm: 4, md: 6, lg: 4 },
          rowStart: { sm: 1, md: 1, lg: 1 },
          children: [
            /* @__PURE__ */ jsx52(Typography, {
              Element: "div",
              className: "footerImageCta ui-flex ui-flex-col ui-text-heading-lg ui-max-w-80 xl:ui-max-w-none",
              color: ((_b = (_a = footerCardLink == null ? void 0 : footerCardLink.link) == null ? void 0 : _a.overlay) == null ? void 0 : _b.color) || "light",
              "data-cy": "footer-cta-title",
              height: "tight",
              variant: "unset",
              weight: "thin",
              children: (footerCardLink == null ? void 0 : footerCardLink.title) || t("footer_image_cta", tValue2)
            }),
            /* @__PURE__ */ jsx52("div", {
              className: cx21(
                "ui-bg-blue-100 ui-text-sandstone-200",
                "ui-self-center ui-rounded-full ui-text-center ui-inline-block",
                "ui-py-2 ui-px-4 lg:ui-py-3 lg:ui-px-6"
              ),
              "data-cy": "footer-cta-action",
              children: ((_c = footerCardLink == null ? void 0 : footerCardLink.link) == null ? void 0 : _c.label) || t("shop")
            })
          ]
        }),
        /* @__PURE__ */ jsxs30(GridItem, {
          className: "ui-relative",
          colEnd: { sm: 5, md: 17, lg: 11 },
          colStart: { sm: "main", md: 11, lg: 8 },
          rowEnd: { sm: 6, md: 2 },
          rowStart: { sm: 4, md: 1 },
          children: [
            /* @__PURE__ */ jsx52(CategoryLinks, {
              category: companyLinks,
              isLocalised: Boolean(footerLinks),
              onClick: onFooterLinkClick
            }),
            /* @__PURE__ */ jsx52("div", {
              className: "lg:ui-hidden",
              children: /* @__PURE__ */ jsx52(CategoryLinks, {
                category: partnerLinks,
                isLocalised: Boolean(footerLinks),
                onClick: onFooterLinkClick
              })
            })
          ]
        }),
        /* @__PURE__ */ jsxs30(GridItem, {
          className: "ui-relative",
          colEnd: { sm: "main", md: "main", lg: 15 },
          colStart: { sm: 6, md: 18, lg: 12 },
          rowEnd: { sm: 6, md: 2 },
          rowStart: { sm: 4, md: 1 },
          children: [
            /* @__PURE__ */ jsx52(CategoryLinks, {
              category: supportLinks,
              isLocalised: Boolean(footerLinks),
              onClick: onFooterLinkClick
            }),
            /* @__PURE__ */ jsx52("div", {
              className: "lg:ui-hidden",
              children: /* @__PURE__ */ jsx52(CategoryLinks, {
                category: blogLinks,
                isLocalised: Boolean(footerLinks),
                onClick: onFooterLinkClick
              })
            })
          ]
        }),
        /* @__PURE__ */ jsxs30(GridItem, {
          className: "ui-relative ui-hidden lg:ui-block",
          colEnd: { sm: "main", md: "main", lg: 20 },
          colStart: { sm: 6, md: 18, lg: 16 },
          rowEnd: { sm: 6, md: 3, lg: 2 },
          rowStart: { sm: 5, md: 2, lg: 1 },
          children: [
            /* @__PURE__ */ jsx52(CategoryLinks, {
              category: partnerLinks,
              isLocalised: Boolean(footerLinks),
              onClick: onFooterLinkClick
            }),
            /* @__PURE__ */ jsx52(CategoryLinks, {
              category: blogLinks,
              isLocalised: Boolean(footerLinks),
              onClick: onFooterLinkClick
            })
          ]
        }),
        /* @__PURE__ */ jsxs30(GridItem, {
          className: "ui-relative ui-text-gray-400 ui-pt-2 lg:ui-pt-28",
          colEnd: { sm: "main", md: "main", lg: 15 },
          colStart: { sm: "main", md: 11, lg: 8 },
          rowEnd: { sm: 8, md: 5, lg: 3 },
          rowStart: { sm: 7, md: 4, lg: 2 },
          children: [
            !hideSocialLinks && /* @__PURE__ */ jsx52(Typography, {
              Element: "span",
              color: "inherit",
              "data-cy": "footer-social-title",
              weight: "bold",
              children: t("footer_social_heading")
            }),
            /* @__PURE__ */ jsxs30("div", {
              className: cx21(
                "ui-flex ui-flex-col ui-pt-4 ui-gap-4",
                "lg:ui-justify-normal lg:ui-pt-7"
              ),
              children: [
                !hideSocialLinks && /* @__PURE__ */ jsx52("div", {
                  "data-cy": "footer-social-links",
                  children: /* @__PURE__ */ jsx52(FooterSocialIconsV3, {
                    onSocialLinkClick
                  })
                }),
                showHsaFsaBlockLogo ? /* @__PURE__ */ jsx52("ul", {
                  children: /* @__PURE__ */ jsx52(NavLink, {
                    className: "ui-inline-block ui-mt-8 md:ui-mt-0 lg:ui-mt-8",
                    "data-cy": "footer-hsa-fsa-nav-link",
                    external: true,
                    hideArrow: true,
                    href: "https://support.ouraring.com/hc/en-us/articles/19777137314579-Purchase-with-FSA-or-HSA-Funds",
                    onClick: onFooterLinkClick,
                    rel: "noopener noreferrer",
                    target: "_blank",
                    children: /* @__PURE__ */ jsx52(HsaFsaBlockOutlinedLogo, {
                      color: "#F7F1E8",
                      fill: "#272625",
                      height: 44,
                      width: 100
                    })
                  })
                }) : null
              ]
            })
          ]
        }),
        /* @__PURE__ */ jsx52(GridItem, {
          className: "ui-relative ui-text-gray-400 ui-pt-4 lg:ui-pt-28",
          colEnd: { sm: "main", md: "main", lg: "main" },
          colStart: { sm: "main", md: 11, lg: 16 },
          rowEnd: { sm: 7, md: 4, lg: 3 },
          rowStart: { sm: 6, md: 3, lg: 2 },
          children: /* @__PURE__ */ jsx52(FooterEmailSignup, {
            emailSubmitted,
            onNewsletterFormSubmit
          })
        }),
        /* @__PURE__ */ jsx52(GridItem, {
          className: "ui-relative",
          colEnd: { sm: "main", md: "main", lg: "main" },
          colStart: { sm: "main", md: 11, lg: 8 },
          rowEnd: { sm: 9, md: 6, lg: 3 },
          rowStart: { sm: 8, md: 5, lg: 3 },
          children: /* @__PURE__ */ jsx52(FooterLegal, {
            isLocalised: Boolean(legalLinks),
            legalLinks: _legalLinks
          })
        })
      ]
    })
  });
}
EcomFooter.displayName = "EcomFooter";

// src/layout/v3/Footer/SimpleFooter/index.tsx
init_esm_shims();
import { cx as cx22 } from "class-variance-authority";
import { jsx as jsx53, jsxs as jsxs31 } from "react/jsx-runtime";
var gradients3 = [
  {
    shape: "ellipse",
    hex: "#3A3837",
    id: "gray-1",
    position: [10, 99],
    opacity: 1,
    size: 50
  },
  {
    shape: "ellipse",
    hex: "#3A3837",
    id: "gray-2",
    position: [99, 10],
    opacity: 1,
    size: 50
  }
];
function SimpleFooter({
  inverseHeaderOnScrollUp = false,
  hideSocialLinks,
  legalLinks,
  onSocialLinkClick,
  wrapperClassName = "ui-bg-gray-600"
}) {
  const _legalLinks = legalLinks != null ? legalLinks : defaultFooterData_default.legalLinks;
  return /* @__PURE__ */ jsx53(InverseHeader, {
    enter: true,
    exit: inverseHeaderOnScrollUp,
    children: /* @__PURE__ */ jsxs31(LayoutGrid, {
      className: cx22(wrapperClassName),
      "data-cy": "simple-footer",
      children: [
        /* @__PURE__ */ jsx53(GridItem, {
          colEnd: { sm: "full" },
          colStart: { sm: "full" },
          rowEnd: { sm: 4 },
          rowStart: { sm: 1 },
          children: /* @__PURE__ */ jsx53(RadialGradientBG, {
            background: "gray-600",
            className: "ui-h-full ui-w-full ui-overflow-hidden",
            gradients: gradients3
          })
        }),
        /* @__PURE__ */ jsxs31(GridItem, {
          className: cx22(
            "ui-relative ui-text-gray-400",
            "ui-pt-8 ui-pb-1",
            "ui-flex ui-justify-between ui-flex-wrap ui-gap-x-12",
            {
              "ui-items-end ui-gap-y-1": !hideSocialLinks,
              "ui-items-center ui-gap-y-16": hideSocialLinks
            }
          ),
          colEnd: { sm: "main" },
          colStart: { sm: "main" },
          rowEnd: { sm: 2 },
          rowStart: { sm: 1 },
          children: [
            /* @__PURE__ */ jsxs31("div", {
              className: "ui-flex ui-flex-col ui-gap-y-16",
              children: [
                /* @__PURE__ */ jsx53(Oura, {
                  color: "#F7F1E8",
                  fill: "#272625",
                  height: 44,
                  width: 100
                }),
                !hideSocialLinks && /* @__PURE__ */ jsxs31("section", {
                  "data-cy": "footer-social-links",
                  children: [
                    /* @__PURE__ */ jsx53(Typography, {
                      Element: "h4",
                      className: "ui-sr-only",
                      children: t("footer_social_heading")
                    }),
                    /* @__PURE__ */ jsx53(FooterSocialIconsV3, {
                      onSocialLinkClick
                    })
                  ]
                })
              ]
            }),
            /* @__PURE__ */ jsx53("div", {
              className: "ui-py-3",
              children: /* @__PURE__ */ jsx53(FooterLegalLinks, {
                isLocalised: Boolean(legalLinks),
                links: _legalLinks
              })
            })
          ]
        }),
        /* @__PURE__ */ jsx53(GridItem, {
          className: cx22(
            "ui-relative",
            "ui-text-gray-400 ui-border-t ui-border-gray-400",
            "ui-pt-8 ui-pb-8 lg:ui-pb-16"
          ),
          colEnd: { sm: "main" },
          colStart: { sm: "main" },
          rowEnd: { sm: 3 },
          rowStart: { sm: 2 },
          children: /* @__PURE__ */ jsx53(FooterLegalese, {})
        })
      ]
    })
  });
}

// src/layout/v3/Footer/index.tsx
import { jsx as jsx54 } from "react/jsx-runtime";
function Footer({
  hidden,
  variant = "ecom",
  ...footerProps
}) {
  const FooterComponent = useMemo5(() => {
    if (variant === "simple") {
      return SimpleFooter;
    }
    return EcomFooter;
  }, [variant]);
  const { setIsFooterInView } = useFooterContext();
  const footerRef = useRef6(null);
  const isInView = useInView2(footerRef);
  useEffect4(() => {
    setIsFooterInView(isInView);
  }, [isInView, setIsFooterInView]);
  if (hidden) {
    return null;
  }
  return /* @__PURE__ */ jsx54("footer", {
    "data-cy": "footer",
    ref: footerRef,
    children: /* @__PURE__ */ jsx54(FooterComponent, {
      ...footerProps
    })
  });
}

// src/layout/v3/PageLayout/index.tsx
import { jsx as jsx55, jsxs as jsxs32 } from "react/jsx-runtime";
var MAIN_CONTENT_ID = "main-content";
function Eyebrow({
  className,
  displayMessage: DisplayMessage,
  ...props
}) {
  return /* @__PURE__ */ jsx55("div", {
    className: cx23(
      "ui-py-3.5 ui-px-1 ui-text-center ui-pointer-events-auto ui-relative ui-z-10",
      className
    ),
    "data-cy": "eyebrow-cta-message",
    ...props,
    children: /* @__PURE__ */ jsx55(DisplayMessage, {})
  });
}
function PageLayout({
  children,
  className = "",
  containerProps,
  eyebrowProps,
  footnotesProps,
  headerProps,
  hideFooter = false,
  hideHeader = false,
  footerProps,
  mainLabel,
  HeaderComponent = Header,
  preFooterContent
}) {
  const {
    name = "",
    padding = "both",
    className: containerClassName = "",
    h1 = void 0
  } = containerProps;
  return /* @__PURE__ */ jsxs32("div", {
    className: "tailwind",
    children: [
      /* @__PURE__ */ jsx55("div", {
        className: "ui-sr-only focus-within:ui-not-sr-only focus-within:ui-py-2 focus-within:ui-px-4",
        children: /* @__PURE__ */ jsx55("a", {
          "data-cy": "skip-to-content",
          href: `#${MAIN_CONTENT_ID}`,
          children: t("header_skip_to_content")
        })
      }),
      /* @__PURE__ */ jsxs32("div", {
        className: cx23(className, "ui-flex ui-flex-col ui-min-h-screen"),
        "data-cy": "page-wrapper",
        id: "page-wrapper",
        children: [
          /* @__PURE__ */ jsxs32("div", {
            className: "ui-relative ui-pointer-events-none ui-flex-grow",
            children: [
              eyebrowProps ? /* @__PURE__ */ jsx55(Eyebrow, {
                ...eyebrowProps
              }) : null,
              /* @__PURE__ */ jsx55("div", {
                className: "ui-absolute ui-top-auto ui-bottom-auto ui-w-full ui-h-full ui-pointer-events-none",
                children: !hideHeader && /* @__PURE__ */ jsx55(HeaderComponent, {
                  ...headerProps
                })
              }),
              /* @__PURE__ */ jsxs32("main", {
                "aria-label": mainLabel,
                className: "ui-pointer-events-auto",
                "data-cy": MAIN_CONTENT_ID,
                id: MAIN_CONTENT_ID,
                tabIndex: -1,
                children: [
                  /* @__PURE__ */ jsxs32("div", {
                    className: cx23({
                      "ui-pt-36": padding === "top",
                      "ui-pb-16": padding === "bottom",
                      "ui-pt-36 ui-pb-16": padding === "both" || !padding,
                      [containerClassName]: Boolean(containerClassName)
                    }),
                    "data-cy": `page-${name}`,
                    children: [
                      h1 ? /* @__PURE__ */ jsx55("h1", {
                        className: "ui-sr-only",
                        children: h1
                      }) : null,
                      children
                    ]
                  }),
                  footnotesProps ? /* @__PURE__ */ jsx55(Footnotes, {
                    ...footnotesProps
                  }) : null,
                  preFooterContent
                ]
              })
            ]
          }),
          /* @__PURE__ */ jsx55(Footer, {
            ...footerProps,
            hidden: footerProps.hidden || hideFooter
          })
        ]
      })
    ]
  });
}
PageLayout.displayName = "PageLayout";

// src/layout/v4/PageLayout/index.tsx
init_esm_shims();
import { cx as cx39 } from "class-variance-authority";

// src/v3/Eyebrow/index.tsx
init_esm_shims();
import { cx as cx24 } from "class-variance-authority";
import { jsx as jsx56 } from "react/jsx-runtime";
function Eyebrow2({
  className,
  displayMessage: DisplayMessage,
  ...props
}) {
  return /* @__PURE__ */ jsx56("div", {
    className: cx24(
      "ui-py-3.5 ui-px-1 ui-text-center ui-pointer-events-auto ui-relative ui-z-[60]",
      className
    ),
    "data-cy": "eyebrow-cta-message",
    ...props,
    children: /* @__PURE__ */ jsx56(DisplayMessage, {})
  });
}

// src/layout/v4/Header/index.tsx
init_esm_shims();
import { cx as cx31 } from "class-variance-authority";
import { FocusScope } from "react-aria";

// src/layout/_hooks/usePdpHeaderAnimation.ts
init_esm_shims();
import { useMotionValueEvent as useMotionValueEvent2, useScroll as useScroll3 } from "framer-motion";
import { useEffect as useEffect5, useState as useState6 } from "react";
function usePdpHeaderAnimation({
  enableScrollAnimation,
  isCarouselInView
}) {
  const [fadeLinks, setFadeLinks] = useState6(false);
  const [fadeOuraLogo, setFadeOuraLogo] = useState6(false);
  const { scrollY } = useScroll3();
  useMotionValueEvent2(scrollY, "change", (latest) => {
    if (latest > 10) {
      setFadeLinks(true);
    } else {
      setFadeLinks(false);
    }
  });
  useEffect5(() => {
    if (!isCarouselInView) {
      setFadeOuraLogo(true);
    } else {
      setFadeOuraLogo(false);
    }
  }, [isCarouselInView]);
  if (!enableScrollAnimation) {
    return { fadeLinks: false, fadeOuraLogo: false };
  }
  return { fadeLinks, fadeOuraLogo };
}

// src/layout/v4/Header/NavBar/index.tsx
init_esm_shims();
import { cx as cx29 } from "class-variance-authority";
import { useScroll as useScroll4, useTransform as useTransform2, motion as motion5 } from "framer-motion";
import { useIntl as useIntl7 } from "react-intl";

// src/icons/ChevronThinLeftIcon.tsx
init_esm_shims();
import { jsx as jsx57, jsxs as jsxs33 } from "react/jsx-runtime";
function ChevronThinLeftIcon({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs33("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx57("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx57("path", {
        d: "M11 2 5 8l6 6",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeWidth: 1.5
      })
    ]
  });
}

// src/layout/v4/Header/navVariants.ts
init_esm_shims();
import { cva as cva8 } from "class-variance-authority";
var navTone = cva8("ui-transition-colors ui-duration-300", {
  variants: {
    tone: {
      default: "ui-border-sandstone-500/25 ui-text-sandstone-500 hover:ui-border-sandstone-500",
      inverse: "ui-border-white/25 ui-text-white hover:ui-border-white"
    }
  },
  defaultVariants: { tone: "default" }
});
var navStroke = cva8("ui-text-stroke-width-0.5", {
  variants: {
    active: {
      true: "ui-text-stroke-color-current",
      false: "ui-text-stroke-color-transparent "
    },
    hover: {
      none: "",
      self: "hover:ui-text-stroke-color-current",
      group: "group-hover:ui-text-stroke-color-current"
    }
  },
  defaultVariants: { active: false, hover: "none" }
});

// src/layout/v4/Header/NavDrawer/NavDrawerContentSelector.tsx
init_esm_shims();
import { cx as cx25 } from "class-variance-authority";
import { jsx as jsx58, jsxs as jsxs34 } from "react/jsx-runtime";
var DRAWER_SELECTOR = "NAV_DRAWER_SELECTOR";
function NavDrawerContentSelector({
  headerConfig,
  isLocalized,
  onSectionClicked,
  secondaryLinks
}) {
  return /* @__PURE__ */ jsxs34("div", {
    className: "ui-flex ui-h-full ui-w-full ui-flex-col ui-justify-between ui-pt-28 ui-pb-20 md:ui-justify-start md:ui-pb-4",
    children: [
      /* @__PURE__ */ jsx58("div", {
        className: "ui-mb-8 ui-flex ui-w-full ui-flex-col ui-gap-2 lg:ui-items-center",
        children: headerConfig.map((config) => {
          const { title } = config;
          const isLink = "href" in config;
          return /* @__PURE__ */ jsx58(Button, {
            className: cx25(
              "ui-w-fit ui-text-3xl ui-text-sandstone-500",
              navStroke({ active: false, hover: "self" })
            ),
            href: isLink ? config.href : void 0,
            onClick: () => {
              if (!isLink) {
                onSectionClicked(title);
              }
            },
            variant: "text",
            children: isLocalized ? title : t(title)
          }, title);
        })
      }),
      /* @__PURE__ */ jsx58("div", {
        className: "ui-flex ui-w-full ui-flex-col lg:ui-items-center",
        children: secondaryLinks.map((link) => /* @__PURE__ */ jsx58(Button, {
          className: cx25(
            "ui-w-fit ui-text-base ui-text-sandstone-500",
            navStroke({ active: false, hover: "self" })
          ),
          "data-cy": link.dataCy,
          href: link.href,
          variant: "text",
          children: isLocalized ? link.title : t(link.title)
        }, link.title))
      })
    ]
  });
}
var NavDrawerContentSelector_default = NavDrawerContentSelector;

// src/layout/v4/NavLink/index.tsx
init_esm_shims();
import { cx as cx26 } from "class-variance-authority";
import { useContext as useContext8 } from "react";
import { jsx as jsx59, jsxs as jsxs35 } from "react/jsx-runtime";
function NavLink2({
  as,
  children,
  className,
  external,
  hideArrow = false,
  href = "",
  id,
  replace,
  scroll,
  shallow,
  onClick = void 0,
  ...props
}) {
  const context = useContext8(Context);
  const LinkComponent = external || !context.LinkComponent ? "a" : context.LinkComponent;
  const hasArrow = external && !hideArrow;
  return /* @__PURE__ */ jsxs35(LinkComponent, {
    as,
    className: cx26(className, {
      "ui-relative ui-inline": hasArrow
    }),
    "data-cy": id,
    "data-menu-link": true,
    href,
    id,
    onClick,
    replace,
    scroll,
    shallow,
    tabIndex: 0,
    ...props,
    children: [
      children,
      hasArrow ? /* @__PURE__ */ jsx59(CardBtnArrowIcon, {
        "aria-hidden": "true",
        className: "ui-absolute ui-inline ui--rotate-45 ui-translate-x-2 ui-translate-y-[0.375rem]",
        "data-cy": "nav-link-arrow"
      }) : null
    ]
  });
}
NavLink2.displayName = "NavLink";

// src/layout/v4/Header/NavBar/NavbarLinks.tsx
init_esm_shims();
import { motion as motion4 } from "framer-motion";
import { cx as cx27 } from "class-variance-authority";

// src/icons/ChevronDownIcon.tsx
init_esm_shims();
import { jsx as jsx60, jsxs as jsxs36 } from "react/jsx-runtime";
function ChevronDownIcon({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs36("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 16,
    viewBox: "0 0 17 16",
    width: 17,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx60("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx60("path", {
        clipRule: "evenodd",
        d: "M13.638 4.86201C13.3776 4.60166 12.9555 4.60166 12.6952 4.86201L8.49992 9.05727L4.30466 4.86201C4.04431 4.60166 3.6222 4.60166 3.36185 4.86201C3.1015 5.12236 3.1015 5.54447 3.36185 5.80482L8.02851 10.4715C8.28886 10.7318 8.71097 10.7318 8.97132 10.4715L13.638 5.80482C13.8983 5.54447 13.8983 5.12236 13.638 4.86201Z",
        fill: "currentColor",
        fillRule: "evenodd"
      })
    ]
  });
}

// src/layout/v4/Header/NavBar/NavbarLinks.tsx
import { jsx as jsx61, jsxs as jsxs37 } from "react/jsx-runtime";
function NavbarLinkItem({
  activeSection,
  currentPath,
  disableTab,
  hover,
  isLocalized,
  onMenuLinkClick,
  section,
  setActiveSection,
  setIgnoreHover,
  tone
}) {
  const isLink = "href" in section;
  const handleClick = (event) => {
    if (isLink && onMenuLinkClick) {
      const payload = {
        cta: section.analyticCta,
        event: "link_clicked",
        location: "global nav",
        section: section.analyticId,
        path: section.href
      };
      onMenuLinkClick(event, payload);
    } else if (!isLink) {
      setActiveSection(section.title);
      setIgnoreHover(true);
    }
  };
  return /* @__PURE__ */ jsx61("li", {
    role: "none",
    children: /* @__PURE__ */ jsx61(Button, {
      "aria-expanded": !isLink && activeSection === section.title,
      "aria-haspopup": !isLink,
      className: cx27("ui-group ui-relative ui-px-6", {
        "ui-text-stroke-width-0.5 ui-text-stroke-color-current": isLink && currentPath === section.href
      }),
      "data-cy": section.dataCy,
      href: isLink ? section.href : void 0,
      onClick: handleClick,
      onMouseEnter: () => {
        if (hover) {
          setActiveSection(isLink ? null : section.title);
        }
      },
      role: "menuitem",
      tabIndex: disableTab ? -1 : void 0,
      variant: "text",
      children: /* @__PURE__ */ jsxs37(Typography, {
        Element: "span",
        className: cx27(
          "ui-relative",
          navTone({ tone }),
          navStroke({
            active: activeSection === section.title,
            hover: "group"
          })
        ),
        children: [
          isLocalized ? section.title : t(section.title),
          /* @__PURE__ */ jsx61(ChevronDownIcon, {
            className: cx27("ui-inline-block ui-ml-2 ui-transition-all", {
              "ui-opacity-0": activeSection !== null || isLink,
              "ui-opacity-100": activeSection === null && !isLink
            }),
            height: 16,
            width: 17
          }),
          /* @__PURE__ */ jsx61(motion4.div, {
            animate: {
              scaleX: activeSection === section.title ? 1 : 0
            },
            className: "ui-absolute ui--left-1 ui-right-[21px] ui--bottom-1 ui-h-0.5 ui-bg-sandstone-500 ui-opacity-25 ui-will-change-transform",
            exit: { scaleX: 0 },
            initial: { scaleX: 0 },
            transition: {
              type: "tween",
              duration: 0.2,
              ease: "easeOut"
            }
          })
        ]
      })
    }, section.title)
  });
}
function NavbarLinks({
  activeSection,
  disableTab,
  hover,
  setActiveSection,
  setIgnoreHover,
  isLocalized,
  headerConfig,
  currentPath,
  onMenuLinkClick,
  tone
}) {
  return headerConfig.map((section) => /* @__PURE__ */ jsx61(NavbarLinkItem, {
    activeSection,
    currentPath,
    disableTab,
    hover,
    isLocalized,
    onMenuLinkClick,
    section,
    setActiveSection,
    setIgnoreHover,
    tone
  }, section.title));
}
var NavbarLinks_default = NavbarLinks;

// src/layout/v4/Header/NavBar/NavCartButton.tsx
init_esm_shims();

// src/icons/ShoppingCartV3Icon.tsx
init_esm_shims();
import { jsx as jsx62, jsxs as jsxs38 } from "react/jsx-runtime";
function ShoppingCartV3Icon({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs38("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 22,
    viewBox: "0 0 21 22",
    width: 21,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx62("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx62("path", {
        d: "M6.41347 20C5.95753 20 5.56885 19.8319 5.24742 19.4956C4.926 19.1593 4.76528 18.755 4.76528 18.2828C4.76528 17.8106 4.92762 17.408 5.25229 17.0751C5.57698 16.7422 5.96728 16.5757 6.4232 16.5757C6.87914 16.5757 7.26782 16.7439 7.58925 17.0801C7.91067 17.4164 8.07139 17.8207 8.07139 18.2929C8.07139 18.7651 7.90905 19.1677 7.58438 19.5006C7.25969 19.8335 6.86939 20 6.41347 20ZM15.5971 20C15.1411 20 14.7525 19.8319 14.431 19.4956C14.1096 19.1593 13.9489 18.755 13.9489 18.2828C13.9489 17.8106 14.1112 17.408 14.4359 17.0751C14.7606 16.7422 15.1509 16.5757 15.6068 16.5757C16.0628 16.5757 16.4514 16.7439 16.7729 17.0801C17.0943 17.4164 17.255 17.8207 17.255 18.2929C17.255 18.7651 17.0927 19.1677 16.768 19.5006C16.4433 19.8335 16.053 20 15.5971 20ZM5.22446 4.30538L7.74996 9.72716H14.3622L17.232 4.30538H5.22446ZM4.53569 2.8786H18.0603C18.4118 2.8786 18.6792 3.04506 18.8626 3.37797C19.046 3.71089 19.0458 4.0438 18.8621 4.37672L15.7627 10.1552C15.5943 10.4564 15.3757 10.6982 15.107 10.8805C14.8382 11.0628 14.544 11.1539 14.2244 11.1539H7.26782L5.98211 13.627H17.255V15.0538H6.18874C5.54589 15.0538 5.08288 14.8319 4.79972 14.388C4.51656 13.9441 4.52039 13.4447 4.8112 12.8899L6.28058 10.0839L2.79081 2.42678H1V1H3.68621L4.53569 2.8786Z",
        fill: "currentColor"
      })
    ]
  });
}

// src/layout/v4/Header/NavBar/NavIconButton.tsx
init_esm_shims();
import { cx as cx28 } from "class-variance-authority";
import { jsx as jsx63, jsxs as jsxs39 } from "react/jsx-runtime";
function NavIconButton({
  children,
  className,
  dataCy,
  disableTab,
  hasAlert,
  href,
  onClick,
  tone
}) {
  return /* @__PURE__ */ jsxs39(Button, {
    className: cx28(
      `group ui-relative ui-flex ui-size-10 ui-items-center ui-justify-center ui-rounded-full ui-border ui-!p-0 md:ui-size-12 ui-border-solid`,
      navTone({ tone }),
      {
        "hover:ui-bg-sandstone-500/10": tone === "default",
        "hover:ui-bg-white/10": tone === "inverse"
      },
      className
    ),
    "data-cy": dataCy,
    href,
    onClick,
    size: "none",
    tabIndex: disableTab ? -1 : void 0,
    variant: "unset",
    children: [
      children,
      hasAlert ? /* @__PURE__ */ jsx63("span", {
        className: "ui-absolute -ui-top-px ui--right-px ui-size-3 ui-rounded-full ui-bg-blue-100 ui-shadow md:ui-size-[14px]"
      }) : null
    ]
  });
}
var NavIconButton_default = NavIconButton;

// src/layout/v4/Header/NavBar/NavCartButton.tsx
import { jsx as jsx64, jsxs as jsxs40 } from "react/jsx-runtime";
function NavCartButton({
  disableTab,
  tone,
  count,
  onClick
}) {
  return /* @__PURE__ */ jsxs40(NavIconButton_default, {
    dataCy: "nav-cart-button",
    disableTab,
    hasAlert: Number(count) > 0,
    href: "/cart",
    onClick,
    tone,
    children: [
      /* @__PURE__ */ jsx64(ShoppingCartV3Icon, {}),
      /* @__PURE__ */ jsx64("span", {
        className: "ui-sr-only",
        children: /* @__PURE__ */ jsx64(FormattedMessage_default, {
          id: "cart_count_sr_label",
          values: { count }
        })
      })
    ]
  });
}
var NavCartButton_default = NavCartButton;

// src/layout/v4/Header/NavBar/NavHamburgerButton.tsx
init_esm_shims();
import { cva as cva9 } from "class-variance-authority";
import { jsx as jsx65, jsxs as jsxs41 } from "react/jsx-runtime";
var bar = cva9(
  "ui-h-0.5 ui-w-[18px] ui-origin-center ui-transition-all ui-duration-300 ui-ease-in-out",
  {
    variants: {
      tone: {
        default: "ui-bg-sandstone-500",
        inverse: "ui-bg-white"
      },
      state: {
        open: "",
        closed: ""
      },
      pos: {
        top: "",
        bottom: ""
      }
    },
    compoundVariants: [
      { state: "open", pos: "top", class: "ui-translate-y-[4px] ui-rotate-45" },
      {
        state: "open",
        pos: "bottom",
        class: "-ui-translate-y-[4px] -ui-rotate-45"
      },
      { state: "closed", pos: "top", class: "group-hover:-ui-translate-y-0.5" },
      {
        state: "closed",
        pos: "bottom",
        class: "group-hover:ui-translate-y-0.5"
      }
    ]
  }
);
function NavHamburgerButton({
  className,
  disableTab,
  open,
  tone,
  onClick
}) {
  const state = open ? "open" : "closed";
  return /* @__PURE__ */ jsxs41(NavIconButton_default, {
    "aria-expanded": open,
    "aria-pressed": open,
    className,
    dataCy: "nav-menu-button",
    disableTab,
    onClick,
    tone,
    children: [
      /* @__PURE__ */ jsx65("span", {
        className: "ui-sr-only",
        children: open ? t("close") : t("menu")
      }),
      /* @__PURE__ */ jsxs41("div", {
        className: "ui-group ui-flex ui-h-full ui-w-full ui-flex-col ui-items-center ui-justify-center ui-gap-1.5",
        children: [
          /* @__PURE__ */ jsx65("span", {
            className: bar({ tone, state, pos: "top" })
          }),
          /* @__PURE__ */ jsx65("span", {
            className: bar({ tone, state, pos: "bottom" })
          })
        ]
      })
    ]
  });
}
var NavHamburgerButton_default = NavHamburgerButton;

// src/layout/v4/Header/NavBar/index.tsx
import { jsx as jsx66, jsxs as jsxs42 } from "react/jsx-runtime";
function Navbar({
  activeSection: activeTitle,
  count,
  currentPath,
  disableBlur,
  disableTab,
  fadeLinks,
  fadeOuraLogo,
  headerConfig,
  hideCart,
  hideHamburger,
  hideLinks,
  hover,
  inverse,
  isLocalized,
  onHamburgerClick,
  onMenuLinkClick,
  onShoppingCartClick,
  open,
  setActiveSection,
  setIgnoreHover
}) {
  const { formatMessage } = useIntl7();
  const { scrollY } = useScroll4();
  const scrolledOpacity = useTransform2(scrollY, [0, 200], [0, 1]);
  const tone = !open && inverse ? "inverse" : "default";
  return /* @__PURE__ */ jsxs42("nav", {
    "aria-hidden": disableTab,
    className: "ui-relative ui-z-50 ui-mt-2 ui-w-full ui-py-2",
    children: [
      /* @__PURE__ */ jsx66(motion5.div, {
        className: cx29(
          "ui-absolute ui-inset-0 ui-mx-3 ui-rounded-lg ui-bg-sandstone-500/10 ui-backdrop-blur-[2rem] md:ui-mx-6 ui-transition-opacity ui-duration-400",
          navTone({ tone }),
          {
            "!ui-opacity-0": open,
            "lg:ui-hidden": disableBlur
          }
        ),
        style: { opacity: scrolledOpacity },
        transition: { duration: 0.2, type: "tween", ease: "easeInOut" }
      }),
      /* @__PURE__ */ jsx66(LayoutGrid, {
        children: /* @__PURE__ */ jsx66(GridItem, {
          colEnd: { sm: "main" },
          colStart: { sm: "main" },
          children: /* @__PURE__ */ jsxs42("div", {
            className: cx29(
              "ui-relative ui-z-10 ui-min-h-12 ui-flex ui-w-full ui-flex-row ui-items-center ui-justify-between ui-px-0 md:ui-px-8 lg:ui-px-0"
            ),
            children: [
              /* @__PURE__ */ jsxs42("div", {
                children: [
                  /* @__PURE__ */ jsx66("div", {
                    className: cx29("ui-opacity-100 ui-transition-opacity", {
                      "lg:ui-opacity-0 lg:ui-pointer-events-none": fadeOuraLogo,
                      "lg:ui-opacity-100 lg:ui-pointer-events-auto": !fadeOuraLogo
                    }),
                    children: /* @__PURE__ */ jsx66(NavLink2, {
                      "aria-label": formatMessage({ id: "oura_home_link" }),
                      className: cx29(
                        "ui-py-3 ui-block ui-w-16 lg:ui-w-20 ui-z-10 ui-transition-colors ui-duration-700",
                        navTone({ tone }),
                        {
                          "ui-hidden lg:ui-block": open && activeTitle !== DRAWER_SELECTOR
                        }
                      ),
                      "data-cy": "nav_logo_link",
                      href: "/",
                      id: "nav_home",
                      onClick: (event) => {
                        if (onMenuLinkClick) {
                          const payload = {
                            cta: "go home",
                            event: "link_clicked",
                            location: "global nav",
                            section: "Oura Logo",
                            path: "/"
                          };
                          onMenuLinkClick(event, payload);
                        }
                      },
                      tabIndex: disableTab ? -1 : void 0,
                      children: /* @__PURE__ */ jsx66(Oura, {})
                    })
                  }),
                  /* @__PURE__ */ jsx66(Button, {
                    className: cx29(
                      "ui-h-full ui-pr-2 ui-pl-0 ui-py-0 ui-opacity-70 hover:ui-opacity-100 lg:ui-hidden",
                      {
                        "ui-hidden": !open || activeTitle === DRAWER_SELECTOR
                      }
                    ),
                    onClick: () => {
                      setActiveSection(DRAWER_SELECTOR);
                    },
                    size: "none",
                    tabIndex: disableTab ? -1 : void 0,
                    variant: "unset",
                    children: /* @__PURE__ */ jsx66(ChevronThinLeftIcon, {
                      height: 24,
                      width: 24
                    })
                  })
                ]
              }),
              /* @__PURE__ */ jsx66("ul", {
                className: cx29(
                  "ui-hidden ui-flex-row ui-items-center ui-justify-between ui-shrink ui-transition-opacity lg:ui-flex",
                  {
                    "lg:ui-opacity-0 lg:ui-pointer-events-none": fadeLinks,
                    "lg:ui-opacity-100 lg:ui-pointer-events-auto": !fadeLinks
                  }
                ),
                role: "menubar",
                children: !hideLinks ? /* @__PURE__ */ jsx66(NavbarLinks_default, {
                  activeSection: activeTitle,
                  currentPath,
                  disableTab,
                  headerConfig,
                  hover,
                  isLocalized,
                  onMenuLinkClick,
                  setActiveSection,
                  setIgnoreHover,
                  tone
                }) : void 0
              }),
              /* @__PURE__ */ jsxs42("div", {
                className: cx29(
                  "ui-flex ui-flex-row ui-items-center ui-gap-2 ui-transition-opacity md:ui-gap-4",
                  {
                    "lg:ui-opacity-0 lg:ui-pointer-events-none": fadeLinks,
                    "lg:ui-opacity-100 lg:ui-pointer-events-auto": !fadeLinks
                  }
                ),
                children: [
                  !hideCart ? /* @__PURE__ */ jsx66(NavCartButton_default, {
                    count,
                    disableTab,
                    onClick: onShoppingCartClick,
                    tone
                  }) : void 0,
                  !hideHamburger ? /* @__PURE__ */ jsx66(NavHamburgerButton_default, {
                    className: "lg:ui-hidden",
                    disableTab,
                    onClick: () => {
                      setActiveSection(open ? null : DRAWER_SELECTOR);
                      setIgnoreHover(true);
                      onHamburgerClick == null ? void 0 : onHamburgerClick({ open: !open });
                    },
                    open,
                    tone
                  }) : void 0
                ]
              })
            ]
          })
        })
      })
    ]
  });
}
var NavBar_default = Navbar;

// src/layout/v4/Header/NavDrawer/index.tsx
init_esm_shims();
import { AnimatePresence, motion as motion6 } from "framer-motion";

// src/layout/v4/Header/NavDrawer/DrawerContent.tsx
init_esm_shims();

// src/layout/v4/Header/NavDrawer/NavCard.tsx
init_esm_shims();
import { useId as useId2 } from "react";

// src/icons/ChevronThinRightIcon.tsx
init_esm_shims();
import { jsx as jsx67, jsxs as jsxs43 } from "react/jsx-runtime";
function ChevronThinRightIcon({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs43("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx67("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx67("path", {
        d: "m5 14 6-6-6-6",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeWidth: 1.5
      })
    ]
  });
}

// src/layout/v4/Header/NavDrawer/NavLinkImage.tsx
init_esm_shims();
import { jsx as jsx68 } from "react/jsx-runtime";
function NavLinkImage({
  src
}) {
  return /* @__PURE__ */ jsx68("img", {
    alt: "",
    className: "ui-object-cover ui-object-center ui-absolute ui-inset-0 ui-h-full ui-w-full ui-z-0 hover:ui-scale-105 ui-transition-transform ui-duration-500 ui-ease-out",
    src
  });
}
var NavLinkImage_default = NavLinkImage;

// src/layout/v4/Header/NavDrawer/NavCard.tsx
import { jsx as jsx69, jsxs as jsxs44 } from "react/jsx-runtime";
function NavCard({
  analyticId,
  analyticCta,
  analyticEvent,
  analyticAction,
  backgroundImage,
  dataCy,
  href,
  isLocalized,
  onMenuLinkClick,
  title
}) {
  const handleClick = (event) => {
    if (onMenuLinkClick) {
      const payload = {
        section: analyticId,
        event: analyticEvent,
        cta: analyticCta,
        location: "global nav",
        path: href,
        action: analyticAction
      };
      onMenuLinkClick(event, payload);
    }
  };
  const titleId = useId2();
  return /* @__PURE__ */ jsx69("div", {
    className: "ui-mb-4 lg:ui-mb-0 ui-aspect-[320/136] md:ui-aspect-auto ui-shrink-0 md:ui-shrink md:ui-h-[136px] md:ui-w-80 lg:ui-h-48 lg:ui-w-[300px] ui-overflow-hidden ui-rounded-3xl lg:ui-rounded-4xl ui-bg-sandstone-500",
    children: /* @__PURE__ */ jsxs44(NavLink2, {
      className: "ui-grid ui-w-full ui-h-full",
      "data-cy": dataCy,
      href,
      onClick: handleClick,
      children: [
        /* @__PURE__ */ jsx69("div", {
          className: "ui-col-start-1 ui-row-start-1 ui-relative",
          children: /* @__PURE__ */ jsx69(NavLinkImage_default, {
            src: backgroundImage.src
          })
        }),
        /* @__PURE__ */ jsx69("div", {
          className: "ui-col-start-1 ui-row-start-1 ui-relative ui-pointer-events-none",
          children: /* @__PURE__ */ jsx69("div", {
            className: "ui-absolute ui-top-3/4 md:ui-top-[70%] ui-right-0 ui-bottom-0 ui-left-0",
            style: {
              background: "linear-gradient(to bottom, transparent, rgba(74, 71, 65, 0.7))"
            }
          })
        }),
        /* @__PURE__ */ jsx69("div", {
          className: "ui-col-start-1 ui-row-start-1 ui-relative ui-pointer-events-none ui-flex ui-flex-col ui-justify-end",
          children: /* @__PURE__ */ jsxs44("div", {
            className: "ui-flex ui-flex-row ui-items-center ui-justify-between ui-px-5 ui-pb-3",
            children: [
              /* @__PURE__ */ jsx69(Typography, {
                color: "light",
                id: titleId,
                variant: "h6",
                children: isLocalized ? title : t(title)
              }),
              /* @__PURE__ */ jsx69(ChevronThinRightIcon, {
                className: "ui-text-sandstone-100 lg:ui-hidden"
              })
            ]
          })
        })
      ]
    })
  });
}
var NavCard_default = NavCard;

// src/layout/v4/Header/NavDrawer/NavLinkList.tsx
init_esm_shims();
import { useId as useId3 } from "react";
import { cx as cx30 } from "class-variance-authority";
import { jsx as jsx70, jsxs as jsxs45 } from "react/jsx-runtime";
function NavLinkContent({
  currentPath,
  href,
  Icon,
  imgIcon,
  isLocalized,
  title,
  typographyClassName
}) {
  const titleId = useId3();
  return /* @__PURE__ */ jsxs45("div", {
    className: "ui-flex ui-flex-row ui-items-center ui-gap-6",
    children: [
      Icon ? /* @__PURE__ */ jsx70("div", {
        className: cx30(
          "ui-flex ui-size-10 ui-items-center ui-justify-center ui-text-gray-400 group-hover:ui-text-gray-450",
          {
            "ui-text-gray-450": currentPath === href
          }
        ),
        children: /* @__PURE__ */ jsx70(Icon, {
          height: 24,
          width: 24
        })
      }) : null,
      imgIcon ? /* @__PURE__ */ jsx70("div", {
        className: "ui-m-0 ui-size-10 ui-shrink-0 ui-p-0 ui-relative",
        children: /* @__PURE__ */ jsx70(NavLinkImage_default, {
          src: imgIcon.src
        })
      }) : null,
      /* @__PURE__ */ jsx70(Typography, {
        className: cx30(
          "ui-leading-10 ui-text-nowrap",
          navStroke({
            active: currentPath === href,
            hover: "group"
          }),
          typographyClassName
        ),
        color: typographyClassName ? "unset" : "dark",
        id: titleId,
        children: isLocalized ? title : t(title)
      })
    ]
  });
}
function NavLinkList({
  analyticId,
  currentPath,
  isLocalized,
  links,
  onMenuLinkClick
}) {
  return /* @__PURE__ */ jsx70("ul", {
    className: "ui-flex ui-flex-col ui-justify-start ui-gap-4 ui-pt-2 md:ui-gap-2",
    role: "menu",
    children: links.map(
      ({
        analyticCta,
        dataCy,
        href,
        Icon,
        imgIcon,
        title,
        typographyClassName
      }) => {
        const handleClick = (event) => {
          if (onMenuLinkClick) {
            const payload = {
              section: analyticId,
              event: "link_clicked",
              cta: analyticCta,
              location: "global nav",
              path: href
            };
            onMenuLinkClick(event, payload);
          }
        };
        return /* @__PURE__ */ jsx70("li", {
          role: "none",
          children: /* @__PURE__ */ jsx70(NavLink2, {
            "aria-current": currentPath === href ? "page" : void 0,
            className: "ui-group ui-m-0 ui-block !ui-h-fit ui-p-0",
            "data-cy": dataCy,
            href,
            onClick: handleClick,
            role: "menuitem",
            children: /* @__PURE__ */ jsx70(NavLinkContent, {
              Icon,
              currentPath,
              href,
              imgIcon,
              isLocalized,
              title,
              typographyClassName
            })
          }, title)
        }, title);
      }
    )
  });
}
var NavLinkList_default = NavLinkList;

// src/layout/v4/Header/NavDrawer/DrawerContent.tsx
import { jsx as jsx71 } from "react/jsx-runtime";
function DrawerContent({
  analyticId,
  columns,
  currentPath,
  isLocalized,
  onMenuLinkClick
}) {
  return /* @__PURE__ */ jsx71("div", {
    className: "ui-mt-28 ui-mb-8 ui-flex ui-flex-col ui-justify-start ui-px-6 ui-h-full lg:ui-h-fit lg:ui-min-h-48 lg:ui-flex-row lg:ui-justify-center lg:ui-gap-16 lg:ui-px-4",
    "data-cy": "nav-drawer-content",
    children: columns.map((column) => {
      if (column.type === "card") {
        const {
          analyticAction,
          analyticCta,
          analyticEvent,
          backgroundImage,
          dataCy,
          href,
          title
        } = column;
        return /* @__PURE__ */ jsx71(NavCard_default, {
          analyticAction,
          analyticCta,
          analyticEvent,
          analyticId,
          backgroundImage,
          dataCy,
          href,
          isLocalized,
          onMenuLinkClick,
          title
        }, column.id);
      }
      return /* @__PURE__ */ jsx71(NavLinkList_default, {
        analyticId,
        currentPath,
        isLocalized,
        links: column.links,
        onMenuLinkClick
      }, column.id);
    })
  });
}
var DrawerContent_default = DrawerContent;

// src/layout/v4/Header/NavDrawer/index.tsx
import { jsx as jsx72, jsxs as jsxs46 } from "react/jsx-runtime";
function NavDrawer({
  activeSection,
  currentPath,
  headerConfig,
  isLocalized,
  onMenuLinkClick,
  open,
  secondaryLinks,
  setActiveSection
}) {
  var _a, _b;
  const activeHeaderSection = headerConfig.find(
    (section) => section.title === activeSection
  );
  const analyticId = (_a = activeHeaderSection == null ? void 0 : activeHeaderSection.analyticId) != null ? _a : "";
  const columns = (_b = activeHeaderSection == null ? void 0 : activeHeaderSection.columns) != null ? _b : [];
  return /* @__PURE__ */ jsxs46(motion6.div, {
    animate: {
      height: open ? "auto" : 0
    },
    className: "ui-absolute ui-top-0 ui-left-0 ui-z-0 ui-w-full ui-overflow-hidden ui-bg-sandstone-200 ui-shadow-2xl lg:ui-rounded-b-[3rem]",
    initial: { height: 0 },
    transition: { duration: 0.4, type: "tween", ease: "easeInOut" },
    children: [
      /* @__PURE__ */ jsx72("div", {
        className: "ui-w-full ui-h-24 ui-absolute ui-top-0 ui-z-20 ui-bg-gradient-to-b ui-from-sandstone-200 ui-to-transparent lg:ui-hidden"
      }),
      /* @__PURE__ */ jsx72(AnimatePresence, {
        mode: "wait",
        children: /* @__PURE__ */ jsx72(motion6.div, {
          animate: { opacity: 1 },
          className: "ui-px-0 ui-h-[100svh] lg:ui-h-fit md:ui-px-8 lg:ui-mb-6 lg:ui-px-0 ui-overflow-y-auto lg:ui-overflow-y-hidden",
          exit: { opacity: 0 },
          initial: { opacity: 0 },
          transition: {
            duration: 0.2,
            type: "tween",
            ease: "easeInOut"
          },
          children: activeSection === DRAWER_SELECTOR ? /* @__PURE__ */ jsx72(NavDrawerContentSelector_default, {
            headerConfig,
            isLocalized,
            onSectionClicked: setActiveSection,
            secondaryLinks
          }) : /* @__PURE__ */ jsx72(DrawerContent_default, {
            analyticId,
            columns,
            currentPath,
            isLocalized,
            onMenuLinkClick: (...args) => {
              setActiveSection(null);
              onMenuLinkClick == null ? void 0 : onMenuLinkClick(...args);
            }
          })
        }, activeSection != null ? activeSection : "empty")
      })
    ]
  });
}
var NavDrawer_default = NavDrawer;

// src/layout/v4/Header/useHeaderV4State.ts
init_esm_shims();
import { useEffect as useEffect7, useRef as useRef7, useState as useState8 } from "react";
import { useMotionValueEvent as useMotionValueEvent3, useScroll as useScroll5 } from "framer-motion";

// src/hooks/useMediaQuery.ts
init_esm_shims();
import { useEffect as useEffect6, useState as useState7 } from "react";
function matchMedia(query) {
  if (typeof window === "undefined")
    return null;
  return window.matchMedia(query);
}
var useMediaQuery = (query) => {
  var _a;
  const [matches, setMatches] = useState7((_a = matchMedia(query)) == null ? void 0 : _a.matches);
  useEffect6(() => {
    const media = matchMedia(query);
    if (!media)
      return;
    if (media.matches !== matches)
      setMatches(media.matches);
    if (!media.addEventListener)
      return;
    const listener = () => {
      setMatches(media.matches);
    };
    media.addEventListener("change", listener);
    return () => {
      media.removeEventListener("change", listener);
    };
  }, [matches, query]);
  return matches;
};

// src/v3/consts/breakpoints.ts
init_esm_shims();
var BREAKPOINTS = {
  small: 320,
  medium: 768,
  large: 1024,
  xLarge: 1280,
  xxLarge: 1440,
  super: 1568,
  ultra: 1920
};

// src/layout/v4/Header/useHeaderV4State.ts
function useHeaderV4State(hoverAnimation, hide) {
  const [activeSection, setActiveSection] = useState8(null);
  const [ignoreHover, setIgnoreHover] = useState8(false);
  const open = activeSection !== null;
  const hover = Boolean(hoverAnimation && !ignoreHover);
  const positionRef = useRef7(0);
  const [visible, setVisible] = useState8(true);
  const { scrollY } = useScroll5();
  const isLg = useMediaQuery(`(min-width: ${BREAKPOINTS.large}px)`);
  useEffect7(() => {
    if (hide) {
      setActiveSection(null);
    }
  }, [hide]);
  useEffect7(() => {
    if (activeSection === null) {
      setIgnoreHover(false);
    }
  }, [activeSection]);
  useEffect7(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setActiveSection(null);
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
  useEffect7(() => {
    if (!isLg && open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  }, [isLg, open]);
  useEffect7(() => {
    if (isLg && activeSection === DRAWER_SELECTOR) {
      setActiveSection(null);
    }
  }, [isLg, activeSection, setActiveSection]);
  useMotionValueEvent3(scrollY, "change", (latest) => {
    setVisible(positionRef.current > latest);
    positionRef.current = latest;
  });
  return {
    activeSection,
    setActiveSection,
    ignoreHover,
    setIgnoreHover,
    open,
    hover,
    visible
  };
}

// src/layout/v4/Header/index.tsx
import { jsx as jsx73, jsxs as jsxs47 } from "react/jsx-runtime";
function Header2({
  count,
  currentPath,
  enableScrollAnimation = false,
  headerConfig,
  headerPosition = "fold",
  hide = false,
  hideCart,
  hideHamburger,
  hideLinks,
  hoverAnimation = true,
  inverse,
  isCarouselInView = true,
  isLocalized,
  onHamburgerClick,
  onMenuLinkClick,
  onShoppingCartClick,
  secondaryLinks
}) {
  const {
    activeSection,
    setActiveSection,
    setIgnoreHover,
    open,
    hover,
    visible
  } = useHeaderV4State(hoverAnimation, hide);
  const { fadeLinks, fadeOuraLogo } = usePdpHeaderAnimation({
    enableScrollAnimation,
    isCarouselInView
  });
  return /* @__PURE__ */ jsxs47("header", {
    "aria-hidden": hide,
    className: cx31(
      "ui-pointer-events-auto ui-z-50 ui-w-full ui-py-2 ui-transition-all ui-duration-500 ui-min-h-[90px]",
      {
        "ui--top-28": !visible && !open && headerPosition === "fold" && !hide,
        "ui-fixed ui--top-full": hide,
        "ui-top-0": headerPosition !== "static" && (visible || open || headerPosition === "fixed") && !hide,
        "ui-sticky": ["fold", "fixed"].includes(headerPosition) && !hide,
        "ui-relative": headerPosition === "static" && !hide,
        "lg:ui-pointer-events-none": fadeLinks || hide,
        "lg:ui-pointer-events-auto": !fadeLinks && !hide
      }
    ),
    "data-cy": "header",
    children: [
      /* @__PURE__ */ jsx73("div", {
        "aria-hidden": "true",
        className: cx31(
          "ui-fixed ui-inset-x-0 ui-top-40 ui-bottom-0 ui-transition-all",
          {
            "ui-pointer-events-none": !open,
            "ui-backdrop-blur-xs": open
          }
        ),
        onClick: () => {
          setActiveSection(null);
        },
        onMouseEnter: () => {
          if (hover) {
            setActiveSection(null);
          }
        }
      }),
      /* @__PURE__ */ jsxs47(FocusScope, {
        contain: open,
        children: [
          /* @__PURE__ */ jsx73(NavBar_default, {
            activeSection,
            count,
            currentPath,
            disableBlur: headerPosition === "static" || enableScrollAnimation,
            disableTab: hide,
            fadeLinks,
            fadeOuraLogo,
            headerConfig,
            hideCart,
            hideHamburger,
            hideLinks,
            hover,
            inverse,
            isLocalized,
            onHamburgerClick,
            onMenuLinkClick,
            onShoppingCartClick,
            open,
            setActiveSection,
            setIgnoreHover
          }),
          /* @__PURE__ */ jsx73(NavDrawer_default, {
            activeSection,
            currentPath,
            headerConfig,
            isLocalized,
            onMenuLinkClick,
            open,
            secondaryLinks,
            setActiveSection
          })
        ]
      })
    ]
  });
}

// src/layout/v4/Footer/index.tsx
init_esm_shims();
import { useInView as useInView3 } from "framer-motion";
import { useRef as useRef11, useEffect as useEffect9 } from "react";

// src/icons/index.ts
init_esm_shims();

// src/icons/ActivityIcon.tsx
init_esm_shims();
import { jsx as jsx74, jsxs as jsxs48 } from "react/jsx-runtime";
function ActivityIcon({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs48("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 20,
    viewBox: "0 0 16 20",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx74("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx74("path", {
        clipRule: "evenodd",
        d: "M4.45095 5.5117C4.73428 3.67008 6.05393 1.87404 8.09191 1.52088C7.87 3.93585 9.16508 6.22092 10.9827 7.70813C11.7822 8.36225 12.5567 9.12287 13.1274 9.94975C13.6986 10.7773 14.0416 11.6357 14.0416 12.5C14.0416 14.4344 13.3821 15.9313 12.3284 16.9455C11.7028 17.5476 10.9213 17.9959 10.0213 18.2617C10.3223 17.8622 10.4999 17.3306 10.4999 16.6667C10.4999 14.6204 9.66248 12.5742 8.67308 11.4419C8.43837 11.1733 8.05572 11.3873 8.03086 11.7431C7.94516 12.9702 7.30981 13.6392 6.6972 14.2842C6.08728 14.9263 5.49989 15.5448 5.49989 16.6667C5.49989 17.2843 5.72388 17.8497 6.09505 18.2859C3.77124 17.6208 2.36883 15.7411 1.94609 13.6274C1.55658 11.6799 1.95462 10.1547 2.30891 9.44618C2.46328 9.13744 2.33815 8.76202 2.02941 8.60765C1.72068 8.45328 1.34525 8.57842 1.19088 8.88715C0.711819 9.84525 0.276544 11.6535 0.720367 13.8726C1.34807 17.0111 3.85096 19.7917 7.9999 19.7917C10.0418 19.7917 11.8718 19.12 13.1952 17.8461C14.5224 16.5687 15.2916 14.7323 15.2916 12.5C15.2916 11.2998 14.8162 10.1961 14.1562 9.23973C13.4957 8.28274 12.6263 7.4378 11.7743 6.74069C10.0428 5.32399 8.99677 3.20252 9.40747 1.14904C9.50396 0.6666 9.13159 0.192803 8.61205 0.212508C5.48704 0.331034 3.58739 2.90426 3.21549 5.32163C2.98407 6.82588 3.3324 8.09555 3.73237 8.9812C3.93249 9.42431 4.14729 9.77555 4.31407 10.0185C4.39762 10.1401 4.46958 10.2353 4.52233 10.302C4.54872 10.3353 4.57035 10.3616 4.58628 10.3806L4.6058 10.4035L4.61215 10.4107L4.61443 10.4133L4.61534 10.4144C4.61534 10.4144 4.6161 10.4152 5.08323 10L4.6161 10.4152C4.84543 10.6732 5.24047 10.6965 5.49846 10.4671C5.75591 10.2383 5.77959 9.8444 5.55178 9.58638L5.55068 9.58513L5.54295 9.57601C5.53466 9.56616 5.5209 9.5495 5.50253 9.52629C5.46576 9.47983 5.41077 9.40737 5.34457 9.31096C5.21187 9.11767 5.03605 8.83089 4.87158 8.46671C4.54238 7.73778 4.26571 6.71579 4.45095 5.5117Z",
        fill: "currentColor",
        fillRule: "evenodd"
      })
    ]
  });
}

// src/icons/HeartOrganIcon.tsx
init_esm_shims();
import { jsx as jsx75, jsxs as jsxs49 } from "react/jsx-runtime";
function HeartOrganIcon({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs49("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx75("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx75("path", {
        clipRule: "evenodd",
        d: "M14.3131 1.28924C14.4586 0.756448 14.1446 0.206631 13.6118 0.0611859C13.079 -0.0842591 12.5292 0.229745 12.3837 0.762534L11.6292 3.52654C10.9568 3.47037 10.19 3.48232 9.45218 3.57379L8.66099 0.823452C8.50831 0.292692 7.95427 -0.0137983 7.42351 0.138886C6.89275 0.29157 6.58626 0.845611 6.73894 1.37637L7.77456 4.97637C7.90385 5.42582 8.32095 5.71445 8.768 5.69962C8.85141 5.70224 8.93651 5.69439 9.02169 5.67503C9.99178 5.45455 11.1999 5.44605 11.9743 5.58432C12.6369 5.70264 12.9919 5.80293 13.6277 6.10089C13.4158 6.47486 13.2479 6.84838 13.0974 7.20171C13.0414 7.3332 12.9885 7.46013 12.9369 7.58404L12.9366 7.58469L12.9365 7.58484L12.9364 7.58506L12.9363 7.5853L12.9363 7.58534L12.9363 7.5854C12.7786 7.9636 12.6326 8.31383 12.4467 8.68045C12.1806 9.20541 11.5584 9.67005 10.6989 10.0263C9.86602 10.3714 8.97763 10.5446 8.43744 10.5954C7.88758 10.647 7.48369 11.1346 7.53533 11.6845C7.58698 12.2344 8.07459 12.6383 8.62446 12.5866C9.33071 12.5203 10.4188 12.3072 11.4645 11.8739C12.4835 11.4516 13.642 10.7456 14.2305 9.58489C14.4534 9.14528 14.6383 8.70146 14.8014 8.30979L14.8015 8.30964C14.8485 8.19672 14.8938 8.08813 14.9376 7.98522C15.1427 7.50351 15.3334 7.10252 15.5853 6.73883C16.0543 6.06157 16.8259 5.38308 18.6238 4.81895C19.1507 4.6536 19.4439 4.09239 19.2785 3.56543C19.1132 3.03848 18.552 2.74534 18.025 2.91068C16.6441 3.34398 15.6589 3.87783 14.925 4.50776C14.3906 4.2411 13.9898 4.06191 13.5932 3.92658L14.3131 1.28924ZM2.52694 1.83506C2.94055 1.46908 3.57254 1.5077 3.93852 1.92132C4.4232 2.4691 4.80439 3.10854 5.06649 3.71455C5.32136 4.30385 5.49991 4.94577 5.49991 5.49987C5.49991 6.06746 5.35856 6.76847 5.19925 7.47292C5.1388 7.74022 5.07446 8.01301 5.00791 8.29516L5.00791 8.29517C4.88695 8.80803 4.7587 9.35176 4.63333 9.94946C4.25066 11.7737 3.94701 13.8786 4.18369 16.0473C4.33859 17.4666 5.60662 18.8262 7.55709 19.932C9.4571 21.0091 11.7126 21.6726 13.2642 21.8337C15.593 22.0754 16.6488 21.7137 17.2232 21.2161C17.839 20.6826 18.1634 19.7927 18.5272 18.2678C18.5813 18.0413 18.6352 17.8187 18.6882 17.5997L18.6894 17.5949L18.6896 17.5939L18.69 17.5924C19.0818 15.9745 19.4264 14.5513 19.4331 13.2043C19.4403 11.7532 19.0494 10.4462 17.7978 9.21189C17.4045 8.82411 17.4001 8.19096 17.7879 7.79772C18.1757 7.40448 18.8088 7.40006 19.2021 7.78785C20.8946 9.45694 21.4425 11.3107 21.4331 13.2142C21.4252 14.8139 21.018 16.4869 20.632 18.0727L20.632 18.0727C20.5781 18.2943 20.5246 18.5142 20.4726 18.732C20.1242 20.1922 19.6986 21.7177 18.5327 22.7277C17.3255 23.7736 15.5679 24.0836 13.0577 23.823C11.2262 23.6329 8.70576 22.8822 6.57075 21.6718C4.4862 20.4901 2.46012 18.689 2.1955 16.2642C1.92517 13.7873 2.27668 11.4421 2.67593 9.53887C2.80549 8.9212 2.94583 8.32566 3.07071 7.79569C3.13532 7.52149 3.1958 7.26484 3.24851 7.03177C3.4141 6.29952 3.49991 5.81026 3.49991 5.49987C3.49991 5.32364 3.42851 4.96557 3.23082 4.50847C3.04035 4.0681 2.76638 3.61475 2.44067 3.24664C2.07469 2.83302 2.11332 2.20103 2.52694 1.83506Z",
        fill: "currentColor",
        fillRule: "evenodd"
      })
    ]
  });
}

// src/icons/LinkIcon.tsx
init_esm_shims();
import { jsx as jsx76, jsxs as jsxs50 } from "react/jsx-runtime";
function LinkIcon({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs50("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx76("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx76("path", {
        d: "M13.7687 2.45406C14.9403 1.28249 16.8398 1.28249 18.0114 2.45406L19.4256 3.86827C20.5972 5.03984 20.5971 6.93934 19.4256 8.11091L17.481 10.0555C17.0905 10.446 16.4573 10.446 16.0668 10.0555C15.6763 9.66495 15.6763 9.03179 16.0668 8.64126L18.0114 6.6967C18.4019 6.30617 18.4019 5.67301 18.0114 5.28249L16.5971 3.86827C16.2066 3.47775 15.5735 3.47775 15.1829 3.86827L9.52608 9.52513C9.13556 9.91565 9.13556 10.5488 9.52608 10.9393L10.9403 12.3536C10.976 12.3892 11.0137 12.4217 11.0531 12.4508C11.1943 12.5555 11.3628 12.6512 11.5345 12.7487C11.9446 12.9816 12.3735 13.2252 12.4955 13.6267C12.6351 14.0859 12.396 14.5913 11.918 14.6343C11.0628 14.7113 10.1808 14.4225 9.52608 13.7678L8.11187 12.3536C6.9403 11.182 6.9403 9.28248 8.11187 8.11091L13.7687 2.45406Z",
        fill: "currentColor"
      }),
      /* @__PURE__ */ jsx76("path", {
        d: "M10.2332 21.5459C9.06159 22.7175 7.1621 22.7175 5.99053 21.5459L4.57631 20.1317C3.40474 18.9602 3.40474 17.0607 4.57631 15.8891L6.52088 13.9445C6.9114 13.554 7.54457 13.554 7.93509 13.9445C8.32561 14.3351 8.32561 14.9682 7.93509 15.3587L5.99053 17.3033C5.6 17.6938 5.6 18.327 5.99053 18.7175L7.40474 20.1317C7.79526 20.5223 8.42843 20.5223 8.81895 20.1317L14.4758 14.4749C14.8663 14.0844 14.8663 13.4512 14.4758 13.0607L13.0616 11.6465C13.0259 11.6108 12.9882 11.5783 12.9488 11.5492C12.8076 11.4445 12.6391 11.3489 12.4674 11.2513C12.0573 11.0184 11.6284 10.7748 11.5064 10.3733C11.3668 9.91414 11.6059 9.40875 12.0839 9.36572C12.9391 9.28872 13.8211 9.57756 14.4758 10.2322L15.89 11.6465C17.0616 12.818 17.0616 14.7175 15.89 15.8891L10.2332 21.5459Z",
        fill: "currentColor"
      })
    ]
  });
}

// src/icons/LunchIcon.tsx
init_esm_shims();
import { jsx as jsx77, jsxs as jsxs51 } from "react/jsx-runtime";
function LunchIcon({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs51("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx77("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx77("path", {
        d: "M13.7173 3.08616C13.1251 2.26753 12.1811 1.96333 10.9624 2.11257C10.0995 2.21824 9.45117 2.7172 8.99225 3.41858C8.52147 4.1381 8.30067 5.00357 8.29862 5.64421C8.29747 6.00181 8.10547 6.33157 7.79505 6.50909C7.48463 6.68661 7.10305 6.68486 6.79427 6.5045C6.40815 6.27898 5.67937 6.0393 4.86548 5.98891C4.05151 5.93851 3.30722 6.08603 2.78604 6.45626C2.41563 6.71939 2.1571 7.30736 2.20266 8.22902C2.2469 9.1241 2.5771 10.0653 3.01851 10.6784C3.09295 10.7818 3.1448 10.8946 3.17502 11.011C3.26376 11.0037 3.35376 11 3.44494 11H13.0005V10.7374C13.0005 10.7373 13.0005 10.7374 13.0005 10.7374C13 8.6362 13.7645 6.72519 14.939 5.33015C16.1057 3.94434 17.7411 3.00084 19.5 3.00003H22.0005C22.5528 3.00003 23.0005 3.44775 23.0005 4.00003V6.28574C23.0005 7.5766 22.7311 9.22247 21.8346 10.5781C21.7104 10.7658 21.5752 10.9464 21.4286 11.1183C22.9684 11.5482 24.0005 13.0901 24.0005 14.75L24.0005 14.8059C24.0006 15.6568 24.0007 16.4514 23.7878 17.3101C23.5668 18.2014 23.1353 19.1005 22.3659 20.2547C21.1406 22.0926 19.0337 23.0009 17.1046 23.4659C15.1491 23.9374 13.1811 24 12.0005 24H11.9765C10.826 24.0001 8.9014 24.0001 6.97219 23.5628C5.03564 23.1238 2.93839 22.2097 1.63511 20.2547C0.865649 19.1005 0.434231 18.2014 0.213224 17.3101C0.000296474 16.4514 0.000391364 15.6568 0.000492692 14.8059L0.000497222 14.75C0.000497222 13.5853 0.508589 12.4788 1.34362 11.7737C0.689018 10.8297 0.265302 9.54573 0.205097 8.32776C0.144633 7.10456 0.448781 5.66331 1.62779 4.82578C2.65602 4.09535 3.91556 3.92627 4.98907 3.99273C5.50615 4.02475 6.01599 4.1134 6.48359 4.24226C6.64825 3.59202 6.92447 2.92601 7.31866 2.32355C8.01869 1.25366 9.13879 0.320958 10.7193 0.127399C12.3923 -0.0774744 14.1807 0.314454 15.3377 1.91393C15.6614 2.3614 15.5611 2.98657 15.1136 3.31027C14.6661 3.63397 14.041 3.53364 13.7173 3.08616ZM17.0005 11C18.6669 11 19.6027 10.3272 20.1664 9.47481C20.7699 8.56227 21.0005 7.351 21.0005 6.28574V5.00003H19.501C18.4701 5.0005 17.3551 5.56574 16.469 6.61824C15.5907 7.66146 15.0001 9.1185 15.0005 10.7368V11H17.0005ZM3.44494 13C2.75467 13 2.0005 13.6696 2.0005 14.75C2.0005 15.663 2.00535 16.2275 2.15444 16.8288C2.3001 17.4162 2.60201 18.0995 3.29921 19.1453C4.19593 20.4904 5.71124 21.2262 7.41431 21.6123C9.11122 21.9969 10.8399 22 12.0005 22C13.1281 22 14.9102 21.9377 16.6359 21.5216C18.3881 21.0992 19.8937 20.3575 20.7018 19.1453C21.399 18.0995 21.7009 17.4162 21.8466 16.8288C21.9956 16.2275 22.0005 15.663 22.0005 14.75C22.0005 13.6695 21.2463 13 20.5561 13H3.44494Z",
        fill: "currentColor"
      })
    ]
  });
}

// src/icons/MoonIcon.tsx
init_esm_shims();
import { jsx as jsx78, jsxs as jsxs52 } from "react/jsx-runtime";
function MoonIcon({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs52("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx78("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx78("path", {
        clipRule: "evenodd",
        d: "M9.35462 0.470653C9.50015 0.674849 9.50956 0.946258 9.37851 1.16004C8.58337 2.45718 8.12484 3.98276 8.12484 5.61735C8.12484 9.66621 10.9425 13.0585 14.7247 13.9375C15.0609 14.0156 15.2701 14.3515 15.1919 14.6877C15.1138 15.0239 14.7779 15.2332 14.4417 15.155C10.106 14.1474 6.87484 10.2605 6.87484 5.61735C6.87484 4.28976 7.13935 3.023 7.61866 1.86766C4.49425 3.1376 2.2915 6.20413 2.2915 9.78401C2.2915 14.5014 6.11574 18.3257 10.8332 18.3257C13.9163 18.3257 16.6185 16.6926 18.1212 14.2413C18.3016 13.947 18.6864 13.8547 18.9807 14.0351C19.2749 14.2155 19.3673 14.6003 19.1869 14.8946C17.4665 17.7011 14.369 19.5757 10.8332 19.5757C5.42538 19.5757 1.0415 15.1918 1.0415 9.78401C1.0415 5.10448 4.32354 1.19298 8.71075 0.223135C8.9556 0.169011 9.20908 0.266457 9.35462 0.470653Z",
        fill: "currentColor",
        fillRule: "evenodd"
      })
    ]
  });
}

// src/icons/OuraSymbolIcon.tsx
init_esm_shims();
import { jsx as jsx79, jsxs as jsxs53 } from "react/jsx-runtime";
function OuraSymbolIcon({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs53("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx79("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx79("path", {
        clipRule: "evenodd",
        d: "M7.5 3H16.5V1H7.5V3ZM5 14C5 10.134 8.13401 7 12 7C15.866 7 19 10.134 19 14C19 17.866 15.866 21 12 21C8.13401 21 5 17.866 5 14ZM12 5C7.02944 5 3 9.02944 3 14C3 18.9706 7.02944 23 12 23C16.9706 23 21 18.9706 21 14C21 9.02944 16.9706 5 12 5Z",
        fill: "currentColor",
        fillRule: "evenodd"
      })
    ]
  });
}

// src/icons/ProfileIcon.tsx
init_esm_shims();
import { jsx as jsx80, jsxs as jsxs54 } from "react/jsx-runtime";
function ProfileIcon({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs54("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx80("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx80("path", {
        d: "M12.0005 14C15.3142 14 18.0005 11.3137 18.0005 8C18.0005 4.68629 15.3142 2 12.0005 2C8.68678 2 6.00049 4.68629 6.00049 8C6.00049 9.94359 6.92462 11.6713 8.35746 12.7678C5.20183 14.1664 3.00049 17.3261 3.00049 21C3.00049 21.5523 3.4482 22 4.00049 22H20.0005C20.5528 22 21.0005 21.5523 21.0005 21C21.0005 18.3118 19.8207 15.8979 17.9539 14.2503C17.5398 13.8848 16.9079 13.9242 16.5424 14.3383C16.1769 14.7523 16.2163 15.3843 16.6304 15.7497C17.849 16.8253 18.689 18.3158 18.9297 20H5.07138C5.55661 16.6077 8.47402 14 12.0005 14ZM8.00049 8C8.00049 5.79086 9.79135 4 12.0005 4C14.2096 4 16.0005 5.79086 16.0005 8C16.0005 10.2091 14.2096 12 12.0005 12C9.79135 12 8.00049 10.2091 8.00049 8Z",
        fill: "currentColor"
      })
    ]
  });
}

// src/icons/ReportsIcon.tsx
init_esm_shims();
import { jsx as jsx81, jsxs as jsxs55 } from "react/jsx-runtime";
function ReportsIcon({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs55("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx81("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx81("path", {
        d: "M19.0005 3C19.0005 1.89543 19.8959 1 21.0005 1C22.1051 1 23.0005 1.89543 23.0005 3C23.0005 4.10457 22.1051 5 21.0005 5C20.8213 5 20.6477 4.97644 20.4824 4.93226L16.9327 8.48196C16.9769 8.64718 17.0005 8.82084 17.0005 9C17.0005 10.1046 16.1051 11 15.0005 11C13.8959 11 13.0005 10.1046 13.0005 9C13.0005 8.95674 13.0019 8.91381 13.0046 8.87124L9.88737 6.7931C9.6201 6.92555 9.31899 7 9.00049 7C8.82133 7 8.64767 6.97644 8.48244 6.93226L4.93274 10.482C4.97693 10.6472 5.00049 10.8208 5.00049 11C5.00049 12.1046 4.10506 13 3.00049 13C1.89592 13 1.00049 12.1046 1.00049 11C1.00049 9.89543 1.89592 9 3.00049 9C3.17965 9 3.3533 9.02356 3.51853 9.06774L7.06823 5.51804C7.02405 5.35282 7.00049 5.17916 7.00049 5C7.00049 3.89543 7.89592 3 9.00049 3C10.1051 3 11.0005 3.89543 11.0005 5C11.0005 5.04326 10.9991 5.08619 10.9964 5.12876L14.1136 7.2069C14.3809 7.07445 14.682 7 15.0005 7C15.1796 7 15.3533 7.02356 15.5185 7.06774L19.0682 3.51804C19.024 3.35282 19.0005 3.17916 19.0005 3Z",
        fill: "currentColor"
      }),
      /* @__PURE__ */ jsx81("path", {
        d: "M20.0005 8C20.0005 7.44771 20.4482 7 21.0005 7C21.5528 7 22.0005 7.44771 22.0005 8V22C22.0005 22.5523 21.5528 23 21.0005 23C20.4482 23 20.0005 22.5523 20.0005 22V8Z",
        fill: "currentColor"
      }),
      /* @__PURE__ */ jsx81("path", {
        d: "M15.0005 13C14.4482 13 14.0005 13.4477 14.0005 14V22C14.0005 22.5523 14.4482 23 15.0005 23C15.5528 23 16.0005 22.5523 16.0005 22V14C16.0005 13.4477 15.5528 13 15.0005 13Z",
        fill: "currentColor"
      }),
      /* @__PURE__ */ jsx81("path", {
        d: "M3.0005 15C2.44822 15 2.0005 15.4477 2.0005 16V22C2.0005 22.5523 2.44822 23 3.0005 23C3.55279 23 4.0005 22.5523 4.0005 22V16C4.0005 15.4477 3.55279 15 3.0005 15Z",
        fill: "currentColor"
      }),
      /* @__PURE__ */ jsx81("path", {
        d: "M9.0005 9C8.44822 9 8.0005 9.44771 8.0005 10V22C8.0005 22.5523 8.44822 23 9.0005 23C9.55279 23 10.0005 22.5523 10.0005 22V10C10.0005 9.44771 9.55279 9 9.0005 9Z",
        fill: "currentColor"
      })
    ]
  });
}

// src/icons/RingOutlineIcon.tsx
init_esm_shims();
import { jsx as jsx82, jsxs as jsxs56 } from "react/jsx-runtime";
function RingOutlineIcon({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs56("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx82("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx82("path", {
        clipRule: "evenodd",
        d: "M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5ZM12 21.5C17.2467 21.5 21.5 17.2467 21.5 12C21.5 6.75329 17.2467 2.5 12 2.5C6.75329 2.5 2.5 6.75329 2.5 12C2.5 17.2467 6.75329 21.5 12 21.5Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }),
      /* @__PURE__ */ jsx82("path", {
        clipRule: "evenodd",
        d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "currentColor",
        fillRule: "evenodd"
      })
    ]
  });
}

// src/icons/StressIcon.tsx
init_esm_shims();
import { jsx as jsx83, jsxs as jsxs57 } from "react/jsx-runtime";
function StressIcon({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs57("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx83("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx83("path", {
        clipRule: "evenodd",
        d: "M6.68674 6.27278C6.60863 6.19467 6.482 6.19467 6.4039 6.27277L1.65646 11.0202C1.34404 11.3326 0.837506 11.3326 0.525086 11.0202C0.212667 10.7078 0.212667 10.2013 0.525086 9.88884L5.27253 5.1414C5.97547 4.43846 7.11517 4.43846 7.81811 5.1414L11.8584 9.18174C11.9365 9.25984 12.0632 9.25984 12.1413 9.18174L16.1816 5.1414C16.8846 4.43846 18.0243 4.43846 18.7272 5.14141L23.4746 9.88884C23.7871 10.2013 23.7871 10.7078 23.4746 11.0202C23.1622 11.3326 22.6557 11.3326 22.3433 11.0202L17.5958 6.27278C17.5177 6.19467 17.3911 6.19467 17.313 6.27277L13.2727 10.3131C12.5697 11.0161 11.43 11.0161 10.7271 10.3131L6.68674 6.27278ZM6.68674 14.7228C6.60863 14.6447 6.482 14.6447 6.4039 14.7228L1.65646 19.4702C1.34404 19.7826 0.837505 19.7826 0.525086 19.4702C0.212667 19.1578 0.212667 18.6513 0.525086 18.3388L5.27253 13.5914C5.97547 12.8885 7.11517 12.8885 7.81811 13.5914L11.8584 17.6317C11.9365 17.7098 12.0632 17.7098 12.1413 17.6317L16.1816 13.5914C16.8846 12.8885 18.0243 12.8885 18.7272 13.5914L23.4746 18.3388C23.7871 18.6513 23.7871 19.1578 23.4746 19.4702C23.1622 19.7826 22.6557 19.7826 22.3433 19.4702L17.5958 14.7228C17.5177 14.6447 17.3911 14.6447 17.313 14.7228L13.2727 18.7631C12.5697 19.4661 11.43 19.4661 10.7271 18.7631L6.68674 14.7228Z",
        fill: "currentColor",
        fillRule: "evenodd"
      })
    ]
  });
}

// src/icons/UterusIcon.tsx
init_esm_shims();
import { jsx as jsx84, jsxs as jsxs58 } from "react/jsx-runtime";
function UterusIcon({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs58("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx84("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx84("path", {
        clipRule: "evenodd",
        d: "M2.49223 4.29049C4.64863 3.41145 7.08133 4.60115 7.75756 6.86549L8.64414 9.83418H15.3559L16.2424 6.86549C16.9187 4.60115 19.3514 3.41145 21.5078 4.29049L21.8669 4.43688C23.1552 4.96205 24 6.23366 24 7.64774C24 9.44855 22.6439 10.948 20.8827 11.0945L16.5069 11.4585L15.5486 14.6672C15.2714 15.5956 15.1304 16.5607 15.1304 17.5312V20.2024C15.1304 20.6429 14.78 21 14.3478 21C13.9156 21 13.5652 20.6429 13.5652 20.2024V17.5312C13.5652 16.4034 13.729 15.2817 14.0512 14.2027L14.8795 11.4293H9.12051L9.94878 14.2027C10.271 15.2817 10.4348 16.4034 10.4348 17.5312V20.2024C10.4348 20.6429 10.0844 21 9.65217 21C9.21995 21 8.86957 20.6429 8.86957 20.2024V17.5312C8.86957 16.5607 8.72864 15.5956 8.45137 14.6672L7.49313 11.4585L3.11729 11.0945C1.35609 10.948 0 9.44855 0 7.64774C0 6.23366 0.844786 4.96205 2.13311 4.43688L2.49223 4.29049ZM7.003 9.81731L3.24464 9.50465C2.2958 9.42571 1.56522 8.61792 1.56522 7.64774C1.56522 6.88591 2.02034 6.20084 2.71442 5.9179L3.07353 5.77151C4.37861 5.23951 5.8509 5.95953 6.26016 7.32993L7.003 9.81731ZM16.997 9.81731L20.7554 9.50465C21.7042 9.42571 22.4348 8.61792 22.4348 7.64774C22.4348 6.88591 21.9797 6.20084 21.2856 5.9179L20.9265 5.77151C19.6214 5.23951 18.1491 5.95953 17.7398 7.32993L16.997 9.81731Z",
        fill: "currentColor",
        fillRule: "evenodd"
      })
    ]
  });
}

// src/layout/v4/data/defaultFooterData.ts
init_esm_shims();
var defaultFooterLayout = {
  sm: [
    ["our-company-category" /* CompanyCategory */, "support-category" /* SupportCategory */],
    ["partner-category" /* PartnerCategory */, "connect-category" /* ConnectCategory */]
  ],
  md: [
    ["our-company-category" /* CompanyCategory */, "partner-category" /* PartnerCategory */],
    ["support-category" /* SupportCategory */],
    ["connect-category" /* ConnectCategory */]
  ],
  lg: [
    ["our-company-category" /* CompanyCategory */],
    ["support-category" /* SupportCategory */],
    ["partner-category" /* PartnerCategory */],
    ["connect-category" /* ConnectCategory */]
  ]
};
var defaultFooterData = {
  ["our-company-category" /* CompanyCategory */]: {
    title: "footer_company_heading",
    links: [
      {
        id: "about-us",
        href: "/about-us",
        label: "footer_about_us",
        analyticCta: "about us"
      },
      {
        id: "leadership",
        href: "/leadership",
        label: "footer_leadership",
        analyticCta: "leadership"
      },
      {
        id: "medical-advisory-board",
        href: "/medical-advisory-board",
        label: "footer_medical_advisory_board",
        analyticCta: "medical"
      },
      {
        id: "careers",
        href: "/careers",
        label: "footer_careers",
        analyticCta: "careers"
      },
      {
        id: "newsroom",
        href: "/newsroom",
        label: "newsroom_link",
        analyticCta: "newsroom"
      }
    ],
    isLocalized: false
  },
  ["support-category" /* SupportCategory */]: {
    title: "footer_support_heading",
    links: [
      {
        id: "help-center",
        href: "https://support.ouraring.com/hc/en-us",
        label: "nav_help_center",
        external: true,
        target: "_blank",
        analyticCta: "help center"
      },
      {
        id: "sizing",
        href: "/sizing",
        label: "footer_sizing",
        analyticCta: "sizing"
      },
      {
        id: "recycling-program",
        href: "https://support.ouraring.com/hc/articles/44414370533139",
        label: "recycling_program_link",
        external: true,
        target: "_blank",
        analyticCta: "recycling program"
      },
      {
        id: "flexible-spending",
        href: "https://support.ouraring.com/hc/en-us/articles/19777137314579-Purchase-with-HSA-or-FSA-Funds",
        label: "flexible_spending_footer_link",
        analyticCta: "flexible spending"
      },
      {
        id: "heart-rate-monitoring",
        href: "/heart-rate-monitoring",
        label: "heart_rate_monitoring_link",
        analyticCta: "heart rate monitoring"
      },
      {
        id: "my-account",
        href: "/my-account",
        label: "footer_my_account",
        analyticCta: "my account"
      },
      {
        id: "oura-on-the-web",
        href: "https://cloud.ouraring.com/user/sign-in",
        label: "footer_oura_on_the_web",
        external: true,
        target: "_blank",
        analyticCta: "oura on the web"
      },
      {
        id: "contact",
        href: "/contact",
        label: "footer_contact",
        analyticCta: "contact"
      }
    ],
    isLocalized: false
  },
  ["partner-category" /* PartnerCategory */]: {
    title: "footer_partner_heading",
    links: [
      {
        id: "business",
        href: "/business",
        label: "for_business_link",
        analyticCta: "business"
      },
      {
        id: "partnerships",
        href: "/partnerships",
        label: "partnerships_link",
        analyticCta: "partnerships"
      },
      {
        id: "developers",
        href: "/developer",
        label: "footer_developers",
        analyticCta: "developers"
      }
    ],
    isLocalized: false
  },
  ["connect-category" /* ConnectCategory */]: {
    title: "footer_connect",
    links: [
      {
        id: "blog",
        href: "/blog",
        label: "footer_pulse_blog",
        analyticCta: "blog"
      },
      {
        id: "facebook",
        href: "https://www.facebook.com/ouraring",
        label: "facebook",
        target: "_blank",
        analyticCta: "facebook"
      },
      {
        id: "instagram",
        href: "https://www.instagram.com/ouraring",
        label: "instagram",
        target: "_blank",
        analyticCta: "instagram"
      },
      {
        id: "pinterest",
        href: "https://www.pinterest.com/ouraring/",
        label: "pinterest",
        target: "_blank",
        analyticCta: "pinterest"
      },
      {
        id: "tiktok",
        href: "https://www.tiktok.com/@ouraring",
        label: "tiktok",
        target: "_blank",
        analyticCta: "tiktok"
      },
      { id: "x", href: "https://x.com/ouraring", label: "x", analyticCta: "x" },
      {
        id: "youtube",
        href: "https://www.youtube.com/channel/UCf-xFf4xPcT9DVdOkcCaScg",
        label: "youtube",
        target: "_blank",
        analyticCta: "youtube"
      }
    ],
    isLocalized: false
  }
};
var defaultFooterLegalLinks = [
  {
    href: "/terms-and-conditions",
    label: "footer_terms_and_conditions"
  },
  {
    href: "/privacy-policy",
    label: "footer_privacy_policy"
  },
  {
    href: "/accessibility",
    label: "footer_accessibility"
  },
  {
    href: "/fcc-compliance-statements",
    label: "fcc_compliance_link"
  },
  {
    href: "/intellectual-property-notice",
    label: "footer_ip_notice"
  },
  {
    href: "/security",
    label: "footer_security_center"
  }
];
var allFooterLanguages = {
  cs: "\u010Ce\u0161tina",
  da: "Dansk",
  de: "Deutsch",
  en: "English",
  es: "Espa\xF1ol",
  fi: "Suomi",
  fr: "Fran\xE7ais",
  it: "Italiano",
  ja: "\u65E5\u672C\u8A9E",
  nb: "Norsk",
  nl: "Nederlands",
  sv: "Svenska"
};
var futureLanguages = ["nb", "sv", "da", "nl", "cs"];
var defaultFooterLanguages = Object.fromEntries(
  Object.entries(allFooterLanguages).filter(
    ([key]) => !futureLanguages.includes(key)
  )
);

// src/layout/v4/Footer/BackgroundWrapper.tsx
init_esm_shims();
import { cx as cx32 } from "class-variance-authority";
import { forwardRef as forwardRef5 } from "react";
import { jsx as jsx85, jsxs as jsxs59 } from "react/jsx-runtime";
var BackgroundWrapper = forwardRef5(
  function BackgroundWrapper2({ className, children, radius, dataCy }, ref) {
    return /* @__PURE__ */ jsxs59("footer", {
      className: "ui-relative ui-w-full",
      "data-cy": dataCy,
      ref,
      style: { marginTop: -radius, paddingTop: radius },
      children: [
        /* @__PURE__ */ jsxs59("svg", {
          className: "ui-absolute ui-inset-0 ui-w-full ui-h-full ui-z-0",
          children: [
            /* @__PURE__ */ jsxs59("defs", {
              children: [
                /* @__PURE__ */ jsxs59("mask", {
                  id: "oura-footer-v4-mask",
                  maskUnits: "userSpaceOnUse",
                  children: [
                    /* @__PURE__ */ jsx85("rect", {
                      fill: "#fff",
                      height: "100%",
                      width: "100%"
                    }),
                    /* @__PURE__ */ jsx85("rect", {
                      fill: "#000",
                      height: radius * 2,
                      rx: radius,
                      ry: radius,
                      width: "100%",
                      x: 0,
                      y: -radius
                    })
                  ]
                }),
                /* @__PURE__ */ jsxs59("radialGradient", {
                  cx: ".1",
                  cy: ".2",
                  id: "oura-footer-v4-gradient",
                  r: "1.2",
                  children: [
                    /* @__PURE__ */ jsx85("stop", {
                      offset: "0%",
                      stopColor: "#3A3837"
                    }),
                    /* @__PURE__ */ jsx85("stop", {
                      offset: "100%",
                      stopColor: "#1C1B1A"
                    })
                  ]
                })
              ]
            }),
            /* @__PURE__ */ jsx85("rect", {
              fill: "url(#oura-footer-v4-gradient)",
              height: "100%",
              mask: "url(#oura-footer-v4-mask)",
              width: "100%"
            })
          ]
        }),
        /* @__PURE__ */ jsx85("div", {
          className: cx32("ui-relative ui-z-10", className),
          children
        })
      ]
    });
  }
);
var BackgroundWrapper_default = BackgroundWrapper;

// src/layout/v4/Footer/EmailSection/index.tsx
init_esm_shims();

// src/layout/v4/Footer/EmailSection/EmailCapture.tsx
init_esm_shims();
import { cx as cx33 } from "class-variance-authority";
import { useState as useState9 } from "react";
import { useFormik as useFormik2 } from "formik";
import { useIntl as useIntl8 } from "react-intl";
import { jsx as jsx86, jsxs as jsxs60 } from "react/jsx-runtime";
function EmailCapture({
  className,
  emailSubmitted = false,
  onSubmit
}) {
  const [focused, setFocused] = useState9(false);
  const { formatMessage } = useIntl8();
  const handleFocus = () => {
    setFocused(true);
  };
  const formik = useFormik2({
    validateOnChange: false,
    validateOnBlur: false,
    validate: (values) => {
      const errors = {};
      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
        errors.email = formatMessage({ id: "footer_email_validation_error" });
      }
      return errors;
    },
    initialValues: {
      email: ""
    },
    onSubmit: (values) => {
      onSubmit(values.email);
    }
  });
  const handleSubmit = (e) => {
    e.preventDefault();
    formik.handleSubmit();
  };
  if (emailSubmitted) {
    return /* @__PURE__ */ jsx86("div", {
      className: cx33("ui-relative ui-w-full xl:ui-w-80", className),
      children: /* @__PURE__ */ jsx86("div", {
        className: "ui-w-full ui-rounded-xl ui-bg-[#757573] ui-text-white ui-px-5 ui-py-2 ui-tracking-wide ui-shadow-[inset_0_1px_0_rgba(255,255,255,0.06)] ui-text-center",
        children: formatMessage({ id: "footer_thanks_for_subscribing" })
      })
    });
  }
  return /* @__PURE__ */ jsxs60("form", {
    className: cx33("ui-relative ui-w-full xl:ui-w-80", className),
    "data-cy": "footer_email_signup",
    noValidate: true,
    onSubmit: handleSubmit,
    children: [
      /* @__PURE__ */ jsx86("input", {
        autoComplete: "email",
        className: "ui-w-full ui-rounded-xl ui-bg-[#757573] ui-placeholder-white ui-text-white ui-pl-5 ui-py-2 ui-pr-12 ui-tracking-wide ui-shadow-[inset_0_1px_0_rgba(255,255,255,0.06)]",
        id: "footer_email_signup_input",
        inputMode: "email",
        name: "email",
        onBlurCapture: formik.handleBlur,
        onChange: formik.handleChange,
        onFocus: handleFocus,
        placeholder: formatMessage({ id: "footer_email" }),
        required: true,
        type: "email",
        value: formik.values.email
      }),
      /* @__PURE__ */ jsx86("button", {
        "aria-label": formatMessage({
          id: "footer_newsletter_submit_label"
        }),
        className: cx33(
          "ui-absolute ui-right-2 ui-top-1/2 ui--translate-y-1/2",
          "ui-h-8 ui-w-8 ui-flex ui-items-center ui-justify-center",
          "ui-bg-transparent ui-rounded-lg ui-transition-colors",
          {
            "ui-text-white/60 hover:ui-text-white": !focused,
            "ui-text-white hover:ui-text-white/80": focused
          }
        ),
        "data-cy": "footer_email_signup_submit",
        name: "submit",
        type: "submit",
        children: /* @__PURE__ */ jsx86(RightArrowIcon, {
          className: "ui-h-4 ui-w-4"
        })
      }),
      formik.errors.email ? /* @__PURE__ */ jsx86("div", {
        className: "ui-absolute ui-text-xs ui-top-full ui-mt-1 ui-text-red-400",
        "data-cy": "email_error_message",
        children: formik.errors.email
      }) : null
    ]
  });
}

// src/layout/v4/Footer/EmailSection/index.tsx
import { jsx as jsx87, jsxs as jsxs61 } from "react/jsx-runtime";
function PrivacyPolicyLink2(text) {
  return /* @__PURE__ */ jsx87(BodyLink, {
    color: "inherit",
    href: "/privacy-policy",
    children: text
  }, "privacy-policy-link");
}
function EmailSection({
  emailSubmitted = false,
  onSubmit
}) {
  return /* @__PURE__ */ jsxs61("div", {
    className: "ui-w-full lg:ui-w-64 xl:ui-w-96 ui-gap-y-6 md:ui-gap-y-2 lg:ui-gap-y-8 ui-shrink-0 ui-grow-0 ui-grid ui-grid-cols-1 ui-auto-rows-min md:ui-grid-cols-[auto_1fr] lg:ui-grid-cols-1 ui-gap-x-10",
    children: [
      /* @__PURE__ */ jsx87(Typography, {
        Element: "span",
        className: "ui-tracking-tight md:ui-row-start-1 lg:ui-row-start-auto",
        color: "gray",
        font: "serif",
        height: "tight",
        variant: "h4",
        children: t("footer_email_input_heading")
      }),
      /* @__PURE__ */ jsx87("div", {
        className: "md:ui-row-span-2 md:ui-min-w-60 lg:ui-min-w-0 lg:ui-row-span-1 ui-flex ui-flex-col md:ui-justify-center lg:ui-justify-self-start",
        children: /* @__PURE__ */ jsx87(EmailCapture, {
          emailSubmitted,
          onSubmit
        })
      }),
      /* @__PURE__ */ jsxs61("div", {
        className: "ui-hidden lg:ui-block",
        children: [
          /* @__PURE__ */ jsx87(Typography, {
            color: "gray",
            variant: "eyebrow-small",
            children: t("footer_dataprotect_1")
          }),
          /* @__PURE__ */ jsx87(Typography, {
            Element: "div",
            color: "gray",
            variant: "eyebrow-small",
            children: /* @__PURE__ */ jsx87(FormattedMessage_default, {
              id: "footer_dataprotect_privacy_policy",
              values: {
                PrivacyPolicyLink: PrivacyPolicyLink2
              }
            })
          })
        ]
      }),
      /* @__PURE__ */ jsx87("div", {
        className: "md:ui-row-start-2 lg:ui-row-start-auto md:ui-flex md:ui-flex-row lg:ui-flex-col ui-flex-col ui-gap-1",
        children: /* @__PURE__ */ jsxs61(Typography, {
          className: "lg:ui-hidden",
          color: "gray",
          variant: "eyebrow-small",
          children: [
            t("footer_dataprotect_1"),
            " ",
            /* @__PURE__ */ jsx87(FormattedMessage_default, {
              id: "footer_dataprotect_privacy_policy",
              values: {
                PrivacyPolicyLink: PrivacyPolicyLink2
              }
            })
          ]
        })
      })
    ]
  });
}
var EmailSection_default = EmailSection;

// src/layout/v4/Footer/LinkColumns.tsx
init_esm_shims();
import { useEffect as useEffect8, useMemo as useMemo6, useState as useState10 } from "react";

// src/layout/v4/Footer/LinkColumn.tsx
init_esm_shims();
import { cx as cx34 } from "class-variance-authority";
import { jsx as jsx88, jsxs as jsxs62 } from "react/jsx-runtime";
function LinkColumn({
  category,
  currentPath,
  onClick
}) {
  const isLocalized = category.isLocalized;
  return /* @__PURE__ */ jsxs62("div", {
    className: "ui-text-gray-400",
    children: [
      category.title ? /* @__PURE__ */ jsx88(Typography, {
        Element: "span",
        color: "inherit",
        weight: "bold",
        children: isLocalized ? category.title : t(category.title)
      }) : null,
      /* @__PURE__ */ jsx88("div", {
        className: "ui-text-sandstone-200 ui-pt-2",
        children: /* @__PURE__ */ jsx88("ul", {
          className: "ui-space-y-2",
          children: category.links.map(({ id, label, analyticCta, ...args }) => /* @__PURE__ */ jsx88("li", {
            children: /* @__PURE__ */ jsx88(NavLink2, {
              className: cx34({
                "ui-font-bold ui-cursor-default": currentPath === args.href
              }),
              id,
              ...args,
              onClick: (event) => {
                onClick(event, analyticCta);
              },
              children: isLocalized ? label : t(label)
            })
          }, id))
        })
      })
    ]
  });
}

// src/layout/v4/Footer/LinkColumns.tsx
import { jsx as jsx89 } from "react/jsx-runtime";
function splitIntoColumns(ids, numCols) {
  const columns = Array.from({ length: numCols }, () => []);
  ids.forEach((id, idx) => {
    columns[idx % numCols].push(id);
  });
  return columns;
}
function LinkColumns({
  currentPath,
  groups,
  layout,
  onClick
}) {
  const [tier, setTier] = useState10(null);
  const isMd = useMediaQuery(`(min-width: ${BREAKPOINTS.medium}px)`);
  const isLg = useMediaQuery(`(min-width: ${BREAKPOINTS.large}px)`);
  const activeLayout = useMemo6(() => {
    if (!layout) {
      const groupIds = Object.keys(groups);
      const defaultLayouts = {
        sm: splitIntoColumns(groupIds, 2),
        md: splitIntoColumns(groupIds, 3),
        lg: splitIntoColumns(groupIds, 4)
      };
      return defaultLayouts;
    }
    return layout;
  }, [groups, layout]);
  useEffect8(() => {
    if (isLg) {
      setTier("lg");
    } else if (isMd) {
      setTier("md");
    } else {
      setTier("sm");
    }
  }, [isLg, isMd]);
  const columns = useMemo6(() => {
    if (!tier)
      return [];
    return activeLayout[tier];
  }, [activeLayout, tier]);
  return /* @__PURE__ */ jsx89("div", {
    className: "ui-grid ui-gap-6 ui-grid-cols-2 md:ui-grid-cols-3 lg:ui-grid-cols-4 ui-w-full",
    children: columns.map((groupKeys, colIdx) => /* @__PURE__ */ jsx89("div", {
      className: "ui-space-y-8",
      children: groupKeys.map((k) => /* @__PURE__ */ jsx89(LinkColumn, {
        category: groups[k],
        currentPath,
        onClick
      }, k))
    }, colIdx))
  });
}
var LinkColumns_default = LinkColumns;

// src/layout/v4/Footer/LegalSection.tsx
init_esm_shims();

// src/layout/v4/Footer/LocalePicker/index.tsx
init_esm_shims();

// src/icons/WorldIcon.tsx
init_esm_shims();
import { jsx as jsx90, jsxs as jsxs63 } from "react/jsx-runtime";
function WorldIcon({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs63("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 20,
    viewBox: "0 0 19 20",
    width: 19,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx90("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx90("path", {
        d: "M9.5 19.5C8.1975 19.5 6.96833 19.2503 5.8125 18.751C4.65667 18.2517 3.64867 17.5718 2.7885 16.7115C1.92817 15.8513 1.24833 14.8433 0.749 13.6875C0.249667 12.5317 0 11.3025 0 10C0 8.68717 0.249667 7.45542 0.749 6.30475C1.24833 5.15408 1.92817 4.14867 2.7885 3.2885C3.64867 2.42817 4.65667 1.74833 5.8125 1.249C6.96833 0.749667 8.1975 0.5 9.5 0.5C10.8128 0.5 12.0446 0.749667 13.1953 1.249C14.3459 1.74833 15.3513 2.42817 16.2115 3.2885C17.0718 4.14867 17.7517 5.15408 18.251 6.30475C18.7503 7.45542 19 8.68717 19 10C19 11.3025 18.7503 12.5317 18.251 13.6875C17.7517 14.8433 17.0718 15.8513 16.2115 16.7115C15.3513 17.5718 14.3459 18.2517 13.1953 18.751C12.0446 19.2503 10.8128 19.5 9.5 19.5ZM9.5 17.9788C10.0103 17.3019 10.4398 16.6192 10.7885 15.9307C11.1372 15.2422 11.4212 14.4897 11.6405 13.673H7.3595C7.59167 14.5153 7.87892 15.2808 8.22125 15.9693C8.56342 16.6578 8.98967 17.3276 9.5 17.9788ZM7.5635 17.7038C7.18017 17.1538 6.83592 16.5285 6.53075 15.828C6.22558 15.1273 5.98842 14.409 5.81925 13.673H2.427C2.95517 14.7115 3.6635 15.584 4.552 16.2905C5.4405 16.9968 6.44433 17.4679 7.5635 17.7038ZM11.4365 17.7038C12.5557 17.4679 13.5595 16.9968 14.448 16.2905C15.3365 15.584 16.0448 14.7115 16.573 13.673H13.1807C12.9794 14.4153 12.7262 15.1368 12.421 15.8375C12.116 16.5382 11.7878 17.1603 11.4365 17.7038ZM1.798 12.173H5.5155C5.45267 11.8013 5.40708 11.4369 5.37875 11.0798C5.35058 10.7228 5.3365 10.3628 5.3365 10C5.3365 9.63717 5.35058 9.27725 5.37875 8.92025C5.40708 8.56308 5.45267 8.19867 5.5155 7.827H1.798C1.70183 8.16667 1.62817 8.51983 1.577 8.8865C1.52567 9.25317 1.5 9.62433 1.5 10C1.5 10.3757 1.52567 10.7468 1.577 11.1135C1.62817 11.4802 1.70183 11.8333 1.798 12.173ZM7.01525 12.173H11.9848C12.0474 11.8013 12.0929 11.4402 12.1212 11.0895C12.1494 10.7388 12.1635 10.3757 12.1635 10C12.1635 9.62433 12.1494 9.26117 12.1212 8.9105C12.0929 8.55983 12.0474 8.19867 11.9848 7.827H7.01525C6.95258 8.19867 6.90708 8.55983 6.87875 8.9105C6.85058 9.26117 6.8365 9.62433 6.8365 10C6.8365 10.3757 6.85058 10.7388 6.87875 11.0895C6.90708 11.4402 6.95258 11.8013 7.01525 12.173ZM13.4845 12.173H17.202C17.2982 11.8333 17.3718 11.4802 17.423 11.1135C17.4743 10.7468 17.5 10.3757 17.5 10C17.5 9.62433 17.4743 9.25317 17.423 8.8865C17.3718 8.51983 17.2982 8.16667 17.202 7.827H13.4845C13.5473 8.19867 13.5929 8.56308 13.6212 8.92025C13.6494 9.27725 13.6635 9.63717 13.6635 10C13.6635 10.3628 13.6494 10.7228 13.6212 11.0798C13.5929 11.4369 13.5473 11.8013 13.4845 12.173ZM13.1807 6.327H16.573C16.0385 5.27567 15.335 4.40317 14.4625 3.7095C13.59 3.016 12.5813 2.54167 11.4365 2.2865C11.8198 2.8685 12.1608 3.50508 12.4595 4.19625C12.7583 4.88725 12.9987 5.5975 13.1807 6.327ZM7.3595 6.327H11.6405C11.4083 5.491 11.1163 4.72075 10.7645 4.01625C10.4125 3.31175 9.991 2.64675 9.5 2.02125C9.009 2.64675 8.5875 3.31175 8.2355 4.01625C7.88367 4.72075 7.59167 5.491 7.3595 6.327ZM2.427 6.327H5.81925C6.00125 5.5975 6.24167 4.88725 6.5405 4.19625C6.83917 3.50508 7.18017 2.8685 7.5635 2.2865C6.41217 2.54167 5.40192 3.01767 4.53275 3.7145C3.66342 4.41117 2.9615 5.282 2.427 6.327Z",
        fill: "currentColor"
      })
    ]
  });
}

// src/v4/Modal/index.tsx
init_esm_shims();
import {
  cloneElement as cloneElement3
} from "react";

// src/v4/Modal/ModalDialog.tsx
init_esm_shims();
import { cx as cx35 } from "class-variance-authority";
import { cloneElement, useRef as useRef8 } from "react";
import { useDialog } from "react-aria";
import { jsx as jsx91 } from "react/jsx-runtime";
function ModalDialog({
  children,
  className,
  variant,
  ...props
}) {
  const ref = useRef8(null);
  const { dialogProps, titleProps } = useDialog(props, ref);
  return /* @__PURE__ */ jsx91("div", {
    ...dialogProps,
    className: cx35(
      "ui-w-full ui-overflow-y-auto !ui-outline-none ui-px-6 ui-pb-8 md:ui-px-8",
      {
        "md:ui-pt-16": variant === "large" || variant === "extra-large",
        "md:ui-pt-10": variant === "small"
      },
      className
    ),
    "data-cy": "modal-v4-dialog",
    ref,
    children: cloneElement(children({ titleProps }))
  });
}

// src/v4/Modal/ModalTrigger.tsx
init_esm_shims();
import { AnimatePresence as AnimatePresence2 } from "framer-motion";
import {
  cloneElement as cloneElement2,
  useRef as useRef10
} from "react";
import { useButton, useOverlayTrigger } from "react-aria";
import {
  useOverlayTriggerState
} from "react-stately";

// src/v4/Modal/ModalWrapper.tsx
init_esm_shims();
import { cx as cx37 } from "class-variance-authority";
import { motion as motion7, useReducedMotion as useReducedMotion3 } from "framer-motion";
import { useRef as useRef9 } from "react";
import {
  Overlay,
  useModalOverlay
} from "react-aria";

// src/v4/Modal/hooks/useDrawerControls.ts
init_esm_shims();
import {
  useAnimate,
  useDragControls,
  useMotionValue
} from "framer-motion";
function useDrawerControls(state, animated, duration) {
  const [scope, animate] = useAnimate();
  const opacity = useMotionValue(0);
  const y = useMotionValue(0);
  const controls = useDragControls();
  const handleClose = async () => {
    if (animated) {
      void animate(opacity, [1, 0], { duration, ease: "easeInOut" });
      const OVERSHOOT = 100;
      const yStart = typeof y.get() === "number" ? y.get() : 0;
      const drawerOffset = scope.current.getBoundingClientRect().top;
      const yTarget = yStart + (window.innerHeight + OVERSHOOT - drawerOffset);
      await animate(
        scope.current,
        {
          y: [yStart, yTarget]
        },
        {
          duration,
          ease: "easeInOut"
        }
      );
    }
    state.close();
  };
  return {
    controls,
    handleClose,
    opacity,
    scope,
    y
  };
}

// src/v4/Modal/ModalCloseButton.tsx
init_esm_shims();
import { cx as cx36 } from "class-variance-authority";
import { Fragment as Fragment7, jsx as jsx92, jsxs as jsxs64 } from "react/jsx-runtime";
function ModalCloseButton({
  controls,
  dragHandleClassName,
  state,
  variant
}) {
  return /* @__PURE__ */ jsxs64(Fragment7, {
    children: [
      /* @__PURE__ */ jsxs64("button", {
        className: cx36(
          "ui-flex ui-w-full ui-cursor-grab ui-touch-none ui-items-center ui-justify-center ui-rounded-t-[20px] ui-p-5 active:ui-cursor-grabbing active:ui-bg-neutral-800/10 md:ui-hidden",
          dragHandleClassName
        ),
        "data-cy": "modal-drag-handle",
        onPointerDown: (e) => {
          controls.start(e);
        },
        type: "button",
        children: [
          /* @__PURE__ */ jsx92("span", {
            className: "ui-sr-only",
            children: t("close")
          }),
          /* @__PURE__ */ jsx92("span", {
            className: "ui-block ui-h-2 ui-w-14 ui-cursor-grab ui-touch-none ui-rounded-full ui-bg-[#d6caba] active:ui-cursor-grabbing"
          })
        ]
      }),
      /* @__PURE__ */ jsx92("div", {
        className: cx36("ui-hidden md:ui-block md:ui-absolute md:ui-z-20", {
          "md:ui-top-4 md:ui-right-6": variant === "small",
          "md:ui-top-8 md:ui-right-8": variant === "large" || variant === "extra-large"
        }),
        "data-cy": "modal-close-button-container",
        children: /* @__PURE__ */ jsxs64("button", {
          className: "ui-relative ui-h-8 ui-w-8 ui-rounded-full ui-text-gray-400 hover:ui-text-gray-500 ui-bg-inherit",
          "data-cy": "modal-close-button",
          onClick: state.close,
          type: "button",
          children: [
            /* @__PURE__ */ jsx92("span", {
              className: "ui-sr-only",
              children: t("close")
            }),
            /* @__PURE__ */ jsx92("span", {
              className: "ui-block ui-absolute ui-inset-0 ui-rounded-full ui-border-[1.5px] ui-border-current"
            }),
            /* @__PURE__ */ jsx92("span", {
              className: "ui-block ui-absolute ui-top-1/2 ui-left-1/2 ui-h-[1.5px] ui-w-5 -ui-translate-x-1/2 -ui-translate-y-1/2 ui-rotate-45 ui-transform ui-rounded-full ui-bg-current"
            }),
            /* @__PURE__ */ jsx92("span", {
              className: "ui-block ui-absolute ui-top-1/2 ui-left-1/2 ui-h-[1.5px] ui-w-5 -ui-translate-x-1/2 -ui-translate-y-1/2 -ui-rotate-45 ui-transform ui-rounded-full ui-bg-current"
            })
          ]
        })
      })
    ]
  });
}

// src/v4/Modal/ModalWrapper.tsx
import { jsx as jsx93, jsxs as jsxs65 } from "react/jsx-runtime";
function ModalWrapper({
  animated,
  animationDuration,
  backdropClassName,
  blur,
  children,
  className,
  dragHandleClassName,
  state,
  variant,
  ...props
}) {
  const ref = useRef9(null);
  const reduceMotion = useReducedMotion3() || !animated;
  const { modalProps, underlayProps } = useModalOverlay(props, state, ref);
  const { controls, handleClose, scope, y } = useDrawerControls(
    state,
    !reduceMotion,
    animationDuration
  );
  const backdropDuration = animationDuration + 0.05;
  return /* @__PURE__ */ jsx93(Overlay, {
    children: /* @__PURE__ */ jsx93(motion7.div, {
      animate: { opacity: 1 },
      className: cx37(
        "ui-fixed ui-inset-0 ui-z-200 ui-bg-black/60",
        {
          "ui-backdrop-blur-[10px]": blur
        },
        backdropClassName
      ),
      exit: { opacity: 0 },
      initial: { opacity: 0 },
      transition: {
        duration: backdropDuration,
        ease: "easeInOut"
      },
      children: /* @__PURE__ */ jsx93("div", {
        ...underlayProps,
        className: "ui-size-full ui-flex ui-justify-center ui-items-center",
        "data-cy": "modal-v4-underlay",
        children: /* @__PURE__ */ jsx93(motion7.div, {
          animate: { y: 0 },
          className: cx37(
            "ui-relative ui-z-10 ui-w-full ui-mt-auto md:ui-mt-0",
            {
              "md:ui-w-[85vw] md:ui-max-w-[840px] lg:ui-w-[75vw] lg:ui-max-w-none xl:ui-w-[65vw]": variant === "extra-large",
              "md:ui-w-[85vw] md:ui-max-w-[840px] lg:ui-w-[75vw] xl:ui-w-[65vw]": variant === "large",
              "md:ui-max-w-[375px]": variant === "small"
            }
          ),
          drag: "y",
          dragConstraints: { top: 0, bottom: 0 },
          dragControls: controls,
          dragElastic: { top: 0.15, bottom: 0.85 },
          dragListener: false,
          exit: { y: reduceMotion ? 0 : 100 },
          initial: { y: reduceMotion ? 0 : 250 },
          onDragEnd: () => {
            if (y.get() > 100) {
              void handleClose();
            }
          },
          ref: scope,
          style: { y },
          transition: {
            duration: animationDuration,
            ease: "easeInOut"
          },
          children: /* @__PURE__ */ jsxs65("div", {
            ...modalProps,
            className: cx37(
              "ui-w-full ui-max-h-[80dvh] ui-flex ui-flex-col ui-flex-1 ui-rounded-t-[20px] ui-bg-sandstone-200 ui-shadow-[0_200px_0_0] ui-shadow-sandstone-200 ui-overflow-hidden",
              "md:ui-rounded-[20px] md:ui-shadow-none",
              className
            ),
            "data-cy": "modal-v4",
            children: [
              /* @__PURE__ */ jsx93(ModalCloseButton, {
                controls,
                dragHandleClassName,
                state,
                variant
              }),
              children
            ]
          })
        })
      })
    })
  });
}

// src/v4/Modal/ModalTrigger.tsx
import { Fragment as Fragment8, jsx as jsx94, jsxs as jsxs66 } from "react/jsx-runtime";
function ModalTrigger({
  triggerButton,
  children,
  onButtonClick,
  wrapperProps,
  ...props
}) {
  const buttonRef = useRef10(null);
  const overlayTriggerState = useOverlayTriggerState(props);
  const { triggerProps, overlayProps } = useOverlayTrigger(
    { type: "dialog" },
    overlayTriggerState
  );
  const { buttonProps } = useButton(triggerProps, buttonRef);
  const handleButtonClick = (event) => {
    var _a;
    (_a = buttonProps.onClick) == null ? void 0 : _a.call(buttonProps, event);
    onButtonClick == null ? void 0 : onButtonClick(event);
  };
  return /* @__PURE__ */ jsxs66(Fragment8, {
    children: [
      triggerButton({
        ...buttonProps,
        onClick: handleButtonClick,
        ref: buttonRef
      }),
      /* @__PURE__ */ jsx94(AnimatePresence2, {
        children: overlayTriggerState.isOpen ? /* @__PURE__ */ jsx94(ModalWrapper, {
          ...wrapperProps,
          state: overlayTriggerState,
          children: cloneElement2(children({ overlayTriggerState }), overlayProps)
        }) : null
      })
    ]
  });
}

// src/v4/Modal/index.tsx
import { jsx as jsx95 } from "react/jsx-runtime";
function Modal({
  animated = true,
  animationDuration = 0.25,
  backdropClassName,
  blur = true,
  children,
  className,
  defaultOpen,
  dialogClassName,
  dragHandleClassName,
  isOpen,
  onOpenChange,
  onTriggerButtonClick,
  triggerButton,
  variant = "small"
}) {
  return /* @__PURE__ */ jsx95(ModalTrigger, {
    defaultOpen,
    isOpen,
    onButtonClick: onTriggerButtonClick,
    onOpenChange,
    triggerButton,
    wrapperProps: {
      animated,
      animationDuration,
      backdropClassName,
      blur,
      className,
      dragHandleClassName,
      variant
    },
    children: ({ overlayTriggerState }) => /* @__PURE__ */ jsx95(ModalDialog, {
      className: dialogClassName,
      variant,
      children: ({ titleProps }) => cloneElement3(
        children({
          overlayTriggerState,
          titleProps
        })
      )
    })
  });
}

// src/layout/v4/Footer/LocalePicker/index.tsx
import { jsx as jsx96, jsxs as jsxs67 } from "react/jsx-runtime";
function LocalePicker({
  selectedLocale: selectedLanguage,
  options,
  onChange
}) {
  return /* @__PURE__ */ jsx96(Modal, {
    blur: false,
    triggerButton: (args) => /* @__PURE__ */ jsxs67("button", {
      ...args,
      "aria-expanded": "false",
      "aria-haspopup": "listbox",
      className: "ui-border ui-border-solid ui-border-white ui-rounded-full ui-py-2 ui-px-4 ui-text-white ui-flex ui-flex-row ui-gap-2 ui-items-center hover:ui-bg-white/10 ui-transition-colors",
      type: "button",
      children: [
        /* @__PURE__ */ jsx96(WorldIcon, {}),
        options[selectedLanguage]
      ]
    }),
    children: () => {
      return /* @__PURE__ */ jsxs67("div", {
        className: "ui-h-[50svh] md:ui-h-fit ui-px-3 ui-pb-3",
        children: [
          /* @__PURE__ */ jsx96(Typography, {
            Element: "label",
            className: "ui-mt-8",
            children: t("language_preference")
          }),
          /* @__PURE__ */ jsxs67("div", {
            className: "ui-relative ui-mt-2",
            children: [
              /* @__PURE__ */ jsx96("select", {
                className: "ui-block ui-w-full ui-rounded-md ui-border ui-border-gray-300 ui-bg-white ui-pl-3 ui-py-2 ui-pr-5 ui-text-sm ui-shadow-sm ui-appearance-none",
                id: "language",
                name: "language",
                onChange: (e) => {
                  onChange == null ? void 0 : onChange(e.target.value);
                },
                value: selectedLanguage,
                children: Object.entries(options).map(([locale, value]) => /* @__PURE__ */ jsx96("option", {
                  value: locale,
                  children: value
                }, locale))
              }),
              /* @__PURE__ */ jsx96(ChevronDownIcon, {
                "aria-hidden": true,
                className: "ui-pointer-events-none ui-absolute ui-right-3 ui-top-1/2 ui-h-4 ui-w-4 -ui-translate-y-1/2 ui-text-gray-500",
                fill: "currentColor"
              })
            ]
          })
        ]
      });
    }
  });
}
var LocalePicker_default = LocalePicker;

// src/layout/v4/Footer/LegalSection.tsx
import { Fragment as Fragment9, jsx as jsx97, jsxs as jsxs68 } from "react/jsx-runtime";
function LegalSection({
  isLocalized,
  legalLinks,
  languageOptions,
  selectedLocale,
  onLocaleChange,
  showImpressum
}) {
  return /* @__PURE__ */ jsxs68(Fragment9, {
    children: [
      /* @__PURE__ */ jsxs68("div", {
        className: "ui-grid lg:ui-grid-cols-[1fr_auto] lg:grid-rows-2 ui-gap-y-6 md:ui-gap-y-4",
        children: [
          /* @__PURE__ */ jsx97("ul", {
            className: "ui-flex ui-flex-wrap ui-gap-4 ui-text-gray-400 ui-text-xs lg:ui-row-start-1 lg:ui-order-none ui-order-1",
            children: legalLinks.map((link) => /* @__PURE__ */ jsx97("li", {
              children: /* @__PURE__ */ jsx97(NavLink2, {
                href: link.href,
                children: isLocalized ? link.label : t(link.label)
              })
            }, link.href))
          }),
          /* @__PURE__ */ jsx97("div", {
            className: "lg:ui-row-start-2 ui-order-3 lg:ui-order-none",
            children: /* @__PURE__ */ jsx97(Typography, {
              color: "gray",
              variant: "eyebrow-small",
              children: t("footer_legal_link_v4")
            })
          }),
          /* @__PURE__ */ jsx97("div", {
            className: "lg:ui-row-span-2 ui-flex ui-items-center ui-justify-start lg:ui-justify-center ui-order-2 lg:ui-order-none",
            children: /* @__PURE__ */ jsx97(LocalePicker_default, {
              onChange: onLocaleChange,
              options: languageOptions,
              selectedLocale
            })
          })
        ]
      }),
      showImpressum ? /* @__PURE__ */ jsxs68("div", {
        className: "ui-mt-2",
        children: [
          /* @__PURE__ */ jsxs68(Typography, {
            color: "gray",
            variant: "eyebrow-small",
            children: [
              "Oura Health Oy",
              /* @__PURE__ */ jsx97("br", {}),
              "Elektroniikkatie 10, 90590 Oulu, Finland"
            ]
          }),
          /* @__PURE__ */ jsx97(NavLink2, {
            className: "ui-block ui-text-gray-400 ui-text-xs ui-underline",
            href: "/impressum",
            children: t("impressum_page_title")
          })
        ]
      }) : void 0
    ]
  });
}

// src/layout/v4/Footer/index.tsx
import { jsx as jsx98, jsxs as jsxs69 } from "react/jsx-runtime";
function Footer2({
  currentPath,
  emailSubmitted = false,
  inverseHeaderOnScrollUp,
  isLegalLinksLocalized = false,
  legalLinks = defaultFooterLegalLinks,
  linkGroups = defaultFooterData,
  linkLayout = defaultFooterLayout,
  localeOptions: languageOptions = defaultFooterLanguages,
  multiVariates,
  onLinkClick,
  onLocaleChange,
  onNewsletterFormSubmit,
  selectedLocale,
  showImpressum
}) {
  const { setIsFooterInView } = useFooterContext();
  const footerRef = useRef11(null);
  const isInView = useInView3(footerRef);
  useEffect9(() => {
    setIsFooterInView(isInView);
  }, [isInView, setIsFooterInView]);
  return /* @__PURE__ */ jsx98(InverseHeader, {
    enter: true,
    exit: inverseHeaderOnScrollUp,
    children: /* @__PURE__ */ jsxs69(BackgroundWrapper_default, {
      className: "ui-px-8 md:ui-px-12 ui-pt-16 ui-pb-16",
      dataCy: "footer",
      radius: 48,
      ref: footerRef,
      children: [
        /* @__PURE__ */ jsxs69("div", {
          className: "ui-flex ui-flex-col lg:ui-flex-row lg:ui-items-center ui-justify-between ui-text-gray-400 ui-gap-10 lg:ui-gap-2 ui-mb-10 lg:ui-mb-16",
          children: [
            /* @__PURE__ */ jsx98(Oura, {
              color: "currentColor",
              width: 150
            }),
            multiVariates
          ]
        }),
        /* @__PURE__ */ jsxs69("div", {
          className: "ui-flex lg:ui-flex-row ui-flex-col-reverse ui-gap-12",
          children: [
            /* @__PURE__ */ jsx98(EmailSection_default, {
              emailSubmitted,
              onSubmit: onNewsletterFormSubmit
            }),
            /* @__PURE__ */ jsx98(LinkColumns_default, {
              currentPath,
              groups: linkGroups,
              layout: linkLayout,
              onClick: onLinkClick
            })
          ]
        }),
        /* @__PURE__ */ jsx98("div", {
          className: "ui-h-px ui-w-full ui-bg-sandstone-500 ui-mt-10 ui-mb-6"
        }),
        /* @__PURE__ */ jsx98(LegalSection, {
          isLocalized: isLegalLinksLocalized,
          languageOptions,
          legalLinks,
          onLocaleChange,
          selectedLocale,
          showImpressum
        })
      ]
    })
  });
}

// src/layout/v4/CtaHeader/index.tsx
init_esm_shims();
import { cx as cx38 } from "class-variance-authority";
import { jsx as jsx99, jsxs as jsxs70 } from "react/jsx-runtime";
function CtaHeader({
  hide = false,
  href,
  inverse = false,
  logo,
  onCtaButtonClick
}) {
  return /* @__PURE__ */ jsx99("nav", {
    "aria-hidden": hide,
    className: cx38(
      "ui-fixed ui-top-0 ui-z-100 ui-w-full ui-transition-transform ui-duration-500 ui-pointer-events-auto",
      "ui-bg-sandstone-200/30 ui-backdrop-blur-[2rem]",
      {
        "ui-text-white": inverse,
        "ui-text-sandstone-500": !inverse,
        "ui--translate-y-full ui-pointer-events-none": hide,
        "ui-translate-y-0 ui-pointer-events-auto": !hide
      }
    ),
    children: /* @__PURE__ */ jsxs70("div", {
      className: "ui-flex ui-items-center ui-justify-between ui-px-6 lg:ui-px-16 ui-py-3",
      children: [
        logo,
        /* @__PURE__ */ jsx99(Button, {
          "data-cy": "cta-header-button",
          href,
          onClick: onCtaButtonClick,
          size: "small",
          tabIndex: hide ? -1 : void 0,
          variant: "primary",
          children: t("header_shop_now")
        })
      ]
    })
  });
}

// src/layout/v4/PageLayout/index.tsx
import { jsx as jsx100, jsxs as jsxs71 } from "react/jsx-runtime";
var MAIN_CONTENT_ID2 = "main-content";
function PageLayout2({
  children,
  className = "",
  containerProps,
  ctaHeaderProps,
  eyebrowProps,
  footnotesProps,
  headerProps,
  hideHeader = false,
  mainLabel,
  Header: Header3 = Header2,
  footerProps,
  showCtaHeader = false,
  preFooterContent
}) {
  const {
    name = "",
    padding = "both",
    className: containerClassName = "",
    h1 = void 0
  } = containerProps;
  return /* @__PURE__ */ jsxs71("div", {
    className: "tailwind",
    children: [
      /* @__PURE__ */ jsx100("div", {
        className: "ui-sr-only focus-within:ui-not-sr-only focus-within:ui-py-2 focus-within:ui-px-4",
        children: /* @__PURE__ */ jsx100("a", {
          "data-cy": "skip-to-content",
          href: `#${MAIN_CONTENT_ID2}`,
          children: t("header_skip_to_content")
        })
      }),
      /* @__PURE__ */ jsxs71("div", {
        className: cx39(className, "ui-flex ui-flex-col ui-min-h-screen"),
        "data-cy": "page-wrapper",
        id: "page-wrapper",
        children: [
          /* @__PURE__ */ jsxs71("div", {
            className: "ui-relative ui-flex-grow",
            children: [
              /* @__PURE__ */ jsxs71("div", {
                className: "ui-absolute ui-top-0 ui-w-full ui-h-full ui-pointer-events-none ui-z-100",
                children: [
                  eyebrowProps ? /* @__PURE__ */ jsx100(Eyebrow2, {
                    ...eyebrowProps
                  }) : null,
                  !hideHeader && /* @__PURE__ */ jsx100(Header3, {
                    ...headerProps,
                    hide: showCtaHeader
                  }),
                  ctaHeaderProps ? /* @__PURE__ */ jsx100(CtaHeader, {
                    ...ctaHeaderProps,
                    hide: !showCtaHeader
                  }) : null
                ]
              }),
              /* @__PURE__ */ jsxs71("main", {
                "aria-label": mainLabel,
                className: "ui-pointer-events-auto",
                "data-cy": MAIN_CONTENT_ID2,
                id: MAIN_CONTENT_ID2,
                tabIndex: -1,
                children: [
                  /* @__PURE__ */ jsxs71("div", {
                    className: cx39({
                      "ui-pt-36": padding === "top",
                      "ui-pb-16": padding === "bottom",
                      "ui-pt-36 ui-pb-16": padding === "both" || !padding,
                      [containerClassName]: Boolean(containerClassName)
                    }),
                    "data-cy": `page-${name}`,
                    children: [
                      h1 ? /* @__PURE__ */ jsx100("h1", {
                        className: "ui-sr-only",
                        children: h1
                      }) : null,
                      children
                    ]
                  }),
                  footnotesProps ? /* @__PURE__ */ jsx100(Footnotes, {
                    ...footnotesProps
                  }) : null,
                  preFooterContent
                ]
              })
            ]
          }),
          /* @__PURE__ */ jsx100(Footer2, {
            ...footerProps
          })
        ]
      })
    ]
  });
}

// src/layout/v3/Header/PdpHeader/index.tsx
init_esm_shims();
import { cx as cx40 } from "class-variance-authority";
import { jsx as jsx101, jsxs as jsxs72 } from "react/jsx-runtime";
function PdpHeader({
  accordionOpenAtIndex,
  count,
  currentPath,
  menuImageComponent,
  menuLinks,
  headerLinks,
  isCarouselInView = false,
  onClick,
  onHamburgerClick,
  onMenuLinkClick,
  onMenuShopButtonClick,
  onShoppingCartClick
}) {
  const {
    blurElement,
    formatMessage,
    hamburgerElement,
    inverse,
    open,
    tabIndex,
    onHamburgerButtonClick,
    onOutsideClick
  } = useHeaderV3({ onHamburgerClick });
  const { fadeLinks, fadeOuraLogo } = usePdpHeaderAnimation({
    isCarouselInView
  });
  return /* @__PURE__ */ jsxs72("header", {
    className: cx40(
      "ui-relative ui-top-0 ui-py-2 ui-mt-4 ui-w-full ui-transition-all ui-duration-500 ui-z-100 ui-pointer-events-auto",
      "lg:ui-sticky lg:ui-top-4",
      { "lg:ui-pointer-events-none": fadeLinks },
      { "lg:ui-pointer-events-auto": !fadeLinks }
    ),
    "data-cy": "header",
    children: [
      /* @__PURE__ */ jsx101("div", {
        className: cx40(
          "headerBlurV3 ui-overflow-hidden ui-rounded-lg",
          "ui-absolute ui-top-0 ui-right-2 ui-bottom-0 ui-left-2",
          "lg:ui-opacity-0",
          {
            inverse
          }
        )
      }),
      /* @__PURE__ */ jsx101(LayoutGrid, {
        className: cx40("ui-z-200", {
          "ui-fixed ui-top-6 ui-left-0 ui-right-0 ui-w-full xxl:ui-left-1/2 xxl:-ui-translate-x-1/2": open,
          "ui-relative": !open
        }),
        children: /* @__PURE__ */ jsx101(GridItem, {
          colEnd: { sm: "main" },
          colStart: { sm: "main" },
          children: /* @__PURE__ */ jsxs72("nav", {
            className: cx40("headerV3 ui-flex ui-items-center", {
              inverse
            }),
            children: [
              /* @__PURE__ */ jsx101("ul", {
                className: cx40(
                  "ui-opacity-100 ui-relative ui-w-24 ui-z-200 ui-transition-opacity",
                  {
                    "lg:ui-opacity-0 lg:ui-pointer-events-none": fadeOuraLogo,
                    "lg:ui-opacity-100 lg:ui-pointer-events-auto": !fadeOuraLogo
                  }
                ),
                children: /* @__PURE__ */ jsx101(NavLink, {
                  "aria-label": formatMessage({ id: "oura_home_link" }),
                  className: "ui-py-3 ui-block ui-w-16 lg:ui-w-20",
                  "data-cy": "nav_logo_link",
                  href: "/",
                  id: "nav_home",
                  onClick,
                  children: /* @__PURE__ */ jsx101(Oura, {})
                })
              }),
              /* @__PURE__ */ jsx101("div", {
                className: cx40(
                  "ui-flex-1 ui-flex ui-items-center ui-justify-end ui-mx-2",
                  "ui-transition lg:ui-gap-12 lg:ui-justify-center",
                  "sm:ui-mx-4",
                  {
                    "ui-opacity-0 ui-pointer-events-none": open,
                    "lg:ui-opacity-0": fadeLinks,
                    "lg:ui-opacity-100": !fadeLinks
                  }
                ),
                children: /* @__PURE__ */ jsx101(MainLinks, {
                  currentPath,
                  headerLinks,
                  onClick,
                  open
                })
              }),
              count ? /* @__PURE__ */ jsx101("div", {
                className: cx40("ui-transition-opacity", {
                  "ui-hidden": open,
                  "lg:ui-opacity-0": fadeLinks,
                  "lg:ui-opacity-100": !fadeLinks
                }),
                children: /* @__PURE__ */ jsx101(ShoppingCart, {
                  hiddenHamburger: false,
                  inverseHeader: inverse,
                  onShoppingCartClick,
                  shoppingCartCount: count
                })
              }) : null,
              /* @__PURE__ */ jsx101("div", {
                className: cx40("ui-transition-opacity", {
                  "lg:ui-opacity-0": fadeLinks,
                  "lg:ui-opacity-100": !fadeLinks
                }),
                children: /* @__PURE__ */ jsx101(HamburgerBox, {
                  hideLinks: false,
                  onClick: onHamburgerButtonClick,
                  open,
                  ref: hamburgerElement
                })
              })
            ]
          })
        })
      }),
      /* @__PURE__ */ jsx101(Menu, {
        accordionOpenAtIndex,
        currentPath,
        hideLinks: false,
        menuImageComponent,
        menuLinks,
        onMenuLinkClick,
        onMenuShopButtonClick,
        open
      }),
      /* @__PURE__ */ jsx101(DesktopMenuBlur, {
        blurElement,
        onOutsideClick,
        open,
        tabIndex
      })
    ]
  });
}
PdpHeader.displayName = "PdpHeader";

// src/layout/v4/data/defaultHeaderData.ts
init_esm_shims();
var shopSection = ({
  isGiftCardEnabled,
  isSteloEnabled
}) => ({
  analyticId: "Shop",
  title: "shop",
  dataCy: "nav-shop",
  columns: [
    {
      analyticAction: "go to pop",
      analyticCta: "shop",
      analyticEvent: "CTA Clicked",
      backgroundImage: {
        src: "https://ourahealth.imgix.net/global-nav/or4-ceramic-card.jpg?s=9e7b6eb8126c7ebe186ed4416d0dfffd"
      },
      dataCy: "nav-oura-ring-4-ceramic",
      href: "/store/rings/oura-ring-4-ceramic",
      id: "shop-column-1",
      title: "oura_ring_4_ceramic",
      type: "card"
    },
    {
      analyticAction: "go to pop",
      analyticCta: "shop",
      analyticEvent: "CTA Clicked",
      backgroundImage: {
        src: "https://ourahealth.imgix.net/global-nav/or4-card.jpg?s=51f67a0408a790c582a89e052671ec0b"
      },
      dataCy: "nav-oura-ring-4",
      href: "/store/rings",
      id: "shop-column-2",
      title: "ring_gen_4",
      type: "card"
    },
    {
      id: "shop-column-4",
      type: "list",
      links: [
        {
          analyticCta: "stelo glucose biosensor",
          dataCy: "nav-stelo-glucose-biosensor",
          href: "/store/dexcom/stelo-glucose-biosensor",
          imgIcon: {
            src: "https://ourahealth.imgix.net/global-nav/stelo-biosensor.png?s=3e149d294b027410f28195c736d1b07a"
          },
          title: "stelo_glucose_biosensor"
        },
        {
          analyticCta: "gift cards",
          dataCy: "nav-gift-card",
          href: "/store/gift-card",
          imgIcon: {
            src: "https://ourahealth.imgix.net/global-nav/gift-cards.png?s=0ae28b602f10d2933ad814eaef87f0ff"
          },
          title: "business_gallery_gift_card_title"
        },
        {
          analyticCta: "extra charger",
          dataCy: "nav-extra-charger",
          href: "/store/accessories/charger-oura-4",
          imgIcon: {
            src: "https://ourahealth.imgix.net/global-nav/extra-charger.png?s=bda24d6bea9a5da9f55d988f84696e97"
          },
          title: "drop_down_extra_charger"
        },
        {
          analyticCta: "all products",
          title: "nav_shop_all_products",
          dataCy: "nav-shop-all-products",
          href: "/store",
          typographyClassName: "ui-text-blue-500 lg:ui-text-sandstone-500 group-hover:ui-text-blue-500",
          imgIcon: {
            src: "https://ourahealth.imgix.net/global-nav/shop-all-products.png?s=35f17e9b4e625f3186376f4560d1192d"
          }
        }
      ].filter(({ title }) => {
        if (title === "stelo_glucose_biosensor") {
          return isSteloEnabled;
        } else if (title === "business_gallery_gift_card_title") {
          return isGiftCardEnabled;
        }
        return true;
      })
    }
  ]
});
var healthFeaturesSection = {
  analyticId: "Health Features",
  title: "nav_health_features",
  dataCy: "nav-health-features",
  columns: [
    {
      analyticCta: "why oura",
      analyticEvent: "link_clicked",
      backgroundImage: {
        src: "https://ourahealth.imgix.net/global-nav/why-oura-card.jpg?s=d2675c5e31afc7e7ec8deeed6252e5df"
      },
      dataCy: "nav-why-oura",
      href: "/why-oura",
      id: "health-column-1",
      title: "why_oura_link",
      type: "card"
    },
    {
      id: "health-column-2",
      type: "list",
      links: [
        {
          analyticCta: "science and research",
          dataCy: "nav-science-and-research",
          href: "/science-and-research",
          Icon: ReportsIcon,
          title: "science_and_research_link"
        },
        {
          analyticCta: "sleep and rest",
          dataCy: "nav-sleep-and-rest",
          href: "/sleep-and-rest",
          Icon: MoonIcon,
          title: "sleep_and_rest_link"
        },
        {
          analyticCta: "womens health",
          dataCy: "nav-womens-health",
          href: "/womens-health",
          Icon: UterusIcon,
          title: "womens_health_link"
        },
        {
          analyticCta: "stress",
          dataCy: "nav-stress",
          href: "/stress",
          Icon: StressIcon,
          title: "stress_link"
        }
      ]
    },
    {
      id: "health-column-3",
      type: "list",
      links: [
        {
          analyticCta: "heart health",
          dataCy: "nav-heart-health",
          href: "/heart-health",
          Icon: HeartOrganIcon,
          title: "heart_health_link"
        },
        {
          analyticCta: "activity and movement",
          dataCy: "nav-activity-and-movement",
          href: "/activity-and-movement",
          Icon: ActivityIcon,
          title: "activity_and_movement_link"
        },
        {
          analyticCta: "metabolic health",
          dataCy: "nav-metabolic-health",
          href: "/metabolic-health",
          Icon: LunchIcon,
          title: "metabolic_health"
        }
      ]
    }
  ]
};
var experienceSection = {
  analyticId: "Experience",
  title: "nav_experience",
  dataCy: "nav-experience",
  columns: [
    {
      analyticCta: "how it works",
      analyticEvent: "link_clicked",
      backgroundImage: {
        src: "https://ourahealth.imgix.net/global-nav/how-it-works-card.jpg?s=973002eacc3de993df2a6d04b06837a8"
      },
      dataCy: "nav-how-it-works",
      href: "/how-it-works",
      id: "experience-column-1",
      title: "how_it_works_link",
      type: "card"
    },
    {
      id: "experience-column-2",
      type: "list",
      links: [
        {
          analyticCta: "sizing guide",
          dataCy: "nav-sizing-guide",
          href: "/sizing",
          Icon: RingOutlineIcon,
          title: "nav_sizing_guide"
        },
        {
          analyticCta: "integrations",
          dataCy: "nav-integrations",
          href: "/integrations",
          Icon: LinkIcon,
          title: "integrations_link"
        },
        {
          analyticCta: "membership",
          dataCy: "nav-oura-membership",
          href: "/membership",
          Icon: ProfileIcon,
          title: "oura_membership"
        },
        {
          analyticCta: "help center",
          dataCy: "nav-help-center",
          href: "https://support.ouraring.com/",
          Icon: OuraSymbolIcon,
          title: "nav_help_center"
        }
      ]
    }
  ]
};
var forBusinessSection = {
  analyticId: "For Business",
  analyticCta: "for business",
  title: "for_business_link",
  dataCy: "nav-for-business",
  href: "/business"
};
var defaultHeaderData = ({
  isGiftCardEnabled,
  isSteloEnabled
}) => [
  shopSection({
    isGiftCardEnabled,
    isSteloEnabled
  }),
  healthFeaturesSection,
  experienceSection,
  forBusinessSection
];
var defaultHeaderSecondaryLinks = [
  {
    dataCy: "nav-secondary-pulse-blog",
    href: "/blog",
    title: "footer_pulse_blog"
  },
  {
    dataCy: "nav-secondary-help-center",
    href: "https://support.ouraring.com",
    title: "nav_help_center"
  },
  {
    dataCy: "nav-secondary-careers",
    href: "/careers",
    title: "footer_careers"
  }
];
export {
  CtaHeader,
  EcomFooter,
  Footer,
  Footer2 as FooterV4,
  Footnotes,
  HamburgerBox,
  Header,
  Header2 as HeaderV4,
  InverseHeader,
  Menu,
  NavLink,
  PageLayout,
  PageLayout2 as PageLayoutV4,
  PdpHeader,
  ShoppingCart,
  SimpleFooter,
  UiProvider,
  defaultFooterData,
  defaultFooterLanguages,
  defaultFooterLayout,
  defaultFooterLegalLinks,
  defaultHeaderData,
  defaultHeaderSecondaryLinks,
  useFooterContext,
  useHeaderContext
};
//# sourceMappingURL=index.mjs.map